import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Popover from "../components/Popover";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import { useMediaQuery, useTheme } from "@mui/material";

const History = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const getImageSize = () => {
    if (isMobile) return "300px";
    if (isTablet) return "400px";
    if (isDesktop) return "600px";
    return "500px";
  };

  return (
    <div>
      <Header />
      <Container maxWidth="md">
        <Box py={2}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            direction="column"
            alignItems="center"
          >
            <Grid item>
              <Typography
                variant="h4"
                color="black"
                align="center"
                sx={{ marginTop: 6, fontWeight: "bold" }}
              >
                WORD ETYMOLOGIES AND COGNATES
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="h5"
                color="black"
                align="center"
                sx={{ marginBottom: 5, fontWeight: "bold" }}
              >
                A MULTILINGUAL LIST
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                - -
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="h6"
                color="black"
                align="left"
                sx={{ fontWeight: "bold" }}
              >
                Hover over a word below to see a summary of its origin story as
                well as a non-exhaustive list of its relations to other words
                (ancestors, cognates, descendants, <i>etc.</i>). Click on the
                YouTube symbol next to each word to see a more detailed video
                overview of its etymology. Hover over the flag emoji next to the
                YouTube symbol to see the word's family tree. <u>Note</u>: All
                words are nouns unless otherwise indicated.
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                ================================{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇬🇧 ENGLISH 🇬🇧
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/acrid.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;acrid (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "ācer" -- "sour".
                      <div></div>
                      <strong>Related to:</strong> eager, vin<u>egar</u>
                      <div></div>
                      <strong>Cognates:</strong> acre 🇪🇸, âcre 🇫🇷, acre 🇵🇹, acre
                      🇮🇹, acru 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/admire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;admire (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", plus the prefix "ad-"
                      -- (added to verbs to intensify the action).
                      <div></div>
                      <strong>Related to:</strong> mirror, mirage
                      <div></div>
                      <strong>Cognates:</strong> admirer 🇫🇷, admirar 🇪🇸, admirar
                      🇵🇹, ammirare 🇮🇹, admiroj 🇦🇱, ammira 🇲🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adolescent.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;adolescent"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "alescere" --
                      "to be nourished", "to grow up", via the Latin verb
                      "adolēscere" -- "to grow up", "to come to maturity", "to
                      ripen" and its present participle "adolescens" -- "growing
                      up", "maturing", "becoming an adult".
                      <div></div>
                      <strong>Related to:</strong> adult, <u>ali</u>mony,{" "}
                      <u>alu</u>mnus
                      <div></div>
                      <strong>Cognates:</strong> adolescente 🇪🇸, adolescent 🇫🇷,
                      adolescente 🇵🇹, adolescent 🇷🇴, adolescent 🇦🇩, adolescente
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adult.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;adult"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "alescere" --
                      "to be nourished", "to grow up", via the Latin verb
                      "adolēscere" -- "to grow up", "to come to maturity", "to
                      ripen" and its past participle "adultus" -- "grown up",
                      "matured", "adult".
                      <div></div>
                      <strong>Related to:</strong> adolescent, <u>ali</u>mony,
                      alumnus
                      <div></div>
                      <strong>Cognates:</strong> adulto 🇪🇸, adulte 🇫🇷, adulto
                      🇵🇹, adult 🇷🇴, adult 🇦🇩, adulto 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adventure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/t4CwXz_CSU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;adventure"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "adventūrus" --
                      "to be about to arrive", a participle of the verb
                      "adveniō" -- "to arrive", "to come to a specific
                      location". The original sense is therefore "something that
                      is about to happen (no matter how mundane or exciting)."
                      <div></div>
                      <strong>Related to:</strong> Advent
                      <div></div>
                      <strong>Cognates:</strong> Abenteuer 🇩🇪, aventure 🇫🇷,
                      avontuur 🇳🇱, aventura 🇪🇸, avventura 🇮🇹, aventura 🇵🇹,
                      äventyr 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adverb.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;adverb"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Latin "adverbium" --
                      "adverb", a combination of "ad" -- "to" and "verbum" --
                      "verb", so called because it added meaning to the verb,
                      thus affecting how it acted upon the other words in the
                      sentence.
                      <div></div>
                      <strong>Related to:</strong> word, verb
                      <div></div>
                      <strong>Cognates:</strong> adverbe 🇫🇷, adverbio 🇪🇸,
                      advérbio 🇵🇹, Adverb 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/advice.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;advice"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin prefix
                      "ad-" -- "to", "in", and the passive participle "vīsus" --
                      "having been seen" of the verb "videō" -- "to see". The
                      combination was the basis of the latter part of the Old
                      French phrase "ce m'est a vis" – “it is my view”, which
                      eventually developed into the single word "avis" --
                      "opinion", and then, from there, the Middle English "avys"
                      -- "opinion".
                      <div></div>
                      <strong>Related to:</strong> en<u>vy</u>, pru<u>dence</u>,
                      visa, vision, visit, video, evidence
                      <div></div>
                      <strong>Cognates:</strong> advies 🇳🇱, advies 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/alumnus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;alimony"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "alimōnia" --
                      "food", "support", "nourishment", "sustenance", which
                      itself is a combination of the verb "alō" -- "to nourish"
                      and the suffix "-mōnia" -- (denoting an action, state, or
                      condition).
                      <div></div>
                      <strong>Related to:</strong> adult, adolescent, alumnus
                      <div></div>
                      <strong>Cognates:</strong> pensión <u>ali</u>menticia 🇪🇸,
                      pension <u>ali</u>mentaire 🇫🇷, pensão <u>ali</u>mentícia
                      🇵🇹, <u>ali</u>menti 🇮🇹, <u>ali</u>menty 🇵🇱, алименты 🇷🇺,
                      аліме́нти 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/alumnus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;alumnus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "alō" -- "to
                      nourish" via its present passive participle "alumnus" --
                      "foster child", "nourished one".
                      <div></div>
                      <strong>Related to:</strong> adult, adolescent, <u>ali</u>
                      mony
                      <div></div>
                      <strong>Cognates:</strong> ex <u>alumno</u> 🇪🇸, ex-
                      <u>aluno</u> 🇵🇹, alumni 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/amuse.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;amuse (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French verb "amuser"
                      (<i>i</i>.<i>e</i>.<i>,</i> "a-" -- (prefix used to
                      indicate a change of state) + "muser" -- “to cause to
                      stare stupidly”).
                      <div></div>
                      <strong>Not related to:</strong> music, museum, muse
                      (goddess)
                      <div></div>
                      <div></div>
                      <strong>Cognates:</strong> amuser 🇫🇷, amüsieren 🇩🇪
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/animal1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;animal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "anima" -- "soul",
                      "spirit", "life", "air" , "breath" via the adjective
                      "animālis" -- "animate", "living."
                      <div></div>
                      <strong>Related to:</strong> animate (<i>v.</i>)
                      <div></div>
                      <strong>Cognates:</strong> animal 🇫🇷, animale 🇮🇹, annimal
                      🇲🇹, animal 🇪🇸, animal 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/animate.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;animate (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "anima" -- "soul",
                      "spirit", "life", "air" , "breath", via the verb "animō"
                      -- "to fill with breath", "quicken", "encourage".
                      <div></div>
                      <strong>Related to:</strong> animal
                      <div></div>
                      <strong>Cognates:</strong> animer 🇫🇷, animare 🇮🇹, animar
                      🇪🇸, animar 🇵🇹, animować 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/answer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VvZv83SW8Bg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;answer"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old English "andswaru"
                      -- "answer", which is a combination of the prefix "and-"
                      -- "against" and "swaru" -- "oath", "vow". Historically,
                      an "answer" was by definition a "sworn statement".
                      <div></div>
                      <strong>Related to:</strong> swear (v.)
                      <div></div>
                      <strong>Cognates:</strong> <u>Ant</u>wort 🇩🇪, <u>ant</u>
                      woord 🇳🇱,
                      <u>ant</u>woord 🇿🇦, svar 🇳🇴, svar 🇩🇰, svar 🇸🇪, svar 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apocalypse.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/tOnL1s10mE4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;apocalypse"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek preposition "ἀπό" /apó/ -- “back", "away from” and
                      the verb "καλύπτω" /kalúptō/ “to cover”. Literally, an
                      apocalypse is an "uncovering".
                      <div></div>
                      <strong>Related to:</strong> <u>apo</u>cryphal (adj.),{" "}
                      <u>apo</u>logy,
                      <div></div>
                      <strong>Cognates:</strong> apocalipsis 🇪🇸, apocalipse 🇵🇹,
                      apocalypse 🇫🇷, apocalipsă 🇷🇴, apocalisse 🇮🇹, apokalyps 🇸🇪,
                      apokalipse 🇱🇻, apocalyps 🇳🇱, апокалипсис 🇧🇬, апокаліпсис
                      🇺🇦, apokalipszis 🇭🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apology.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/tOnL1s10mE4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;apology"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek ἀπολογία
                      /apología/ -- "formal defense of an opinion, position, or
                      action". The word gradually experienced a shift in meaning
                      thanks to the teaching of the Catholic Church, which
                      preached repentance, and also, gradually shifting
                      politeness norms, which preferred toning down one’s
                      rhetoric and showing humility as conducive to smoother
                      social interactions.
                      <div></div>
                      <strong>Related to:</strong> <u>apo</u>cryphal (adj.),{" "}
                      <u>apo</u>calypse, pro<u>logue</u>, epi<u>logue</u>, etymo
                      <u>logy</u>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/appoint.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mn09t2xE2QU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;appoint (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin phrase "ad" --
                      "to" + "punctum" -- "point" (<i>i.e.</i>, "to the point").
                      The meaning comes from the idea of coming to an agreement
                      over a specific matter, including all the details (
                      <i>i.e.,</i> "getting to the point").
                      <div></div>
                      <strong>Related to:</strong> disappoint (v.), point
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apricot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;apricot"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and finally, the Catalan "a(l)bercoc", before
                      evolving into the modern English word.
                      <div></div>
                      <strong>Related to:</strong> precocious (<i>adj.</i>)
                      <div></div>
                      <strong>Ancestor:</strong> albercoc 🇦🇩
                      <div></div>
                      <strong>Descendants:</strong> aibreog 🇮🇪, aprikoti 🇹🇿,
                      aprikot 🇮🇩
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      albaricoque 🇪🇸, abrikoos 🇳🇱, abricot 🇫🇷, абрико́с 🇷🇺,
                      абрико́с 🇺🇦, berquq 🇲🇹, Aprikose 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apron.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;apron"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Phoenician "𐤌𐤀𐤐"
                      /mappē/ ⁠ -- "fine cloth" via the Latin "mappa" -- "a
                      tablecloth (or large napkin) that guests would often bring
                      and use at the dinner table to wrap items of food that
                      they wished to take away with them". From there the word
                      arrived in English via the Old French "napperon" -- "small
                      tablecloth" and the Middle English "naperoun". Over time,
                      "a naperoun" became "an aperoun".
                      <div></div>
                      <strong>Related to:</strong> map, mop, <u>nap</u>kin
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/architect.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;architect"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ἀρχι-" /arkhi-/ -- “chief” and "τέκτων" /téktōn/ --
                      “builder”.
                      <div></div>
                      <strong>Related to:</strong> <u>arch</u>enemy, <u>arch</u>
                      bishop
                      <div></div>
                      <strong>Cognates:</strong> Architekt 🇩🇪, arhitekts 🇱🇻,
                      architecte 🇫🇷, arquitecto 🇪🇸, arquiteto 🇵🇹, architetto 🇮🇹,
                      архіте́ктор 🇺🇦, arxitektor 🇺🇿, arsitèk 🇮🇩, arhitekt 🇸🇮,
                      argitek 🇿🇦, arkitekt 🇮🇸, архитектор 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;arrival"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Derived from the verb "to
                      arrive", which comes from the Classical Latin "rīpa" --
                      via the Medieval Latin verb "adrīpāre" -- "to land", "to
                      come ashore", plus the suffix "-al" -- ("of" or
                      "pertaining to").
                      <div></div>
                      <strong>Not related to:</strong> rival, derive (<i>v.</i>)
                      <div></div>
                      <strong>Related to:</strong> river, riparian
                      <div></div>
                      <strong>Cognates:</strong> arrivée 🇫🇷, arrivo 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/assassin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zSk51b0WVHw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;assassin"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "أَسَاسِيِّين"
                      /ʔasāsiyyīn/ (the name for members of a fundamentalist
                      order in Shia Islam who made it their mission to protect
                      the Muslim faith in the Levant and Persia during the
                      Crusader Era). The word is traditionally thought to derive
                      from "حَشَّاشِين" /ḥaššāšīn/ -- "hashish users", as
                      members of the order were presumed (primarily by their
                      enemies) to be heavy users of hashish. It is, however,
                      more likely derived from "أَسَاس" /ʔasās/ -- “foundation",
                      "basis”.
                      <div></div>
                      <strong>Cognates:</strong> assassin 🇫🇷, asesino 🇪🇸,
                      assassino 🇵🇹, assassino 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/astronomy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Gt0B3coiu7s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;astronomy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ἄστρον"
                      /ástron/ -- “celestial body” and "νόμος" /nómos/ -- “law",
                      "custom".
                      <div></div>
                      <strong>Related to:</strong> dis<u>aster</u>, star
                      <div></div>
                      <strong>Cognates:</strong> astronomía 🇪🇸, astronomia 🇵🇹,
                      astronomie 🇫🇷, astronomie 🇷🇴, astronomia 🇮🇹, astronomi 🇸🇪,
                      astronomija 🇱🇻, astronomie 🇳🇱, астроно́мия 🇧🇬, астрано́мія
                      🇧🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/attic.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/BBMUYDMWK_w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;attic"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Ἀττικός"
                      /attikós/, the region of Attica in Greece (<i>lit.</i>{" "}
                      “relating to Athens”). In the architecture of the region
                      of Attica, lots of building facades in ancient times had
                      an upper decorative row above the entablature that was
                      elaborately decorated and had a distinctive appearance.
                      Over time this row expanded and became known as an "Attic
                      Storey".
                      <div></div>
                      <strong> Ancestor:</strong> attique 🇫🇷
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/average.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/cI0Fa9UD9S8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;average"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Arabic verb
                      "عَوِرَ" /ʕawira/ -- “to lose an eye" and the derived
                      "عَوَار" /ʕawār/ -- "blemish", "defect" via "عَوَارِيَّة"
                      /ʕawāriyya/ -- “damaged goods" and, later, the Italian
                      "avaria" -- "damage done to goods (that have been thrown
                      overboard) on a watercraft." An "average" comes from the
                      medieval practice of calculating the cost of goods thrown
                      off ships during weather-related emergencies. The cost of
                      the lost goods was divided equally among all parties
                      shipping goods on that same ship, including those whose
                      goods were not lost.
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ball.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ball"
                  hoverText={
                    <span>
                      <strong>
                        <u>"formal dance"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Ancient Greek "βάλλω"
                        /bállō/, -- “to throw, to cast, to hurl” via the Latin
                        "ballō" -- “to dance”.
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Related to:</strong> pro<u>blem</u>, ballet
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Not related to:</strong> ball (as in "football")
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> Ball 🇩🇪, bal 🇳🇱, baile 🇵🇹,
                        baile 🇪🇸, ballo 🇮🇹, бал 🇧🇬, бал 🇲🇰, bal 🇺🇿, ball 🇮🇸, бал
                        🇺🇦, бал 🇷🇺
                      </div>
                      <div></div>
                      <strong>
                        <u>"round object for games or sports"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From Proto-Indo-European
                        "*bʰol-n-" -- "ball", "bubble" via the Proto-Germanic
                        "balluz" -- "round object", "ball".
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Not related to:</strong> pro<u>blem</u>, ballet,
                        ball (as in "dance")
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> Ball 🇩🇪, bol 🇳🇱, balle 🇫🇷,
                        bola 🇵🇹, palla 🇮🇹, pallo 🇫🇮, ball 🇳🇴
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Descendants:</strong> ボール 🇯🇵
                      </div>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ball.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ballet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "βάλλω" /bállō/ -- “to throw", "to cast", "to hurl” via
                      the Latin "ballō" -- “to dance”.
                      <div></div>
                      <strong>Ancestor:</strong> balletto 🇮🇹
                      <div></div>
                      <strong>Related to:</strong> pro<u>blem</u>, ball (as in
                      "dance")
                      <div></div>
                      <strong>Not related to:</strong> ball (as in "football")
                      <div></div>
                      <strong>Cognates:</strong> Ballett 🇩🇪, ballet 🇳🇱, balé 🇵🇹,
                      ballet 🇪🇸, balletto 🇮🇹, baletas 🇱🇹, бале́т 🇧🇬, бале́т 🇲🇰,
                      balets 🇱🇻, ballett 🇪🇪, balett 🇭🇺, балет 🇷🇸, бале́т 🇺🇦,
                      бале́т 🇷🇺, balet 🇷🇴, μπαλλέτο 🇬🇷, ballett 🇳🇴, بیلے 🇵🇰,
                      بَالِيه 🇸🇦, باله 🇮🇷, バレエ 🇯🇵, <u>芭蕾</u>舞 🇨🇳, 발레 🇰🇷,
                      ບາເລ 🇱🇦, បាឡេ 🇰🇭, балет 🇲🇳, ba lê 🇻🇳, ဘဲလေး 🇲🇲, բալետ 🇦🇲,
                      ბალეტი 🇬🇪, บัลเล่ต์ 🇹🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;banana"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳
                      <div></div>
                      <strong>Cognates:</strong> banane 🇫🇷, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana
                      🇪🇸, banana 🇵🇹, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪,
                      banaan 🇳🇱, μπανάνα 🇬🇷, banan 🇸🇪
                      <div></div>
                      <strong>Descendants:</strong> バナナ 🇯🇵, 바나나 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/beach.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PtZcAf8r9Ws"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;beach"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "bʰeg-" -- "flowing water", via the Proto-Germanic
                      "*bakiz" -- "brook", "stream", and the Old English "bæċ"
                      -- "brook", "stream".
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bear"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*bʰerH-" -- "brown", via the
                      Proto-Germanic "*berô" -- "the brown one". Most scholars
                      believe that early Germanic peoples called the animal “the
                      brown one”, in an effort to avoid calling it by its real
                      name, which, in those superstitious cultures, was
                      considered taboo, and could cause it to appear during a
                      hunt.
                      <div></div>
                      <strong>Related to:</strong> brown (adj.)
                      <div></div>
                      <strong>Cognates:</strong> Bär 🇩🇪, beer 🇳🇱, bjørn 🇩🇰,
                      bjørn 🇳🇴
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong> медве́дь 🇷🇺,
                      niedźwiedź 🇵🇱, lokys 🇱🇹, lācis 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/belly.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bdywn-WNYnw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;belly"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰelǵʰ-" -- "to swell", via the Proto-Germanic "*balguz"
                      -- "skin", "hide", "bellows", "bag", and the Old English
                      "bielġ" -- "bag", "pouch", "bulge".
                      <div></div>
                      <strong>Related to:</strong> bulge, budget
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/berry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;berry"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*bazją"
                      -- "berry", via the Proto-West-Germanic "*baʀi" – "berry",
                      the Old English "berġe" -- "berry", and the Middle English
                      "berye" -- "berry".
                      <div></div>
                      <strong>Not related to:</strong> fraise
                      <div></div>
                      <strong>Possibly related to:</strong> canneberge
                      <div></div>
                      <strong>Cognates:</strong> Beere 🇩🇪, beri 🇹🇿, bes 🇳🇱, bær
                      🇳🇴, bär 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/berserk.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;berserk (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "*ber-" --
                      "bear" and "serkr" -- "shirt." So called because of the
                      bearskin shirt worn by warriors in ancient Scandinavian
                      cultures (who were quite ferocious, hence the modern
                      adjective, which is derived from the noun "berserker" --
                      "Norse warrior").
                      <div></div>
                      <strong>Ancestor:</strong> berserker (<i>n.</i>)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bloom.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;bloom (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Proto-Germanic
                      "*blōmô" -- “flower”, and the Old Norse blóm – "flower".
                      <div></div>
                      <strong>Related to:</strong> flour, flower, blossom (
                      <i>v</i>.), flourish (<i>v</i>.)
                      <div></div>
                      <strong>Cognates:</strong> bloesemen 🇳🇱, florescer 🇵🇹,
                      florecer 🇪🇸, fiore 🇮🇹, fleurir 🇫🇷, blomstre 🇳🇴, blomstre
                      🇩🇰, blomstra 🇸🇪, blühen 🇩🇪, în<u>flori</u> 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/blossom.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;blossom (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Proto-Germanic
                      *blōstmô –- "flower" and the Old English blōstm –-
                      "blossom", "flower".
                      <div></div>
                      <strong>Related to:</strong> flour, flower, bloom (
                      <i>v</i>.), flourish (<i>v</i>.)
                      <div></div>
                      <strong>Cognates:</strong> bloesemen 🇳🇱, florescer 🇵🇹,
                      florecer 🇪🇸, fiore 🇮🇹, fleurir 🇫🇷, blomstre 🇳🇴, blomstre
                      🇩🇰, blomstra 🇸🇪, blühen 🇩🇪, în<u>flori</u> 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bow"
                  hoverText={
                    <span>
                      <strong>
                        <u>"curved instrument or weapon"</u>
                      </strong>{" "}
                      <div></div>
                      <strong>Origin:</strong> From the Proto-Germanic "*bugô"
                      -- "bend".
                      <div></div>
                      <strong>Related to:</strong> elbow
                      <div></div>
                      <strong>Cognates:</strong> Bogen 🇩🇪, boog 🇳🇱, bue 🇩🇰, bue
                      🇳🇴, bogi 🇮🇸, båge 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/britches.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;britches (<i>pl.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*brōks"
                      -- "crotch", "hindquarters", "clothing that covers the
                      rear end".
                      <div></div>
                      <strong>Ancestor:</strong> breeches 🇬🇧
                      <div></div>
                      <strong>Possibly related to:</strong> trousers
                      <div></div>
                      <strong>Cognates:</strong> брюки 🇷🇺, broek 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/broom.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;broom"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*bʰrem-" -- "thorn", "sharp point", via the
                      Proto-West-Germanic "*brāma" -- "bramble", "thorn bush",
                      and the Old English "brōm" -- "brushwood" "shrub with
                      tough, slender branches".
                      <div></div>
                      <strong>Descendant:</strong> brum 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/brush.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;brush"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*bruskaz" --
                      “tuft", "thicket", "underbrush” via the Old French
                      "broisse" -- "brush".
                      <div></div>
                      <strong>Cognates:</strong> brosse 🇫🇷, brocha 🇪🇸, brocha 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/budget.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bdywn-WNYnw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;budget"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰelǵʰ-" -- "to swell", via the Latin "bulga" --
                      "knapsack", "wallet" and the Old French "bougette" --
                      "small leather pouch", "wallet". In the 17th and 18th
                      centuries, politicians often used "budgets" for their
                      everyday affairs, including government officials, who used
                      them to carry important paperwork, including ones related
                      to finance (such as Prime Minister Robert Walpole, whose
                      tax policies were criticized in an 1833 pamphlet called
                      “the budget opened”).
                      <div></div>
                      <strong>Related to:</strong> bulge, belly
                      <div></div>
                      <strong>Descendants:</strong> budget 🇫🇷, budget 🇩🇰,
                      buiséad 🇮🇪, budget 🇸🇪, буџет 🇲🇰, bütçe 🇹🇷, bajeti 🇹🇿,
                      բյուջե 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bulge.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bdywn-WNYnw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bulge"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰelǵʰ-" -- "to swell", via the Latin "bulga" --
                      "knapsack", "wallet".
                      <div></div>
                      <strong>Related to:</strong> budget, belly
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Descendants:</strong> 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas
                      🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/butterfly.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UrmfcQSPcqk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;butterfly"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old English
                      "butorflēoge", whose further etymology is unknown. The
                      name perhaps derives from the belief in medieval Germanic
                      folklore that butterflies are actually witches in disguise
                      who shape-shift into butterflies and steal uncovered dairy
                      products out of homes.
                      <div></div>
                      <div></div>
                      <strong>Semantic equivalents:</strong> Schmetterling 🇩🇪
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cage.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cage"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", and its derivative noun "cavea" – "hollow
                      place", "enclosure for animals", via the Old French "cage"
                      – "cage", "enclosure" and the Middle English "cage", --
                      "cage", "pen", "enclosure".
                      <div></div>
                      <strong>Related to:</strong> cave, cavity, jail, cajole (
                      <i>v.</i>)<div></div>
                      <strong>Cognates:</strong> Käfig 🇩🇪, kooi 🇳🇱, gabbia 🇮🇹,
                      jaula 🇪🇸, cage 🇫🇷, gaiola 🇵🇹, Käfeg 🇱🇺, kou 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cajole.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;cajole (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", via the Late Latin noun "caveola –- “little
                      cage", the Old French verb "gaioler" -- "entice into a
                      cage", and the Middle French "cageoler" -- "chatter like a
                      jaybird"
                      <div></div>
                      <strong>Related to:</strong> cage, cave, jail, cavity
                      <div></div>
                      <strong>Cognates:</strong> cajoler 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/camel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;camel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel", via the Ancient Greek "κᾰ́μηλος" /kắmēlos/ --
                      "camel".
                      <div></div>
                      <strong>Cognates:</strong> ޖަމަލު 🇲🇻, جَمَل 🇸🇦, ግመል 🇪🇹,
                      גמל 🇮🇱, ngamia 🇹🇿, Kamel 🇩🇪, chameau 🇫🇷, cammello 🇮🇹,
                      camelo 🇵🇹, camello 🇪🇸, kamel 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;canal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/ --
                      "reed", via the Ancient Greek "κάννα" /kánna/ -- “reed”,
                      and the Latin "canna" -- "reed". The name comes from the
                      fact that a canal has a long cylindrical reed-like shape.
                      <div></div>
                      <strong>Related to:</strong> canyon, cannon, channel,
                      cane, canon
                      <div></div>
                      <strong>Not related to:</strong> cannabis
                      <div></div>
                      <strong>Cognates:</strong> canal 🇫🇷, canal 🇵🇹, canal 🇪🇸,
                      kanal 🇸🇪, canale 🇮🇹, Kanal 🇩🇪, kanal 🇩🇰, канал 🇹🇯, кана́л
                      🇷🇺, kanał 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/candle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/SRAX1HQCFcI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;candle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "candeō" --
                      "to be white", "to be bright", "to shine”, via the noun
                      "candēla" -- "candle", "torch".
                      <div></div>
                      <strong>Related to:</strong> candid (adj.)
                      <div></div>
                      <strong>Not related to:</strong> candy
                      <div></div>
                      <strong>Cognates:</strong> kynttilä 🇫🇮, cannwyll 🏴󠁧󠁢󠁷󠁬󠁳󠁿,
                      candela 🇮🇹, kandila 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/candy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;candy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Probably from the Sanskrit "खण्ड"
                      /khaṇḍa/ -- "broken piece", "fragment", "scrap" via the
                      Persian "کند" /kand/ -- “candied sugar” and the Arabic
                      "قَنْد" /qand/ -- "solidified sugarcane sap" (<i>i.e.,</i>{" "}
                      "rock candy") all of which formed the basis of the
                      adjective in the Old French "sucre candi" -- "candied
                      sugar", and, thence, the modern English word.
                      <div></div>
                      <strong>Descendants:</strong> کَینْڈی 🇵🇰, kendi 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cane.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cane"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/ --
                      "reed", via the Ancient Greek "κάννα" /kánna/ -- “reed”,
                      the Latin "canna" -- “reed”, "cane", and the Old French
                      "cane" -- "sugar cane".
                      <div></div>
                      <strong>Related to:</strong> cannon, canyon, channel,
                      canal, canon
                      <div></div>
                      <strong>Not related to:</strong> cannabis
                      <div></div>
                      <strong>Cognates:</strong> canne 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canine.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9YJzi3P2Wto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;canine (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "canis" -- "dog"
                      via "canīnus" -- "doglike", "of dogs".
                      <div></div>
                      <strong>Related to:</strong> kennel
                      <div></div>
                      <strong>Cognates:</strong> canin 🇫🇷, canino 🇵🇹, canino 🇪🇸,
                      caní 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cannabis.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cannabis"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Probably from the Scythian
                      "*kanab" -- "hemp", via the Old Persian "کنب" -- "hemp"
                      and the Ancient Greek "κάνναβις" -- "hemp".
                      <div></div>
                      <strong>Related to:</strong> canvas, hemp
                      <div></div>
                      <strong>Not related to:</strong> cannon, canyon, canal,
                      channel, canon, cane
                      <div></div>
                      <strong>Cognates:</strong> cannabis 🇫🇷, cânabis 🇵🇹,
                      cannabis 🇪🇸, cannabis 🇸🇪, canapa 🇮🇹, Hanf 🇩🇪, hamp 🇩🇰,
                      конопля́ 🇷🇺, kanapė 🇱🇹, კანაფი 🇬🇪, قِنَّب 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cannibal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cannibal"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Caribbean (<i>adj.</i>)
                      <div></div>
                      <strong>Not related to:</strong> cannon, cannabis
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> cannibale 🇫🇷, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cannon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cannon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/ --
                      "reed", via Ancient Greek "κάννα" /kánna/ -- “reed”, the
                      Latin "canna" -- "reed", and the Old French "canon" --
                      "tube", "cannon". The name comes from the fact that a
                      cannon has a long cylindrical reed-like shape.
                      <div></div>
                      <strong>Related to:</strong> canon, canyon, channel,
                      canal, cane
                      <div></div>
                      <strong>Not related to:</strong> cannabis
                      <div></div>
                      <strong>Cognates:</strong> canon 🇫🇷, canhão 🇵🇹, cañón 🇪🇸,
                      kanon 🇸🇪, cannone 🇮🇹, Kanone 🇩🇪, kanon 🇩🇰, kanyon 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;canon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/ --
                      "reed", via Latin "canōn", via Ancient Greek "κανών"
                      /kanṓn/ -- “measuring rod", "standard” and Latin "canōn"
                      -- "a measuring line", "precept", "rule".
                      <div></div>
                      <strong>Related to:</strong> cannon, canyon, channel,
                      canal, cane
                      <div></div>
                      <strong>Not related to:</strong> cannabis
                      <div></div>
                      <strong>Cognates:</strong> kanun 🇦🇱, канон 🇧🇬, kanon 🇩🇰,
                      kanon 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canyon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;canyon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/ --
                      "reed", via the Ancient Greek "κάννα" /kánna/ -- “reed”,
                      Latin "canna" -- "reed", and the Spanish "caño" -- "pipe",
                      "tube". The name comes from the fact that a canyon has a
                      long cylindrical reed-like shape (<i>i.e.</i>, it is an
                      elongated and semicylindrical surface that conducts water,
                      like a pipe or a tube).
                      <div></div>
                      <strong>Ancestor:</strong> cañón 🇪🇸
                      <div></div>
                      <strong>Related to:</strong> cannon, channel, canal, cane,
                      canon
                      <div></div>
                      <strong>Not related to:</strong> cannabis
                      <div></div>
                      <strong>Cognates:</strong> canyon 🇫🇷, canhão 🇵🇹, kanjon
                      🇸🇪, каньо́н 🇷🇺, kanion 🇵🇱, kanjon 🇸🇮, каньо́н 🇧🇬, kanjons
                      🇱🇻, каньон 🇰🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/car.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;car"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱr̥sós" -- "vehicle", via the Latin "carrus" --
                      "two-wheeled baggage wagon", "cart" and the Old French
                      "carre" - "cart".
                      <div></div>
                      <strong>Related to:</strong> cart, horse
                      <div></div>
                      <strong>Not related to:</strong> carpet
                      <div></div>
                      <strong>Cognates:</strong> <u>kar</u>ozza 🇲🇹
                      <div></div>
                      <strong>Descendants:</strong> ကား 🇲🇲, carr 🇮🇪, kā 🇹🇴, car
                      🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/carpet.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;carpet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Old Armenian
                      "կապ" /kap/ -- "knot", "bond" and later "կապերտ" /kapert/
                      -- "rag". The theory stems from the fact that knotted
                      Armenian carpets were exported to Europe via Florence in
                      the Middle Ages.
                      <div></div>
                      <strong>Likely ancestor:</strong> կարպետ 🇦🇲
                      <div></div>
                      <strong>Not related to:</strong> car, cart, horse
                      <div></div>
                      <strong>Descendants:</strong> カーペット 🇯🇵
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cave.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cave"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", and its derivative noun "cavea" – "hollow
                      place", "enclosure for animals", via the Old French "cave"
                      -- "cavity", "hollow place in the earth", and the Middle
                      English "cave".
                      <div></div>
                      <strong>Related to:</strong> cage, cavity, jail, cajole (
                      <i>v.</i>)<div></div>
                      <strong>Cognates:</strong> caverna 🇮🇹, cueva 🇪🇸, caverne
                      🇫🇷, caverna 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cavity.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cavity"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", via the Middle French "cavité" -- "cavity".
                      <div></div>
                      <strong>Related to:</strong> cage, cave, jail, cajole (
                      <i>v.</i>)<div></div>
                      <strong>Cognates:</strong> cavità 🇮🇹, cavidad 🇪🇸, cavité
                      🇫🇷, cavidade 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ceiling.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qf-snhErvDc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ceiling"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cēlāre" --
                      "to hide", "to conceal” via the French verb "celer" -- "to
                      conceal", "to cover with paneling" and the Middle English
                      verb "ceil" -- "to panel a room", "to put a cover or
                      ceiling over" plus the suffix "-ing" -- (used to form
                      nouns <i>e.g.</i>, gerunds).
                      <div></div>
                      <strong>Related to:</strong> conceal (v.), color
                      <div></div>
                      <strong>Descendants:</strong> siling 🇲🇾, <u>síl</u>eáil 🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cmentarz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cemetery"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "κοιμητήριον"
                      /koimētḗrĭon/ -- "place to sleep", "dormitory".
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cimitir 🇷🇴, cemitério 🇵🇹, cmentarz 🇵🇱, sementeryo 🇵🇭,
                      cimetière 🇫🇷, cementerio 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/channel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;channel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sumerian 𒄀𒈾 /gi.na/ --
                      "reed", via Ancient Greek "κάννα" /kánna/ -- “reed”, and
                      Latin "canna" -- "reed". The name comes from the fact that
                      a canal has a long cylindrical reed-like shape.
                      <div></div>
                      <strong>Related to:</strong> canyon, cannon, channel,
                      cane, canon
                      <div></div>
                      <strong>Not related to:</strong> cannabis
                      <div></div>
                      <strong>Cognates:</strong> kanaal 🇳🇱, canal 🇷🇴, kanal 🇸🇪,
                      kanal 🇳🇴, канал 🇹🇯, кана́л 🇷🇺, کانال 🇮🇷, cainéal 🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chaos.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chaos"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> from the Ancient Greek "χάος"
                      /kháos/ -- “chasm", "void", "empty space”.
                      <div></div>
                      <strong>Related to:</strong> gas, gasoline
                      <div></div>
                      <strong>Cognates:</strong> chaos 🇨🇿, kaos 🇩🇰, ქაოსი 🇬🇪,
                      χάος 🇬🇷, kaaos 🇫🇮, haos 🇷🇴, ха́ос 🇷🇺, caos 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chaste.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;chaste (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "castus" -- "pure"
                      via the Old French "chaste" -- "morally pure".
                      <div></div>
                      <strong>Related to:</strong> in<u>cest</u>
                      <div></div>
                      <strong>Not related to:</strong> insect, sex
                      <div></div>
                      <strong>Cognates:</strong> casto 🇪🇸, chaste 🇫🇷, casto 🇵🇹,
                      cast 🇷🇴, cast 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cheese"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product".
                      <div></div>
                      <strong>Cognates:</strong> Käse 🇩🇪, kaas 🇳🇱, queso 🇪🇸,
                      queijo 🇵🇹
                      <div></div>
                      <strong>Descendants:</strong> चीज़ 🇮🇳, チーズ 🇯🇵, 치즈 🇰🇷,
                      චීස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chocolate.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chocolate"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water", or from the Yucatec
                      Mayan "chokolātl" -– "hot water". In both variants the
                      latter element descends from the Proto-Uto-Aztecan "*pa"
                      -- "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestor:</strong> chocolate 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> شکلات 🇮🇷, siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿,
                      seacláid 🇮🇪, coklat 🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳,
                      チョコレート 🇯🇵, 초콜릿 🇰🇷, چاکْلیٹ 🇵🇰
                      <div></div>
                      <strong>Cognates:</strong> tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ
                      🇱🇦, chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat
                      🇫🇷, xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/climate.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;climate"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west.
                      <div></div>
                      <strong>Related to:</strong> incline
                      <div></div>
                      <strong>Cognates:</strong> climat 🇫🇷, klimaat 🇳🇱, кли́мат
                      🇷🇺, κλίμα 🇬🇷, iklim 🇮🇩, iqlim 🇺🇿, iklim 🇹🇷, ַַאַקְלִים 🇮🇱,
                      اِقْلِیم 🇮🇷. clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cloak.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cloak"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Celtic
                      "*klokkos" -- "bell" via the Medieval Latin "clocca" --
                      "bell" and the Old Northern French "cloque" -- "travelling
                      cloak". The word got its name from the "cloque's"
                      bell-like shape.
                      <div></div>
                      <strong>Related to:</strong> clock
                      <div></div>
                      <strong>Cognates:</strong> clogyn 🏴󠁧󠁢󠁷󠁬󠁳󠁿, klok 🇳🇱, klukka 🇮🇸,
                      clóca 🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/clock.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;clock"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Celtic
                      "*klokkos" -- "bell" via the Medieval Latin "clocca" --
                      "bell". The word emerged in the Middle Ages with the
                      emergence of mechanical clocks, which first emerged in the
                      late 13th century and had a small bell that would ring at
                      intervals, for example, to remind monks in a monastery
                      when it was time for prayer.
                      <div></div>
                      <strong>Related to:</strong> cloak
                      <div></div>
                      <strong>Cognates:</strong> cloch 🏴󠁧󠁢󠁷󠁬󠁳󠁿, klok 🇳🇱, klukka 🇮🇸,
                      clog 🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/coffee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;coffee"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then spread to Italian and other
                      European languages (and all around the world).
                      <div></div>
                      <strong>Ancestors:</strong> قَهْوَة 🇸🇦, koffie 🇳🇱, caffè
                      🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> café 🇫🇷, café 🇪🇸, Kaffee 🇩🇪,
                      ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰,
                      kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦,
                      ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴, کافی 🇵🇰, кофе 🇰🇿,
                      kafe 🇲🇬, 咖啡 🇹🇼, қаҳва 🇹🇯, قهوه 🇮🇷, コーヒー 🇯🇵, 咖啡 🇨🇳,
                      커피 🇰🇷, ກາເຟ 🇱🇦, កាហ្វេ 🇰🇭, кофе 🇲🇳, cà phê 🇻🇳, ကော်ဖီ
                      🇲🇲, ყავა 🇬🇪, กาแฟ 🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, kahawa 🇹🇿, কফি
                      🇧🇩, ކޮފީ 🇲🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/color.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qf-snhErvDc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;color"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱel-" -- "to cover", via the Latin "color" and the Old
                      French "color".
                      <div></div>
                      <strong>Related to:</strong> <u>ceil</u>ing, conceal (v.)
                      <div></div>
                      <strong>Cognates:</strong> couleur 🇫🇷, color 🇪🇸, colore
                      🇮🇹, cor 🇵🇹, culoare 🇷🇴, kleur 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/come.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/t4CwXz_CSU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;come (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*gʷémt" -- "to step" via the Proto-Germanic verb
                      "*kwemaną" -- "to come".
                      <div></div>
                      <strong>Cognates:</strong> kommen 🇩🇪, komen 🇳🇱, komme 🇳🇴,
                      koma 🇮🇸, venir 🇫🇷, vir 🇵🇹
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/county.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/M2lknMW7HiI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;computer"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "computō" --
                      "to calculate", "to compute", "to reckon with" (which
                      itself is a combination of the prefix "com-" - "with", and
                      the verb "putō" -- "to reckon").
                      <div></div>
                      <strong>Related to:</strong> count (<i>v.</i>)<div></div>
                      <strong>Not related to:</strong> country, county
                      <div></div>
                      <strong>Desdendants:</strong> computadora 🇪🇸, computador
                      🇵🇹, computer 🇮🇹, computer 🇷🇴, Computer 🇩🇪, kompiuteris 🇱🇹,
                      компютър 🇧🇬, kompjuter 🇦🇱, комп'ю́тер 🇺🇦, компью́тер 🇷🇺,
                      کَمْپْیُوٹَر 🇵🇰, компьютер 🇰🇿, کامپیوتر 🇮🇷, コンピュータ
                      🇯🇵, 컴퓨터 🇰🇷, កុំព្យូទ័រ 🇰🇭, компьютер 🇲🇳, ကွန်ပျူတာ 🇲🇲,
                      კომპიუტერი 🇬🇪, คอมพิวเตอร์ 🇹🇭, kompyuta 🇹🇿, ኮምፕዩተር 🇪🇷,
                      komputer 🇮🇩, कम्प्युटर 🇳🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/conceal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qf-snhErvDc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;conceal (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin verb
                      "cēlāre" -- "to hide", "to conceal” and the prefix "con-"
                      -- "together", "with".
                      <div></div>
                      <strong>Related to:</strong> <u>ceil</u>ing, color
                      <div></div>
                      <strong>Cognates:</strong> ceil 🇮🇪, celare 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/conscience.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/DJ-ABPy6Udw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;conscience"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cōnsciō" --
                      "to be conscious of", "have on one's conscience", which is
                      a combination of the prefix "con-" -- "together", "with"
                      and the verb "sciō" -- "to know". A "conscience" therefore
                      literally means "being with knowledge".
                      <div></div>
                      <strong>Related to:</strong> nice (adj.), science,
                      conscious (adj.)
                      <div></div>
                      <strong>Cognates:</strong> conciencia 🇪🇸, consciência 🇵🇹,
                      conscience 🇬🇧, coscienza 🇮🇹, conștiință 🇷🇴, coinsias 🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/consider.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/OyZjPK6RSss"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;consider (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely a combination of the Latin
                      prefix "con-" -- "together", "with", and the noun "sīdus"
                      -- "star(s)". The origin of the word is linked to the
                      notion of ancient peoples looking at the sky and gaining
                      insight by considering the movements of the stars.
                      <div></div>
                      <strong>Likely related to:</strong> de<u>sire</u>
                      <div></div>
                      <strong>Cognates:</strong> considérer 🇫🇷, considerar 🇪🇸,
                      considerar 🇵🇹, considerare 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/conspiracy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;conspiracy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cōnspīrō" --
                      "to agree", "to unite", "to plot", and the action-noun
                      suffix "-tiō". Literally, "to conspire" means "to breathe
                      together".
                      <div></div>
                      <strong>Related to:</strong> in<u>spire</u>, per
                      <u>spire</u>, ex<u>pire</u>, spirit
                      <div></div>
                      <strong>Cognates:</strong> cospirazione 🇮🇹, conspiración
                      🇪🇸, conspiração 🇵🇹, konspirasi 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/corner.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;corner"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Latin “cornū” --
                      “end”, “horn”, “place where two converging lines meet”.
                      <div></div>
                      <strong>Related to:</strong> horn, hornet
                      <div></div>
                      <strong>Semantic equivalents:</strong> 角 🇨🇳, 각 🇰🇷, 角
                      🇯🇵, góc 🇻🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/county.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/M2lknMW7HiI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;count"
                  hoverText={
                    <span>
                      <strong>
                        <u>"nobleman"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Latin "comes" --
                        "companion" via the Old French "comte" -- "count".
                        <div></div>
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Not related to:</strong> count (v.), country
                        <div></div>{" "}
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Related to:</strong> county
                        <div></div>{" "}
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> comte 🇫🇷, conde 🇪🇸, conde 🇵🇹,
                        κόμης 🇬🇷, comte 🇦🇩, comite 🇷🇴
                        <div></div>{" "}
                      </div>
                      <strong>
                        <u>
                          "<i>verb</i>: to recite a sequence of numbers"
                        </u>
                      </strong>{" "}
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Latin verb "computō"
                        -- "to calculate", "to compute", "to reckon with" (which
                        itself is a combination of the prefix "com-" - "with",
                        and the verb "putō" -- "to reckon"), via the Old French
                        verb "conter" -- "to add up", "to tell a story”.
                        <div></div>
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Not related to:</strong> count, country
                        <div></div>
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Related to:</strong> computer
                        <div></div>{" "}
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> compter 🇫🇷, contar 🇪🇸, contar
                        🇵🇹, contare 🇮🇹
                        <div></div>
                      </div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/country.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/M2lknMW7HiI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;country"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Vulgar Latin phrase
                      "terra contrāta" -- "land lying opposite" (the first
                      element was eventually dropped). In the Middle Ages, when
                      people in a walled city looked beyond the city walls, the
                      land facing them on the other side of the wall was called
                      the “terra contrata”. Over time the noun came to denote
                      the people who inhabited the area beyond the city walls,
                      and eventually the word carried much more political and
                      geographical connotations.
                      <div></div>
                      <strong>Not related to:</strong> county, count
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/county.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/M2lknMW7HiI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;county"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "comitātus" --
                      "jurisdiction of a count", via the Old French "counté" --
                      "land ruled by a count or countess".
                      <div></div>
                      <strong>Not related to:</strong> country, count (<i>v.</i>
                      )<div></div>
                      <strong>Cognates:</strong> comté 🇫🇷, condado 🇪🇸, condado
                      🇵🇹, contea 🇮🇹, contae 🇮🇪, comitat 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/craze.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;craze"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old Norse verb "*krasa"
                      –- "to shatter" (which itself is likely of onomatopoeic
                      origin), via the Middle English verb "crasen" -– "to
                      crush", "to break (to pieces)", “to shatter".
                      <div></div>
                      <strong>Related to:</strong> crazy (<i>adj.</i>)
                      <div></div>
                      <strong>Possibly related to:</strong> crash (<i>v.</i>)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/crazy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;crazy (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old Norse verb "*krasa"
                      –- "to shatter" (which itself is likely of onomatopoeic
                      origin), via the Middle English verb "crasen" -– "to
                      crush", "to break (to pieces)", “to shatter" and the Early
                      Modern English verb "craze" –- "to weaken", "to impair".
                      Over time, the word became more generally associated with
                      a disease, or ailment of the mind (<i>i.e.</i>, a body
                      that was considered "broken"), and then gradually became
                      an adjective.
                      <div></div>
                      <strong>Related to:</strong> craze
                      <div></div>
                      <strong>Possibly related to:</strong> crash (<i>v.</i>)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/crimson.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;crimson"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-Iranian noun
                      "*kŕ̥miš" -- "worm". The word comes from the crimson dye
                      produced by a worm-like insect called "kermes".
                      <div></div>
                      <strong>Cognates:</strong> cramoisi 🇫🇷, قِرْمِزِيّ 🇸🇦,
                      cremisi 🇮🇹, carmesim 🇵🇹, क़िरमिज़ी 🇮🇳, karmosin 🇸🇪,
                      червоний 🇺🇦, czerwony 🇵🇱, червен 🇧🇬, црвен 🇲🇰, červený 🇸🇰,
                      чырво́ны 🇧🇾 kırmızı 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cubicle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cubicle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cubō" -- "to
                      lie down" via "cubiculum" -- "small bedroom".
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/curfew.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/suyCgi6wEos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;curfew"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Old French "cuevre-fu" (
                      <i>lit.</i> "cover fire"), from the medieval practice of
                      ringing a bell every evening to signal that fires should
                      be put out for the night.
                      <div></div>
                      <strong>Cognates:</strong> couvre-feu 🇫🇷, coprifuoco 🇮🇹
                      <div></div>
                      <div></div>
                      <strong>Semantic equivalents:</strong> avondklok 🇳🇱, toque
                      de queda 🇪🇸, toque de recolher 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/danger.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qJKkaRTmYbs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;danger"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "dominus" --
                      "lord", "master" via the Vulgar Latin "*dominārium" --
                      “authority", "power”, the Old French "dangier" -- "power
                      (to harm)", "mastery", "authority", "control", and the
                      Middle English "daunger" -- "danger", "peril", "hazard".
                      The meaning of the word comes from the concept of being
                      under the power of someone else (<i>e.g.,</i> a feudal
                      lord), which, in the feudal Europe of the Middle Ages,
                      could definitely be hazardous.
                      <div></div>
                      <strong>Related to:</strong> dungeon
                      <div></div>
                      <strong>Cognates:</strong> danger 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/defeat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/MWWZM7nhMIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;defeat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "dis-" --
                      "(reversal)", "un-" + verb "faciō" -- “to do", "to make",
                      via the Old French verb "desfaire" -- "to undo". The word,
                      therefore, is the opposite of "a feat" -- (<i>lit.</i>{" "}
                      "something done", "something accomplished") <i>i.e.</i>,
                      it is something not done (successfully), not accomplished.
                      <div></div>
                      <strong>Related to:</strong> feat, fact
                      <div></div>
                      <strong>Cognates:</strong> défaite 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/defenestration.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;defenestration"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin preposition "dē"
                      -- “from, out” + "fenestra" -- “window”.
                      <div></div>
                      <strong>Cognates:</strong> défenestration 🇫🇷,
                      defenestrazione 🇮🇹, <u>Fenster</u>sturz 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/deport.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;deport (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French "deporter" -- "to amuse", "to
                      entertain".
                      <div></div>
                      <strong>Ancestor:</strong> déporter 🇫🇷
                      <div></div>
                      <strong>Related to:</strong> sport
                      <div></div>
                      <strong>Cognates:</strong> deportar 🇵🇹, deportare 🇭🇺,
                      deportar 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/derive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;derive (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "dē-" --
                      "away" and the noun "rīvus" -- "brook", "small stream of
                      water" thus to "derive" literally means "to lead (a stream
                      of water) from its source".
                      <div></div>
                      <strong>Not related to:</strong> arrive (v.), river,
                      riparian
                      <div></div>
                      <strong>Related to:</strong> rival
                      <div></div>
                      <strong>Cognates:</strong> derivar 🇵🇹, derivar 🇪🇸, deriva
                      🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/desire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/OyZjPK6RSss"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;desire"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely a combination of the Latin
                      prefix "de-" -- "of", "from" and the genitive form
                      "sīderis" of the noun "sidus" -- "star(s)", "of the
                      star(s)", via the verb "dēsīderō" -- "to long for",
                      "desire", and the Old French verb "desirrer" -- "to
                      covet", "to desire". In ancient times, people would look
                      to the positions of stars to try to gain some insights on
                      the future, but at times it would be cloudy, and there
                      would be no stars, so they would get "desiderium", that
                      is, a yearning for their lost celestial guides.
                      <div></div>
                      <strong>Likely related to:</strong> con<u>sider</u>
                      <div></div>
                      <strong>(Possible) Cognates:</strong> desire 🇬🇧, desiderio
                      🇮🇹, (deseo 🇪🇸), (desejo 🇵🇹)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/detail.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;detail"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French prefix "de-"
                      -- (prefix indicating separation) and the verb "taillier"
                      -- "to cut". A "detail" is literally what you get when you
                      stop focusing on the big picture but instead "cut it up"
                      into dozens of individual segments and focus on those
                      instead.
                      <div></div>
                      <strong>Not related to:</strong> tail (on animals)
                      <div></div>
                      <strong>Related to:</strong> retail, entail (v.), tailor
                      <div></div>
                      <strong>Cognates:</strong> dettaglio 🇮🇹, detail 🇳🇱,
                      detalle 🇪🇸, detalhe 🇵🇹, détail 🇫🇷, detay 🇹🇷, detaliu 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/disappoint.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mn09t2xE2QU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;disappoint (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle French verb
                      "desapointer" -- "to un-appoint", "to remove from office".
                      The word derives from the emotion frequently experienced
                      after missing out on a promotion and/or losing one's job.
                      <div></div>
                      <strong>Related to:</strong> appoint (v.), point
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/disaster.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Gt0B3coiu7s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;disaster"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "dis-" --
                      (used to convey negation/separation) and the noun
                      "-astrum". A "disaster" is literally a "negative (
                      <i>i.e.</i>, unlucky) star". In ancient times catastrophes
                      were often thought to be the results of misalignments of
                      planets and stars in the sky.
                      <div></div>
                      <strong>Related to:</strong> <u>astro</u>nomy, star
                      <div></div>
                      <strong>Cognates:</strong> desastre 🇪🇸, desastre 🇵🇹,
                      désastre 🇫🇷, dezastru 🇷🇴, disastro 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/distance.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sJgO6bNR7x4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;distance"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the present participle of
                      the Latin verb "distō" -- "to stand apart", "to be
                      distant" (itself a combination of the prefix "dis-" --
                      "apart" "in two" and the verb "stō" -- "to stand"), via
                      the Old French "destance" -- "debate", "distinction",
                      "quarrel", "dispute". The concept comes from the idea that
                      when people argue, they’re not on the same page (or
                      really, in the same place). Therefore, they stand apart,
                      and there is "distance" between them.
                      <div></div>
                      <strong>Related to:</strong> stance
                      <div></div>
                      <strong>Cognates:</strong> distancia 🇪🇸, distância 🇵🇹,
                      distance 🇫🇷, distanță 🇷🇴, distanza 🇮🇹
                      <div></div>
                      <strong>Semantic equivalents:</strong> afstand 🇩🇰, avstånd
                      🇸🇪, afstand 🇳🇱
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/double.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;double (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*dwóh₁" -- "two", via the Latin "duplus" -- “twofold”.
                      <div></div>
                      <strong>Related to:</strong> two, twig, twin
                      <div></div>
                      <strong>Cognates:</strong> double 🇫🇷, doble 🇪🇸, doppio 🇵🇹,
                      dubbel 🇳🇱, doppel 🇩🇪, подвійний 🇺🇦, dvojitý 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dungeon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qJKkaRTmYbs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dungeon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "dominus" --
                      "lord", "master" via the Old French "donjon" -- "tower
                      inside a fortress", "castle residence", "dominant building
                      -<i>i.e.</i>, home of the dominus".
                      <div></div>
                      <strong>Related to:</strong> danger
                      <div></div>
                      <strong>Cognates:</strong> donjon 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/acrid.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;eager (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "ācer" -- “sour”.
                      <div></div>
                      <strong>Related to:</strong> acrid, vin<u>egar</u>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/east.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;east"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₂ewsér" -- "in the direction of dawn", "east", via the
                      Proto-Germanic "*austrą" -- "east" and the Old English
                      "ēast" -- "east".
                      <div></div>
                      <strong>Cognates:</strong> Osten 🇩🇪, oosten 🇳🇱, este 🇪🇸,
                      est 🇫🇷, est 🇮🇹, øst 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ecology.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ecology"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "οἶκος"
                      /oîkos/ -- "dwelling place", "house" and "-λογία" /-logía/
                      -- “study of”.
                      <div></div>
                      <strong>Ancestor:</strong> Ökologie 🇩🇪
                      <div></div>
                      <strong>Related to:</strong> <u>eco</u>nomy
                      <div></div>
                      <strong>Cognates:</strong> écologie 🇫🇷, ecología 🇪🇸,
                      ecologia 🇵🇹, ecologie 🇷🇴, ecologia 🇮🇹, økologi 🇳🇴, økologi
                      🇩🇰, οικολογία 🇬🇷, ეკოლოგია 🇬🇪, эколо́гия 🇷🇺, ekologi 🇮🇩,
                      ekoloģija 🇱🇻, אקולוגיה 🇮🇱, էկոլոգիա 🇦🇲, ökológia 🇭🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/economy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;economy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "οἰκονομία"
                      /oikonomía/ -- "management of a household (a combination
                      of "οἶκος" /oîkos/ -- "house", "dwelling place" and the
                      verb "νέμω" /némō/ -- "to distribute", "to allocate”).
                      Originally, the word denoted the concept of properly
                      allocating and distributing the resources within one's
                      house.
                      <div></div>
                      <strong>Related to:</strong> <u>eco</u>logy, numb (adj.)
                      <div></div>
                      <strong>Cognates:</strong> économie 🇫🇷, economía 🇪🇸,
                      economia 🇵🇹, economie 🇷🇴, economia 🇮🇹, økonomi 🇳🇴, økonomi
                      🇩🇰, οικονομία 🇬🇷, ეკონომია 🇬🇪, эконо́мия 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/elbow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;elbow"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*alinō"
                      -- “forearm" + "*bugô" -- "bend", so literally, "place
                      where the forearm bends".
                      <div></div>
                      <strong>Related to:</strong> bow (as in "crossbow")
                      <div></div>
                      <strong>Cognates:</strong> Ellenbogen 🇩🇪, elleboog 🇳🇱,
                      albue 🇩🇰, albue 🇳🇴, ло́коть 🇷🇺, łokieć 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/elephant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;elephant"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek genitive
                      noun "ἐλέφαντος" /eléphăntos/ -- "(pertaining to) ivory",
                      via the Latin "elephantus" -- "elephant".
                      <div></div>
                      <strong>Cognates:</strong> elefante 🇪🇸, éléphant 🇫🇷,
                      elefante 🇵🇹, elefant 🇩🇰, elefante 🇮🇹, elefant 🇷🇴, Elefant
                      🇩🇪, olifant 🇳🇱, elefant 🇳🇴, elefant 🇸🇪
                      <div></div>
                      <strong>Descendants:</strong> eliffant 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/enemy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;enemy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "inimīcus" (
                      <i>i.e.</i>, "in-" -- “not” + "amīcus" - “friend”) via the
                      Old French "enemi" -- "non-friend", "enemy".
                      <div></div>
                      <strong>Cognates:</strong> ennemi 🇫🇷, enemigo 🇪🇸, inimigo
                      🇵🇹, inamic 🇷🇴, nemico 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/entail.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;entail (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French prefix "en-"
                      -- (prefix indicating cause) and the verb "taillier" --
                      "to cut", via the Old French verb "tailler" -- "to
                      restrict (in the legal sense)".
                      <div></div>
                      <strong>Not related to:</strong> tail (on animals)
                      <div></div>
                      <strong>Related to:</strong> retail, detail, tailor
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/entomology.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;entomology"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ἔντομον"
                      /én.to.mon/ -- "insect" (<i>lit.</i> "cut into sections").
                      The word comes from the observation that insects are
                      physically separated (or "cut") into three separate
                      sections (head, thorax, abdomen).
                      <div></div>
                      <strong>Cognates:</strong>
                      entomologie 🇫🇷, entomología 🇪🇸, entomologia 🇵🇹,
                      entomologia 🇮🇹, entomologie 🇷🇴, ентомоло́гія 🇺🇦,
                      entomoloġija 🇲🇹, אֶנְטוֹמוֹלוֹגְיָה 🇮🇱, ентомоло́гија 🇲🇰,
                      ენტომოლოგია 🇬🇪, entomologi 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/envy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;envy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin prefix
                      "in-" -- “on", "upon" and the verb "videō" -- “to look",
                      "see", via the verb "invidere" -- "to look at with
                      malice”" and the noun "invidia" -- "malicious look",
                      "envy".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dence</u>, pru
                      <u>dence</u>, visa, vision, visit, video, ad<u>vice</u>
                      <div></div>
                      <strong>Cognates:</strong> envie 🇫🇷, envidia 🇪🇸, inveja
                      🇵🇹, invidie 🇷🇴, за́<u>висть</u> 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/epilogue.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/tOnL1s10mE4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;epilogue"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ἐπῐ́λογος"
                      /epĭ́logos/ -- "conclusion (of a speech)", "inference",
                      which is a combination of the prefix "ἐπῐ-" /epĭ-/ --
                      “on”, "in addition" and the noun "λόγος" /lógos/ --
                      "speech".
                      <div></div>
                      <strong>Related to:</strong> apo<u>logy</u>, pro
                      <u>logue</u>
                      <div></div>, etymo<u>logy</u>
                      <strong>Cognates:</strong> epílogo 🇪🇸, epílogo 🇵🇹,
                      épilogue 🇫🇷, epilog 🇷🇴, epilogo 🇮🇹, epilogas 🇱🇻, epilogs
                      🇱🇻, epiloog 🇳🇱, эпило́г 🇷🇺, епіло́г 🇺🇦, epilog 🇦🇱, epíleg 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/etymology.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/tOnL1s10mE4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;etymology"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ἔτυμον"
                      /étumon/ -- “true sense”, and the suffix "-λογία" /-logía/
                      -- “study or logic of”. "Etymology" is therefore the study
                      of the true (<i>i.e.</i>, original) meaning of a word.
                      <div></div>
                      <strong>Related to:</strong> apo<u>logy</u>, pro
                      <u>logue</u>, epi<u>logue</u>
                      <div></div>
                      <strong>Cognates:</strong> etimología 🇪🇸, etimologia 🇵🇹,
                      étymologie 🇫🇷, etimologie 🇷🇴, etimologia 🇮🇹, etymologi 🇸🇪,
                      etymologi 🇩🇰, etimoloģija 🇱🇻, etymologie 🇳🇱, етимоло́гия
                      🇧🇬, етимоло́гія 🇺🇦, etimológia 🇭🇺, etimologji 🇦🇱, etimologi
                      🇲🇾, этимология 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/eve.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;eve"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*ēbanþs"
                      –- "evening", via the Old English "ǣfen" –- "evening",
                      "day before".
                      <div></div>
                      <strong>Related to:</strong> eve
                      <div></div>
                      <strong>Not related to:</strong> even (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> aften 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/even.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;even (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*ebnaz"
                      -- "even", "level", via the Proto-West-Germanic "*ebn" --
                      "even", "level" and the Old English "efn" -- "flat",
                      "level", "even", "equal".
                      <div></div>
                      <strong>Not related to:</strong> evening, eve
                      <div></div>
                      <strong>Cognates:</strong> eben 🇩🇪, even 🇳🇱, jafn 🇮🇸, jämn
                      🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/evening.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;evening"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*ēbanþs"
                      –- "evening", via the Old English "ǣfen" –- "evening",
                      "day before", "beginning of the day".
                      <div></div>
                      <strong>Related to:</strong> eve
                      <div></div>
                      <strong>Not related to:</strong> even (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> Abend 🇩🇪, avond 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/evidence.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;evidence"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin
                      preposition "ē" -- "out", (in the sense "out in plain
                      view") and the verb "videō" -- "to see", via the adjective
                      "ēvidēns" -- "visible", "apparent", "clear", "plain", and
                      the Old French adjective "evident" -- "clear", "apparent".
                      <div></div>
                      <strong>Related to:</strong> en<u>vy</u>, pru<u>dence</u>,
                      visa, vision, visit, video, ad<u>vice</u>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/expire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;expire (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "ex-" --
                      "out" and the verb "spīrō" -- "to breathe" (<i>i.e.</i>,
                      "breathing out (one's last breath")).
                      <div></div>
                      <strong>Related to:</strong> spirit, in<u>spire</u>, per
                      <u>spire</u>, con<u>spir</u>acy
                      <div></div>
                      <strong>Cognates:</strong> expirar 🇪🇸, expirer 🇫🇷, expirar
                      🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/eye.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;eye"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃ekʷ-" -- "eye", "to see" via the Proto-Germanic
                      "*augô" -- “eye” and the Old English "ēage" -- “eye”.
                      <div></div>
                      <strong>Related to:</strong> wind<u>ow</u>
                      <div></div>
                      <strong>Cognates:</strong> ojo 🇪🇸, œil 🇫🇷, olho 🇵🇹, occhio
                      🇮🇹, ochi 🇷🇴, Auge 🇩🇪, oog 🇳🇱, øye 🇩🇰, øye 🇳🇴, öga 🇸🇪, oko
                      🇵🇱, oko 🇸🇮, oko 🇭🇷, око́ 🇧🇬, acs 🇱🇻, akis 🇱🇹, sy 🇦🇱, աչք 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fact.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/MWWZM7nhMIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fact"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "faciō" --
                      “to do", via the perfect passive participle form "factus"
                      -- “done or made", <i>i.e</i>, "something that happened".
                      <div></div>
                      <strong>Related to:</strong> de<u>feat</u>, feat
                      <div></div>
                      <strong>Cognates:</strong> hecho 🇪🇸, fait 🇫🇷, facto 🇵🇹,
                      факт 🇷🇺, fatto 🇮🇹, fapt 🇷🇴, Fakt 🇩🇪, feit 🇳🇱, faktum 🇳🇴,
                      faktum 🇸🇪, fakt 🇵🇱, fakt 🇸🇰, факт 🇧🇬, fakts 🇱🇻, faktas 🇱🇹,
                      fakt 🇦🇱, fakt 🇪🇪, факт 🇰🇿, факт 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;family"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Cognates:</strong> familia 🇪🇸, familja 🇲🇹, famille
                      🇫🇷, familie 🇩🇰, familie 🇳🇴, pamilya 🇵🇭, Familie 🇩🇪,
                      famiglia 🇮🇹, família 🇵🇹, familie 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fact.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/MWWZM7nhMIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;feat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "faciō" --
                      “do", indicating something done successfully,
                      accomplished.
                      <div></div>
                      <strong>Related to:</strong> de<u>feat</u>, fact
                      <div></div>
                      <strong>Cognates:</strong> feito 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/feather.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;feather"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*péth₂r̥" -- “feather", "wing”, via the Proto-Germanic
                      "*feþrō" -- "feather" and the Old English "feþer".
                      <div></div>
                      <strong>Related to:</strong> pen, <u>ptero</u>dactyl,
                      helic
                      <u>opter</u>
                      <div></div>
                      <strong>Cognates:</strong> φτερό 🇬🇷, Feder 🇩🇪, veer 🇳🇱,
                      fjær 🇳🇴, fjer 🇩🇰, fjöður 🇮🇸, fjäder 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/flour.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;flour"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Latin "flōs" (and
                      its accusative form "flōrem") –- “flower”, “blossom”, and
                      the Old French "flor" – "the finest part (of the grain)".
                      <div></div>
                      <strong>Related to:</strong> flower, bloom (<i>v</i>.),
                      blossom (<i>v</i>.), flourish
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/flower.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;flower"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Latin "flōs" (and
                      its accusative form "flōrem") –- “flower”, “blossom”, the
                      Old French "flor" – “the finest part (of the grain)", and
                      the Middle English "flower" -- "the finest part (of a
                      plant)".
                      <div></div>
                      <strong>Related to:</strong> flour, bloom (<i>v</i>.),
                      blossom (<i>v</i>.), flourish (<i>v</i>.), cauli
                      <u>flower</u>
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, flor 🇵🇹, flor 🇪🇸,
                      fiore 🇮🇹, fleur 🇫🇷, blomst 🇳🇴, blomst 🇩🇰, blomma 🇸🇪, Blume
                      🇩🇪, floare 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/foot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;foot"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Proto-Germanic
                      "*fōts" -- "foot" and the Old English "fōt" -- "foot".
                      <div></div>
                      <strong>Related to:</strong> pedal, pilot, pedestrian
                      <div></div>
                      <strong>Cognates:</strong> Fuß 🇩🇪, voet 🇳🇱, pie 🇪🇸, pied
                      🇫🇷, πόδι 🇬🇷, fot 🇸🇪, پا 🇮🇷, پَاؤُں 🇵🇰, पैर 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fungus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fungus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "σφόγγος"
                      /sphóngos/ -- "sponge".
                      <div></div>
                      <strong>Related to:</strong> sponge
                      <div></div>
                      <strong>Cognates:</strong> hongo 🇪🇸, fungo 🇵🇹
                      <div></div>
                      <strong>Semantic Equivalents:</strong> svamp 🇩🇰, svamp 🇸🇪,
                      zwam 🇳🇱
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/garbage.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1-1U32CjI3w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;garbage"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Probably from the
                      Proto-Germanic verb "*garwijaną" -- "to prepare", via the
                      Frankish verb "garwijan" -- "to make ready", and the Old
                      French verb "garber" -- "to refine", "to make neat or
                      clean” (in the context of food being prepared for
                      consumption). The word was a derivative of the Old French
                      verb and originally denoted "the offal of a fowl",
                      "giblets, "kitchen waste", which were purged away from
                      meat during the "garbage" process.
                      <div></div>
                      <strong>Likely related to:</strong> gear, garb
                      <div></div>
                      <strong>Not related to:</strong> garage
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to :</strong> chaos, gasoline
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gaz 🇫🇷, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gasoline.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gasoline"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of: 1) "gas", from
                      the Dutch "gas", which was coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, 2) "-ol" -- (suffix for
                      oils, from the Latin "oleum" -- "oil", "olive oil") and 3)
                      "-ine" -- (chemical suffix). The word's modern form was
                      perhaps also influenced by the name "Cassell" (John
                      Cassell was a British entrepreneur who first marketed the
                      product in the 1860s).
                      <div></div>
                      <strong>Related to :</strong> chaos, gas
                      <div></div>
                      <strong>Cognates:</strong> gasolina 🇪🇸, gasolina 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1-1U32CjI3w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gear"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Germanic
                      verb "*garwijaną" -- "to prepare", via the Old Norse
                      "gørvi" -- "gear".
                      <div></div>
                      <strong>Likely related to:</strong> garbage
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gem.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gem"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "gemma“ -- "a
                      swelling bud (of a plant)".
                      <div></div>
                      <strong>Not related to:</strong> jewel
                      <div></div>
                      <strong>Cognates:</strong> gemma 🇮🇹, gem 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ghost.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ghost"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Germanic
                      "*gaistaz" -- "spirit", "ghost", via the Old English
                      "gǣst" -- "breath", "spirit", "soul".
                      <div></div>
                      <strong>Cognates:</strong> geest 🇳🇱, Geist 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/grammar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/SGyesbKQod8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;glamour"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "γραμματική" /grammatikḗ/ --“skilled in writing”. In the
                      Middle Ages the word meant not only "rules of a language",
                      but also “any type of knowledge or scholarship” including
                      that pertaining to magic and the occult. Over time this
                      second meaning came to mean “magical beauty and alluring
                      charm” and gradually through alteration became the word
                      “glamour”.
                      <div></div>
                      <strong>Related to:</strong> grammar, grimoire
                      <div></div>
                      <strong>Descendants:</strong> гламу́р 🇷🇺, glamour 🇩🇰,
                      glamour 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/god.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;god"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the via the Proto-Germanic
                      "gudą" - "god", "deity" and the Old English "god" --
                      "god".
                      <div></div>
                      <strong>Related to:</strong> <u>go</u>ssip
                      <div></div>
                      <strong>Cognates:</strong> god 🇳🇱, gud 🇩🇰, gud 🇸🇪, gud 🇳🇴,
                      Gott 🇩🇪
                      <div></div>
                      <strong>Descendants:</strong> god 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gossip.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gossip"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old English "godsibb" --
                      "one who has become spiritually related to another" (a
                      combination of "god" -- "god" + "sibb" -- "relative") via
                      the Middle English "godsibb" -- “a close friend or
                      relation", "a godparent". Traditionally godsibbs would
                      attend a baptism or christening together, during which
                      they would talk about other family members who weren’t
                      there.
                      <div></div>
                      <strong>Related to:</strong> god, <u>sib</u>ling
                      <div></div>
                      <strong>Descendants:</strong> gosip 🇲🇾, gosip 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/grammar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/SGyesbKQod8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;grammar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "γραμματική" /grammatikḗ/ --“skilled in writing”.
                      <div></div>
                      <strong>Related to:</strong> glamour, grimoire
                      <div></div>
                      <strong>Cognates:</strong> grammaire 🇫🇷, грамма́тика 🇷🇺,
                      Grammatik 🇩🇪, γραμματική 🇬🇷, grammatika 🇪🇪, gramática 🇪🇸,
                      gramática 🇵🇹, grammatik 🇸🇪, grammatica 🇮🇹, gramatika 🇱🇻,
                      grammatika 🇹🇲, gramatika 🇱🇹, gramadach 🇮🇪, ګرامر 🇦🇫
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gravity.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;grave (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "gravis"
                      -- "heavy", via the noun "gravitās" -- "weight".
                      <div></div>
                      <strong>Related to:</strong> gravity
                      <div></div>
                      <strong>Not related to:</strong> grave (<i>n</i>.)
                      <div></div>
                      <strong>Cognates:</strong> grave 🇫🇷, grav 🇷🇴
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gravity.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gravity"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "gravis"
                      -- "heavy", via the noun "gravitās" -- "weight".
                      <div></div>
                      <strong>Related to:</strong> grave (<i>adj</i>.)
                      <div></div>
                      <strong>Cognates:</strong> gravité 🇫🇷, gravedad 🇪🇸,
                      gravidade 🇵🇹, gravità 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1VA4S3AMxB4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;guest"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ghos-ti-" -- "stranger", "guest", "host", "someone with
                      whom one has reciprocal duties of hospitality". Via
                      different paths the root eventually developed into the
                      antonym pair "guest" and "host".
                      <div></div>
                      <strong>Related to:</strong> host, hostel, hotel,
                      hospital, hostility, hospitality, hospice
                      <div></div>
                      <strong>Cognates:</strong> gość 🇵🇱, huésped 🇪🇸, ospite 🇮🇹,
                      гость 🇷🇺, oaspete 🇷🇴, Gast 🇩🇪, gast 🇳🇱, hosť 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gymnasium.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/iFVte6KSLaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gymnasium"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "γυμνάσιον" /gumnásion/ -- “exercise", "school” (which
                      itself is a combination of the adjective "γυμνός" /gumnós/
                      -- "naked" and "-ιον" /-ion/ -- (neuter adjective
                      suffix)). In Ancient Greece, gym-goers would generally be
                      completely naked, hence the name.
                      <div></div>
                      <strong>Related to:</strong> gymnastics
                      <div></div>
                      <strong>Cognates:</strong> gimnaziya 🇦🇿, gimnasio 🇪🇸,
                      gymnase 🇫🇷, giomnáisiam 🇮🇪, ginásio 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gymnastics.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/iFVte6KSLaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gymnastics"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "gŭmnắzō" -- "to train (naked)", "to exercise (naked)" via
                      the the Ancient Greek "γυμναστής" /gumnastḗs/ -- “(naked)
                      athlete, (naked) gymnast”.
                      <div></div>
                      <strong>Related to:</strong> gymnasium
                      <div></div>
                      <strong>Cognates:</strong> gimnasia 🇪🇸, gymnastique 🇫🇷,
                      ژیمناستیک 🇮🇷, ginástica 🇵🇹, ginnastica 🇮🇹, gimnastică 🇷🇴,
                      gymnastiek 🇳🇱, Gymnastik 🇱🇺, gymnastik 🇩🇰, gymnastikk 🇳🇴,
                      gymnastik 🇸🇪, gimnastyka 🇵🇱, gimnastika 🇸🇮, gimnastika 🇭🇷,
                      гимнастика 🇧🇬, gjimnastikë 🇦🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ham1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ham"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*hammō"
                      -- "shinbone", "hollow of the knee", the Old English
                      "hamm" -- "inner part of the knee", and the Middle English
                      "hamme" -- "the inner part of the knee".
                      <div></div>
                      <strong>Cognates</strong>: ham 🇳🇱, ham 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/helicopter.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;helicopter"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ἕλιξ"
                      /hélix/ -- “spiral” + πτερόν /pterón/ -- “wing”, so called
                      because its inventor (in 1861) thought the propeller
                      looked like spiral-shaped wings.
                      <div></div>
                      <strong>Ancestor:</strong> hélicoptère 🇫🇷
                      <div></div>
                      <strong>Related to:</strong> <u>ptero</u>dactyl, feather,
                      helix
                      <div></div>
                      <strong>Cognates:</strong> helicóptero 🇪🇸, helicóptero 🇵🇹,
                      helikopter 🇹🇷, helikopter 🇭🇺, helikopter 🇪🇪, helikopter 🇸🇪
                      <div></div>
                      <strong>Descendants:</strong> हेलिकॉप्टर 🇮🇳, เฮลิคอปเตอร์
                      🇹🇭, ヘリコプター 🇯🇵, ሄሊኮፕተር 🇪🇷, ሄሊኮፕተር 🇪🇹, ເຮລີກົບແຕ 🇱🇦,
                      ဟယ်လီကော့ပတာ 🇲🇲, 헬리콥터 🇰🇷, helikopta 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/helix.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;helix"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "ἕλιξ" /hélix/
                      -- “spiral”.
                      <div></div>
                      <strong>Related to:</strong> <u>helic</u>opter
                      <div></div>
                      <strong>Cognates:</strong> hélice 🇪🇸, hélice 🇵🇹, hélice
                      🇫🇷, elica 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hippopotamus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ἱπποπόταμος" /hippopótamos/, which itself is a compound
                      of "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Cognates:</strong> xипопота́м 🇧🇬, hipopótamo 🇪🇸,
                      hipopótamo 🇵🇹, hippopotame 🇫🇷, гиппопота́м 🇷🇺, ippopotamo
                      🇮🇹, ჰიპოპოტამი 🇬🇪
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, 河马 🇨🇳,
                      Nilpferd 🇩🇪, nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा
                      🇮🇳, dobhareach 🇮🇪, su aygırı 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobby.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hobby"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Likely related to:</strong> hop (v.)
                      <div></div>
                      <strong>Descendants:</strong> hobi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, xоби 🇲🇰, hobi 🇹🇷,
                      hobby 🇸🇪, хо́бби 🇷🇺, Hobby 🇩🇪, hobbi 🇭🇺, hobis 🇱🇹, hobbi
                      🇦🇿, hobijs 🇱🇻, хоби 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/horn.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;horn"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Latin “cornū” --
                      “end”, “horn”, “place where two converging lines meet”.
                      <div></div>
                      <strong>Related to:</strong> corner, hornet
                      <div></div>
                      <strong>Cognates:</strong> Horn 🇩🇪, cuerno 🇪🇸, corne 🇫🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> 角 🇨🇳, tê{" "}
                      <u>giác</u> 🇻🇳, pembe 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/horse.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;horse"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱr̥sós" -- "vehicle", via the Proto-Germanic "*hrussą" --
                      “horse” and the Old English "hors" -- “horse”.
                      <div></div>
                      <strong>Related to:</strong> cart, car
                      <div></div>
                      <strong>Cognates:</strong> ίππος 🇬🇷
                      <div></div>
                      <strong>Descendants:</strong> hos 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1VA4S3AMxB4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hospital"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ghos-ti-" -- "stranger", "guest", "host", "someone with
                      whom one has reciprocal duties of hospitality". So called
                      because in the Middle Ages a "hospital" was known as a
                      shelter that hosted the needy.
                      <div></div>
                      <strong>Related to:</strong> hotel, hostel, hostility,
                      hospitality, hospice, guest
                      <div></div>
                      <strong>Cognates:</strong> hospital 🇪🇸, hospital 🇵🇹,
                      szpital 🇵🇱, hôpital 🇫🇷, ospedale 🇮🇹
                      <div></div>
                      <strong>Descendants:</strong> ሆስፒታል 🇪🇹, hospitali 🇹🇿,
                      hospital 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1VA4S3AMxB4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;host"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ghos-ti-" -- "stranger", "guest", "host", "someone with
                      whom one has reciprocal duties of hospitality". Via
                      different paths the root eventually developed into the
                      antonym pair "guest" and "host".
                      <div></div>
                      <strong>Related to:</strong> hostel, hotel, hospital,
                      hostility, hospitality, hospice, guest
                      <div></div>
                      <strong>Cognates:</strong> hôte 🇫🇷, <u>gos</u>podarz 🇵🇱,{" "}
                      <u>gost</u>itelj 🇸🇮, <u>Gast</u>geber 🇩🇪, <u>gast</u>heer
                      🇳🇱, <u>host</u>itel 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1VA4S3AMxB4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hotel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ghos-ti-" -- "stranger", "guest", "host", "someone with
                      whom one has reciprocal duties of hospitality". In the
                      Middle Ages the Old French "hostel", a distant descendant
                      of the Proto-Indo European root which later became the
                      English "hotel", was a guesthouse or inn for lodgers.
                      <div></div>
                      <strong>Related to:</strong> hostel, hospital, hostility,
                      hospitality, hospice, host, guest
                      <div></div>
                      <strong>Cognates:</strong> hotel 🇪🇸, hotel 🇵🇹, hotel 🇵🇱,
                      hôtel 🇫🇷, hotelli 🇫🇮, hotel 🇳🇱, hotel 🇩🇰, hotel 🇵🇭, hotell
                      🇳🇴
                      <div></div>
                      <strong>Descendants:</strong> ホテル 🇯🇵, هُتِل 🇮🇷, होटल
                      🇮🇳, 호텔 🇰🇷, হোটেল 🇧🇩, ဟိုတယ် 🇲🇲, होटल 🇳🇵, готель 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hour.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hour"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ὥρα"
                      /hṓra/ -- "any time or period, whether of the year, month,
                      or day", via the Latin "hōra" -- "hour".
                      <div></div>
                      <strong>Related to:</strong> <u>horo</u>scope, year
                      <div></div>
                      <strong>Cognates:</strong> hora 🇵🇹, hora 🇪🇸, heure 🇫🇷, ora
                      🇮🇹, uur 🇳🇱, oră 🇷🇴, hora 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/human.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;human"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "hominem" (which
                      is likely a derivative of the noun "homō̆" -- "human
                      being"), via the adjective "hūmānus" -- "human", and the
                      Middle French "humain" -- "human".
                      <div></div>
                      <strong>Likely related to:</strong> <u>homo</u>sexual
                      <div></div>
                      <strong>Not related to:</strong> man, woman
                      <div></div>
                      <strong>Cognates:</strong> humain 🇫🇷, humano 🇪🇸, humano
                      🇵🇹, umano 🇮🇹, humà 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hundred.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hundred"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*hundaradą" -- "a large number (usually equal to either
                      100 or 120)", via the Old English "hundred" -- "100".
                      <div></div>
                      <strong>Distantly related to:</strong> per<u>cent</u>
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, cent 🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idiom"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδίωμα" /idíōma/ -- "a peculiarity", "a property", "a
                      peculiar phraseology", "idiom".
                      <div></div>
                      <strong>Related to:</strong> idiot
                      <div></div>
                      <strong>Cognates:</strong> идио́м 🇲🇰, идио́ма 🇷🇺, idiom 🇵🇱,
                      idiom 🇮🇩, идиома 🇰🇿, идѝо̄м 🇷🇸, idiotisme 🇫🇷, idiomë 🇦🇱,
                      იდიომი 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idiot"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”, and the
                      Latin "idiōta" -- "uneducated or illiterate person". Like
                      the Greeks before them, the Romans used the word to refer
                      to someone lacking any professional skills, but they
                      placed emphasis on the fact that an “idiota” lacked
                      education and was therefore ignorant.
                      <div></div>
                      <strong>Related to:</strong> idiom
                      <div></div>
                      <strong>Cognates:</strong> Idiot 🇩🇪, идиот 🇲🇰, идиот 🇷🇺,
                      идиот 🇧🇬, idiota 🇪🇸, idiota 🇵🇹, idiota 🇵🇱, idiot 🇫🇷,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/incest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;incest"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Latin "incestus" (
                      <i>i.e.</i>, in- + castus) -- "not pure".
                      <div></div>
                      <strong>Related to:</strong> chaste
                      <div></div>
                      <strong>Not related to:</strong> insect, sex
                      <div></div>
                      <strong>Cognates:</strong> incesto 🇪🇸, inceste 🇫🇷, incesto
                      🇵🇹, incesto 🇮🇹, incest 🇷🇴, Inzest 🇩🇪, incest 🇳🇱, incest
                      🇳🇴, инце́ст 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/incline.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;incline"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "inclīnō" --
                      "to cause to lean", "to bend" (a combination of the
                      prepositional prefix "in-" and the verb "clīnō" -- "to
                      bend", "to incline", which is itself derived from the
                      Proto-Indo-European root "*ḱley-" -- "to lean", "to
                      slope").
                      <div></div>
                      <strong>Related to:</strong> climate
                      <div></div>
                      <strong>Possible cognates:</strong> на<u>кло́н</u> 🇷🇺, на
                      <u>клон</u> 🇧🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/inocente.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;innocent (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> The first component comes
                      from the Latin prefix "in-" –- "not". The second component
                      comes from the Latin verb "noceō (v.) –- "to injure", "to
                      damage", which itself is derived from the
                      Proto-Indo-European root "neḱ-" -- "to perish", "to
                      disappear".
                      <div></div>
                      <strong>Possibly Related to:</strong> nectar, nectarine
                      <div></div>
                      <strong>Cognates:</strong>
                      innocent 🇫🇷, inocente 🇵🇹, inocente 🇪🇸
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/insanity.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;insanity"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first element is from the Old
                      English prefix "in-" -– "in", "into". The second element
                      is from the Latin adjective "sānus" (<i>adj.</i>) –-
                      "healthy", "whole", "well" via the noun "sānitās" –-
                      "health", "soundness of body” and the Middle French
                      "sanité" -- "reasonable and rational behaviour".
                      <div></div>
                      <strong>Cognates:</strong> insanidade 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/insect.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;insect"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "īnsectus" (
                      <i>i.e.</i>, īn + sectus) -- "cut into sections". Borrowed
                      as a word-for-word translation of the Ancient Greek
                      "ἔντομον" /éntomon/ -- "cut into sections". From the
                      observation (first made by Aristotle) that insects are
                      physically separated (or "cut") into three separate
                      sections (head, thorax, abdomen).
                      <div></div>
                      <strong>Related to:</strong> sex, <u>sect</u>ion
                      <div></div>
                      <strong>Not related to:</strong> incest
                      <div></div>
                      <strong>Cognates:</strong> insecto 🇪🇸, insecte 🇫🇷, inseto
                      🇵🇹, insetto 🇮🇹, insectă 🇷🇴, Insekt 🇩🇪, insect 🇳🇱, insekt
                      🇳🇴, insekt 🇩🇰, на<u>сек</u>о́мое 🇷🇺, на<u>сек</u>омо 🇧🇬
                      <div></div>
                      <strong>Semantic equivalents:</strong> έντομο 🇬🇷, rovar
                      🇭🇺, trychfil 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/inspire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;inspire (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "in-" --
                      "in" and the verb "spīrō" -- "to breathe". When we are
                      "inspired", we literally receive a breath from some divine
                      force that gives us not only life, but also, great ideas.
                      <div></div>
                      <strong>Related to:</strong> spirit, ex<u>pire</u>, per
                      <u>spire</u>, con<u>spir</u>acy
                      <div></div>
                      <strong>Cognates:</strong> inspirar 🇪🇸, inspirer 🇫🇷,
                      inspirar 🇵🇹, ispirare 🇮🇹, inspirieren 🇩🇪, inspirować 🇵🇱,
                      inspirera 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/intellectual.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lVpHk6bQL_I"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;intellectual"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "intelligere"
                      -- "to comprehend", "to perceive" (which itself is a
                      combination of the preposition "inter" -- "between" and
                      the verb "legere" -- "to read") plus the suffix "-ālis"
                      which creates adjectives of relationship (<i>e.g.</i>,
                      "relating to..."). Literally, an "intellectual" is someone
                      with the ability to read between the lines.
                      <div></div>
                      <strong>Related to:</strong> intelligence
                      <div></div>
                      <strong>Cognates:</strong> intelectual 🇪🇸, intellectuel
                      🇫🇷, intelectual 🇵🇹, intellettuale 🇮🇹, intellectual 🇩🇪,
                      entelektüel 🇹🇷, ინტელექტუალი 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/intelligence.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lVpHk6bQL_I"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;intelligence"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the present participle of
                      the Latin verb "intelligere" -- "to comprehend", "to
                      perceive" (which itself is a combination of the
                      preposition "inter" -- "between" and the verb "legere" --
                      "to read"). Literally, intelligence is the ability to read
                      between the lines.
                      <div></div>
                      <strong>Related to:</strong> intellectual
                      <div></div>
                      <strong>Cognates:</strong> inteligencia 🇪🇸, intelligence
                      🇫🇷, inteligência 🇵🇹, intelligens 🇩🇰, intelligenza 🇮🇹,
                      inteligență 🇷🇴, Intelligenz 🇩🇪, intelligentie 🇳🇱,
                      intelligens 🇳🇴, intelligens 🇸🇪, inteligenca 🇸🇮,
                      inteligence 🇨🇿, inteligencia 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/invest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hZaC6v6pM0o"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;invest (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wéstis" -- "the act of dressing/clothing" via the Latin
                      "vestis" -- "garment", "gown", "robe", "vestment" and the
                      verb "investio" -- "to clothe", "to cover". The modern
                      financial sense of the word comes from the idea of giving
                      one's money a new form (<i>i.e.</i>, clothing it in a new
                      attire).
                      <div></div>
                      <strong>Related to:</strong> investiture, vest, wear (v.)
                      <div></div>
                      <strong>Not related to:</strong> investigate (v.)
                      <div></div>
                      <strong>Cognates:</strong> investeren 🇳🇱, investere 🇳🇴,
                      investere 🇩🇰, investera 🇸🇪, investir 🇫🇷, investir 🇵🇹,
                      investire 🇮🇹, investi 🇷🇴, investieren 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/island.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ztj_kCMZFS8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;island"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂ekʷeh₂" -- "water" + " *lendʰ-" -- “land", via the
                      Proto-Germanic "*awjōlandą" -- “island", "waterland",
                      "meadow”. The original sense was therefore "land that is
                      characterized (and, thus, surrounded) by water".
                      <div></div>
                      <strong>Not related to:</strong> isle
                      <div></div>
                      <strong>Cognates:</strong> eiland 🇳🇱, øy 🇳🇴, ø 🇩🇰, ey 🇮🇸,
                      ö 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/isle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ztj_kCMZFS8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;isle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "insula" --
                      "island" via the Old French "ile" -- "island".
                      <div></div>
                      <strong>Related to:</strong> <u>isola</u>tion
                      <div></div>
                      <strong>Not related to:</strong> island
                      <div></div>
                      <strong>Cognates:</strong> isla 🇪🇸, île 🇫🇷, ilha 🇵🇹, isola
                      🇮🇹, insulă 🇷🇴, Insel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jail.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jail"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", via the Late Latin noun "caveola –- “little
                      cage", the Old French "jaiole" – “cage”, “jail”, and the
                      Middle English "gayole" –- “jail”, “prison”.
                      <div></div>
                      <strong>Related to:</strong> cage, cave, cajole (<i>v.</i>
                      ), cavity
                      <div></div>
                      <strong>Cognates:</strong> geôle 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jewel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jewel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Either from the Latin "iocus" --
                      "joke", "amusement", "pastime", "sport" or from the Latin
                      "gaudium" -- "joy".
                      <div></div>
                      <strong>Possibly related to:</strong> joy, joke
                      <div></div>
                      <strong>Not related to:</strong> gem
                      <div></div>
                      <strong>Possible cognates:</strong> joia 🇵🇹, joya 🇪🇸,
                      Juwel 🇩🇪, juweel 🇳🇱, juvel 🇩🇰, juvel 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/joke.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;joke"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "iocus" -- "joke",
                      "amusement", "pastime", "sport".
                      <div></div>
                      <strong>Possibly related to:</strong> jewel
                      <div></div>
                      <strong>Cognates:</strong> joks 🇱🇻
                      <div></div>
                      <strong>Descendants:</strong> jôc 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/joy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;joy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "gaudium" --
                      "joy".
                      <div></div>
                      <strong>Possibly related to:</strong> jewel
                      <div></div>
                      <strong>Cognates:</strong> joie 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jungle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jungle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert". The word
                      was adopted by British colonists in the Indian
                      subcontinent to refer to any territory that was
                      inhospitable, and then gradually it evolved to denote a
                      place with “tangled thickets”, and then, from there, "any
                      area with lots of vegetation".
                      <div></div>
                      <strong>Ancestors:</strong> جَنْگَل 🇵🇰, जंगल 🇮🇳
                      <div></div>
                      <strong>Cognates:</strong> جَن٘گَل 🇮🇷, জঙ্গল 🇧🇩, जङ्गल 🇳🇵,
                      cəngəllik 🇦🇿, ځنګل 🇦🇫, ҷангал 🇹🇯
                      <div></div>
                      <strong>Descendants:</strong> Dschungel 🇩🇪, джу́нгли 🇷🇺,
                      jungle 🇫🇷, jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪, dżungla 🇵🇱,
                      ջունգլի 🇦🇲, ჯუნგლი 🇬🇪, ジャングル 🇯🇵, džungla 🇸🇮, džùngla
                      🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿, 정글 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kennel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9YJzi3P2Wto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kennel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "canis" -- "dog",
                      via the Vulgar Latin "*canīle" -- "kennel" and the Old
                      French "chenil" -- "kennel".
                      <div></div>
                      <strong>Related to:</strong> canine
                      <div></div>
                      <strong>Cognates:</strong> canile 🇮🇹, kennel 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/left.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;left</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Old English "lyft" --
                      “weak", "clumsy", "foolish”. In superstitious medieval
                      societies the left hand (and the left side in general) was
                      considered unlucky and disadvantageous, hence the semantic
                      evolution into modern English.
                      <div></div>
                      <strong>Semantic equivalents:</strong> gauche 🇫🇷, sinistro
                      🇮🇹, ле́вый 🇷🇺, 왼쪽 🇰🇷, kreiss 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/like.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;like (<i>prep./v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>
                        <u>(preposition)</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Proto-Indo-European
                        root "*leyg-" -- "similar", "level", "even", via the
                        Proto-Germanic "*galīkōną" -- "to be like", "to
                        resemble", the Old English "ġelīcian" -- "to make
                        alike", "to be like", and the Modern English adjective
                        "like".
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Ancestor:</strong> like (<i>adj.</i>)
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Related to:</strong> gleich (<i>adj.</i>) 🇩🇪,
                        gelijk (<i>adj.</i>) 🇳🇱
                      </div>
                      <div></div>
                      <strong>
                        <u>(verb)</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Proto-Indo-European
                        root "*leyg-" -- "similar", "level", "even", via the
                        Proto-Germanic "*galīkōną" -- "to be like", "to
                        resemble" and the Old English "ġelīcian" -- "to make
                        alike", "to be like" (which itself is a combination of
                        the prefix "ge-" -- (an intensifier for verbs) plus the
                        verb "līcian" -- "to like").
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Related to:</strong> like (<i>prep.</i>), alike
                        (<i>adv.</i>)
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates</strong>: like 🇳🇴, líka 🇮🇸,
                      </div>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/major.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ga15HCmlzig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;major (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "maior" (a
                      comparative of the adjective "magnus" -- "great", "large",
                      "noble", "important").
                      <div></div>
                      <strong>Related to:</strong> major (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> mayor 🇪🇸, maior 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/man.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;man"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*mann"
                      –- "human", "human being", via the Proto-West-Germanic
                      "*mann" –- "human", "human being" and the "Old English --
                      "mann" -- – "person", "man".
                      <div></div>
                      <strong>Related to:</strong> woman, <u>mann</u>equin
                      <div></div>
                      <strong>Cognates:</strong> Mann 🇩🇪, man 🇸🇪, mann 🇳🇴, maður
                      🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/maneuver.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7fe2-UxXMI8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;maneuver"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Vulgar Latin verb
                      "*manuoperare" -- "to work by hand" (a compound of "manū"
                      -- "hand" + verb "operārī" -- "to work", "to toil"), via
                      the Old French verb "manouvrer" -- “to maneuver”.
                      <div></div>
                      <strong>Related to:</strong> manure
                      <div></div>
                      <strong>Cognates:</strong> մանևր 🇦🇲, manœuvre 🇫🇷, манёвр
                      🇷🇺, маневар 🇲🇰, maniobra 🇪🇸, manuver 🇮🇩, manewr 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7fe2-UxXMI8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;manure"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Vulgar Latin verb
                      "*manuoperare" -- "to work by hand", a compound of "manū"
                      -- "hand" + verb "operārī" -- "to work", "to toil". The
                      word was originally a verb and derived from the concept of
                      working with one's hands to cultivate land (<i>i.e.</i>,
                      by filling it with fertilizer).
                      <div></div>
                      <strong>Related to:</strong> maneuver
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/map.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;map"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Phoenician "𐤌𐤀𐤐"
                      /mappē/ ⁠ -- "fine cloth" via the Latin "mappa" -- "a
                      tablecloth (or large napkin) that guests would often bring
                      and use at the dinner table to wrap items of food that
                      they wished to take away with them". People later started
                      to use these fine cloths as writing surfaces for elaborate
                      world maps, which they called "mappa mundi" or "cloth of
                      the earth". Eventually, the second component "mundi" was
                      dropped, leaving only "mappa".
                      <div></div>
                      <strong>Related to:</strong> mop, apron, napkin
                      <div></div>
                      <strong>Cognates:</strong> mapa 🇵🇱, mapa 🇨🇿, מַפָּה 🇮🇱,
                      mapa 🇪🇸, mapa 🇵🇹, mappa 🇮🇹, mappa 🇲🇹
                      <div></div>
                      <strong>Descendants:</strong> map 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mare.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mare"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*marhaz"
                      -- "horse".
                      <div></div>
                      <strong>Related to:</strong> <u>mar</u>shal
                      <div></div>
                      <strong>Not related to:</strong> night<u>mare</u>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mathematics.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mathematics"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μάθημα"
                      /máthēma/ -- "something that is learned", "lesson",
                      "knowledge", whence the phrase "μαθηματικὴ τέχνη"
                      /mathēmatikḗ tékhnē/ -- "mathematical sciences”, "sciences
                      of matters that have been learned" was derived.
                      Originally, “mathematics” referred to the science of
                      learning in general. Only after the term was used by the
                      "mathematikoi" (<i>i.e.,</i> "those who love to learn"), a
                      group of scholars in Ancient Greece who studied the ideas
                      of Pythagoras, especially those pertaining to arithmetic
                      and geometry, did the term "mathematics" become closely
                      associated with its modern meaning.
                      <div></div>
                      <strong>Cognates:</strong> mathématiques 🇫🇷, математика
                      🇰🇿, matematik 🇹🇷, matematica 🇮🇹, matematika 🇸🇰, Mathematik
                      🇩🇪, математика 🇰🇬, matematyka 🇵🇱, matematik 🇸🇪,
                      matemáticas 🇪🇸, matematik 🇹🇷, математик 🇲🇳, матема́тика 🇷🇺,
                      matematika 🇵🇭, matamaitic 🇮🇪
                      <div></div>
                      <strong>Descendants:</strong> mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mattress.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mattress"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Cognates:</strong> matelas 🇫🇷, materasso 🇮🇹,
                      matrac 🇸🇰, Matratze 🇩🇪, matras 🇳🇱, матра́с 🇷🇺, матрас 🇰🇬,
                      матрас 🇰🇿, materac 🇵🇱, madrass 🇸🇪
                      <div></div>
                      <strong>Descendants:</strong> 매트리스 🇰🇷, マットレス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mayor.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ga15HCmlzig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mayor"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin comparative
                      adjective "maior" -- "bigger", "greater", "superior" via
                      the Old French "maire" -- "head of a city or town
                      government".
                      <div></div>
                      <strong>Related to:</strong> major (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> maire 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mint.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mint"
                  hoverText={
                    <span>
                      <strong>
                        <u>"place where coins are made"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        {" "}
                        <strong> Origin:</strong> From the Latin "monēta" --
                        "place for coining money", via the Old English "mynet"
                        -- "coin". In Roman times the temple honoring the
                        Goddess Juno Moneta in Rome was next to the site where
                        coins were minted.
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Related to:</strong> money
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Not related to:</strong> mint (the plant)
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Cognates:</strong> <u>Münz</u>anstalt 🇩🇪, casa
                        de <u>moeda</u> 🇵🇹, hôtel des <u>monnaies</u> 🇫🇷, casa
                        de <u>moneda</u> 🇪🇸, mennica 🇵🇱, <u>моне́тный</u> двор 🇷🇺
                      </div>
                      <div></div>
                      <strong>
                        <u>"plant"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        {" "}
                        <strong> Origin:</strong> From Mycenaean Greek "𐀖𐀲"
                        /mi-ta/ -- "mint plant" via the Latin "menta" -- "mint
                        (plant)".
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Not related to:</strong> mint (for coins)
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Cognates:</strong> Minze 🇩🇪, menta 🇵🇹, menthe
                        🇫🇷, menta 🇪🇸, mięta 🇵🇱, мя́та 🇷🇺, menta 🇭🇺, mentă 🇷🇴,
                        mynte 🇳🇴, minttu 🇫🇮
                      </div>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/miracle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;miracle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", via the Latin
                      "mīrāculum" -- "something marveled at".
                      <div></div>
                      <strong>Related to:</strong> admire (v.), mirror, mirage
                      <div></div>
                      <strong>Cognates:</strong> miracle 🇫🇷, milagro 🇪🇸, milagre
                      🇵🇹, miracol 🇷🇴, miracolo 🇮🇹, milagro 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mirror.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mirror"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", via the Old French
                      "mireor" -- “mirror” (<i>lit.</i> “one who looks”, "one
                      who watches"). The semantic link to the modern word comes
                      from the idea of people admiring their own reflection and
                      marveling at how good they look when looking into a mirror
                      (<i>i.e.</i>, the mirror makes one admire oneself).
                      <div></div>
                      <strong>Related to:</strong> admire (v.), miracle, mirage
                      <div></div>
                      <strong>Cognates:</strong> miroir 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mocha.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mocha"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Mocha, Yemen, a port on the
                      Red Sea where coffee was exported during the Ottoman
                      period.
                      <div></div>
                      <strong>Cognates:</strong> moca 🇪🇸, moka 🇫🇷, moca 🇵🇹,
                      мо́кко 🇷🇺, moca 🇮🇹, moca 🇷🇴, Mokka 🇩🇪, mokka 🇫🇮, مُوكَا 🇸🇦,
                      모카 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/money.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;money"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "monēta" -- "place
                      for coining money". In Roman times the temple honoring the
                      Goddess Juno Moneta in Rome was next to the site where
                      coins were minted.
                      <div></div>
                      <strong>Related to:</strong> mint (for coins)
                      <div></div>
                      <strong>Perhaps related to:</strong> monopoly
                      <div></div>
                      <strong>Not related to:</strong> mint (the plant)
                      <div></div>
                      <strong>Descendants:</strong> mani 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/monopoly.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;monopoly"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "μονοπώλιον" /monopṓlion/ -- "right of exclusive sale", a
                      combination of the adjective "μόνος" /mónos/ -- “sole” and
                      the verb "πωλέω" /pōléō/ -- “I barter", "I sell”.
                      <div></div>
                      <strong>Perhaps related to:</strong> money
                      <div></div>
                      <strong>Cognates:</strong> monopole 🇫🇷, monopolio 🇪🇸,
                      monopólio 🇵🇹, monopol 🇷🇴, monopolio 🇮🇹, монополия 🇰🇿,
                      monopol 🇸🇮, monopólium 🇭🇺, монополь 🇲🇳, monopol 🇩🇰,
                      monopol 🇸🇰, מוֹנוֹפּוֹל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mop.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mop"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Phoenician "𐤌𐤀𐤐"
                      /mappē/ ⁠ -- "fine cloth" via the Latin "mappa" -- "a
                      tablecloth (or large napkin) that guests would often bring
                      and use at the dinner table to wrap items of food that
                      they wished to take away with them". From there the word
                      arrived in English via the Old French "mappe" -- "napkin"
                      and the Middle English "mappe" -- "bundle of coarse yarn",
                      "cloth".
                      <div></div>
                      <strong>Related to:</strong> map, apron, napkin
                      <div></div>
                      <strong>Descendants:</strong> moppi 🇫🇮, mopa 🇮🇪, モップ
                      🇯🇵, mopp 🇸🇪, mop 🇵🇱, Mopp 🇩🇪, mop 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/morning.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;morning"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*murginaz" – "morning", "tomorrow", via the Old English
                      "morgen" -- "morning", "the next day/morning".
                      <div></div>
                      <strong>Related to:</strong> to<u>morrow</u>
                      <div></div>
                      <strong>Not related to:</strong> mourning
                      <div></div>
                      <strong>Cognates:</strong> Morgen 🇩🇪, morgen 🇳🇱, morgen
                      🇳🇴, morgon 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mortgage.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;mortal (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "mortuus"-- "dead"
                      (a perfect active participle of the verb "morior" -- "to
                      die").
                      <div></div>
                      <strong>Related to:</strong> <u>mort</u>gage
                      <div></div>
                      <strong>Cognates:</strong> mortel 🇫🇷, mortal 🇵🇹, mortal
                      🇪🇸, <u>mirst</u>īgs 🇱🇻, մահկանացու 🇦🇲, mirtingasis 🇱🇹,
                      сме́ртный 🇷🇺, mortale 🇮🇹, смртан 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mortgage.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mortgage"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin phrase "mortuum
                      vadium" -- “dead pledge”, a combination of the perfect
                      participle "mortuum" -- "dead" and the Frankish "*wadi" --
                      "wager", "pledge". In a medieval "death pledge", the
                      borrower agrees to give up ownership of the property to
                      the lender upon failure to make payments on it, in which
                      case the pledge "dies" (at which point the lender takes
                      possession of the property). If the borrower is able to
                      make all the payments (through "a
                      <u>mort</u>ization", then the pledge also "dies", and the
                      borrower is able to keep the property).
                      <div></div>
                      <strong>Related to:</strong> wage, a<u>mort</u>ization,
                      mortal
                      <div></div>
                      <strong>Cognates:</strong> morgáiste 🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/moss.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;moss"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*musą" --
                      "damp place where moss (or fungi that grow on moss) often
                      grows".
                      <div></div>
                      <strong>Related to:</strong> mushroom, mousse
                      <div></div>
                      <strong>Not related to:</strong> mush
                      <div></div>
                      <strong>Cognates:</strong> Moos 🇩🇪, mos 🇳🇱, mos 🇸🇪, mousse
                      🇫🇷, musgo 🇪🇸, мох 🇷🇺, mach 🇸🇰, мох 🇰🇬, moh 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/motto.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FamWPsuUjK8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;motto"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "muttum" -- "a
                      mutter" "a grunt”, via the Old Italian "motto" -- "a
                      word", "a saying”.
                      <div></div>
                      <strong>Ancestor:</strong> motto 🇮🇹
                      <div></div>
                      <strong>Related to:</strong> mutter (v.)
                      <div></div>
                      <strong>Cognates:</strong> motto 🇩🇰, motto 🇫🇮, motto 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mouse"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Proto-Germanic *mūs -- "mouse".
                      <div></div>
                      <strong>Related to:</strong> muscle, mussel
                      <div></div>
                      <strong>Cognates:</strong> muis 🇳🇱, Maus 🇩🇪, mus 🇩🇰, mus
                      🇳🇴, mús 🇮🇸, mus 🇸🇪, myš 🇨🇿, myš 🇸🇰, mysz 🇵🇱, мышь 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muscle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", so
                      called because flexed arm muscles look like little mice.
                      <div></div>
                      <strong>Related to:</strong> mouse, mussel
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, Muskel 🇩🇪, muskel 🇩🇰, muskel
                      🇳🇴, muskel 🇸🇪, мышца 🇷🇺, mišića 🇭🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/museum.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;museum"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)".
                      <div></div>
                      <strong>Related to:</strong> music, muse (goddess)
                      <div></div>
                      <strong>Not related to:</strong> amusement
                      <div></div>
                      <div></div>
                      <strong>Cognates:</strong> musée 🇫🇷, museo 🇮🇹, museo 🇪🇸,
                      museu 🇵🇹, Museum 🇩🇪, müze 🇹🇷, музе́й 🇧🇾, muzeum 🇦🇱, موزه
                      🇮🇷, muzej 🇸🇮, muzejs 🇱🇻, muzeum 🇨🇿, muuseum 🇪🇪, múzeum 🇭🇺,
                      מוּזֵיאוֹן 🇮🇱, muzeý 🇹🇲, музе́й 🇷🇺
                      <div></div>
                      <strong>Descendants:</strong> muzium 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mush.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mush"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European
                      "*meh₂d-" -- “wet", "fat", "dripping” via the
                      Proto-Germanic "*mōsą" -- “porridge", "food”.
                      <div></div>
                      <strong>Not related to:</strong> mushroom, mousse
                      <div></div>
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Mus 🇩🇪, moes 🇳🇱,
                      mos 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/moss.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mushroom"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*musą" --
                      "damp place where moss (or fungi that grow on moss) often
                      grow"
                      <div></div>
                      <strong>Related to:</strong> mousse, moss
                      <div></div>
                      <strong>Not related to:</strong> mush
                      <div></div>
                      <div></div>
                      <strong>Semantic Equivalents:</strong> hongo 🇪🇸, svamp 🇩🇰,
                      svamp 🇸🇪, zwam 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/museum.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;music"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)"
                      <div></div>
                      <strong>Related to:</strong> museum, muse (goddess)
                      <div></div>
                      <strong>Not related to:</strong> amusement
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, música 🇪🇸,
                      مُوسِيقَى 🇸🇦, му́зыка 🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik
                      🇮🇩, musiikki 🇫🇮, musik 🇸🇪, музыка 🇰🇬, му́зика 🇺🇦, მუსიკა
                      🇬🇪, ሙዚቃ 🇪🇹
                      <div></div>
                      <strong>Descendants:</strong> މިއުޒިކް 🇲🇻, muzik 🇲🇾,
                      muziki 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mussel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mussel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", so
                      called because in antiquity people thought they look like
                      tiny mouse-like rodents. Spelled "muscle" until the 17th
                      century.
                      <div></div>
                      <strong>Related to:</strong> mouse, muscle
                      <div></div>
                      <strong>Cognates:</strong> Muschel 🇩🇪, musling 🇩🇰, mussla
                      🇸🇪, mossel 🇳🇱, mossel 🇿🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/name.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;name"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₁nómn̥" -- "name", via the Proto-Germanic "*namô" --
                      "name", the Old English "nama", and the Middle English
                      "name" -- "name".
                      <div></div>
                      <strong>Related to:</strong> noun, <u>onoma</u>topoeia,
                      nomination
                      <div></div>
                      <strong>Cognates:</strong> nom 🇫🇷, naam 🇳🇱, nome 🇵🇹, navn
                      🇩🇰, نَام 🇮🇷, نوم 🇦🇫, Name 🇩🇪, nombre 🇪🇸, όνομα 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/napkin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;napkin"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Phoenician "𐤌𐤀𐤐"
                      /mappē/ ⁠ -- "fine cloth" via the Latin "mappa" -- "a
                      tablecloth (or large napkin) that guests would often bring
                      and use at the dinner table to wrap items of food that
                      they wished to take away with them". From there the word
                      arrived in English via the Old French "nape" --
                      "tablecloth" with the added Middle English diminutive
                      suffix "-kin", so the word literally means "small
                      tablecloth".
                      <div></div>
                      <strong>Related to:</strong> map, mop, apron
                      <div></div>
                      <strong>Likely cognate:</strong> מַפִּית 🇮🇱
                      <div></div>
                      <strong>Descendants:</strong> नैपकिन 🇮🇳, ナプキン 🇯🇵, 냅킨
                      🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nectar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nectar"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely a combination of
                      the Proto-Indo-European "*neḱ-" -- "to perish" and
                      "*tere-" -- "to overcome", "to pass through". Together
                      these components likely evolved into the Ancient Greek
                      "νέκταρ" /néktar/ -- "nourishment of the gods" via the
                      Latin "nectar" -- "nectar".
                      <div></div>
                      <strong>Related to:</strong> nectarine
                      <div></div>
                      <strong>Cognates:</strong> νέκταρ 🇬🇷, nettare 🇮🇹, َرْقُوق
                      🇲🇷, néctar 🇪🇸, некта́р 🇷🇺, некта́р 🇺🇦, nectar 🇫🇷, neachtar
                      🇮🇪, Nektar 🇩🇪, nektar 🇹🇿, некта́р 🇧🇬
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nectarine.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nectarine"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> The first component is
                      from "nectar", which itself is likely a combination of the
                      Proto-Indo-European "*neḱ-" -- "to perish" and "*tere-" --
                      "to overcome", "to pass through". Together these
                      components likely evolved into the Ancient Greek "νέκταρ"
                      /néktar/ -- "nourishment of the gods" via the Latin
                      "nectar" -- "nectar". The second component comes from the
                      Latin suffix "-ine" – "of"/"pertaining to".
                      <div></div>
                      <strong>Related to:</strong> nectar
                      <div></div>
                      <strong>Cognates:</strong> νεκταρίνι 🇬🇷, nettarina 🇮🇹,
                      nectarina 🇪🇸, нектари́н 🇷🇺, нектари́н 🇺🇦, nectarine 🇫🇷,
                      neachtairín 🇮🇪, Nektarine 🇩🇪, некта́р 🇧🇬, նեկտարին 🇦🇲
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nice.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/DJ-ABPy6Udw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;nice (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "nesciō" --
                      "to know not", "be ignorant of" (the verb is itself a
                      combination of the adverb "ne" -- "not" and the verb
                      "sciō" -- "to know"), via the adjective "nescius" --
                      "ignorant", "not knowing" and the Old French adjective
                      "nisce" -- "simple", "foolish", "ignorant". Originally
                      someone who was "nice" was someone who didn’t really know
                      that much, and, therefore, was innocent and naïve (but
                      also, was often someone who was pleasant to be around).
                      <div></div>
                      <strong>Related to:</strong> science, con<u>science</u>
                      <div></div>
                      <strong>Descendant:</strong> neis 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nightmare.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nightmare"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the unattested Old English
                      "*nihtmare" (<i>i</i>.<i>e</i>.<i>,</i> "night" + "mare"
                      -- “an evil spirit who sits on your chest while you sleep
                      and tries to suffocate you”).
                      <div></div>
                      <strong>Cognates:</strong> cauche<u>mar</u> 🇫🇷, <u>mar</u>
                      dröm 🇸🇪, кош<u>ма́р</u> 🇷🇺, <u>mar</u>tröð 🇮🇸, kosz
                      <u>mar</u> 🇵🇱, <u>mare</u>ritt 🇳🇴, coș<u>mar</u> 🇷🇴
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, incubo
                      🇮🇹, كابوس 🇸🇦, painajainen 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/noun.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;noun"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₁nómn̥" -- "name", via the Proto-Italic "*nōmn̥" --
                      "name" and the Latin "nōmen" -- "name", "noun".
                      <div></div>
                      <strong>Related to:</strong> name, <u>onoma</u>topoeia,
                      nomination
                      <div></div>
                      <strong>Cognates:</strong> nom 🇫🇷, <u>naam</u>word 🇳🇱,
                      nomino 🇹🇿, nom 🇲🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/numb.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;numb (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*nemaną"
                      -- "to take" via the Old English "nim" the past participle
                      of the verb "niman" -- “to take" (in the sense "captured",
                      "dazed").
                      <div></div>
                      <strong>Related to:</strong> eco<u>nomy</u>
                      <div></div>
                      <strong>Cognates:</strong> benommen 🇩🇪, nummen 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/onomatopeia.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;onomatopeia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek noun "ὄνομα" /ónomă/ –- “name" and the verb "ποιέω"
                      /poiéō/ -- "to make", "to do", "to produce”. Literally, an
                      "onomatopeia" is a word whose name sounds like the sound
                      it produces.
                      <div></div>
                      <strong>Related to:</strong> noun, name, nomination, pro
                      <u>noun</u>
                      <div></div>
                      <strong>Cognates:</strong> onomatopée 🇫🇷, onomatopee 🇳🇱,
                      onomatopeia 🇵🇹, onomatopoietikon 🇩🇰, onomatopeya 🇪🇸,
                      ονοματοποιία 🇬🇷, onomatopoeettisuus 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/orange.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;orange"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", via the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange", the Arabic "نارنج"
                      /nāranj/ –- “bitter orange”, the Italian "narancia" (and,
                      after rebracketing, "arancia") -- "orange", and the Old
                      French "orenge" -- "orange".
                      <div></div>
                      <strong>Cognates:</strong> orange 🇫🇷, naranja 🇪🇸, arancia
                      🇮🇹, laranja 🇵🇹, на̀ра̄нча 🇷🇸, naranča 🇭🇷, نارَنْج 🇮🇷, नारंगी
                      🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/orphan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;orphan"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Ancient Greek adjective "ὀρφανός" /orphanós/ --
                      "without parents", "fatherless".
                      <div></div>
                      <strong>Related to:</strong> robot
                      <div></div>
                      <strong>Cognates:</strong> orphelin 🇫🇷, huérfano 🇪🇸,
                      orfano 🇮🇹, órfão 🇵🇹, orfan 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pants.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pants"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Short form of "pantaloons", a
                      word named after a funny-looking character in the Italian{" "}
                      <i>Commedia del Arte</i> named "Pantalone" who had skinny
                      legs and wore tight pants.
                      <div></div>
                      <strong>Cognates:</strong> pantalons 🇫🇷, pantalones 🇪🇸,
                      pantolon 🇹🇷, pantaloni 🇮🇹, παντελόνι 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paper.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paper"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πᾰ́πῡρος"
                      /pắpūros/ -- "the papyrus plant", via the Latin "papȳrus"
                      -- "paper made from papyrus". Although related
                      etymologically, "paper" and "papyrus" are made from
                      different materials and use different production methods.
                      <div></div>
                      <strong>Related to:</strong> papyrus
                      <div></div>
                      <strong>Cognates:</strong> papel 🇪🇸, papier 🇫🇷, papel 🇵🇹,
                      Papier 🇩🇪, papier 🇳🇱, papper 🇸🇪, papīrs 🇱🇻, paperi 🇫🇮,
                      popierius 🇱🇹, papier 🇵🇱, papur 🏴󠁧󠁢󠁷󠁬󠁳󠁿, папі́р 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paradise"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible.
                      <div></div>
                      <strong>Cognates:</strong> paradis 🇫🇷, paraíso 🇵🇹, paraiso
                      🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸, paraíso 🇪🇸,
                      paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/peach.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;peach"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name. From Latin, the word entered
                      Modern English via the Old French "pesche" -- "peach" and
                      the Middle English "peche" -- "peach".
                      <div></div>
                      <strong>Related to:</strong> Persia
                      <div></div>
                      <strong>Descendant:</strong> pichi 🇹🇿
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, pêssego 🇵🇹, ferskja
                      🇮🇸, Pfirsich 🇩🇪, fersken 🇩🇰, fersken 🇳🇴, пе́рсик 🇷🇺, perzik
                      🇳🇱, persik 🇮🇩, piersică 🇷🇴, pjeshkë 🇦🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pedal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pedal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Latin adjective
                      "pedālis" -- "(relating to) the foot".
                      <div></div>
                      <strong>Related to:</strong> pedestrian, pilot, foot
                      <div></div>
                      <strong>Cognates:</strong> pedale 🇮🇹, pedal 🇪🇸, pedal 🇵🇹,
                      pédale 🇫🇷, πετάλι 🇬🇷, Pedal 🇩🇪, pedālis 🇩🇰, pedal 🇦🇱,
                      pedał 🇵🇱, педа́л 🇲🇰, pedala 🇧🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pedal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pedestrian"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Latin adjective
                      "pedester" -- "(of) one who walks on foot".
                      <div></div>
                      <strong>Related to:</strong> pedal, pilot, foot
                      <div></div>
                      <strong>Cognates:</strong> <u>Fuß</u>gänger 🇩🇪, <u>پی</u>
                      ادِه 🇮🇷, <u>pie</u>szy 🇵🇱, <u>pea</u>tón 🇪🇸, <u>pje</u>šak
                      🇭🇷, pyýada 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pen.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pen"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Latin "penna" -- "feather"
                      via Old French "penne" -- "feather", "quill pen".
                      <div></div>
                      <strong>Related to:</strong> feather
                      <div></div>
                      <strong>Not related to:</strong> pencil
                      <div></div>
                      <strong>Cognates:</strong> penna 🇮🇹, pen 🇩🇰, pen 🇳🇱, penni
                      🇮🇸, peann 🇮🇪, penna 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pencil"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Medieval Latin "pincellus" --
                      "painter's brush", "hair-pencil," (<i>lit.</i> "little
                      tail").
                      <div></div>
                      <strong>Not related to:</strong> pen
                      <div></div>
                      <strong>Descendants:</strong> ފަންސުރު 🇲🇻, pensil 🇵🇬,
                      pensil 🇮🇩, पेंसिल 🇮🇳, pensel 🇲🇾, penseli 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/peril.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qJKkaRTmYbs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;peril"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "perīculum" --
                      "risk", "danger".
                      <div></div>
                      <strong>Cognates:</strong> pericolo 🇮🇹, perigo 🇵🇹, peligro
                      🇪🇸, pericol 🇷🇴, periklu 🇲🇹, perygl 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/person.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LCiQz7vmiLY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;person"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "persōna" -- "mask
                      used by actor", "role", "part", "character”. In the Roman
                      world, actors would wear “personae” during performances,
                      which would allow them “to portray a role” and “assume a
                      persona”. Gradually the word became associated both with
                      the mask itself and the actors wearing it, and eventually,
                      the mask meaning disappeared, and only the meaning related
                      to actors, and eventually, all human beings, remained.
                      <div></div>
                      <strong>Related to</strong>: persona
                      <div></div>
                      <strong>Cognates:</strong> personne 🇫🇷, Person 🇩🇪, persoon
                      🇳🇱, persona 🇪🇸, persona 🇮🇹, pessoa 🇵🇹, person 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/perspire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;perspire (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin preposition "per"
                      -- "through" and the verb "spīrō" -- "to breathe" (
                      <i>i.e.</i>, "breathing out (one's last breath")). The
                      original meaning refers to the way sweat passes through
                      the pores of the skin, like "breathing" through an
                      opening.
                      <div></div>
                      <strong>Related to:</strong> spirit, in<u>spire</u>, ex
                      <u>pire</u>, con<u>spir</u>acy
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pillow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hicuJlF5hew"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pillow"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "pulvinus" --
                      "pillow", "cushion", and perhaps, earlier, from "pulvis"
                      -- "dust", "powder", "ashes", which stems from the theory
                      that "pulvis" is what pillows were originally filled with.
                      <div></div>
                      <strong>Likely related to:</strong> pollen
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pilot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pilot"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Ancient Greek "πηδόν"
                      /pēdón/ -- "oar (blade)" and the Byzantine Greek
                      "*πηδώτης" /pēdṓtēs/ -- “helmsman”. Before the emergence
                      of the airplane, a “pilot” was the person at the helm of a
                      ship who steered it into and out of a harbor and navigated
                      it to its destination. The original meaning "foot" comes
                      from the fact that the "πηδόν" looked like the boat’s foot
                      due to its flat shape and position underneath the boat’s
                      body.
                      <div></div>
                      <strong>Related to:</strong> pedal, foot, pedestrian
                      <div></div>
                      <strong>Cognates:</strong> pilota 🇮🇹, piloto 🇪🇸, piloto
                      🇵🇹, pilote 🇫🇷, πιλότος 🇬🇷, Pilot 🇩🇪, pilot 🇩🇰, pilot 🇦🇱,
                      pilots 🇱🇻, pilot 🇨🇿, piloot 🇪🇪, pilot 🇹🇷, piloot 🇳🇱,
                      პილოტი 🇬🇪
                      <div></div>
                      <strong>Descendants:</strong> पायलट 🇮🇳, パイロット 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/plan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;plan"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*pleh₂-no-s" -- “flattened” via Latin "planus" -- “flat,
                      plane” and French "plan" -- "a drawing on a flat surface
                      (in the context of designing buildings)".
                      <div></div>
                      <strong>Related to:</strong> plane, plain
                      <div></div>
                      <strong>Possibly related to:</strong> planet
                      <div></div>
                      <strong>Cognates:</strong> plan 🇫🇷, piano 🇮🇹, plan 🇪🇸,
                      plano 🇵🇹, Plan 🇩🇪, план 🇧🇾, план 🇧🇬, plan 🇩🇰, plan 🇦🇱,
                      plāns 🇱🇻, plán 🇨🇿, planeet 🇪🇪, план 🇷🇺, plan 🇹🇷, plan 🇳🇱,
                      план 🇰🇬, plan 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/plan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;plane"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*pleh₂-no-s" -- “flattened” via Latin "planus" -- “flat,
                      plane”. From there, "airplane" comes from the concept of a
                      flat surface moving through the air.
                      <div></div>
                      <strong>Related to:</strong> plan, plain
                      <div></div>
                      <strong>Possibly related to:</strong> planet
                      <div></div>
                      <strong>Cognates:</strong> plan 🇫🇷, piano 🇮🇹, plano 🇪🇸,
                      plano 🇵🇹, plan 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/planet.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;planet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "
                      <u>πλάνητες</u> ἀστέρες" /plánētes astéres/, or "wandering
                      stars", so called because, compared to "απλανείς αστέρες"
                      /aplaneís astéres/, or "fixed stars", the stars that were
                      "πλάνητες" seemed to move around the sky a lot more.
                      <div></div>
                      <strong>Possibly related to:</strong> plan, plane, plain
                      <div></div>
                      <strong>Cognates:</strong> planète 🇫🇷, pianeta 🇮🇹, planeta
                      🇪🇸, planeta 🇵🇹, Planet 🇩🇪, плане́та 🇧🇾, planet 🇦🇱, planet
                      🇸🇮, planēta 🇱🇻, planeta 🇨🇿, planeet 🇪🇪, planeta 🇵🇭,
                      плане́та 🇷🇺, planeetta 🇫🇮, planeet 🇳🇱
                      <div></div>
                      <strong>Semantic equivalent:</strong> gezegen 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/plant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;plant"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old English -- "plante"
                      -- "young tree or shrub", which may itself descend from
                      the Latin "planta" -- "sole of the foot". The semantic
                      link between the modern word and its plausible Latin
                      ancestor is unclear, but perhaps related to the idea of
                      surrounding a growing plant with soil using the sole of
                      one's foot.
                      <div></div>
                      <strong>Cognates:</strong> plantă 🇷🇴, plante 🇫🇷, pianta
                      🇮🇹, planta 🇪🇸, planta 🇵🇹, Pflanze 🇩🇪, plant 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/plan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;plain"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*pleh₂-no-s" -- “flattened” via Latin "planus" -- “flat,
                      plane”.
                      <div></div>
                      <strong>Related to:</strong> plan, plane
                      <div></div>
                      <strong>Possibly related to:</strong> planet
                      <div></div>
                      <strong>Cognates:</strong> plaine 🇫🇷, <u>pian</u>ura 🇮🇹,{" "}
                      <u>llan</u>ura 🇪🇸, <u>plan</u>ície 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/point.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mn09t2xE2QU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;point"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the perfect passive
                      participle form "pūnctus" ("a hole punched in") of the
                      Latin verb "pungō" -- "I prick", "I punch", via the Old
                      French "point" -- "dot", "tiny amount".
                      <div></div>
                      <strong>Related to:</strong> puncture, ap<u>point</u>{" "}
                      (v.), disap<u>point</u> (v.)
                      <div></div>
                      <strong>Cognates:</strong> point 🇫🇷, punto 🇪🇸, ponto 🇵🇹,
                      Punkt 🇩🇪, пункт 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/poison.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;poison"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the accusative noun "pōtiōnem" --
                      "draught", "(magic) potion". The original word had a
                      double meaning of a liquid substance that was potable but
                      that also often had a little extra something that gave it
                      a little more flavor (and that was also likely harmful to
                      health).
                      <div></div>
                      <strong>Related to:</strong> potable (<i>adj.</i>), potion
                      <div></div>
                      <strong>Cognates:</strong>poison 🇫🇷, poizina 🇲🇬, peçonha
                      🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pollen.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hicuJlF5hew"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pollen"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*pel-" -- "flour", "dust" via
                      the Latin "pollen" -- "mill dust", "fine flour".
                      <div></div>
                      <strong>Likely related to:</strong> pillow
                      <div></div>
                      <strong>Cognates:</strong> pollen 🇫🇷, polen 🇪🇸, pólen 🇵🇹,
                      pollen 🇸🇪, pollen 🇩🇰, pollen 🇳🇴, polline 🇮🇹
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/poison.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;potable (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the adjective "pōtābilis" --
                      “drinkable", "potable".
                      <div></div>
                      <strong>Related to:</strong> potion, poison
                      <div></div>
                      <strong>Cognates:</strong> potable 🇫🇷, potável 🇵🇹, potable
                      🇪🇸, potabile 🇮🇹, potabil 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/potato.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;potato"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Combination of Taíno "b
                      <u>atata</u>", and Quechua "<u>p</u>
                      apa", which denoted the sweet potato and white potato,
                      respectively. Both varieties of potato were brought back
                      to Europe from the Americas. For generations the two were
                      thought to come from the same plant and often mistaken for
                      one another, hence why the names were gradually merged.
                      <div></div>
                      <strong>Cognates:</strong> بَطَاطَا 🇸🇦, patates 🇹🇷, batata
                      🇵🇹, potet 🇳🇴, patatas 🇵🇭, patata 🇪🇸, potatis 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/potion.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;potion"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the accusative noun "pōtiōnem" --
                      "draught", "(magic) potion".
                      <div></div>
                      <strong>Related to:</strong> potable (<i>adj.</i>), poison
                      <div></div>
                      <strong>Cognates:</strong> potion 🇫🇷, poção 🇵🇹, poción 🇪🇸,
                      pozione 🇮🇹, poţiune 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/precocious.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;precocious (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the Latin adjective
                      "praecox" -- "premature", "ripe before time", which itself
                      is a combination of the preposition "prae" -- "before" and
                      the verb "coquō" -- "to cook", "to boil, "to ripen".
                      <div></div>
                      <strong>Related to:</strong> apricot
                      <div></div>
                      <strong>Descendants:</strong> aibreog 🇮🇪, aprikoti 🇹🇿,
                      aprikot 🇮🇩
                      <div></div>
                      <strong>Cognates:</strong> precoz 🇪🇸, précoce 🇫🇷, precoce
                      🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pregnant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;pregnant (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "prae-" -- “pre-”
                      + "*gnāscī" -- "to be born", so, literally, "pre-birth".
                      <div></div>
                      <strong>Cognates:</strong> naître (v.) 🇫🇷, nacer (v.) 🇪🇸,
                      nascer (v.) 🇵🇹, nascere (v.) 🇮🇹, naște (v.) 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problem"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a problem is
                      an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> ballet, ball (as in "dance")
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problema 🇪🇸, problema 🇲🇹,
                      problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problème 🇫🇷, problēma
                      🇱🇻, probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭, problem
                      🇵🇱, problem 🇹🇷, Problem 🇱🇺, problemă 🇷🇴
                      <div></div>
                      <strong>Descendants:</strong> problem 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/prologue.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/tOnL1s10mE4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;prologue"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πρόλογος"
                      /prólogos/ -- "introduction (of a speech)" which is a
                      combination of the prefix "προ-" /pro-/ -- “before” and
                      the noun "λόγος" /lógos/ -- "speech".
                      <div></div>
                      <strong>Related to:</strong> apo<u>logy</u>, epi
                      <u>logue</u>
                      <div></div>, etymo<u>logy</u>
                      <strong>Cognates:</strong> prólogo 🇪🇸, prólogo 🇵🇹,
                      prologue 🇫🇷, prolog 🇷🇴, prologo 🇮🇹, prologas 🇱🇻, prologs
                      🇱🇻, proloog 🇳🇱, проло́г 🇷🇺, проло́г 🇺🇦, prolog 🇵🇱, pròleg 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/prudent.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;prudent (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin prefix
                      "prō-" -- "prior", "fore-" and the verb "videō" -- "to
                      see", via the noun "prōvidēns" -- "foresight", the
                      adjective "prūdēns" -- "wise", "prudent", and, later, the
                      Old French adjective "prudent" -- "prudent".
                      <div></div>
                      <strong>Related to:</strong> en<u>vy</u>, pru<u>dence</u>,
                      visa, vision, visit, video, ad<u>vice</u>, provi
                      <u>dence</u>
                      <div></div>
                      <strong>Not related to:</strong> proud, prude
                      <div></div>
                      <strong>Cognates:</strong> prudente 🇪🇸, prudente 🇵🇹,
                      prudent 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pterodactyl.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pterodactyl"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πτερόν"
                      /pterón/ -- "wing" + "δάκτυλος" /dáktulos/ -- “finger”,
                      coined in 1809.
                      <div></div>
                      <strong>Ancestor</strong> ptérodactyle 🇫🇷
                      <div></div>
                      <strong>Related to:</strong> pen, feather, helic
                      <u>opter</u>
                      <div></div>
                      <strong>Cognates:</strong> птерода́ктиль 🇷🇺, pterodattilo
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/psychiatry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;psychiatrist"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ψυχή" /psukhḗ/ -- "soul" and "ἰατρός" /iatrós/ --
                      “doctor”.
                      <div></div>
                      <strong>Cognates:</strong> Psychiater 🇩🇪, psiquiatra 🇪🇸,
                      psiquiatra 🇵🇹, psikiyatrist 🇹🇷, ფსიქიატრი 🇬🇪, психиа́тр 🇷🇺,
                      psychiatre 🇫🇷, pszichiáter 🇭🇺, ψυχίατρος 🇬🇷, psühhiaater
                      🇪🇪, פסיכיאטר 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pyjamas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pyjamas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "پایجامه" --
                      "pyjamas", "pants" (which is itself a combination of "پا"
                      /pâ/ -- “leg” and "جامه" /jâme/ -- "garment").
                      <div></div>
                      <strong>Ancestors:</strong> पैजामा 🇮🇳, پائِجامَہ 🇵🇰
                      <div></div>
                      <strong>Descendants:</strong> pijama 🇪🇸, pijama 🇵🇹, Pyjama
                      🇩🇪, пижама 🇰🇿, пижама 🇷🇺, пижама 🇰🇬, pijama 🇹🇷, pijama 🇷🇴,
                      πυτζάμα 🇬🇷, піжама 🇺🇦, pyžamo 🇨🇿, pyjama 🇫🇮, поҷома 🇹🇯,
                      پیژامه 🇦🇫, pidžama 🇭🇷, pijama 🇹🇲, פיג׳מה 🇮🇱, pižama 🇱🇹,
                      piama 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rug.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rag"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*rawwa-"
                      -- "long wool", via the Old Norse "rögg" -- "course fur",
                      "shaggy tuft", "bristles", and the Middle English "ragge"
                      -- "scrap of cloth".
                      <div></div>
                      <strong>Related to:</strong> rug
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/red.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;red (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁rewdʰ-" -- "red" via the Proto-Germanic "*raudaz" --
                      "red".
                      <div></div>
                      <strong>Cognates:</strong> rojo 🇪🇸, rouge 🇫🇷, roux 🇫🇷,
                      ruivo 🇵🇹, roxo 🇵🇹, rosso 🇮🇹, rot 🇩🇪, rood 🇳🇱, röd 🇸🇪,
                      raudonas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/response.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VvZv83SW8Bg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;response"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the perfect passive
                      participle of the Latin verb "respondeō" -- "to reply",
                      "to answer", "to respond", which itself is a combination
                      of the prefix "re-" -- “again" and the verb "spondeō" --
                      "to promise".
                      <div></div>
                      <strong>Cognates:</strong> réponse 🇫🇷, respuesta 🇪🇸,
                      resposta 🇵🇹, risposta 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/retail.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;retail"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French prefix "re-"
                      -- "off", "back" and the verb "taillier" -- "to cut".
                      <div></div>
                      <strong>Not related to:</strong> tail (on animals)
                      <div></div>
                      <strong>Related to:</strong> entail (v.), detail, tailor
                      <div></div>
                      <strong>Cognates:</strong> vente au dé<u>tail</u> 🇫🇷, de
                      <u>tail</u>handel 🇩🇰, de
                      <u>tail</u>handel 🇳🇱
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rival"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "rīvus" --
                      "brook", "small stream of water", via the adjectival noun
                      "rīvālis" -- "someone who uses the same stream as
                      another". The word originated from the idea of groups of
                      people occupying opposite sides of a river (or any body of
                      water) who were often vying for access to the same
                      resource (<i>e.g.</i>, the Romans and the Carthaginians in
                      the first millennium BC who were both active on opposite
                      sides of the Strait of Messina between Sicily and mainland
                      Italy.)
                      <div></div>
                      <strong>Related to:</strong> derive (v.)
                      <div></div>
                      <strong>Not related to:</strong> river, arrival
                      <div></div>
                      <strong>Cognates:</strong> rival 🇫🇷, rival 🇪🇸, rival 🇵🇹,
                      rivale 🇮🇹, rywal 🇵🇱, rival 🇷🇴, rival 🇳🇴, Rivale 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;river"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "rīpa" -- "river
                      bank", "shore", via the Old French "rivere" -- "river".
                      <div></div>
                      <strong>Not related to:</strong> rival, derive
                      <div></div>
                      <strong>Related to:</strong> arrive (v.), riparian
                      <div></div>
                      <strong>Cognates:</strong> rivière 🇫🇷, rivier 🇳🇱
                      <div></div>
                      <strong>Not cognates:</strong> rio 🇵🇹, río 🇪🇸, râu 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/robot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;robot"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Proto-Slavic "*orbota" -- "work", "labor", and the Old
                      Czech "robota" -- "servitude", "enslavement", "hard
                      labor". The Czech word was coined in 1920 by the science
                      fiction writer Karel Čapek in 1920.
                      <div></div>
                      <strong>Related to:</strong> orphan
                      <div></div>
                      <strong>Ancestors:</strong> robot 🇨🇿
                      <div></div>
                      <strong>Cognates:</strong> robot 🇫🇷, robot 🇪🇸, Roboter 🇩🇪,
                      ро́бот 🇷🇸, robot 🇵🇹, robot 🇷🇴, robotas 🇱🇹, ро́бот 🇧🇬, робот
                      🇲🇰, robot 🇩🇰, 🇲🇰, robots 🇱🇻, robots 🇦🇱, robot 🇦🇩 robot 🇪🇪,
                      robot 🇭🇺, ро́бот 🇺🇦, robot 🇹🇲, robot 🇿🇦, ро́бот 🇷🇺, robot
                      🏴󠁧󠁢󠁷󠁬󠁳󠁿, ρομπότ 🇬🇷, ሮቦት 🇪🇷, robot 🇳🇴, روبوٹ 🇵🇰, робот 🇰🇿, rôbô
                      🇲🇬, робот 🇹🇯, رُبات 🇮🇷, робот 🇲🇳, რობოტი 🇬🇪, රොබෝ 🇱🇰, রোবট
                      🇧🇩, ރޮބޮޓް 🇲🇻, ሮቦት 🇪🇹, ռոբոտ 🇦🇲, ро́бат 🇧🇾, robot 🇦🇿,
                      רוֹבּוֹט 🇮🇱, robot 🇸🇳.
                      <div></div>
                      <strong>Descendants:</strong> ロボット 🇯🇵, 로봇 🇰🇷, रोबोट
                      🇮🇳, رُوبُوت 🇸🇦, roboti 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rubble.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1-1U32CjI3w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rubble"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French "*robel" --
                      "bits of broken stone".
                      <div></div>
                      <strong>Likely related to:</strong> rubbish
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rug.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rug"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*rawwa-"
                      -- "long wool", via the Old Norse "rögg" -- "course fur",
                      "shaggy tuft", "bristles", and the Middle English "ragge"
                      -- "scrap of cloth".
                      <div></div>
                      <strong>Related to:</strong> rag
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salad.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salad"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Latin verb "*salō" -- (v.) –
                      “to salt” and its participle "*salāta" –- "salted", the
                      latter of which was combined with the noun "herba" to form
                      "herba salāta" – "salted vegetables". "Herba" was dropped
                      over time, leaving only "salata", and then, later, the Old
                      French "salade" –- "salade", and the Modern English word.
                      <div></div>
                      <strong>Related to:</strong> sausage, salary, salt, sauce
                      <div></div>
                      <strong>Cognates:</strong> salade 🇫🇷, ensalada 🇪🇸,
                      insalata 🇮🇹, σαλάτα 🇬🇷, salat 🇩🇰, sałatka 🇵🇱, sallad 🇸🇪,
                      Salat 🇩🇪, салат 🇷🇺, salát 🇨🇿 صلصة 🇸🇦, salata 🇹🇷, salaatti
                      🇫🇮
                      <div></div>
                      <strong>Descendants:</strong> ソース 🇯🇵, 소스 🇰🇷, سَلاد 🇵🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salary.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salary"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "sal" -- "salt"
                      via the adjective "salārius" -- "related to salt" and the
                      derivative noun "salārium" -- "wages". In Roman times salt
                      was quite valuable, and soldiers who were "worth their
                      salt", so to speak, had to accumulate a hefty "salarium"
                      (or “salt stipend”) to be able to buy some.
                      <div></div>
                      <strong>Related to:</strong> salt, salad, sausage, sauce
                      <div></div>
                      <strong>Cognates:</strong> salario 🇪🇸, salaire 🇫🇷, salário
                      🇵🇹, salarju 🇲🇹, salariu 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salt"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Proto-Germanic "*saltą" --
                      "salt", the Proto-West-Germanic "*salt" -- "salt", and the
                      Old English "sealt" -- "salt".
                      <div></div>
                      <strong>Related to:</strong> sausage, salary, salad, sauce
                      <div></div>
                      <strong>Cognates:</strong> sel 🇫🇷, sal 🇪🇸, sale 🇮🇹, αλάτι
                      🇬🇷, salt 🇩🇰, sól 🇵🇱, salt 🇸🇪, Salz 🇩🇪, соль 🇷🇺, sůl 🇨🇿,
                      sāls 🇱🇻, suola 🇫🇮, sool 🇪🇪, sal 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salute.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;salute (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "salūs" --
                      "health", "safety", "security", via the verb "salūtō" --
                      “to greet", "to wish health to".
                      <div></div>
                      <strong>Cognates:</strong> saluer 🇫🇷, saudar 🇵🇹, saludar
                      🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sanity.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sanity"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "sānus"
                      (<i>adj.</i>) –- "healthy", "whole", "well" via the noun
                      "sānitās" –- "health", "soundness of body” and the Middle
                      French "sanité" -- "reasonable and rational behaviour".
                      <div></div>
                      <strong>Cognates:</strong> sanidade 🇵🇹, sanità 🇮🇹, santé
                      🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sauce.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sauce"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Latin verb "*salō" -- (v.) –
                      “to salt” and its derivative "salsus" –- "salty",
                      "salted". From there, the word evolved into the Old French
                      "sause" -- "sauce", and the Middle English "sauce" --
                      "sauce".
                      <div></div>
                      <strong>Related to:</strong> sausage, salad, salt, salary
                      <div></div>
                      <strong>Cognates:</strong> sauce 🇫🇷, salsa 🇪🇸, salsa 🇮🇹,
                      σάλτσα 🇬🇷, sovs 🇩🇰, sos 🇵🇱, sås 🇸🇪, Soße 🇩🇪, xốt 🇻🇳, соус
                      🇷🇺, صلصة 🇸🇦
                      <div></div>
                      <strong>Descendants:</strong> ソース 🇯🇵, 소스 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sausage.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sausage"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Latin verb "*salō" -- (v.) –
                      “to salt” and its derivative "salsus" –- "salty",
                      "salted". From there, combined with the adjective forming
                      suffix "-īcius", the word evolved into the Late Latin
                      adjective "salsīcius" –- "prepared with salt", the Old
                      French "sausice" -– "sausage", the Middle English
                      "sawsiche" –- "sausage", and, finally, the Modern English
                      word.
                      <div></div>
                      <strong>Related to:</strong> sauce, salad, salt, salary
                      <div></div>
                      <strong>Cognates:</strong> saucisse 🇫🇷, salchicha 🇪🇸,
                      salsiccia 🇮🇹, salsicha 🇵🇹
                      <div></div>
                      <strong>Descendants:</strong> ソーセージ 🇯🇵, 소시지 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/schedule.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;schedule"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "σχέδη"
                      /skhédē/ -- “papyrus leaf” via the Latin "schedula" --
                      "strip of paper made out of 'skhede'", and the Old French
                      "cedule" -- "strip of paper with writing on it". In the
                      19th century a "schedule" was a piece of paper upon which
                      people displayed timetables (initially for use in the
                      railroad industry, and then gradually timetables in all
                      industries and for all purposes).
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/science.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/DJ-ABPy6Udw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;science"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "sciō" -- "to
                      know", and its present participle "sciēns" via the noun
                      "scientia" -- "knowledge", "awareness".
                      <div></div>
                      <strong>Related to:</strong> nice (adj.), con
                      <u>science</u>
                      <div></div>
                      <strong>Cognates:</strong> ciencia 🇪🇸, ciência 🇵🇹, science
                      🇬🇧, scienza 🇮🇹, știință 🇷🇴
                      <div></div>
                      <strong>Descendants:</strong> sayansi 🇹🇿, sains 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sex.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sex"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*sek-"
                      -- "to cut off", "to sever", "to separate into sections
                      (in this case, male and female)".
                      <div></div>
                      <strong>Related to:</strong> <u>sect</u>ion, in<u>sect</u>
                      <div></div>
                      <strong>Not related to:</strong> incest
                      <div></div>
                      <strong>Cognates:</strong> sexo 🇪🇸, sexe 🇫🇷, sexo 🇵🇹,
                      sesso 🇮🇹, Sex 🇩🇪, seks 🇳🇱, sex 🇸🇪, секс 🇧🇬, sekss 🇱🇻,
                      seksas 🇱🇹, seks 🇦🇱, սեքս 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sibling.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sibling"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West-Germanic
                      "*sibbju" - "kinship", "relationship" via the Old English
                      "sibb" -- "relationship", "peace", and the diminutive
                      suffix "-ling".
                      <div></div>
                      <strong>Related to:</strong> go<u>ssip</u>
                      <div></div>
                      <strong>Cognates:</strong> siblín 🇮🇪
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sinister.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sinister (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "sinister" --
                      "left hand". In many medieval societies the left hand was
                      considered slower and disadvantageous compared to the
                      right hand, thus giving "sinister" the connotation
                      "unfavorable" or "adverse".
                      <div></div>
                      <strong>Cognates:</strong> sinistre 🇫🇷, sinistro 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldier.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;soldier"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army.
                      <div></div>
                      <strong>Related to:</strong> solid (<i>adj</i>.)
                      <div></div>
                      <strong>Cognates:</strong> Soldat 🇩🇪, soldat 🇫🇷, soldat
                      🇩🇰, soldado 🇵🇹, cолда́т 🇷🇺, soldato 🇮🇹, soldado 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/solitude.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;solitude"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "solus"
                      -- "only", "sole", via the noun "sōlitūdō" -- "solitude",
                      and the Old French "solitude" -- "solitude".
                      <div></div>
                      <strong>Related to:</strong> solo (<i>adj.</i>)<div></div>
                      <strong>Cognates:</strong> solitude 🇵🇹, solitude 🇫🇷,
                      soledad 🇪🇸, solitudine 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b51FXNHemec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sore (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*seh₂yro" -- "hard", "rough", "painful" via the Old
                      English "sār" -- "painful".
                      <div></div>
                      <strong>Related to:</strong> sorry (<i>adj.</i>)
                      <div></div>
                      <strong>Not related to:</strong> sorrow
                      <div></div>
                      <strong>Cognates:</strong> sår 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b51FXNHemec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sorry (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*seh₂yro" via the Proto-Germanic "*sairagaz" -- “sad”,
                      "hard", "rough", "painful"
                      <div></div>
                      <strong>Related to:</strong> sore (adj.)
                      <div></div>
                      <strong>Not related to:</strong> sorrow
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/spirit.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;spirit"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "spīritus" --
                      "breath" via the Old French "espirit" -- "spirit". A
                      "spirit" is therefore an entity that "breathes" within us.
                      <div></div>
                      <strong>Related to:</strong> in<u>spire</u>, per
                      <u>spire</u>, ex<u>pire</u>, con<u>spir</u>acy
                      <div></div>
                      <strong>Cognates:</strong> esprit 🇫🇷, spirito 🇮🇹, espíritu
                      🇪🇸, espírito 🇵🇹, espiritu 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sponge.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sponge"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "σφόγγος"
                      /sphóngos/ -- "sponge".
                      <div></div>
                      <strong>Related to:</strong> fungus
                      <div></div>
                      <strong>Cognates:</strong> esponja 🇪🇸, esponja 🇵🇹, éponge
                      🇫🇷, spugna 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      Originally the word was more closely associated with the
                      idea of people letting themselves get carried away in a
                      pleasant activity that allowed them to just relax and have
                      fun.
                      <div></div>
                      <strong>Related to:</strong> deport (v.)
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> esporte 🇵🇹, спорт 🇷🇺, Sport
                      🇩🇪, სპორტი 🇬🇪, spor 🇹🇷, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺,
                      ስፖርት 🇪🇹, šport 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/squid.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;squid"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Perhaps from the verb "squirt"
                      (from the action of a squid squirting its ink), which
                      itself is likely onomatopoeic.
                      <div></div>
                      <strong>Possible ancestor:</strong> squirt (<i>v.</i>)
                      <div></div>
                      <strong>Not related to:</strong> squirrel 🇬🇧
                      <div></div>
                      <strong>Possible semantic equivalents:</strong> кальмар
                      🇰🇬, kalamar 🇹🇷, kalmar 🇦🇿, calmar 🇫🇷, kałamarnica 🇵🇱,
                      kalmar 🇸🇰, кальма́р 🇷🇺, klamar 🇲🇹, kalmari 🇫🇮, calamar 🇪🇸,
                      calamar 🇦🇩, calamaro 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/squirrel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/TN89d3tM1aY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;squirrel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Ancient Greek
                      "σκίουρος" /skíouros/ -- “shadow-tail”, via the Old French
                      "escurel" -- "squirrel". So called because presumably a
                      squirrel makes shade with its own tail.
                      <div></div>
                      <strong>Cognates:</strong> écureuil 🇫🇷, esquilo 🇵🇹, սկյուռ
                      🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/squirt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;squirt (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Perhaps from the verb "squirt"
                      (from the action of a squid squirting its ink), which
                      itself is likely onomatopoeic.
                      <div></div>
                      <strong>Possible descendant:</strong> squid
                      <div></div>
                      <strong>Not related to:</strong> squirrel 🇬🇧
                      <div></div>
                      <strong>Possible semantic equivalents:</strong> кальмар
                      🇰🇬, kalamar 🇹🇷, kalmar 🇦🇿, calmar 🇫🇷, kałamarnica 🇵🇱,
                      kalmar 🇸🇰, кальма́р 🇷🇺, klamar 🇲🇹, kalmari 🇫🇮, calamar 🇪🇸,
                      calamar 🇦🇩, calamaro 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/star.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;star"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂stḗr" -- “star” via the Proto-Germanic "*sternô", --
                      “star”.
                      <div></div>
                      <strong>Cognates:</strong> étoile 🇫🇷, Stern 🇩🇪, αστέρι 🇬🇷,
                      estrella 🇪🇸, estrela 🇵🇹, stjerne 🇩🇰, stjärna 🇸🇪, stella
                      🇮🇹, stea 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/strange.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;strange (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a compound of the Latin
                      "extrā" -- "outside” and the suffix "-āneus" -- "of or
                      pertaining to". Literally, being "strange" is akin to
                      being "outside (of the norm)".
                      <div></div>
                      <strong>Cognates:</strong> extraño 🇪🇸, étrange 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sugar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel".
                      <div></div>
                      <strong>Ancestors:</strong> شکر 🇮🇷, سُكَّر 🇸🇦, zucchero 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> ζάχαρη 🇬🇷, са́хар 🇷🇺, sucre 🇫🇷,
                      azúcar 🇪🇸, sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪, suiker 🇳🇱,
                      cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲, suhkur 🇪🇪, ስኳር
                      🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sponge.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;swamp"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*swambaz" --
                      "tree fungus", "mushroom", "sponge".
                      <div></div>
                      <strong>Cognates:</strong> Sumpf 🇩🇪, sump 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/swear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VvZv83SW8Bg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;swear (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*swarjaną" -- "to speak", "to swear" via the Old English
                      "swerian" -- "to swear", "to take an oath of office”.
                      <div></div>
                      <strong>Related to:</strong> an<u>swer</u>
                      <div></div>
                      <strong>Cognates:</strong> schwören 🇩🇪, zweren 🇳🇱, sverge
                      🇳🇴, sværge 🇩🇰, svära 🇸🇪, sverja 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tail.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tail"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*taglą"
                      -- "hair", fiber", "hair of a tail" via the Old English
                      "tæġl" -- “tail”.
                      <div></div>
                      <strong>Not related to:</strong> entail (v.), detail,
                      tailor
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tailor.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tailor"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French prefix "re-"
                      -- "off", "back" and the verb "taillier" -- "to cut", via
                      the Old French "taillour" -- "one who creates or alters
                      clothing".
                      <div></div>
                      <strong>Not related to:</strong> tail
                      <div></div>
                      <strong>Related to:</strong> detail, retail, entail (v.)
                      <div></div>
                      <strong>Cognates:</strong> tailleur 🇫🇷, táilliúir 🇮🇪,
                      teiliwr 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tapestry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tapestry"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Old Persian verb
                      "تَنبَسیدَن" /tanbasidan/ -- "to twist threads" via the
                      Ancient Greek "τάπης" /tápēs/ -- "carpet", "rug".
                      <div></div>
                      <strong>Cognates:</strong> tapisserie 🇫🇷, tapiz 🇪🇸, Wand
                      <u>teppich</u> 🇩🇪, таписерија 🇷🇸, tapeçaria 🇵🇹, tapiserie
                      🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tea.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tea"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/to.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;to (<i>prep.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*do-" -- "to", via the Proto-Germanic "*ta" -- "to", and
                      the Old English "tō" -- "to".
                      <div></div>
                      <strong>Related to:</strong> too (<i>adv.</i>)<div></div>
                      <strong>Cognates:</strong> zu 🇩🇪, do 🇵🇱, до 🇷🇺, i 🏴󠁧󠁢󠁷󠁬󠁳󠁿, do
                      🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tonight.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;today (<i>adv.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the preposition
                      "to" and the noun "night", the latter of which is
                      descended from the Old English "dæġ" -- "day", and,
                      earlier, the Proto-Germanic "*dagaz" -- "day".
                      <div></div>
                      <strong>Related to:</strong> <u>to</u>night, <u>to</u>
                      morrow
                      <div></div>
                      <strong>Cognates:</strong> van<u>daag</u> 🇳🇱, heute 🇩🇪,
                      haut 🇱🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/toilet.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;toilet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tēla" -- "web",
                      "loom", via the Old French "toile" -- "cloth", "net", and
                      the Middle French "toilette" -- "small cloth". Originally,
                      people wrapped the "toilette" around their shoulders to
                      protect their clothes while doing their grooming. Over
                      time the cloth went from being on shoulders to being
                      spread out on a dressing table on which people would put
                      toiletry items. Eventually, the word came to refer to the
                      whole area where the dressing table was located (which was
                      often close to where people did their modern-day "toilet"
                      business).
                      <div></div>
                      <strong>Not related to:</strong> towel
                      <div></div>
                      <strong>Cognates:</strong> toilettes 🇫🇷, Toilette 🇩🇪,
                      toilet 🇳🇱, туале́т 🇷🇺, toaleta 🇵🇱, toalett 🇸🇪, tualete 🇱🇻,
                      tuvalet 🇹🇷
                      <div></div>
                      <strong>Descendant:</strong> トイレ 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tomato.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tomato"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl "tomatl" --
                      "tomatillo", "tomato" via the Spanish "tomate" --
                      "tomato". The word was brought to Spain from the New World
                      and from there spread all over Europe and the rest of the
                      world.
                      <div></div>
                      <strong>Ancestors:</strong> tomate 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> tomate 🇫🇷, Tomate 🇩🇪, tomate
                      🇵🇹, дома́т 🇧🇬, домат 🇲🇰, tomāts 🇱🇻, ντομάτα 🇬🇷, トマト 🇯🇵,
                      토마토 🇰🇷, ቲማቲም 🇪🇹, टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat
                      🇲🇾, tomat 🇸🇪, domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tomorrow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;tomorrow (<i>adv.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the preposition
                      "to" and the noun "morrow" (which originally meant
                      "morning (after today")), the latter of which is descended
                      from the Old English "morgen" -- "morning", "the next
                      day/morning", and, earlier, the Proto-Germanic "*murginaz"
                      – "morning", "tomorrow".
                      <div></div>
                      <strong>Related to:</strong> morning, <u>to</u>day,{" "}
                      <u>to</u>night
                      <div></div>
                      <strong>Cognates:</strong> morgen 🇩🇪, morgen 🇳🇱, i morgen
                      🇳🇴, imorgon 🇸🇪
                      <div></div>
                      <strong>Semantic Equivalents:</strong> mañana 🇪🇸, 明日 🇯🇵,
                      z<u>ítra</u> 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tonight.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;tonight (<i>adv.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the preposition
                      "to" and the noun "night", the latter of which is
                      descended from the Old English "niht" -- "night", and,
                      earlier, the Proto-Germanic "*nahts" -- "night".
                      <div></div>
                      <strong>Related to:</strong> <u>to</u>day, <u>to</u>morrow
                      <div></div>
                      <strong>Cognates:</strong> van<u>nacht</u> 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/towel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;towel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic verb
                      "*þwahaną" -- "to wash" via the Frankish verb "*þwahilu"
                      -- "cloth" and the Old French "toaille" -- "towel".
                      <div></div>
                      <strong>Not related to:</strong> toilet
                      <div></div>
                      <strong>Cognates:</strong> toalla 🇪🇸, toalha 🇵🇹, tuwalya
                      🇵🇭, tuala 🇲🇾, tuáille 🇮🇪
                      <div></div>
                      <strong>Descendants:</strong> タオル 🇯🇵, taulo 🇹🇿, taul 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/trash.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1-1U32CjI3w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;trash"
                  hoverText={
                    <span>
                      <strong>Probable origin:</strong> Likely from the Old
                      Norse "tros" -- "rubbish", "fallen leaves and twigs", via
                      the Middle English "trasch" -- "refuse or rubbish
                      (especially that made of plant matter)".
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/trousers.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;trousers (<i>pl.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Proto-Germanic
                      "*brōks" -- "crotch", "hindquarters", "clothing that
                      covers the rear end" via the Old Irish "triubhas" --
                      "close-fitting shorts".
                      <div></div>
                      <strong>Possibly related to:</strong> britches, breeches
                      <div></div>
                      <strong>Possible cognates:</strong> брюки 🇷🇺, broek 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/turkey.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;turkey"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Most theories link the origin of
                      the word to commerce by Ottoman merchants in the port of
                      Constantinople in the 15th-16th centuries. These merchants
                      imported birds, called the Guinea fowl, which is endemic
                      to sub-Saharan Africa, and then sold them in European
                      markets, where they were known as "turkey cocks" (because
                      they were believed to come from "Turkey"). When British
                      settlers arrived in North America (where "turkeys" are
                      actually from), they saw these new birds but weren’t sure
                      what to call them, therefore giving them the same name as
                      the similar-looking bird they had known back in Europe.
                      <div></div>
                      <strong>Descendants:</strong> टर्की 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/twig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;twig"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*dwóh₁" -- "two", via the Proto-Germanic "*twīgą" --
                      "forked branch", so called because branches are often two
                      pronged.
                      <div></div>
                      <strong>Related to:</strong> two, twin, <u>dou</u>ble
                      <div></div>
                      <strong>Cognates:</strong> twijg 🇳🇱, Zweig 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/twin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;twin"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Germanic "*twinahz" -- “two each”
                      and the Old English "ġetwinn" -- "twin".
                      <div></div>
                      <strong>Related to:</strong> two, twig, <u>dou</u>ble
                      <div></div>
                      <strong>Cognates:</strong> tweeling 🇳🇱, Zwilling 🇩🇪,
                      dvojče 🇨🇿
                      <div></div>
                      <strong>Semantic equivalents:</strong> ikiz 🇹🇷, egizak 🇺🇿,
                      ekiz 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;two"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Germanic "*twai" -- "two" and the
                      Old English "twā" -- "two".
                      <div></div>
                      <strong>Related to:</strong> twig, twin, <u>dou</u>ble
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      deux 🇫🇷, to 🇳🇴, dwa 🇵🇱, dó 🇮🇪, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪,
                      два 🇧🇬, երկու 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/umbrella.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;umbrella"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "umbra" -- "shade"
                      + "-ella" (diminutive suffix), as in "device that gives
                      those beneath it a little shade".
                      <div></div>
                      <strong>Cognates:</strong> ombrello 🇮🇹
                      <div></div>
                      <strong>Semantic equivalents:</strong> مِظَلَّة 🇸🇦, ร่ม 🇹🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/uncle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hW6xrMIwfhI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;uncle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "avus" -- "adult
                      male relative (other than one's father)" and its
                      diminutive form "avunculus", which gradually came to mean
                      "maternal uncle", (<i>lit.</i> “little grandfather"). Over
                      time people realized that you couldn’t use one word to
                      denote two different male relatives, so the diminutive
                      “-unculus” was adopted to differentiate the “avus” (
                      <i>i.e.</i>, "grandfather") from the “avunculus” (
                      <i>i.e.</i>, "little grandfather” or “uncle”).
                      <div></div>
                      <strong>Cognates:</strong> Onkel 🇩🇪, oncle 🇫🇷
                      <div></div>
                      <strong>Descendants:</strong> uncail 🇮🇪, ankol 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vacancy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vacancy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Latin verb "vacō" -- "to be free" and later "vacātiō" --
                      "freedom", "exemption".
                      <div></div>
                      <strong>Related to:</strong> waste <i>v.</i>, vacation,
                      vacuum
                      <div></div>
                      <strong>Cognates:</strong> vacance 🇫🇷, vacancia 🇪🇸, vaga
                      🇮🇹, vakature 🇳🇱, ვაკანსია 🇬🇪, вака́нсія 🇺🇦, wakat 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vacation.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vacation"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Latin verb "vacō" -- "to be free" and later "vacātiō" --
                      "freedom", "exemption". The original "vacation" centered
                      around the idea of being at leisure, idle, and unoccupied,
                      (<i>i.e.</i>, "empty").
                      <div></div>
                      <strong>Related to:</strong> waste (<i>v.</i>), vacancy,
                      vacuum
                      <div></div>
                      <strong>Cognates:</strong> vacances (<i>pl.</i>) 🇫🇷,
                      vacaciones 🇪🇸, vacanza 🇮🇹, vakantie 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vacuum.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vacuum"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Latin verb "vacō" -- "to be free" and the adjective
                      "vacuus" -- "empty".
                      <div></div>
                      <strong>Related to:</strong> waste (<i>v.</i>), vacation,
                      vacancy
                      <div></div>
                      <strong>Cognates:</strong> vide 🇫🇷, vacío 🇪🇸, vácuo 🇵🇹,
                      vuoto 🇮🇹, vid 🇷🇴, Vakuum 🇩🇪, vacuüm 🇳🇱, vakuum 🇩🇰, vakuum
                      🇸🇪, ва́куум 🇷🇺, wiatr 🇵🇱, vákuum 🇸🇮, vakuum 🇭🇷, вакуум 🇧🇬,
                      vakuums 🇱🇻, vakuumas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/venom.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;venom"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wenh₁-" -- "to strive", "to wish", "to love", via the
                      Latin "venēnum" -- "(love) potion", "poison", "charm”.
                      <div></div>
                      <strong>Related to:</strong> Venus, wish, win
                      <div></div>
                      <strong>Cognates:</strong> venim 🇫🇷, veneno 🇵🇹, veneno 🇪🇸,
                      veleno 🇮🇹, venin 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/verb.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;verb"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say", via the Proto-Italic
                      "*werβom" -- "word", and the the Latin "verbum" -- "spoken
                      word", "verb". The modern meaning was influenced by the
                      fact that the Romans considered the "verbum" to be the
                      most important word in a sentence from a grammatical
                      perspective.
                      <div></div>
                      <strong>Related to:</strong> word
                      <div></div>
                      <strong>Cognates:</strong> verbe 🇫🇷, verbo 🇪🇸, verbo 🇵🇹,
                      Verb 🇩🇪
                      <div></div>
                      <strong>Semantic Equivalents:</strong> глагол 🇷🇸, глагол
                      🇧🇬, глагол 🇲🇰, глагол 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/versus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;versus (<i>prep.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "versus" --
                      "facing" (which is a past participle of the verb "vertere"
                      -- "to turn", "to change", "to overthrow").
                      <div></div>
                      <strong>Related to:</strong> weird (<i>adj.</i>), worth
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hZaC6v6pM0o"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vest"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wéstis" -- "the act of dressing/clothing" via the Latin
                      "vestis" -- "garment", "gown", "robe", "vestment"
                      <div></div>
                      <strong>Related to:</strong> invest (v.), investiture,
                      wear (v.)
                      <div></div>
                      <strong>Cognates:</strong> vest 🇳🇱, vest 🇳🇴, vest 🇩🇰, väst
                      🇸🇪, veste 🇫🇷, Weste 🇩🇪, vesta 🇨🇿, vesta 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/video.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;video"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "videō" --
                      "to see".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dence</u>, pru
                      <u>dence</u>, visit, en<u>vy</u>, visa, ad
                      <u>vice</u>
                      <div></div>
                      <strong>Cognates:</strong> vídeo 🇪🇸, vídeo 🇵🇹, vedere 🇷🇴,
                      widzenie 🇵🇱, visió 🇦🇩, vidéo 🇫🇷, ဗီဒီယို 🇲🇲
                      <div></div>
                      <strong>Descendants:</strong> ဗီဒီယို 🇲🇲, ビデオ 🇯🇵,
                      ᠸᠢᠳᠧᠣ᠋ 🇲🇳, βίντεο 🇬🇷, 비디오 🇰🇷, ви́део 🇷🇺, video 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vinegar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vinegar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin
                      "vīnum" -- “wine” and the adjective "ācer" -- “sour”, so
                      literally "sour wine".
                      <div></div>
                      <strong>Related to:</strong> eager, acrid
                      <div></div>
                      <strong>Cognates:</strong> vinagre 🇪🇸, vinaigre 🇫🇷,
                      vinagre 🇵🇹, aceto 🇮🇹, oțet 🇷🇴, ocet 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/visa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;visa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "videō" --
                      "to see", via its perfect passive form "vīsa", which was
                      used together with the noun "charta" -- "paper" (
                      <i>i.e.,</i> "a signed page on a passport"), to denote a
                      "paper that has been seen".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dence</u>, pru
                      <u>dence</u>, visit, vision, en<u>vy</u>, video, ad
                      <u>vice</u>
                      <div></div>
                      <strong>Ancestor:</strong> visa 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> visa 🇪🇸, visto 🇮🇹, visto 🇵🇹,
                      viză 🇷🇴, wiza 🇵🇱, visum 🇳🇱, visum 🇳🇴, visum 🇩🇰, visum 🇸🇪,
                      ви́за 🇧🇬, виза 🇲🇰, vīza 🇱🇻, vizë 🇦🇱, viisa 🇪🇪, vízum 🇭🇺,
                      ві́за 🇺🇦, ви́за 🇷🇺, βίζα 🇬🇷, وِیزا 🇵🇰, виза 🇰🇿, वीज़ा 🇮🇳
                      виза 🇹🇯, ویزا 🇮🇷
                      <div></div>
                      <strong>Descendants:</strong> ビザ 🇯🇵, 咖啡 🇨🇳, วีซา 🇹🇭,
                      viza 🇹🇿, වීසා 🇱🇰, ভিসা 🇧🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vision.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vision"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the passive participle
                      "vīsus" -- "having been seen" of the Latin verb "videō" --
                      "to see", via the noun "vīsiō" -- "seeing", "vision", the
                      Old French "vision" -- "vision" and the Middle English
                      "visioun" -- "vision".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dence</u>, pru
                      <u>dence</u>, visit, en<u>vy</u>, video, ad
                      <u>vice</u>
                      <div></div>
                      <strong>Cognates:</strong> visión 🇪🇸, visão 🇵🇹, vedere 🇷🇴,
                      widzenie 🇵🇱, visió 🇦🇩, vision 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/visit.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;visit"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "videō" --
                      "to see", via the verb "vīsō" -- "to behold", "to survey”,
                      and its frequentative derived form "vīsitō" -- "to go to
                      see", "to visit", and the Old French "visiter" -- "to
                      visit".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dence</u>, pru
                      <u>dence</u>, visa, vision, en<u>vy</u>, video, ad
                      <u>vice</u>
                      <div></div>
                      <strong>Cognates:</strong> visite 🇫🇷, visita 🇪🇸, visita
                      🇮🇹, visita 🇵🇹, vizită 🇷🇴, wizyta 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/war.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;war"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*werru" –- "confusion", "disorder", via the Frankish
                      "*werru" –- "confusion", "disorder", the Medieval Latin
                      "werra" -- "war", "strife", and the Old English "werre" -–
                      "armed conflict", "war".
                      <div></div>
                      <strong>Cognates:</strong> guerra 🇪🇸, guerra 🇮🇹, guerra
                      🇵🇹, guerre 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/waste.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;waste (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Frankish "*wōstī" -- "a waste".
                      <div></div>
                      <strong>Related to:</strong> vacation, vacuum, vacancy
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/wear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hZaC6v6pM0o"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;wear (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wes-" -- "to dress", "to put on (clothes)", via the
                      Proto-Germanic "*wazjaną" -- “to clothe” and the Old
                      English "werian" -- “to clothe", "to cover over".
                      <div></div>
                      <strong>Related to:</strong> invest (v.), investiture,
                      vest
                      <div></div>
                      <strong>Cognates:</strong> vestir 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/weird.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;weird (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wert-" -- "to turn", "to wind", via the Proto-Germanic
                      "*wurdiz –" -- "fate", "destiny", and the Old English
                      "wyrd" -- "fate", "destiny". The word experienced a
                      semantic shift via its use in the name of the the three
                      eccentric witches (called "the Weird Sisters") in William
                      Shakespeare's play "The Tragedy of Macbeth".
                      <div></div>
                      <strong>Related to:</strong> worth, versus (prep.), verse
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/werewolf.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;werewolf"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Old English
                      "wer" -- "man", "male" and "*wulf" -- "wolf".
                      <div></div>
                      <strong>Related to:</strong> <u>wor</u>ld
                      <div></div>
                      <strong>Cognates:</strong> Werwolf 🇩🇪, weerwolf 🇳🇱, varulv
                      🇳🇴, varulv 🇩🇰, varulv 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/wife.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;wife"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*wībą –-
                      "woman", "wife", via the Old English "wīf" -- "woman",
                      "wife".
                      <div></div>
                      <strong>Related to:</strong> <u>wo</u>man
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/window.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;wind"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂weh₁-" -- “to blow”.
                      <div></div>
                      <strong>Related to:</strong> <u>wind</u>ow
                      <div></div>
                      <strong>Cognates:</strong> viento 🇪🇸, vent 🇫🇷, vento 🇵🇹,
                      vento 🇮🇹, vânt 🇷🇴, Wind 🇩🇪, vindur 🇮🇸, wind 🇳🇱, vind 🇩🇰,
                      vind 🇸🇪, ве́тер 🇷🇺, wiatr 🇵🇱, veter 🇸🇮, ве̏тар 🇭🇷, вя́тър 🇧🇬,
                      vējš 🇱🇻, vėjas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/window.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;window"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old Norse "vindauga" (
                      <i>lit</i>. wind + eye) -- "eye (hole) for the wind". A
                      "vindauga" was an unglazed hole in the ceiling of a
                      building in Germanic cultures where smoke from fires could
                      be let out and wind could be let in. 
                      <div></div>
                      <strong>Related to:</strong> wind, eye
                      <div></div>
                      <strong>Cognates:</strong> ventana 🇪🇸, vindue 🇩🇰, vindu 🇳🇴
                      <div></div>
                      <strong>Semantic Equivalents:</strong> okno 🇨🇿, okno 🇵🇱,
                      oкно́ 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vino.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;wine"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wéyh₁ō" -- "wine", "vine", via the Latin "vīnum" --
                      “wine”, and the Old English "wīn" -- "wine".
                      <div></div>
                      <strong>Related to:</strong> vine
                      <div></div>
                      <strong>Cognates:</strong> vin 🇫🇷, wine 🇬🇧, viini 🇫🇮,
                      vinho 🇵🇹, vino 🇮🇹, vin 🇷🇴, wino 🇵🇱, вино́ 🇷🇺, wijn 🇳🇱,
                      vynas 🇱🇹, wain 🇲🇾, víno 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/werewolf.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;wolf"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wĺ̥kʷos" -- "wolf" via the Proto-Germanic "*wulfaz" --
                      "wolf" and the Old English "*wulf" -- "wolf".
                      <div></div>
                      <strong>Cognates:</strong> Wolf 🇩🇪, wolf 🇳🇱, ulv 🇳🇴, ulv
                      🇩🇰, ulv 🇸🇪, گرگ 🇮🇷, волк 🇧🇬, wilk 🇵🇱, λύκος 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/woman.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;woman"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the
                      Proto-Germanic "*wībą –- "woman", "wife" and the
                      Proto-Germanic "*mann" –- "human", "human being".
                      <div></div>
                      <strong>Related to:</strong> wife, man, <u>mann</u>equin
                      <div></div>
                      <strong>Cognates:</strong> Weib 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/woodchuck.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/TN89d3tM1aY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;woodchuck"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Narragansett (an
                      Algonquian language spoken in what is today the US state
                      of Rhode Island), in which it is spelled "ockqutchaun".
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/word.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;word"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say" via the Proto-Germanic
                      "*wurdą" -- "word", "saying", the Proto-West-Germanic
                      "*word" -- "word", and the Old English "word" -- "speech",
                      "utterance", "word", "verb".
                      <div></div>
                      <strong>Related to:</strong> verb, ad<u>verb</u>
                      <div></div>
                      <strong>Cognates:</strong> ord 🇸🇪, ord 🇳🇴, ord 🇩🇰, Wort
                      🇩🇪, Wuert 🇱🇺, woord 🇳🇱, vārds 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/world.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;world"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*weraldiz" -- "lifetime", "worldly existence", "mankind",
                      which was a combination of "*weraz" -- "man", "husband"
                      and "*alþi" -- "age", "generation, "lifetime". The "world"
                      therefore denotes the entire period of history during
                      which humans have inhabited the domain of mankind.
                      <div></div>
                      <strong>Related to:</strong> <u>were</u>wolf
                      <div></div>
                      <strong>Cognates:</strong> Welt 🇩🇪, wereld 🇳🇱, verden 🇳🇴,
                      verden 🇩🇰, värld 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/worm.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;worm"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wr̥mis" -- "worm" via the Proto-Germanic "*wurmiz", --
                      "worm".
                      <div></div>
                      <strong>Cognates:</strong> ver 🇫🇷, Wurm 🇩🇪, verme 🇵🇹, orm
                      🇩🇰, verme 🇮🇹, vierme 🇷🇴, worm 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/worth.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;worth</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wert-" -- "to turn", "to wind", via the Proto-Germanic
                      adjective "*werþaz –" -- "worthy", "valuable", and the Old
                      English "weorþ" -- "worth", "honor", "dignity".
                      <div></div>
                      <strong>Related to:</strong> weird (adj.), versus (prep.)
                      <div></div>
                      <strong>Cognates:</strong> Wert 🇩🇪, värde 🇸🇪, waarde 🇳🇱,
                      wartość 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                ================================{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h4" color="black">
                OTHER LANGUAGES{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇳🇦 AFRIKAANS 🇳🇦
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aartappel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle Dutch "erdappel"
                      -- "apple of the earth".
                      <div></div>
                      <strong>Ancestor:</strong> aardappel 🇳🇱
                      <div></div>
                      <strong>Semantic equivalents:</strong>
                      pomme de terre 🇫🇷, תַּפּוּחַ אֲדָמָה 🇮🇱, سیب‌زمینی 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/teea.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tee"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe and later South Africa via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇫🇮, te 🇸🇪, tee
                      🇫🇮, Tee 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇦🇱 ALBANIAN 🇦🇱
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_pl.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇷🇺, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas
                      🇱🇹, ავტობუსი 🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus
                      🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/çaj.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;çaj"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, çay 🇹🇷, شَاي 🇸🇦, çaý
                      🇹🇲, čaj 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;çështje"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the verb
                      derivative "është" --- "is", the interrogative relative
                      element "ç-" -- "what" and the noun suffix "-je".
                      Literally, a "çështje" is "that which is" (<i>i.e.</i>, an
                      issue).
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gaz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to:</strong> kaos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gas 🇬🇧, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/major.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ga15HCmlzig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;i madh (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*méǵh₂-" -- "big", "great", via tha Proto-Albanian
                      "*madza" -- "big", "large", "tall".
                      <div></div>
                      <strong>Cognates:</strong> mayor 🇪🇸, maior 🇵🇹, major 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/insekt2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;insekt"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "īnsectus" (
                      <i>i.e.</i>, īn + sectus) -- "cut into sections". Borrowed
                      as a word-for-word translation of the Ancient Greek
                      "ἔντομον" /éntomon/ -- "cut into sections". From the
                      observation (first made by Aristotle) that insects are
                      physically separated (or "cut") into three separate
                      sections (head, thorax, abdomen).
                      <div></div>
                      <strong>Related to:</strong> seks, sekt
                      <div></div>
                      <strong>Cognates:</strong> insecto 🇪🇸, insecte 🇫🇷, inseto
                      🇵🇹, insetto 🇮🇹, insectă 🇷🇴, insect 🇬🇧, insect 🇳🇱, insekt
                      🇳🇴, insekt 🇩🇰, на<u>сек</u>о́мое 🇷🇺, на<u>сек</u>омо 🇧🇬
                      <div></div>
                      <strong>Semantic equivalents:</strong> έντομο 🇬🇷, rovar
                      🇭🇺, trychfil 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muzikë"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)", via the Latin "mūsica" --
                      "music".
                      <div></div>
                      <strong>Related to:</strong> muze
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, música 🇪🇸,
                      مُوسِيقَى 🇸🇦, му́зыка 🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik
                      🇮🇩, music 🇬🇧, музыка 🇰🇬, му́зика 🇺🇦, მუსიკა 🇬🇪, ሙዚቃ 🇪🇹,
                      މިއުޒިކް 🇲🇻, muzik 🇲🇾, muziki 🇹🇿, musiikki 🇫🇮, musik 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/portokall.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;portokall"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Italian "portogallo" –
                      “orange (from Portugal)” via the Ottoman Turkish "پورتقال"
                      /portakal/ -- "orange". Portuguese traders brought the
                      fruit from East Asia to Europe, whence the name.
                      <div></div>
                      <strong>Cognates:</strong> ُرْتُقَال 🇸🇦, portakal 🇹🇷,
                      portocală 🇷🇴, πορτοκάλι 🇬🇷, portağal 🇦🇿, портокал 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇪🇹 AMHARIC 🇪🇹
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shaa.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ሻይ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷, شَاي 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, tè 🇮🇹, tee 🇫🇮,
                      te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, shaah 🇸🇴,
                      ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶 🇯🇵, 차 🇰🇷,
                      තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸,
                      thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, çay 🇹🇷, شَاي 🇸🇦, çaý 🇹🇲, čaj 🇨🇿,
                      çaj 🇦🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ሙዚቃ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)"
                      <div></div>
                      <strong>Ancestor:</strong> موسيقى 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, music 🇬🇧, му́зыка
                      🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik 🇮🇩, މިއުޒިކް 🇲🇻, muzik
                      🇲🇾, muziki 🇹🇿, musiikki 🇫🇮, musik 🇸🇪, музыка 🇰🇬, му́зика
                      🇺🇦, მუსიკა 🇬🇪, مُوسِیقِی 🇮🇷, musiqi 🇦🇿, موسیقی 🇵🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tamatim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ቲማቲም"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl (Aztec) "tomatl"
                      -- "tomatillo", "tomato". The word was brought to Spain
                      from the New World and from there spread all over Europe
                      and the rest of the world.
                      <div></div>
                      <strong>Ancestor:</strong> tomate 🇪🇸, طماطم 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> tomate 🇫🇷, Tomate 🇩🇪, tomate
                      🇵🇹, дома́т 🇧🇬, домат 🇲🇰, tomāts 🇱🇻, ντομάτα 🇬🇷, トマト 🇯🇵,
                      토마토 🇰🇷, टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat 🇲🇾, tomat
                      🇸🇪, domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿, tomato 🇬🇧, طوماطيش 🇩🇿, ماطيشة
                      🇲🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gamal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ግመል"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel".
                      <div></div>
                      <strong>Cognates:</strong> גמל 🇮🇱, camello 🇪🇸, camel 🇬🇧,
                      cammello 🇮🇹, camelo 🇵🇹, chameau 🇫🇷, kamel 🇩🇰, جمل 🇸🇦,
                      ޖަމަލު 🇲🇻, ngamia 🇹🇿, Kamel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ጋዝ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, غاز 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, গ্যাস 🇧🇩, gaz
                      🇫🇷, gas 🇬🇧, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ
                      🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass
                      🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, 가스 🇰🇷, ガス 🇯🇵, გაზი
                      🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, گاز 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇸🇦 ARABIC 🇸🇦
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              {" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/iklim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;إقليم"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west.
                      <div></div>
                      <strong>Related to:</strong> تَأَقْلَمَ (v.)
                      <div></div>
                      <strong>Cognates:</strong> climate 🇺🇸, climat 🇫🇷, klimaat
                      🇳🇱, кли́мат 🇷🇺, κλίμα 🇬🇷, clima 🇵🇹
                      <div></div>
                      <strong>Descendants:</strong> Most descendants primarily
                      mean "climate", rather than "territory", "region" - the
                      primary meaning in Arabic). These include the following:
                      اقليم 🇵🇰, اِقْلِیم 🇮🇷, iqlim 🇦🇿, iklim 🇮🇩, iqlim 🇺🇿
                      ַַאַקְלִים 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ananas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;آناناس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Tupi-Guarani
                      "*nanã" -- "pineapple", via the Old Tupi "naná" --
                      "pineapple".
                      <div></div>
                      <strong>Ancestors:</strong> ananas 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> Ananas 🇩🇪, анана́с 🇷🇺, آناناس
                      🇮🇷, nanasi 🇹🇿, ананас 🇰🇿, ananāss 🇱🇻, ananas 🇫🇮, ananas
                      🇹🇷, နာနတ် 🇲🇲, ananas 🇩🇰, ananas 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/awtubis.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;اوتوبيس 🇪🇬"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus 🇹🇲,
                      אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪,
                      buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴,
                      bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi
                      🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pape.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;بابا"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πάππᾰς"
                      /páppăs/ -- "father", via the Latin "pāpa" -- "pope",
                      "bishop".
                      <div></div>
                      <strong>Cognates:</strong> pape 🇫🇷, پاپ 🇮🇷, papa 🇪🇸, papa
                      🇦🇿, պապ 🇦🇲, папа 🇧🇾, papež 🇨🇿, pave 🇩🇰, paavi 🇫🇮, პაპი 🇬🇪,
                      Papst 🇩🇪, πάπας 🇬🇷, पोप 🇮🇳, paus 🇮🇩, pápa 🇮🇪, папа 🇰🇿,
                      pāvests 🇱🇻, popiežius 🇱🇹, Poopst 🇱🇺, пап 🇲🇳, papă 🇷🇴,
                      papež 🇸🇮, papa 🇹🇿, papa 🇹🇲, پوپ 🇵🇰, pab 🏴󠁧󠁢󠁷󠁬󠁳󠁿 بَابَا 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/barquq.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;برقوق 🇲🇷🇪🇭"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", and, finally, the modern Arabic word.
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      berquq 🇲🇹, albaricoque 🇪🇸, абрико́с 🇷🇺, абрико́с 🇺🇦, abricot
                      🇫🇷, aibreog 🇮🇪, apricot 🇬🇧, Aprikose 🇩🇪, aprikoti 🇹🇿,
                      aprikot 🇮🇩, abrikoos 🇳🇱
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/burtuqal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;برتقال"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Italian "portogallo" –
                      “orange (from Portugal)” via the Ottoman Turkish "پورتقال"
                      /portakal/ -- "orange". Portuguese traders brought the
                      fruit from East Asia to Europe, whence the name.
                      <div></div>
                      <strong>Cognates:</strong> portakal 🇹🇷, portocală 🇷🇴,
                      πορτοκάλι 🇬🇷, portağal 🇦🇿, портокал 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;بطاطا"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Taíno "batata" -- "sweet
                      potato".
                      <div></div>
                      <strong>Ancestor:</strong> batata 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> patates 🇹🇷, potato 🇬🇧, batata
                      🇵🇹, potet 🇳🇴, patatas 🇵🇭, potatis 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bandura.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;بندورة 🇸🇾🇱🇧"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the plural "pomi d'oro" of
                      the Italian "pomo d'oro" -- "golden apple".
                      <div></div>
                      <strong>Ancestors:</strong> pomodoro 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> pomidoras 🇱🇹, pomidor 🇵🇱,
                      помідор 🇺🇦, pomidor 🇦🇿, памідор 🇧🇾, помидор 🇰🇬, помидор
                      🇹🇯, pomidor 🇹🇲
                      <div></div>
                      <strong>Descendants:</strong>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tubis.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;طوبيس 🇲🇦"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus 🇹🇲,
                      אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪,
                      buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴,
                      bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi
                      🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jamal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;جمل"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel".
                      <div></div>
                      <strong>Cognates:</strong> ግመል 🇪🇹, גמל 🇮🇱, camello 🇪🇸,
                      camel 🇧, cammello 🇮🇹, camelo 🇵🇹, chameau 🇫🇷, kamel 🇩🇰
                      <div></div>
                      <strong>Descendants:</strong> ޖަމަލު 🇲🇻, ngamia 🇹🇿, Kamel
                      🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cennet.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;جنة"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Classical Syriac "ܓܰܢܬܳܐ"
                      /gannəṯā/ -- "garden", "park".
                      <div></div>
                      <strong>Related to:</strong> جنَّ (v)
                      <div></div>
                      <strong>Cognates:</strong> <u>גן</u> עדן 🇮🇱
                      <div></div>
                      <strong>Descendants:</strong> jennet 🇹🇲, cennet 🇹🇷, cənnət
                      🇦🇿
                      <div></div>
                      <strong>Semantic Equivalents:</strong> paradis 🇫🇷, paraíso
                      🇵🇹, paraiso 🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸,
                      paraíso 🇪🇸, paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷,
                      فِرْدَوْس 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/alfombra.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;حبل"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*ḥabl-"
                      -- "rope".
                      <div></div>
                      <strong>Related to:</strong> حنبل 🇲🇦
                      <div></div>
                      <strong>Cognates:</strong> חֶבֶל 🇮🇱
                      <div></div>
                      <strong>Descendants:</strong> ħabel 🇲🇹
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/assassin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zSk51b0WVHw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;حشيش"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic verb "حَشَّ"
                      /ḥašša/ -- "to mow", "to cut grass".
                      <div></div>
                      <strong>Related to:</strong> حشاش ,حشاشين
                      <div></div>
                      <strong>Descendants:</strong> hashish 🇬🇧, hachís 🇪🇸,
                      haxixe 🇵🇹, hashish 🇮🇹, hashishi 🇹🇿, гашиш 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/alfombra.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;حنبل 🇲🇦"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*ḥabl-"
                      -- "rope".
                      <div></div>
                      <strong>Related to:</strong> حبل
                      <div></div>
                      <strong>Descendants:</strong> alfombra 🇪🇸, alpombra 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/harb.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;حرب"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*ḥarb-"
                      –- "blade", "knife", "sharp instrument".
                      <div></div>
                      <strong>Related to:</strong> حَرْبَة
                      <div></div>
                      <strong>Cognates:</strong> mü<u>harib</u>ə 🇦🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/martaba.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;دوشك 🇾🇪🇰🇼🇧🇭🇮🇶"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic root
                      "*töĺe-" -- "to spread out" via the Ottoman Turkish "دوشك"
                      /döşek/ -- "mattress".
                      <div></div>
                      <strong>Ancestor:</strong> döşek 🇹🇷
                      <div></div>
                      <strong>Cognates:</strong> تشک 🇮🇷, душек 🇷🇸, توشک 🇦🇫,
                      dyshek 🇦🇱, душек 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dinde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ديك روميّ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first element is likely from
                      the Proto-Semitic "*dyka" (whence also the Syriac "ܕܝܟܐ"
                      /dyka/) -- "rooster". The second element is the adjective
                      "رُومِيّ" /rūmiyy/ "from or relating to the Eastern
                      (Byzantine) Roman Empire". The name derives from the
                      mistaken idea in Arabic speaking cultures in previous
                      centuries that turkeys came from the Byzantine Empire.
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sukr.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;سكر"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel", via the Middle Persian
                      "𐭱𐭪𐭥" /šakar/ -- "sugar".
                      <div></div>
                      <strong>Cognates:</strong> ζάχαρη 🇬🇷, са́хар 🇷🇺, شکر 🇮🇷
                      <div></div>
                      <strong>Descendants:</strong> shakar 🇺🇿, şəkər 🇦🇿, şeker
                      🇹🇲, чихэр 🇲🇳, zucchero 🇮🇹, sucre 🇫🇷, sugar 🇬🇧, sukker 🇳🇴,
                      azúcar 🇪🇸, cukier 🇵🇱, siúcra 🇮🇪, suiker 🇳🇱, cukrus 🇱🇹,
                      Zucker 🇩🇪, за́хар 🇧🇬, suhkur 🇪🇪, ስኳር 🇪🇹, zahăr 🇷🇴, сахар 🇷🇺
                      цукар 🇧🇾, շաքար 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sawdah.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;سوداء"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The feminine form of the noun
                      "أَسْوَد" /ʔaswad/ -- "black". The sense "black bile" is
                      likely a calque from the Greek "μελαγχολῐ́ᾱ" /melankholĭ́ā/
                      "melancholy" (which itself is a combination of "μέλας"
                      /mélas/ -- “black” and "χόλος" /khólos/ -- “gall",
                      "bile”).
                      <div></div>
                      <strong>Semantic equivalents:</strong> melancholy 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shai.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;شاي"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, shaah 🇸🇴,
                      ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶 🇯🇵, 차 🇰🇷,
                      තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸,
                      thee 🇳🇱, tee 🇪🇪, чай, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý 🇹🇲
                      <div></div>
                      <strong>Descendants:</strong> ሻሂ 🇪🇷, ሻይ 🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tamatim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;طماطم"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl (Aztec) "tomatl"
                      -- "tomatillo", "tomato". The word was brought to Spain
                      from the New World and from there spread all over Europe
                      and the rest of the world.
                      <div></div>
                      <strong>Ancestor:</strong> tomate 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> tomate 🇫🇷, Tomate 🇩🇪, tomate
                      🇵🇹, дома́т 🇧🇬, домат 🇲🇰, tomāts 🇱🇻, ντομάτα 🇬🇷, トマト 🇯🇵,
                      토마토 🇰🇷, टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat 🇲🇾, tomat
                      🇸🇪, domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿, tomato 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> ቲማቲም 🇪🇹, طوماطيش 🇩🇿, ماطيشة
                      🇲🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tamatim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;طوماطيش 🇩🇿"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl (Aztec) "tomatl"
                      -- "tomatillo", "tomato". The word was brought to Spain
                      from the New World and from there spread all over Europe
                      and the rest of the world.
                      <div></div>
                      <strong>Ancestors:</strong> طماطم 🇸🇦, tomate 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> tomate 🇫🇷, Tomate 🇩🇪, tomate
                      🇵🇹, дома́т 🇧🇬, домат 🇲🇰, tomāts 🇱🇻, ντομάτα 🇬🇷, トマト 🇯🇵,
                      토마토 🇰🇷, ቲማቲም 🇪🇹, टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat
                      🇲🇾, tomat 🇸🇪, domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿, tomato 🇬🇧, ቲማቲም 🇪🇹
                      <div></div>
                      <strong>Descendants:</strong> ماطيشة 🇲🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/myshtsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;عضلة"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "عَضَل" /ʕaḍal/
                      -- "gerbil", so called because flexed arm muscles look
                      like little mice.
                      <div></div>
                      <strong>Related to:</strong> عضل
                      <div></div>
                      <strong>Descendants:</strong> əzələ 🇦🇿, عضله 🇦🇫
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, մկան 🇦🇲,
                      ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲, muscle 🇫🇷, muscolo 🇮🇹, muskel 🇳🇴,
                      muskel 🇸🇪, мышца 🇷🇺, mišića 🇭🇷, Muskel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;غاز"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, গ্যাস 🇧🇩, gaz
                      🇫🇷, gas 🇬🇧, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ
                      🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass
                      🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵,
                      გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, گاز 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paridayjah.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;فردوس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the
                      Proto-Indo-European "*per-" -- "before", "in front" and
                      "*dáyjah" -- "wall" via the Proto-Iranian "*paridayjah" --
                      "walled garden".
                      <div></div>
                      <strong>Semantic relative :</strong> جَنَّة
                      <div></div>
                      <strong>Cognates:</strong> paradise 🇬🇧, paraíso 🇵🇹,
                      paraiso 🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸, paraíso
                      🇪🇸, paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> cennet 🇹🇷, jennet
                      🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;فرس نهر"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first word is from the
                      Proto-Semitic "*paras-" -- "horse”, whereas the second is
                      from the Proto-Semitic "*nahar-" "river".
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, 河马 🇨🇳,
                      Nilpferd 🇩🇪, nijlpaard 🇳🇱, hippopotamus 🇬🇧, दरियाई घोड़ा
                      🇮🇳, dobhareach 🇮🇪, нилски коњ 🇲🇰, اسب آبی 🇮🇷, su aygırı 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/farasha.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;فرشة 🇯🇴🇵🇸"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic verb "فَرَشَ"
                      /faraša/ -- "to spread" via the noun "فَرْشَة" /faraša/ --
                      "carpet", "mat", "mattress".
                      <div></div>
                      <strong>Related to:</strong> فراش, فراشة
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/coffee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;قهوة"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then eventually spread to the
                      Anatolian Peninsula via the Ottoman Turkish "قهوه" /kahve/
                      -- "coffee".
                      <div></div>
                      <strong>Ancestors:</strong> قَهِيَ (v.)
                      <div></div>
                      <strong>Related to:</strong> مَقْهًى
                      <div></div>
                      <strong>Descendants:</strong> café 🇫🇷, café 🇪🇸, Kaffee 🇩🇪,
                      ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰,
                      kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦,
                      ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴, کافی 🇵🇰, кофе 🇰🇿,
                      kafe 🇲🇬, 咖啡 🇹🇼, қаҳва 🇹🇯, قهوه 🇮🇷, コーヒー 🇯🇵, 咖啡 🇨🇳,
                      커피 🇰🇷, ກາເຟ 🇱🇦, កាហ្វេ 🇰🇭, кофе 🇲🇳, cà phê 🇻🇳, ကော်ဖီ
                      🇲🇲, ყავა 🇬🇪, กาแฟ 🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, kahawa 🇹🇿, কফি
                      🇧🇩, ކޮފީ 🇲🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/qalam.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;قلم"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, possibly
                      via the Ge'ez "ቀለም" /ḳäläm/ -- "reed".
                      <div></div>
                      <strong>Descendants:</strong> калем 🇰🇬, kalem 🇹🇷, क़लम 🇮🇳,
                      कलम 🇳🇵, kalamu 🇹🇿, қалам 🇰🇿, қалам 🇹🇯, ގަލަން 🇲🇻, কলম 🇧🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kabus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;كابوس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Syriac "ܟܵܒ݂ܘܿܫܵܐ"
                      /kāḇōšā/ - "invader", "occupier", "incubus".
                      <div></div>
                      <strong>Related to:</strong> كَبْس
                      <div></div>
                      <strong>Descendants:</strong> کابوس 🇮🇷, kabus 🇹🇷, kabus 🇦🇿
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, incubo
                      🇮🇹, painajainen 🇫🇮, кошма́р 🇷🇺, coșmar 🇷🇴, koszmar 🇵🇱,
                      კოშმარი 🇬🇪, košmaras 🇱🇹, cauchemar 🇫🇷, nightmare 🇬🇧, mar
                      dröm 🇸🇪, martröð 🇮🇸, mareritt 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tamatim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ماطيشة 🇲🇦"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl (Aztec) "tomatl"
                      -- "tomatillo", "tomato". The word was brought to Spain
                      from the New World and from there spread all over Europe
                      and the rest of the world.
                      <div></div>
                      <strong>Ancestors:</strong> طماطم 🇸🇦, tomate 🇪🇸, طوماطيش
                      🇩🇿
                      <div></div>
                      <strong>Cognates:</strong> tomate 🇫🇷, Tomate 🇩🇪, tomate
                      🇵🇹, дома́т 🇧🇬, домат 🇲🇰, tomāts 🇱🇻, ντομάτα 🇬🇷, トマト 🇯🇵,
                      토마토 🇰🇷, ቲማቲም 🇪🇹, टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat
                      🇲🇾, tomat 🇸🇪, domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿, tomato 🇬🇧, ቲማቲም 🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/martaba.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;مرتبة 🇪🇬"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic root "رَتَبَ"
                      /rataba/ -- "to stay firm", "to be solid".
                      <div></div>
                      <strong>Related to:</strong> مرْتبة 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/martaba.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;مضربة 🇲🇦"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic root "ضَرَّب"
                      /ḍarraba/ -- "to multiply" (as in "multiplying sewn
                      stitches").
                      <div></div>
                      <strong>Related to:</strong> إِضراب
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/matrah.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;مطرح 🇩🇿"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Modern Standard Arabic
                      "مَطْرَح" -- /maṭraḥ/ -- "place where things are thrown",
                      the noun of place for the verb "طَرَحَ" -- "to throw", "to
                      cast", "to toss" /maṭraḥ/ -- "place where things are
                      thrown". In the Middle Ages the word was brought back to
                      Europe by Crusaders who had discovered the Middle Eastern
                      practice of sleeping on cushions that had been thrown onto
                      the floor of a room.
                      <div></div>
                      <strong>Ancestor:</strong> مطرح 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> mattress 🇬🇧, materasso 🇮🇹,
                      matrac 🇸🇰, Matratze 🇩🇪, matras 🇳🇱, матра́с 🇷🇺, матрас 🇰🇬,
                      матрас 🇰🇿, materac 🇵🇱, madrass 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/midhla.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;مظلة"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the verb "ظَلَّلَ" /ẓallala/
                      -- "to cast a shadow".
                      <div></div>
                      <strong>Related to:</strong> ظل
                      <div></div>
                      <strong>Semantic equivalents:</strong> ร่ม 🇹🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;موسيقى"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)"
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, music 🇬🇧, му́зыка
                      🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik 🇮🇩, މިއުޒިކް 🇲🇻, muzik
                      🇲🇾, muziki 🇹🇿, musiikki 🇫🇮, musik 🇸🇪, музыка 🇰🇬, му́зика
                      🇺🇦, მუსიკა 🇬🇪, ሙዚቃ 🇪🇹
                      <div></div>
                      <strong>Descendants:</strong> مُوسِیقِی 🇮🇷, musiqi 🇦🇿,
                      موسیقی 🇵🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇦🇲 ARMENIAN 🇦🇲
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_ar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ավտոբուս"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, awtobus 🇹🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦,
                      বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵, ኣውቶቡስ 🇪🇷, авто́бус 🇷🇺,
                      אוֹטוֹבּוּס 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;գազ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gaz 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷,
                      ガス 🇯🇵, გაზი 🇬🇪, ගෑස් 🇱🇰, gaas 🇪🇪, gas 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gorg.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;գորգ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old Armenian "գորգ"
                      /gorg/ -- "rag", "floorcloth".
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tey.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;թեյ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe and parts of the Caucasus region
                      via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, thé 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> τσάι 🇬🇷, شَاي 🇸🇦, chá 🇵🇹, tè
                      🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ
                      🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай 🇷🇺,
                      choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇫🇮, te 🇸🇪, tee
                      🇫🇮, Tee 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/carpet.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;կարպետ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Old Armenian
                      "կապ" /kap/ -- "knot", "bond" and later "կապերտ" /kapert/
                      -- "rag".
                      <div></div>
                      <strong>Likely descendants:</strong> carpet 🇬🇧, カーペット
                      🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7fe2-UxXMI8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;մանևր"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Vulgar Latin verb
                      "*manuoperare" -- "to work by hand" (a compound of "manū"
                      -- "hand" + verb "operārī" -- "to work", "to toil"), via
                      the Old French verb "manouvrer" -- “to maneuver”.
                      <div></div>
                      <strong>Ancestor:</strong> manœuvre 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> maneuver 🇬🇧, маневар 🇲🇰,
                      maniobra 🇪🇸, manuver 🇮🇩, manewr 🇵🇱, манёвр 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mec.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ga15HCmlzig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;մեծ (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*méǵh₂-" -- "big", "great", via the Old Armenian "մեծ"
                      /mec/ "great", "big", "large".
                      <div></div>
                      <strong>Cognates:</strong> mayor 🇪🇸, maior 🇵🇹, major 🇬🇧,
                      μεγάλος 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/myshtsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;մկան"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Old Armenian "մուկն /mukn/ -- "mouse",
                      so called because flexed arm muscles look like little
                      mice.
                      <div></div>
                      <strong>Related to:</strong> մուկ
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲, mišića 🇭🇷, Muskel 🇩🇪, muscle 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/skyur.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/TN89d3tM1aY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;սկյուռ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Ancient Greek
                      "σκίουρος" /skíouros/ -- “shadow-tail”. So called because
                      presumably a squirrel makes shade with its own tail.
                      <div></div>
                      <strong>Cognates:</strong> écureuil 🇫🇷, esquilo 🇵🇹,
                      squirrel 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇦🇿 AZERBAIJANI 🇦🇿
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avtobus_uz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avtobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, awtobus 🇹🇲, ավտոբուս 🇦🇲, ավտոբուս 🇦🇲, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵, ኣውቶቡስ
                      🇪🇷, авто́бус 🇷🇺, אוֹטוֹבּוּס 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/moneta.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;manat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "monēta" -- "place
                      for coining money".
                      <div></div>
                      <strong>Ancestors:</strong> моне́та 🇷🇺, moneta 🇵🇱
                      <div></div>
                      <strong>Cognates:</strong> manat 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pomidor2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pomidor"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the plural "pomi d'oro" of
                      the Italian "pomo d'oro" -- "golden apple".
                      <div></div>
                      <strong>Ancestors:</strong> pomodoro 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> pomidoras 🇱🇹, بَنْدُورَة 🇸🇾,
                      помідор 🇺🇦, pomidor 🇦🇿, памідор 🇧🇾, помидор 🇰🇬, помидор
                      🇹🇯, pomidor 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;qaz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gas 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, gáz 🇭🇺,
                      gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵,
                      გაზი 🇬🇪, գազ 🇦🇲, ගෑස් 🇱🇰, gaas 🇪🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/reng.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rəng"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*reng-" – "to dye", via the Proto-Iranian "*rang-" – “to
                      colour", “to dye”, the Classical Persian "رنگ" /rang/ –-
                      “color”, and the Ottoman Turkish "رنك" /renk/ – “color".
                      <div></div>
                      <strong>Cognates:</strong> رنگ 🇮🇷, renk 🇹🇷, رنګ 🇦🇫, रंग 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇧🇾 BELARUSIAN 🇧🇾
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;газ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like "geest" -- "spirit", "ghost" (as in, the
                      "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Likely related to:</strong> хаос
                      <div></div>
                      <strong>Descendants:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷,
                      গ্যাস 🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲,
                      газ 🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, גַּז 🇮🇱,
                      gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz
                      🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス
                      🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, Gas 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zavtrak.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;за́ўтра"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "за" and "утро".
                      "завтра" was originally meant to signify a period that
                      would start as soon as we wake up from our night’s sleep
                      (i.e., in the next morning). Over time "за́ўтра" also came
                      to mean not just "the morning", but also "the entire day
                      after today."
                      <div></div>
                      <strong>Cognates:</strong> за́втра 🇷🇺, за́втра 🇺🇦
                      <div></div>
                      <strong>Semantic Equivalents:</strong> mañana 🇪🇸, morgen
                      🇩🇪, 明日 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;прабле́ма"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "прабле́ма"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> балет
                      <div></div>
                      <strong>Ancestor:</strong> пробле́ма 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> problem 🇬🇧, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problema 🇪🇸, problema 🇲🇹,
                      problema 🇱🇹, про́блем 🇲🇰, problème 🇫🇷, problēma 🇱🇻,
                      probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭, problem 🇵🇱, problem
                      🇹🇷, problemă 🇷🇴, problem 🏴󠁧󠁢󠁷󠁬󠁳󠁿, Problem 🇱🇺, Problem 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/smetse.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cмецце"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic verb
                      "*mestì" -- "to throw", "to sweep", via the noun "*sъ̏metь"
                      -- "sweepings", "trash".
                      <div></div>
                      <strong>Related to:</strong> падмятаць (<i>v</i>.),
                      <div></div>
                      <strong>Cognates:</strong> śmieci (<i>pl</i>.) 🇵🇱, smeti
                      🇸🇮, сміття́ 🇺🇦, смеће 🇷🇸
                      <div></div>
                      <strong>Semantic equivalents:</strong> basura 🇵🇭, basura
                      🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sorak.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cорaк"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old East Slavic verb
                      "cорокъ" -- "bunch (40) of sable pelts".
                      <div></div>
                      <strong>Likely related to:</strong> сарока
                      <div></div>
                      <strong>Cognates:</strong> cорок 🇷🇺, cорок 🇺🇦
                      <div></div>
                      <strong>Possible cognates:</strong> kırk 🇹🇷, кырк 🇰🇬, kyрк
                      🇹🇲, қырық 🇰🇿, qirq 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chay.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;чай"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea" and the Ottoman Turkish "چای" /çay/ -- "tea". The
                      drink and its corresponding word made its way into many
                      West and Central Asian languages via land-based trading
                      routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, чай 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, çay
                      🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭,
                      teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇧🇩 BENGALI 🇧🇩
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bas1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;বাস"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ca.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;চা"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Sino-Tibetan "*s-la" -- "leaf".
                      <div></div>
                      <strong>Ancestor: </strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té
                      🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý 🇹🇲, តែ 🇰🇭, شَاي
                      🇸🇦, çay 🇹🇷, ჩაი 🇬🇪, 차 🇰🇷, trà 🇻🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;গ্যাস"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gas 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷,
                      ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, ගෑස් 🇱🇰, gaas 🇪🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saramontir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;সঙ্গীত"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "संगीत"
                      /saṃgīta/ (which itself is a compound of the prefix "सम्-"
                      /sam-/ -- “together” and the verb "गै" /gai/ -- "to
                      sing").
                      <div></div>
                      <strong>Cognates:</strong> සංගීත 🇱🇰, संगीत 🇮🇳, संगीत 🇳🇵
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇦 BERBER 🇲🇦
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tamcha.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ⴰⵜⴰⵢ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe (and later North Africa) via
                      Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇪🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇧🇦 BOSNIAN 🇧🇦
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sevdah.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sevdah"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "سوداء" /sawdāʔ/
                      -– "melancholy", "black bile", which itself is the
                      feminine form of the noun "أَسْوَد" /ʔaswad/ -- "black",
                      via the Ottoman Turkish "سودا" /sevda/ -- "black bile",
                      "melancholy", "passion".
                      <div></div>
                      <strong>Ancestor:</strong> سوداء 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> sevda 🇹🇷, sevda 🇦🇱, სევდა 🇬🇪,
                      sevda 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇧🇬 BULGARIAN 🇧🇬
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;газ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like "geest" -- "spirit", "ghost" (as in, the
                      "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Likely related to:</strong> хаос
                      <div></div>
                      <strong>Descendants:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷,
                      গ্যাস 🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲,
                      газ 🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, גַּז 🇮🇱,
                      gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz
                      🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス
                      🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, Gas 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tomate.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;домат"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl (Aztec) "tomatl"
                      -- "tomatillo", "tomato". The word was brought to Spain
                      from the New World and from there spread all over Europe
                      and the rest of the world.
                      <div></div>
                      <strong>Ancestor:</strong> tomate 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> tomate 🇫🇷, Tomate 🇩🇪, tomate
                      🇵🇹, домат 🇲🇰, tomāts 🇱🇻, トマト 🇯🇵, 토마토 🇰🇷, ቲማቲም 🇪🇹,
                      टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat 🇲🇾, tomat 🇸🇪,
                      domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿, tomato 🇬🇧, ντομάτα 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;идиот"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”, and the
                      Latin "idiōta" -- "uneducated or illiterate person". Like
                      the Greeks before them, the Romans used the word to refer
                      to someone lacking any professional skills, but they
                      placed emphasis on the fact that an “idiota” lacked
                      education and was therefore ignorant.
                      <div></div>
                      <strong>Related to:</strong> идиоматичен (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> Idiot 🇩🇪, идиот 🇲🇰, идиот 🇷🇺,
                      idiot 🇬🇧, idiota 🇪🇸, idiota 🇵🇹, idiota 🇵🇱, idiot 🇬🇧,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kanibal_ma.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;канибал"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Карибски (<i>adj.</i>)
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/korova.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;крава"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Proto-Slavic "*kòrva"
                      -- "cow".
                      <div></div>
                      <strong>Related to:</strong> сърна́
                      <div></div>
                      <strong>Cognates:</strong> krowa 🇵🇱, корова 🇺🇦, крава 🇲🇰,
                      корова 🇷🇺, krava 🇸🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;проблем"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problém"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> балет
                      <div></div>
                      <strong>Ancestor:</strong> Problem 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> problem 🇬🇧, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problema 🇪🇸, problema 🇲🇹,
                      problema 🇱🇹, про́блем 🇲🇰, problème 🇫🇷, problēma 🇱🇻,
                      probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭, problem
                      🇵🇱, problem 🇹🇷, problemă 🇷🇴, problem 🏴󠁧󠁢󠁷󠁬󠁳󠁿, Problem 🇱🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/stob.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;сто"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Slavic "*sъ̏to" - "100"
                      <div></div>
                      <strong>Related to:</strong> про<u>цент</u>
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, сто
                      🇷🇺, sto 🇵🇱, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;xипопотам"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i> a "calque") of the Ancient Greek
                      "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, Nilpferd
                      🇩🇪, nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा 🇮🇳,
                      dobhareach 🇮🇪, su aygırı 🇹🇷, hipopótamo 🇪🇸, hipopótamo 🇵🇹,
                      hippopotamus 🇬🇧, гиппопота́м 🇷🇺, ippopotamo 🇮🇹, ჰიპოპოტამი
                      🇬🇪, 河马 🇨🇳, 하마 🇰🇷, hà mã 🇻🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇲 BURMESE 🇲🇲
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/myshtsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ကြွက်သား"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "ကြွက်" /krwak/ -- "rat",
                      "mouse", which itself is derived from the
                      Proto-Sino-Tibetan "*rwak" -- "rat". The word stems from
                      the idea that flexed arm muscles look like little rats (or
                      mice).
                      <div></div>
                      <strong>Related to:</strong> ကြွက်
                      <div></div>
                      <strong>Semantic equivalents:</strong> عَضَلَة 🇸🇦, մկան
                      🇦🇲, ماهیچِه 🇮🇷, muscle 🇬🇧, mišića 🇭🇷, ጭዋዳ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hkyau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ချောကလက်"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid
                      🇮🇪, coklat 🇲🇾, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/lakhpak.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;လက်ဖက်"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Sino-Tibetan "*s-la" -- "leaf".
                      <div></div>
                      <strong>Likely Cognates:</strong> 茶 🇨🇳, thé 🇫🇷, τσάι 🇬🇷,
                      chá 🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬,
                      chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪,
                      choy 🇺🇿, шай 🇰🇿, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ
                      🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj
                      🇸🇰, çaý 🇹🇲, តែ 🇰🇭, شَاي 🇸🇦, çay 🇹🇷, ჩაი 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇦🇩 CATALAN 🇦🇩
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/albercoc.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;albercoc"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and finally, the modern Catalan word.
                      <div></div>
                      <strong>Descendants:</strong> абрико́с 🇷🇺, абрико́с 🇺🇦,
                      abricot 🇫🇷, aibreog 🇮🇪, apricot 🇬🇧, Aprikose 🇩🇪, aprikoti
                      🇹🇿, aprikot 🇮🇩, abrikoos 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      berquq 🇲🇹, albaricoque 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobús.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobús"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>bús</u> 🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u>{" "}
                      🇸🇮, auto<u>bus</u> 🇵🇱, auto<u>bus</u>, авто́<u>бус</u> 🇷🇺,
                      autó<u>busz</u> 🇭🇺, ôni<u>bus</u> 🇵🇹, auto<u>busas</u> 🇱🇹,
                      巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস
                      🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/calamar_ca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;calamar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar,
                      kalmari 🇫🇮, calamar 🇦🇩, kalmar 🇸🇰, kałamarnica 🇵🇱, calmar
                      🇫🇷 🇦🇿
                      <div></div>
                      <strong>Ancestor:</strong> calamaro 🇮🇹
                      <div></div>
                      <strong>Descendant:</strong> calamar 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problema"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problema"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> ballar (<i>v.</i>), ballet
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problēma 🇱🇻, probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸,
                      пробле́ма 🇺🇦, пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴,
                      problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/xocolata.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;xocolata"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, seacláid 🇮🇪, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, chocolate 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇼 CHEWA 🇲🇼
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/basi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;basi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́
                      <u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>, 巴士 🇨🇳,
                      बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇲🇼, bhazi 🇿🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇨🇳 CHINESE 🇨🇳
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus_cn.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;巴士 🇭🇰🇲🇴"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, बस 🇮🇳, bas 🇲🇾, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস
                      🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saramontir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;博物館"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "博" /bó/ --
                      "wide," "extensive", "rich in knowledge", "物" /wù/ --
                      "thing", "object", "matter", "館" /guǎn/ -- "public
                      building", "hall", or "establishment". Literally, a
                      "博物館" is a "Hall of wide-ranging/extensive objects."
                      The individual morphemes existed in Classical Chinese.
                      However, compounded, they form the word "博物館", which
                      was borrowed from the Japanese "はくぶつかん"
                      /hakubutsukan/ -- "building for wide learning", a word
                      coined during the early Meiji period to convey the Western
                      concept of a "museum".
                      <div></div>
                      <strong>Semantic Ancestor:</strong> 博物館 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chac.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;茶"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Sino-Tibetan "*s-la" -- "leaf".
                      <div></div>
                      <strong>Likely Cognate:</strong> လက်ဖက် 🇲🇲
                      <div></div>
                      <strong>Descendants:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè
                      🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ
                      🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿,
                      шай 🇰🇿, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa
                      🇵🇭, teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý
                      🇹🇲, តែ 🇰🇭, شَاي 🇸🇦, çay 🇹🇷, ჩაი 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;河马"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i> a "calque") of the Ancient Greek
                      "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Descendants:</strong> 하마 🇰🇷, hà mã 🇻🇳
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, Nilpferd
                      🇩🇪, nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा 🇮🇳,
                      dobhareach 🇮🇪, su aygırı 🇹🇷, xипопота́м 🇧🇬, hipopótamo 🇪🇸,
                      hipopótamo 🇵🇹, hippopotamus 🇬🇧, гиппопота́м 🇷🇺, ippopotamo
                      🇮🇹, ჰიპოპოტამი 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jiao.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;角"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*krəw" -- "horn", "angle", "corner", via the Middle
                      Chinese "角" /kaewk/ -- "horn", "angle", "corner".
                      <div></div>
                      <strong>Cognates:</strong> giác 🇻🇳, 角 🇯🇵, 각 🇰🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> horn 🇬🇧, cuerno 🇪🇸,
                      corne 🇫🇷, hoorn 🇳🇱, horn 🇳🇴, horn 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cafe.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;咖啡"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then spread to Italian and other
                      European languages (and all around the world).
                      <div></div>
                      <strong>Ancestors:</strong> قَهْوَة 🇸🇦, koffie 🇳🇱, caffè
                      🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> kahawa 🇹🇿, কফি 🇧🇩, ކޮފީ 🇲🇻,
                      ကော်ဖီ 🇲🇲, ყავა 🇬🇪, กาแฟ 🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, کافی 🇵🇰,
                      кофе 🇰🇿, kafe 🇲🇬, қаҳва 🇹🇯, قهوه 🇮🇷, コーヒー 🇯🇵, 커피 🇰🇷,
                      кофе 🇲🇳, cà phê 🇻🇳, 咖啡 🇹🇼, kape 🇵🇭, កាហ្វេ 🇰🇭, ກາເຟ 🇱🇦,
                      coffee 🇬🇧, café 🇪🇸, Kaffee 🇩🇪, ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴,
                      kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰, kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩
                      kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦, ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷,
                      kaffe 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;阳伞"
                  hoverText={
                    <span>
                      <strong>Origin:</strong>"阳" /yáng/ -- "sun" is the
                      simplified form of the traditional character "陽" (which
                      itself is a phono-semantic compound of the semantic "阜"
                      -- “hill” + the phonetic "昜" -- "sunshine"). "伞" /sǎn/
                      -- "parasol", "cover" is a pictographic character (
                      <i>i.e.</i>, it looks directly like the object it
                      represents).
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      napernyő 🇭🇺, saulessargs 🇱🇻, 阳伞 🇨🇳, парасо́лька 🇺🇦,
                      parasol 🇪🇸, slnečník 🇸🇰, sončnik 🇸🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;雨伞"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Both "雨" /yǔ/ -- "rain" and "伞"
                      /sǎn/ -- "umbrella", "cover", are pictographic characters
                      (<i>i.e.</i>, they look directly like the object they
                      represent) with roots in Old Chinese.
                      <div></div>
                      <strong>Semantic equivalents:</strong> paraguas 🇪🇸,
                      deštník 🇨🇿, esernyő 🇭🇺, lietussargs 🇱🇻, parapluie 🇫🇷,
                      Regenschirm 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/qiaokeli.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;巧克力"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, チョコレート 🇯🇵, ချောကလက် 🇲🇲, 초콜릿 🇰🇷, چاکْلیٹ 🇵🇰,
                      tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦, chokola 🇭🇹, sokola 🇲🇬,
                      suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷, xocolata 🇦🇩, чокола́да
                      🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺, shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱,
                      шакалод 🇹🇯, Schokolade 🇩🇪, czekolada 🇵🇱, chocolate 🇵🇹,
                      coklat 🇲🇾, شکلات 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇭🇷 CROATIAN 🇭🇷
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_pl.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇷🇺, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas
                      🇱🇹, ავტობუსი 🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus
                      🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/myshtsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mišić"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*múHs" -- "mouse" via the Latin "mūsculus" -- "little
                      mouse", so called because flexed arm muscles look like
                      little mice.
                      <div></div>
                      <strong>Related to:</strong> miš
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, Muskel 🇩🇪, muskel 🇩🇰, muskel
                      🇳🇴, muskel 🇸🇪, мышца 🇷🇺, մկան 🇦🇲
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong> ጭዋዳ 🇪🇷,
                      عَضَلَة 🇸🇦, ماهیچه 🇮🇷, ကြွက်သား 🇲🇲 , ماهیچه 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/naranca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;naranča"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", via the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange", the Arabic "نارنج"
                      /nāranj/ –- “bitter orange”, and the Ottoman Turkish
                      "نارنج" /narenc/.
                      <div></div>
                      <strong>Cognates:</strong> orange 🇬🇧, arancia 🇮🇹, orange
                      🇬🇧, naranja 🇪🇸, на̀ра̄нча 🇷🇸, نارَنْج 🇮🇷, नारंगी 🇮🇳. laranja
                      🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sol1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sol"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Proto-Slavic "*solь" --
                      "salt".
                      <strong>Related to:</strong> salata
                      <div></div>
                      <strong>Cognates:</strong> sel 🇫🇷, sal 🇪🇸, sale 🇮🇹, αλάτι
                      🇬🇷, salt 🇩🇰, sól 🇵🇱, salt 🇸🇪, salt 🇬🇧, Salz 🇩🇪, sůl 🇨🇿,
                      sāls 🇱🇻, suola 🇫🇮, sool 🇪🇪, sal 🇵🇹, соль 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇨🇿 CZECH 🇨🇿
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_pl.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇦🇱, autobus
                      🇮🇹, авто́бус 🇷🇺, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas
                      🇱🇹, ავტობუსი 🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus
                      🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/caj.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;čaj"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, чай, ceai 🇷🇴, çay 🇹🇷, شَاي 🇸🇦,
                      çaý 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;deštník"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the noun
                      "déšť" -- "rain", and the nominal suffix "-ník".
                      <div></div>
                      <strong>Cognates:</strong> dáždnik 🇸🇰, dežnik 🇸🇮
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Regenschirm 🇩🇪,
                      lietussargs 🇱🇻, esernyő 🇭🇺, paraguas 🇪🇸, 雨伞 🇨🇳,
                      parachuva 🇵🇹, parapluie 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muzeum"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)", via the Latin "mūsēum" -- "library", "study".{" "}
                      <div></div>
                      <strong>Related to:</strong> múza
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      Museum 🇩🇪, музе́й 🇧🇾, muzeum 🇦🇱, موزه 🇮🇷, müze 🇹🇷, muzejs
                      🇱🇻, muzeum 🇨🇿, muuseum 🇪🇪, múzeum 🇭🇺, מוּזֵיאוֹן 🇮🇱, muzeý
                      🇹🇲, музе́й 🇷🇺, muzium 🇲🇾, muzȇj 🇸🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/window.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;okno"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*h₃ekʷ"
                      -- "eye" via the Proto-Slavic "okъnò" -- "window", and the
                      Old Czech "okno" -- "window".
                      <div></div>
                      <strong>Related to:</strong> oko
                      <div></div>
                      <strong>Cognates:</strong> okno 🇵🇱, wind<u>ow</u> 🇬🇧, vind
                      <u>u</u> 🇳🇴, акно 🇧🇾, okno 🇸🇮, oкно 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problém"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problém"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> balet
                      <div></div>
                      <strong>Ancestor:</strong> Problem 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> problem 🇬🇧, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problema 🇪🇸, problema 🇲🇹,
                      problema 🇱🇹, про́блем 🇲🇰, problème 🇫🇷, problēma 🇱🇻,
                      probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭, problem
                      🇵🇱, problem 🇹🇷, problemă 🇷🇴, problem 🏴󠁧󠁢󠁷󠁬󠁳󠁿, Problem 🇱🇺,
                      пробле́м 🇧🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;slunečník"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the noun
                      "slunce" -- "sun", and the nominal suffix "-ník".
                      <div></div>
                      <strong>Cognates:</strong> slnečník 🇸🇰, sončnik 🇸🇮
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      napernyő 🇭🇺, saulessargs 🇱🇻, 阳伞 🇨🇳, парасо́лька 🇺🇦,
                      parasol 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Schmetterling.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UrmfcQSPcqk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;smetana"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*sъmetana"
                      -- "whipped cream", via the Old Czech "smetana" --
                      "cream".
                      <div></div>
                      <strong>Descendants:</strong> Schmetten 🇦🇹
                      <div></div>
                      <strong>Cognates:</strong> śmietana 🇵🇱, smotana 🇸🇰,
                      смета́на 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/verblyud.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;velbloud"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek genitive
                      noun "ἐλέφαντος" /eléphăntos/ -- "(pertaining to) ivory",
                      via the Latin "elephantus" -- "elephant", via the Gothic
                      "𐌿𐌻𐌱𐌰𐌽𐌳𐌿𐍃" /ulbandus/ -- "camel", and the Proto-Slavic
                      "*velьb(l)ǫdъ" -- "camel". Neither camels nor elephants
                      are native to Europe, and Europeans traditionally,
                      considered those animals pretty exotic, without always
                      being able to differentiate which one is which, which is
                      why over time some Europeans confused both animals and
                      some, like many Slavic language speakers, took a variation
                      of “elephas” to denote “camel”, whereas others, like
                      Romance and Germanic ones, took it to denote their word
                      for “elephant”.
                      <div></div>
                      <strong>Cognates:</strong> wielbłąd 🇵🇱, верблюд 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vino.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;víno"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "vīnum" -- “wine”,
                      via the Old Czech "víno" -- "wine".
                      <div></div>
                      <strong>Related to:</strong> <u>вино</u>град
                      <div></div>
                      <strong>Cognates:</strong> vin 🇫🇷, wine 🇬🇧, viini 🇫🇮,
                      vinho 🇵🇹, vino 🇮🇹, vin 🇷🇴, wino 🇵🇱, vino 🇪🇸, wijn 🇳🇱,
                      vynas 🇱🇹, wain 🇲🇾, вино 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zavtrak.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;zítra (<i>adv.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*(j)utro"
                      -- "morning", "dawn", via the Old Czech "zajtra" --
                      "tomorrow morning". Over time "zítra" also came to mean
                      not just "the morning (of the coming day)", but also "the
                      entire day after today."
                      <div></div>
                      <strong>Related to:</strong> aura
                      <div></div>
                      <strong>Cognates:</strong> за́<u>ўтра</u> 🇧🇾, у́тре 🇧🇬, у́тре
                      🇲🇰, jutro 🇵🇱, за<u>втра</u> 🇷🇺
                      <div></div>
                      <strong>Semantic Equivalents:</strong> mañana 🇪🇸, morgen
                      🇩🇪, 明日 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇩🇰 DANISH 🇩🇰
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/elbow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;albue"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*alinō"
                      -- “forearm" + "*bugô" -- "bend", so literally, "place
                      where the forearm bends". From there, the word gradually
                      entered Danish through the Old Norse "ǫlnbogi" -- "elbow".
                      <div></div>
                      <strong>Related to:</strong> bue
                      <div></div>
                      <strong>Cognates:</strong> elbow 🇬🇧, Ellenbogen 🇩🇪, albue
                      🇳🇴, elleboog, ло́коть 🇷🇺, łokieć 🇵🇱, elmboog 🇿🇦, armbåge 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bjørn"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*bʰerH-" -- "brown", via the
                      Proto-Germanic "*berô" -- "the brown one", and the Old
                      Norse "bjǫrn" -- "bear". Most scholars believe that early
                      Germanic peoples called the animal “the brown one”, in an
                      effort to avoid calling it by its real name, which, in
                      those superstitious cultures, was considered taboo, and
                      could cause it to appear during a hunt.
                      <div></div>
                      <strong>Related to:</strong> brun (<i>adj.</i>)<div></div>
                      <strong>Cognates:</strong> Bär 🇩🇪, beer 🇳🇱, bjørn 🇳🇴, bear
                      🇬🇧
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong> медве́дь 🇷🇺,
                      niedźwiedź 🇵🇱, lokys 🇱🇹, lācis 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/blume.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;blomst"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Proto-Germanic
                      "*blōmô" -- “flower”, and the Old Norse "blóm" --
                      "flower".
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, fleur 🇫🇷, flor 🇵🇹,
                      flor 🇪🇸, fiore 🇮🇹, flower 🇬🇧, blomst 🇳🇴, Blume 🇸🇪, floare
                      🇷🇴, blomma 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;familie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Ancestor:</strong> Familie 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> familia 🇪🇸, familja 🇲🇹, family
                      🇬🇧, pamilya 🇵🇭, Familie 🇩🇪, famiglia 🇮🇹, família 🇵🇹,
                      familie 🇷🇴, famille 🇫🇷, familie 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fersken.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fersken"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name. From Latin, the word entered
                      modern Danish via the Old Danish "persic".
                      <div></div>
                      <strong>Related to:</strong> Persien
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, peach 🇬🇧, ferskja 🇮🇸,
                      fersken 🇳🇴, Pfirsich 🇩🇪, perzik 🇳🇱, persik 🇮🇩, piersică
                      🇷🇴, pjeshkë 🇦🇱, pichi 🇹🇿, pêssego 🇵🇹, праска 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gravity.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;gravid (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "gravis"
                      -- "heavy", via the noun "gravidus" -- "pregnant".
                      <div></div>
                      <strong>Cognates:</strong> gravid 🇳🇴, gravid 🇸🇪, gravidă
                      🇷🇴, grávida 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hundrede.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hundrede"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*hundaradą" -- "a large number (usually equal to either
                      100 or 120)", via the Old Norse "hundrað" -- "120". The
                      amount associated with "hundre" was gradually reduced to
                      "100" due to the influence of Christianity, which had
                      introduced the "short hundred" (<i>i.e.</i> "100") during
                      the Middle Ages.
                      <div></div>
                      <strong>Distantly related to:</strong> pro<u>cent</u>
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇳🇴, hundrað 🇮🇸, hundra
                      🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад 🇹🇯, εκατό
                      🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto 🇵🇱, сто 🇧🇬,
                      сто 🇷🇺, cent 🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/god.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gud"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the via the Proto-Germanic
                      "gudą" - "god", "deity" via the Old Norse "goð" -- "god".
                      <div></div>
                      <strong>Cognates:</strong> god 🇳🇱, gud 🇳🇴, gud 🇸🇪, Gott
                      🇩🇪, god 🇬🇧, god 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/krig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;krig"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*krīg" –- "strife", "endeavor", "struggle" via the Middle
                      Low German "krîch" -– "battle", "fight", "dispute".
                      <div></div>
                      <strong>Cognates:</strong> Krieg 🇩🇪, krig 🇳🇴, krig 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/morgen1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;morgen"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*murginaz" – "morning", "tomorrow", via the Old Norse
                      "morginn" -– “morning”.
                      <div></div>
                      <strong>Related to:</strong> morganatisk (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> morning 🇬🇧, morgen 🇳🇱, morgen
                      🇳🇴, morgon 🇸🇪, Morgen 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muskel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", so
                      called because flexed arm muscles look like little mice.
                      <div></div>
                      <strong>Related to:</strong> mus
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, muscle 🇬🇧, muskel 🇳🇴, muskel
                      🇸🇪, мышца 🇷🇺, mišića 🇭🇷, Muskel 🇩🇪
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/economy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;økonomi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "οἰκονομία"
                      /oikonomía/ -- "management of a household (a combination
                      of "οἶκος" /oîkos/ -- "house", "dwelling place" and the
                      verb "νέμω" /némō/ -- "to distribute", "to allocate”).
                      Originally, the word denoted the concept of properly
                      allocating and distributing the resources within one's
                      house.
                      <div></div>
                      <strong>Related to:</strong> <u>øko</u>logi
                      <div></div>
                      <strong>Cognates:</strong> economy 🇬🇧, economia 🇵🇹,
                      økonomi 🇳🇴, οικονομία 🇬🇷, economie 🇷🇴, economía 🇪🇸,
                      ekonomi 🇹🇷, экономия, économie 🇫🇷, ეკონომია 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ord.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ord"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say" via the Proto-Germanic
                      "*wurdą" -- "word", "saying", and the Old Norse "orð" --
                      "word", "saying".
                      <div></div>
                      <strong>Cognates:</strong> ord 🇸🇪, ord 🇳🇴, woord 🇳🇱, Wuert
                      🇱🇺, vārds 🇱🇻, word 🇬🇧, woord 🇳🇦, Wort 🇩🇪, word 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pensel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Later Latin "pēnicillum" --
                      "painter's brush", and the Old French "pincel" --
                      "paintbrush".
                      <div></div>
                      <strong>Related to:</strong> penis
                      <div></div>
                      <strong>Ancestor:</strong> Pinsel 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> pincel 🇵🇹, penseel 🇳🇱, pensel
                      🇳🇴, pincel 🇪🇸, pinzell 🇦🇩, pędzel 🇵🇱, пэндзаль 🇧🇾, пензель
                      🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saerk1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;særk"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*sorka" --
                      "shirt", via the Proto-Germanic "*sarkiz" -- "(armored)
                      shirt", "hauberk", and the Old Norse "serkr" -- "shirt".
                      <div></div>
                      <strong>Cognates:</strong> särk 🇸🇪, särk 🇪🇪, cорочка 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;soldat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army. From "solidus", the word eventually developed into
                      the Italian "soldo" -- "penny", cent", then "soldato" --
                      "soldier", "one who earns a 'soldo'", and then, finally,
                      the modern French word.
                      <div></div>
                      <strong>Ancestor:</strong> soldo 🇮🇹, soldato 🇮🇹, soldat 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> Soldat 🇩🇪, soldier 🇬🇧, soldado
                      🇵🇹, cолда́т 🇷🇺, soldado 🇪🇸, soldat 🇸🇪, soldat 🇷🇴, soldaat
                      🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      Originally the word was more closely associated with the
                      idea of people letting themselves get carried away in a
                      pleasant activity that allowed them to just relax and have
                      fun.
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, Sport 🇩🇪, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺,
                      ስፖርት 🇪🇹, šport 🇸🇰, spor 🇹🇷, sport 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fungus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;svamp"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*swambaz" --
                      "tree fungus", "mushroom", "sponge", via the Old East
                      Norse "svampr" -- "sponge", "fungus", and the Old Danish
                      "swamp" -- "sponge", "fungus".
                      <div></div>
                      <strong>Likely related to:</strong> sump
                      <div></div>
                      <strong>Cognates:</strong> svamp 🇳🇴, svamp 🇸🇪, zwam 🇳🇱,
                      fungus 🇬🇧, hongo 🇪🇸, fungo 🇵🇹, sponge 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/varld.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;verden"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*weraldiz" -- "lifetime", "worldly existence", "mankind",
                      which was a combination of "*weraz" -- "man", "husband"
                      and "*alþi" -- "age", "generation, "lifetime". The
                      "verden" therefore denotes the entire period of history
                      during which humans have inhabited the domain of mankind.
                      <div></div>
                      <strong>Related to:</strong> <u>var</u>ulv
                      <div></div>
                      <strong>Cognates:</strong> Welt 🇩🇪, wereld 🇳🇱, verden 🇳🇴,
                      world 🇬🇧, värld 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/window.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vindue"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old Norse "vindauga" (
                      <i>lit</i>. wind + eye) -- "eye (hole) for the wind". A
                      "vindauga" was an unglazed hole in the ceiling of a
                      building in Germanic cultures where smoke from fires could
                      be let out and wind could be let in. 
                      <div></div>
                      <strong>Related to:</strong> vind, øje
                      <div></div>
                      <strong>Cognates:</strong> window 🇬🇧, vindu 🇳🇴, ventana 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇻 DHIVEHI 🇲🇻
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jamal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ޖަމަލު"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel".
                      <div></div>
                      <strong>Ancestor:</strong> جمل 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> גמל 🇮🇱, camello 🇪🇸, camel 🇬🇧,
                      cammello 🇮🇹, camelo 🇵🇹, chameau 🇫🇷, kamel 🇩🇰, ޖަމަލު 🇲🇻,
                      ግመል 🇪🇹, Kamel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/galan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ގަލަން"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, possibly
                      via the Ge'ez "ቀለም" /ḳäläm/ -- "reed".
                      <div></div>
                      <strong>Ancestor:</strong> قلم 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> калем 🇰🇬, क़लम 🇮🇳, कलम 🇳🇵,
                      kalamu 🇹🇿, қалам 🇹🇯, қалам 🇰🇿, কলম 🇧🇩, kalem 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/say.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ސައި"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea" and the Ottoman Turkish "چای" /çay/ -- "tea". The
                      drink and its corresponding word made its way into many
                      West and Central Asian languages via land-based trading
                      routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, çay
                      🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩,
                      té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, чай 🇷🇺, tea 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇳🇱 DUTCH 🇳🇱
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aardappel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle Dutch "erdappel"
                      -- "apple of the earth".
                      <div></div>
                      <strong>Descendants:</strong> aartappel 🇿🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong>
                      pomme de terre 🇫🇷, תַּפּוּחַ אֲדָמָה 🇮🇱, سیب‌زمینی 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/abrikoos.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;abrikoos"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and finally, the modern Spanish word.
                      <div></div>
                      <strong>Ancestor:</strong> albercoc 🇦🇩
                      <div></div>
                      <strong>Descendants:</strong> абрико́с 🇷🇺, абрико́с 🇺🇦
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      abrikoos 🇳🇱, apricot 🇬🇧, berquq 🇲🇹, Aprikose 🇩🇪, aibreog
                      🇮🇪, aprikoti 🇹🇿, aprikot 🇮🇩, abricot 🇫🇷, albaricoque 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/antwoord.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VvZv83SW8Bg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;antwoord"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*andawurdiją" -- "answer", "reply" (which was itself a
                      compound of "*anda-" -- "against" and "*wurdiją" --
                      "speech", "conversation”) via the Middle Dutch "antworde"
                      -- "answer," "affirmation".
                      <div></div>
                      <strong>Related to:</strong> woord
                      <div></div>
                      <strong>Descendant:</strong> antwoord 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> <u>an</u>swer 🇬🇧, Antwort 🇩🇪,
                      antwoord 🇿🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avond.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avond"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*ēbanþs"
                      –- "evening", via the Old Dutch "āvont" -– "evening", "day
                      before", "west", and the Middle Dutch "âvont" --
                      "evening", "beginning of the day".
                      <div></div>
                      <strong>Not related to:</strong> even (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> evening 🇬🇧, Abend 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/toque.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/suyCgi6wEos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avondklok"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "avond --
                      "evening" and "klok" -- "clock", "bell", from the medieval
                      practice of ringing a bell every evening to signal that
                      fires should be put out for the night.
                      <div></div>aandklok
                      <strong>Descendants:</strong> aandklok 🇿🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> couvre-feu 🇫🇷,
                      toque de queda 🇪🇸, toque de recolher 🇵🇹, curfew 🇬🇧,
                      coprifuoco 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/beek.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PtZcAf8r9Ws"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;beek"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "bʰeg-" -- "flowing water", via the Old Dutch "beki" --
                      "brook"
                      <div></div>
                      <strong>Descendant:</strong> beek 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> bäck 🇸🇪, bekk 🇳🇴, beek 🇳🇱, Bach
                      🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/baer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;beer"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*bʰerH-" -- "brown", via the
                      Proto-Germanic "*berô" -- "the brown one". Most scholars
                      believe that early Germanic peoples called the animal “the
                      brown one”, in an effort to avoid calling it by its real
                      name, which, in those superstitious cultures, was
                      considered taboo, and could cause it to appear during a
                      hunt.
                      <div></div>
                      <strong>Related to:</strong> bruin (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> bear 🇬🇧, bjørn 🇩🇰, bjørn 🇳🇴,
                      Bär 🇩🇪
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong> медве́дь 🇷🇺,
                      niedźwiedź 🇵🇱, lokys 🇱🇹, lācis 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bloem.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bloem"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Proto-Germanic
                      "*blōmô" -- “flower”, via the Proto-West-Germanic "*blōmō"
                      -- "flower" and the Old High German "bluomo" –- "flower".
                      <div></div>
                      <strong>Descendant:</strong> blom 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> Blume 🇩🇪, fleur 🇫🇷, flor 🇵🇹,
                      flor 🇪🇸, fiore 🇮🇹, flower 🇬🇧, blomst 🇳🇴, blomst 🇩🇰, blomma
                      🇸🇪, floare 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/britches.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;broek"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*brōks"
                      -- "crotch", "hindquarters", "clothing that covers the
                      rear end", via the Proto-West-Germanic "*brōk" --
                      "crotch", "buttocks" (or also "clothing that covers the
                      buttocks") and the Old Dutch "*bruoc" -- "trousers",
                      "breeches".
                      <div></div>
                      <strong>Descendant:</strong> брюки 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> britches 🇺🇸, breeches 🇬🇧,
                      bríste 🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/braam.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;braam"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West-Germanic
                      "*brāmijō" -- "blackberry" (which itself is a combination
                      of "*brāma" -- "bramble", "thorn bush", and the agent noun
                      suffix "*-jō" – "berry"), via the Old Dutch "*brāmo" --
                      "blackberry", and the Middle Dutch "brame" --
                      "blackberry".
                      <div></div>
                      <strong>Cognates:</strong> Brombeere 🇩🇪, bjørne
                      <u>bær</u> 🇳🇴, bromber 🇫🇴, brombær 🇩🇰, brómber 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Descendant:</strong> bus 🇳🇦
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dag.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dag"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*dagaz"
                      -- "day", via the Old Dutch "dag" -- "day", and the Middle
                      Dutch "dach" -- "day".
                      <div></div>
                      <strong>Cognates:</strong> Tag 🇩🇪, day 🇬🇧, Dag 🇱🇺, dag 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/elbow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;elleboog"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*alinō"
                      -- “forearm" + "*bugô" -- "bend", so literally, "place
                      where the forearm bends". From there, the word gradually
                      entered Dutch through the Old Dutch "*elinbogo" --
                      "elbow".
                      <div></div>
                      <strong>Related to:</strong> boog
                      <div></div>
                      <strong>Related to:</strong> elmboog 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> elbow 🇬🇧, Ellenbogen 🇩🇪, albue
                      🇩🇰, albue 🇳🇴, ло́коть 🇷🇺, łokieć 🇵🇱, elmboog 🇿🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like "geest" -- "spirit", "ghost" (as in, the
                      "geest" that inhabits the air).
                      <div></div>
                      <strong>Likely related to:</strong> chaos, geest
                      <div></div>
                      <strong>Descendants:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷,
                      গ্যাস 🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲,
                      газ 🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬,
                      גַּז 🇮🇱, gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz
                      🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스
                      🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, Gas 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/geest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;geest"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Germanic
                      "*gaistaz" -- "spirit", "ghost", via the Old English
                      "gǣst" -- "breath", "spirit", "soul".
                      <div></div>
                      <strong>Descendants:</strong> gees 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> ghost 🇬🇧, Geist 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/honderd.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;honderd"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*hundaradą" -- "a large number (usually equal to either
                      100 or 120)", via the Old Dutch "*hundert" -- "100".
                      <div></div>
                      <strong>Descendants:</strong> honderd 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundert 🇩🇪, hundred 🇬🇧, صد 🇮🇷, सौ 🇮🇳, cад 🇹🇯, εκατό
                      🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto 🇵🇱, сто 🇧🇬,
                      сто 🇷🇺, cent 🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kaas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product", via the Proto-West-Germanic "*kāsī" -- "cheese".
                      <div></div>
                      <strong>Cognates:</strong> cheese 🇬🇧, queso 🇪🇸, keso 🇵🇭
                      queijo 🇵🇹, Käse 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dinde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kalkoen"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Short for "kalkoense haan" --
                      "hen from Calicut", in India, where turkeys were
                      traditionally believed to come from.
                      <div></div>
                      <strong>Descendants:</strong> kalkoen 🇿🇦, kalkun 🇩🇰,
                      kalkun 🇪🇪, kalakutas 🇱🇹, kalkkuna 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kannibaal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kannibaal"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Caribisch (<i>edj.</i>)
                      <div></div>
                      <strong>Not related to:</strong> canon, cannabis
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> kanibal 🇮🇩, kanibal 🇲🇾
                      <div></div>
                      <strong>Cognates:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/climat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;klimaat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west.
                      <div></div>
                      <strong>Cognates:</strong> climate 🇬🇧, climat 🇫🇷, кли́мат
                      🇷🇺, κλίμα 🇬🇷, iklim 🇮🇩, iqlim 🇺🇿, iklim 🇹🇷, ַַאַקְלִים 🇮🇱,
                      اِقْلِیم 🇮🇷. clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/klok.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;klok"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Celtic
                      "*klokkos" -- "bell", via the Medieval Latin "clocca" --
                      "bell", the Old Dutch "*clocca" -- "bell", and the Middle
                      Dutch "clocke" -- "bell".
                      <div></div>
                      <strong>Descendants:</strong> klok 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> cloch 🏴󠁧󠁢󠁷󠁬󠁳󠁿, klukka 🇮🇸, clog 🇮🇪,
                      cloche 🇫🇷, Glocke 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/coffee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;koffie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then eventually made its way
                      into Dutch via Italian.
                      <div></div>
                      <strong>Ancestors:</strong> قَهْوَة 🇸🇦, caffè 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> café 🇫🇷, café 🇪🇸, Kaffee 🇩🇪,
                      ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰,
                      kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦,
                      ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴, کافی 🇵🇰, кофе 🇰🇿,
                      kafe 🇲🇬, 咖啡 🇹🇼, қаҳва 🇹🇯, قهوه 🇮🇷, 咖啡 🇨🇳, ກາເຟ 🇱🇦,
                      កាហ្វេ 🇰🇭, кофе 🇲🇳, cà phê 🇻🇳, ကော်ဖီ 🇲🇲, ყავა 🇬🇪, กาแฟ
                      🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, কফি 🇧🇩, ކޮފީ 🇲🇻, kahve 🇹🇷
                      <div></div>
                      <strong>Descendants:</strong> coffee 🇬🇧, コーヒー 🇯🇵, kopi
                      🇲🇾, kopi 🇮🇩, 커피 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kooi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kooi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", and its derivative noun "cavea" – "hollow
                      place", "enclosure for animals", via the Middle Dutch
                      "coye" -- "cage".
                      <div></div>
                      <strong>Descendants:</strong> kou 🇳🇦<div></div>
                      <strong>Cognates:</strong> cage 🇬🇧, gabbia 🇮🇹, jaula 🇪🇸,
                      cage 🇫🇷, gaiola 🇵🇹, Käfig 🇩🇪, Koje 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/krijgen.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;krijgen (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*krīg" –- "strife", "endeavor", "struggle" via Old Dutch
                      "*crīgan" -- "to strive", "to gain".
                      <div></div>
                      <strong>Cognates:</strong> kriegen 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leiche.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;lichaam</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*līkahamô" -- "bodily frame", "corpse" (which itself was
                      a combination of "lijk" -- "body" and "haam" -- "covering)
                      via the Old Dutch "lichamo" -- "body" and the Middle Dutch
                      "lichame" -- "body".
                      <div></div>
                      <strong>Related to</strong>: lijk
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leiche.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;lijk</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*līką"
                      -- "body", via the Old Danish "līk" -- "corpse".
                      <div></div>
                      <strong>Not related to</strong>: lijken (<i>v.</i>)
                      <div></div>
                      <strong>Cognates</strong>: Leiche 🇩🇪, lig 🇩🇰, lik 🇸🇪, lík
                      🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leiche.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;lijken (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*leyg-" -- "similar", "level", "even", via the
                      Proto-Germanic verb "*galīkōną" -- "to be like", "to
                      resemble", and the Old Dutch "geliken" -- "to appear
                      similar to".
                      <div></div>
                      <strong>Not related to</strong>: lijk
                      <div></div>
                      <strong>Cognates</strong>: gleichen 🇩🇪 (<i>v.</i>)
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/matras1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;matras"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Descendants:</strong> matras 🇮🇩, matras 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> mattress 🇬🇧, materasso 🇮🇹,
                      matrac 🇸🇰, Matratze 🇩🇪, matelas 🇫🇷, матра́с 🇷🇺, матрас 🇰🇬,
                      матрас 🇰🇿, materac 🇵🇱, madrass 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mint.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;munt"
                  hoverText={
                    <span>
                      <strong>
                        <u>"place where coins are made"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        {" "}
                        <strong> Origin:</strong> From the Latin "monēta" --
                        "place for coining money", via the Old Dutch "munita" --
                        "coin". In Roman times the temple honoring the Goddess
                        Juno Moneta in Rome was next to the site where coins
                        were minted.
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Not related to:</strong> munt (the plant)
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Descendant:</strong> munt 🇿🇦
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Cognates:</strong> <u>Münz</u>anstalt 🇩🇪, casa
                        de <u>moeda</u> 🇵🇹, hôtel des <u>monnaies</u> 🇫🇷, casa
                        de <u>moneda</u> 🇪🇸, mennica 🇵🇱, <u>моне́тный</u> двор
                        🇷🇺, mint 🇬🇧
                      </div>
                      <div></div>
                      <strong>
                        <u>"plant"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        {" "}
                        <strong> Origin:</strong> From Mycenaean Greek "𐀖𐀲"
                        /mi-ta/ -- "mint plant" via the Latin "menta" -- "mint
                        (plant)".
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Not related to:</strong> munt (for coins)
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Descendant:</strong> min 🇮🇩
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong> Cognates:</strong> Minze 🇩🇪, menta 🇵🇹, menthe
                        🇫🇷, menta 🇪🇸, mięta 🇵🇱, мя́та 🇷🇺, menta 🇭🇺, mentă 🇷🇴,
                        mynte 🇳🇴, minttu 🇫🇮
                      </div>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nacht1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nacht"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*nókʷts" -- "night", via the Proto-Germanic "*nahts" --
                      "night", via the Old Dutch "naht" -- "night".
                      <div></div>
                      <strong>Cognates:</strong> Nuecht 🇱🇺, night 🇬🇧, Nacht 🇩🇪,
                      natt 🇳🇴, natt 🇸🇪, nuit 🇫🇷, noche 🇪🇸, noite 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nehmen.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;nemen (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*nemaną"
                      -- "to take" via the Old Dutch "neman" -- "to take (away)"
                      <div></div>
                      <strong>Related to:</strong> eco<u>nomie</u>
                      <div></div>neem
                      <strong>Descendant:</strong> neem 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> nehmen 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nijlpaard"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "Nijl" -- "Nile (River)" +
                      "paard" -- "horse".
                      <div></div>
                      <strong>Cognates:</strong> Nilpferd 🇩🇪, kuda <u>nil</u> 🇮🇩
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, 河马 🇨🇳,
                      فَرَس نَهْر 🇸🇦, दरियाई घोड़ा 🇮🇳, dobhareach 🇮🇪, su aygırı
                      🇹🇷, xипопота́м 🇧🇬, hipopótamo 🇪🇸, hipopótamo 🇵🇹,
                      hippopotamus 🇬🇧, гиппопота́м 🇷🇺, ippopotamo 🇮🇹, ჰიპოპოტამი
                      🇬🇪, virtahepo 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nonkel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hW6xrMIwfhI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nonkel 🇧🇪"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "avus" -- "adult
                      male relative (other than one's father)" and its
                      diminutive form "avunculus", which gradually came to mean
                      "maternal uncle", (<i>lit.</i> “little grandfather"). Over
                      time people realized that you couldn’t use one word to
                      denote two different male relatives, so the diminutive
                      “-unculus” was adopted to differentiate the “avus” (
                      <i>i.e.</i>, "grandfather") from the “avunculus” (
                      <i>i.e.</i>, "little grandfather” or “uncle”).
                      <div></div>
                      <strong>Ancestors:</strong> oncle 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> uncle 🇬🇧, Onkel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/oorlog.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Jl-keLpJSIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;oorlog"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first component, “oor” comes
                      from the Proto-Germanic prefix "uz" -- "up", "out of". The
                      second component "log" comes from the Proto-Germanic
                      "lagą" -- “law”, “situation”. Together, these two
                      components formed the Proto-Germanic "*uzlagą" -- "fate",
                      "destiny” (<i>lit.</i> “outside of the law”). "*uzlagą"
                      was often confused with the similar sounding word
                      "*uzleugō" -- "breaking of an agreement", "war". Over
                      time, people started to use the two words (and the two
                      meanings) interchangeably until the meaning "war" became
                      more prevalent. The Proto-Germanic "*uzlagą" gradually
                      developed into the Old Dutch "urlage" --"war", the Middle
                      Dutch "orloge" -- "war", and then, eventually, the Modern
                      Dutch word.
                      <div></div>
                      <strong>Related to:</strong> <u>oor</u>zaak, <u>oor</u>
                      sprong, leggen (<i>v.</i>)<div></div>
                      <strong>Descendant:</strong> oorlog 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> orlog 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/oorsprong.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Jl-keLpJSIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;oorsprong"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first component comes from
                      the Proto-Germanic prefix "uz" -- "up", "out of". The
                      second component comes from the Proto-West-Germanic
                      "*sprung" -- "jump", "leap". Literally, an "oorsprong" is
                      "that which springs up / springs forth."
                      <div></div>
                      <strong>Descendant:</strong> oorsprong 🇿🇦 <div></div>
                      <strong>Cognates:</strong> Ursprung 🇩🇪 <div></div>
                      <strong>Related to:</strong> <u>oor</u>zaak, <u>oor</u>
                      log
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/oorsprong.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Jl-keLpJSIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;oorzaak"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first component comes from
                      the Proto-Germanic prefix "uz" -- "up", "out of". The
                      second component comes from the Proto-West-Germanic
                      "*sakō" -- "case", "thing", "matter", "leap". Literally,
                      an "oorzaak" is "the thing from which something emerges
                      out of."
                      <div></div>
                      <strong>Descendant:</strong> oorsaak 🇿🇦 <div></div>
                      <strong>Cognates:</strong> Ursache 🇩🇪 <div></div>
                      <strong>Related to:</strong> <u>oor</u>sprong, <u>oor</u>
                      log
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paradijs"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible.
                      <div></div>
                      <strong>Descendants:</strong> paradys 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> paradise 🇬🇧, paraíso 🇵🇹,
                      paraiso 🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸, paraíso
                      🇪🇸, paradis 🇫🇷, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parasol"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Italian "parasole" --
                      "sun-blocker".
                      <div></div>
                      <strong>Related to:</strong> <u>para</u>plu
                      <div></div>
                      <strong>Ancestors:</strong> parasole 🇮🇹, parasol 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> parasol 🇵🇹, parasol 🇪🇸, parasol
                      🇩🇰, parasol 🇵🇱, парасо́лька 🇺🇦, parasol 🇬🇧
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      slunečník 🇨🇿, napernyő 🇭🇺, saulessargs 🇱🇻, 阳伞 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;penseel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Medieval Latin "pincellus" --
                      "painter's brush", "hair-pencil," (<i>lit.</i> "little
                      tail") and the Old French "pincel" -- "paintbrush".
                      <div></div>
                      <strong>Related to:</strong> penis
                      <div></div>
                      <strong>Descendants:</strong> pènsel 🇨🇼
                      <div></div>
                      <strong>Cognates:</strong> pincel 🇵🇹, pincel 🇪🇸, pensel
                      🇳🇴, pensel 🇩🇰, pędzel 🇵🇱, Pinsel 🇩🇪, pinzell 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/person.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LCiQz7vmiLY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;persoon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "persōna" -- "mask
                      used by actor", "role", "part", "character”. In the Roman
                      world, actors would wear “personae” during performances,
                      which would allow them “to portray a role” and “assume a
                      persona”. Gradually the word became associated both with
                      the mask itself and the actors wearing it, and eventually,
                      the mask meaning disappeared, and only the meaning related
                      to actors, and eventually, all human beings, remained.
                      <div></div>
                      <strong>Cognates:</strong> person 🇬🇧, Person 🇩🇪, persoon
                      🇳🇱, persona 🇪🇸, persona 🇮🇹, pessoa 🇵🇹, person 🏴󠁧󠁢󠁷󠁬󠁳󠁿, persuna
                      🇲🇹, personne 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/perzik.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;perzik"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name. From Latin, the word entered
                      modern Dutch via the Proto-West Germanic "*persik" –
                      “peach”, and Old Dutch "*persika" -- "peach".
                      <div></div>
                      <strong>Related to:</strong> Perzië
                      <div></div>
                      <strong>Descendant:</strong> persik 🇮🇩
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, peach 🇬🇧, ferskja 🇮🇸,
                      fersken 🇩🇰, fersken 🇳🇴, пе́рсик 🇷🇺, piersică 🇷🇴, pjeshkë
                      🇦🇱, pichi 🇹🇿, pêssego 🇵🇹, праска 🇲🇰, Pfirsich 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;probleem"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "probleem"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Ancestor:</strong> Problem 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> probleem 🇳🇱, прабле́ма 🇧🇾
                      problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem 🇵🇱,
                      problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧, problēma
                      🇱🇻, problema 🇮🇹, probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sinaasappel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sinaasappel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the French "pomme de Sine"
                      🇫🇷 – “apple from China”. The name reflects the fact that
                      the fruit originated from a region that encompasses
                      Southern China.
                      <div></div>
                      <strong>Cognates:</strong> apelsin 🇸🇪, Apfelsine 🇩🇪,
                      appelsin 🇳🇴, апельсин 🇰🇿, апельсин 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/thee.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;thee"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century and brought to
                      Europe in the following centuries where it was gradually
                      adopted by the local languages.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> τσάι 🇬🇷, شَاي 🇸🇦, chá 🇵🇹, чай
                      🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ
                      🇩🇿, чай 🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, ސައި
                      🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tra 🇻🇳
                      <div></div>
                      <strong>Descendants:</strong> thé 🇫🇷, tè 🇮🇹, tee 🇫🇮, te
                      🇸🇪, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿,
                      tēja 🇱🇻, tae 🇮🇪, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭,
                      teh 🇮🇩, té 🇪🇸, Tee 🇩🇪, tsa 🇵🇭, teh 🇮🇩, tea 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;twee"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Germanic "*twai" -- "two", the
                      Proto-West-Germanic "*twai-" and the Old Dutch "twêe" --
                      "two".
                      <div></div>
                      <strong>Related to:</strong> dubbel, twijg, tweeling
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      two 🇬🇧, to 🇳🇴, dwa 🇵🇱, dó 🇮🇪, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪, два
                      🇧🇬, երկու 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/twig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;twijg"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*dwóh₁" -- "two", via the Proto-Germanic "*twīgą" --
                      "forked branch", so called because branches are often two
                      pronged.
                      <div></div>
                      <strong>Related to:</strong> twee, tweeling, dubbel (
                      <i>adj.</i>)<div></div>
                      <strong>Cognates:</strong> Zweig 🇩🇪, twig 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/heure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;uur"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ὥρα"
                      /hṓra/ -- "any time or period, whether of the year, month,
                      or day”, via the Latin "hōra" -- "hour", and the Middle
                      Dutch "ûre" -- "hour".
                      <div></div>
                      <strong>Related to:</strong> jaar
                      <div></div>
                      <strong>Cognates:</strong> hora 🇵🇹, hora 🇪🇸, hour 🇬🇧, ora
                      🇮🇹, uur 🇳🇱, oră 🇷🇴, hora 🇦🇩, heure 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/foot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;voet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Proto-Germanic
                      "*fōts" -- "foot", and the Old Dutch "fuot" -- "foot".
                      <div></div>
                      <strong>Related to:</strong> pedaal, piloot, <u>voet</u>
                      ganger
                      <div></div>
                      <strong>Cognates:</strong> Fuß 🇩🇪, pie 🇪🇸, pied 🇫🇷, πόδι
                      🇬🇷, fot 🇸🇪, پا 🇮🇷, پَاؤُں 🇵🇰, पैर 🇮🇳, fot 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/war_du.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;war"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*werru" –- "confusion", "disorder", via the Old Dutch
                      "*werra" – "confusion", "disarray".
                      <div></div>
                      <strong>Related to:</strong> ver<u>warr</u>en (<i>v.</i>)
                      <div></div>
                      <strong>Cognates:</strong> Ver<u>wirr</u>ung 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/welt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;wereld"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*weraldiz" -- "lifetime", "worldly existence", "mankind",
                      which was a combination of "*weraz" -- "man", "husband"
                      and "*alþi" -- "age", "generation, "lifetime". The
                      "wereld" therefore denotes the entire period of history
                      during which humans have inhabited the domain of mankind.
                      <div></div>
                      <strong>Related to:</strong> <u>weer</u>wolf
                      <div></div>
                      <strong>Descendant:</strong> wêreld 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> world 🇬🇧, Welt 🇩🇪, verden 🇳🇴,
                      verden 🇩🇰, värld 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/wiskunde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;wiskunde"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined by the 16th Century
                      Flemish mathematician Simon Stevin from the Ancient Greek
                      phrase "μαθηματικὴ τέχνη" /mathēmatikḗ tékhnē/ --
                      "mathematical sciences”, "sciences of matters that have
                      been learned". Originally, "μαθηματικὴ τέχνη" referred to
                      the science of learning in general. Only after the term
                      was used by the "mathematikoi" (<i>i.e.,</i> "those who
                      love to learn"), a group of scholars in Ancient Greece who
                      studied the ideas of Pythagoras, especially those
                      pertaining to arithmetic and geometry, did the term
                      "μαθηματικὴ τέχνη" become closely associated with its
                      modern meaning.
                      <div></div>
                      <strong>Descendant:</strong> wiskunde 🇿🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> mathematics 🇬🇧,
                      математика 🇰🇿, matematik 🇹🇷, matematica 🇮🇹, matematika 🇸🇰,
                      Mathematik 🇩🇪, математика 🇰🇬, matematyka 🇵🇱, matematik 🇸🇪,
                      matemáticas 🇪🇸, matematik 🇹🇷, математик 🇲🇳, матема́тика 🇷🇺,
                      matematika 🇵🇭, matamaitic 🇮🇪, mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/woord.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;woord"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say" via the Proto-Germanic
                      "*wurdą" -- "word", "saying", the Proto-West-Germanic
                      "*word" -- "word", and the Old Dutch "wort" -- "word".
                      <div></div>
                      <strong>Related to:</strong> antwoord
                      <div></div>
                      <strong>Descendant:</strong> woord 🇳🇦
                      <div></div>
                      <strong>Cognates:</strong> ord 🇸🇪, ord 🇳🇴, ord 🇩🇰, Wort
                      🇩🇪, Wuert 🇱🇺, vārds 🇱🇻, word 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/worden.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;worden (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wert-" -- "to turn", "to wind", via the Proto-Germanic
                      "*werþaną" -- "to become", "to come into existence", the
                      Old Dutch "werthan" -- "to become", and the Middle Dutch
                      "werden" -- "to become", "to happen".
                      <div></div>
                      <strong>Related to:</strong> waarde
                      <div></div>
                      <strong>Cognates:</strong> werden (<i>v.</i>) 🇩🇪, verða (
                      <i>v.</i>) 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b51FXNHemec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;zeer (<i>adv.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*seh₂yro" -- "hard", "rough", "painful" via the Old Dutch
                      "sēr" -- "pain" and the Middle Dutch "sêer" -- "pain",
                      "rash"
                      <div></div>
                      <strong>Descendants:</strong> seer 🇿🇦
                      <div></div>
                      <strong>Cognates:</strong> sår 🇩🇰 (<i>n.</i>), sår 🇳🇴 (
                      <i>n.</i>), sore 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fungus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;zwam"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*swambaz" --
                      "tree fungus", "mushroom", "sponge", via the Old East
                      Norse "svampr" -- "sponge", "fungus", and the Old Danish
                      "swamp" -- "sponge", "fungus".
                      <div></div>
                      <strong>Cognates:</strong> svamp 🇩🇰, svamp 🇸🇪, fungus 🇬🇧,
                      hongo 🇪🇸, fungo 🇵🇹, sponge 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇧🇹 DZONGKHA 🇧🇹
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sja.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ཇ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Chinese "茶" /chá/ -- "tea",
                      the Persian "چای" /čây/ -- "tea" and the Tibetan "ཇ" /ja/
                      -- "tea".
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲, chai 🇹🇿, شَاي 🇸🇦, tea 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇪🇪 ESTONIAN 🇪🇪
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/buss.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;buss"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gaas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, Gas 🇩🇪
                      <div></div>
                      <strong>Related to:</strong> kaos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷,
                      ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hüpoteek"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Related to:</strong> tees
                      <div></div>
                      <strong>Ancestor:</strong> Hypothek 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> ipotek 🇹🇷, hipoteca 🇵🇹,
                      hypothèque 🇫🇷, hipoteka 🇵🇱, hipoteka 🇸🇮, ипотека 🇰🇿,
                      hipoteca 🇪🇸, ипотека 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muuseum"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)".
                      <div></div>
                      <strong>Related to:</strong> muusika
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      Museum 🇩🇪, музе́й 🇧🇾, muzeum 🇦🇱, موزه 🇮🇷, müze 🇹🇷, muzejs
                      🇱🇻, muzeum 🇨🇿, muzeum 🇨🇿, múzeum 🇭🇺, מוּזֵיאוֹן 🇮🇱, muzeý
                      🇹🇲, музе́й 🇷🇺, muzium 🇲🇾, muzȇj 🇸🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;probleem"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "probleem"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Ancestor:</strong> Problem 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> probleem 🇳🇱, прабле́ма 🇧🇾
                      problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem 🇵🇱,
                      problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧, problēma
                      🇱🇻, problema 🇮🇹, probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saerk.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;särk"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*sorka" --
                      "shirt", via the Proto-Germanic "*sarkiz" -- "(armored)
                      shirt", "hauberk".
                      <div></div>
                      <strong>Cognates:</strong> særk 🇩🇰, särk 🇸🇪, cорочка 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tee2.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tee"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, Tee 🇩🇪, tee 🇫🇮
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇫🇮, te 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇫🇮 FINNISH 🇫🇮
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kaasu"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1845 by the Finnish
                      physician Samuel Roos, who borrowed the word from Dutch.
                      The original Dutch word was coined by the chemist Jan
                      Baptist van Helmont, who derived the name from the Ancient
                      Greek "χάος" /kháos/ -- “chasm", "void", "empty space”,
                      and likely also from the fact that it sounded like the
                      Dutch "geest" -- "spirit", "ghost" (as in, the "geest"
                      that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to:</strong> kaaos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, gas 🇬🇧, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kalmari.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kalmari"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Ancestor:</strong> calamaro 🇮🇹, calmar 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar
                      🇦🇿, kalmari 🇫🇮, calamar 🇪🇸, calamar 🇦🇩, kalmar 🇸🇰,
                      kałamarnica 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;musiikki"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)", via the Latin "mūsica" --
                      "music".
                      <div></div>
                      <strong>Related to:</strong> museo
                      <div></div>
                      <strong>Ancestor</strong> musik 🇸🇪
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, música 🇪🇸,
                      مُوسِيقَى 🇸🇦, му́зыка 🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik
                      🇮🇩, music 🇬🇧, музыка 🇰🇬, му́зика 🇺🇦, მუსიკა 🇬🇪, ሙዚቃ 🇪🇹,
                      މިއުޒިކް 🇲🇻, muzik 🇲🇾, muziki 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ongelma"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Perhaps from "onki" -- "fishing
                      rod", and the derivational suffix "-lma", which is used to
                      form nouns denoting an object, tool or result. The
                      semantic shift is perhaps from the idea that an "ongelma"
                      is a hitch, a snag, or a difficult situation one is caught
                      up in.
                      <div></div>
                      <strong>Perhaps related to:</strong> onki
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/albtraum.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;painajainen"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first element is from the
                      verb "painaa" -- "to press", "to imprint" (which is from
                      from the Proto-Uralic "*pajńa-" -- "to press" via the
                      Proto-Finnic verb "*painadak" -- "to press", "to push".)
                      The second element is the suffix "-jainen", which is added
                      to certain nouns. Literally, a "painajainen" means "one
                      who presses" or "one who weighs down". The word is linked
                      to the folkloric belief that "painajaiset" are caused by
                      an evil spirit who sits on your chest while you sleep and
                      tries to suffocate you.
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, incubo
                      🇮🇹, كابوس 🇸🇦, nightmare 🇬🇧, cauche<u>mar</u> 🇫🇷,{" "}
                      <u>mar</u>
                      dröm 🇸🇪, кош<u>ма́р</u> 🇷🇺, <u>mar</u>tröð 🇮🇸, kosz
                      <u>mar</u> 🇵🇱, <u>mare</u>ritt 🇳🇴, coș<u>mar</u> 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/suklaa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;suklaa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolat 🇫🇷,
                      choklad 🇸🇪
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾, شکلات 🇮🇷,
                      チョコレート 🇯🇵, chocolate 🇬🇧, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tee2.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tee"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, te 🇸🇪
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸
                      <div></div>
                      <strong>Descendant:</strong> tee 🇪🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇫🇷 FRENCH 🇫🇷
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/abricot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;abricot"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and finally, the Catalan "a(l)bercoc", before
                      evolving into the modern French word.
                      <div></div>
                      <strong>Related to:</strong> précoce (<i>adj.</i>)
                      <div></div>
                      <strong>Ancestor:</strong> albercoc 🇦🇩
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      albaricoque 🇪🇸, abrikoos 🇳🇱, apricot 🇬🇧, абрико́с 🇷🇺,
                      абрико́с 🇺🇦, berquq 🇲🇹, Aprikose 🇩🇪, aibreog 🇮🇪, aprikoti
                      🇹🇿, aprikot 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/admire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;admirer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", plus the prefix "ad-"
                      -- (added to verbs to intensify the action).
                      <div></div>
                      <strong>Related to:</strong> miroir, mirage, merveille
                      <div></div>
                      <strong>Cognates:</strong> admirar 🇪🇸, admirar 🇵🇹,
                      ammirare 🇮🇹, admiroj 🇦🇱, ammira 🇲🇹, admirar 🇦🇩
                      <div></div>
                      <strong>Descendants:</strong> admire 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adult.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;adulte"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "alescere" --
                      "to be nourished", "to grow up", via the Latin verb
                      "adolēscere" -- "to grow up", "to come to maturity", "to
                      ripen" and its past participle "adultus" -- "grown up",
                      "matured", "adult".
                      <div></div>
                      <strong>Related to:</strong> adolescent, aliment
                      <div></div>
                      <strong>Cognates:</strong> adulto 🇪🇸, adult 🇬🇧, adulto 🇵🇹,
                      adult 🇷🇴, adult 🇦🇩, adulto 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/alumnus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aliment"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "alimentum" --
                      "food", "nourishment", which itself is a combination of
                      the verb "alō" -- "to nourish" and the suffix "-mentum" --
                      "instrument", "medium", so literally an "aliment" is "a
                      medium of nourishment"
                      <div></div>
                      <strong>Related to:</strong> adulte
                      <div></div>
                      <strong>Cognates:</strong> alimento 🇪🇸, alimento 🇵🇹,
                      alimento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/animal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;âme"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "anima" -- "soul",
                      "spirit", "life", "air" , "breath" via the Old French
                      "ame"
                      <div></div>
                      <strong>Related to:</strong> animer (v.)
                      <div></div>
                      <strong>Cognates:</strong> anima 🇮🇹, alma 🇪🇸, alma 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ami.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ami"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "amō" -- "I
                      love" via the adjective "amīcus" -- "friendly," "pleasant
                      to be around", and the Old French "amic" -- "friend"
                      <div></div>
                      <strong>Related to:</strong> enn<u>emi</u>
                      <div></div>
                      <strong>Cognates:</strong> amigo 🇪🇸, amigo 🇵🇹, amico 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ananas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ananas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Tupi-Guarani
                      "*nanã" -- "pineapple", via the Old Tupi "naná" --
                      "pineapple".
                      <div></div>
                      <strong>Cognates:</strong> Ananas 🇩🇪, анана́с 🇷🇺, آناناس
                      🇮🇷, أَنَانَاس 🇸🇦, nanasi 🇹🇿, ананас 🇰🇿, ananāss 🇱🇻
                      <div></div>
                      <strong>Descendants:</strong> ananas 🇫🇮, ananas 🇹🇷, နာနတ်
                      🇲🇲, ananas 🇩🇰, ananas 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/animal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;animal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "anima" -- "soul",
                      "spirit", "life", "air" , "breath" via the adjective
                      "animālis" -- "animate", "living."
                      <div></div>
                      <strong>Related to:</strong> animer (<i>v.</i>)<div></div>
                      <strong>Cognates:</strong> animal 🇬🇧, animale 🇮🇹, annimal
                      🇲🇹, animal 🇪🇸, animal 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apologie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/tOnL1s10mE4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;apologie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek ἀπολογία
                      /apología/ -- "formal defense of an opinion, position, or
                      action" via the Ecclesiastical Latin "apologia" --
                      "defense", "apology".
                      <div></div>
                      <strong>Descendants:</strong> apology 🇬🇧
                      <div></div>
                      <strong>Related to:</strong> <u>apo</u>calypse, pro
                      <u>logue</u>, épi<u>logue</u>, étymo
                      <u>logie</u>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/assassin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zSk51b0WVHw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;assassin"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "أَسَاسِيِّين"
                      /ʔasāsiyyīn/ (the name for members of a fundamentalist
                      order in Shia Islam who made it their mission to protect
                      the Muslim faith in the Levant and Persia during the
                      Crusader Era). The word is traditionally thought to derive
                      from "حَشَّاشِين" /ḥaššāšīn/ -- "hashish users", as
                      members of the order were presumed (primarily by their
                      enemies) to be heavy users of hashish. It is, however,
                      more likely derived from "أَسَاس" /ʔasās/ -- “foundation",
                      "basis”.
                      <div></div>
                      <strong>Cognates:</strong> assassin 🇬🇧, asesino 🇪🇸,
                      assassino 🇵🇹, assassino 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobuz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Descendants:</strong> autobús 🇪🇸, avtobus 🇸🇮,
                      авто́бус 🇷🇺, autóbusz 🇭🇺, ônibus 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus 🇹🇲,
                      אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦,
                      বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/average.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/cI0Fa9UD9S8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avarie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Arabic verb
                      "عَوِرَ" /ʕawira/ -- “to lose an eye" and the derived
                      "عَوَار" /ʕawār/ -- "blemish", "defect" via "عَوَارِيَّة"
                      /ʕawāriyya/ -- “damaged goods" and, later, the Italian
                      "avaria" -- "damage done to goods (that have been thrown
                      overboard) on a watercraft."
                      <div></div>
                      <strong>Cognates:</strong> avería 🇪🇸, avaria 🇵🇹, avaria
                      🇮🇹, avaria 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adventure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/t4CwXz_CSU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aventure"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "adventūrus" --
                      "to be about to arrive", a participle of the verb
                      "adveniō" -- "to arrive", "to come to a specific
                      location". The original sense of "aventure" is therefore
                      "something that is about to happen (no matter how mundane
                      or exciting)."
                      <div></div>
                      <strong>Related to:</strong> venir (v.)
                      <div></div>
                      <strong>Cognates:</strong> Abenteuer 🇩🇪, adventure 🇬🇧,
                      avontuur 🇳🇱, aventura 🇪🇸, avventura 🇮🇹, aventura 🇵🇹,
                      äventyr 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avis.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avis"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin prefix
                      "ad-" -- "to", "in", and the passive participle "vīsus" --
                      "having been seen" of the verb "videō" -- "to see". The
                      combination was the basis of the latter part of the Old
                      French phrase "ce m'est a vis" – “it is my view”, which
                      eventually developed into the single word "avis" --
                      "opinion".
                      <div></div>
                      <strong>Related to:</strong> en<u>vie</u>, pru<u>dence</u>
                      , visa, vision, visite, vidéo, évi<u>dent</u> (<i>adj</i>
                      .),
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ball.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "βάλλω"
                      /bállō/ -- “to throw, to cast, to hurl” via the Latin
                      "ballō" -- “to dance”.
                      <div></div>
                      <strong>Related to:</strong> pro<u>blème</u>, ballet
                      <div></div>
                      <strong>Not related to:</strong> balle
                      <div></div>
                      <strong>Cognates:</strong> Ball 🇩🇪, bal 🇳🇱, baile 🇵🇹, ball
                      🇬🇧 baile 🇪🇸, ballo 🇮🇹, бал 🇧🇬, бал 🇲🇰, bal 🇺🇿, ball 🇮🇸,
                      бал 🇺🇦, бал 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;banane"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳
                      <div></div>
                      <strong>Cognates:</strong> banana 🇬🇧, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana
                      🇪🇸, banana 🇵🇹, banāns 🇱🇻, Banane 🇩🇪, banaan 🇳🇱, μπανάνα
                      🇬🇷, banan 🇸🇪
                      <div></div>
                      <strong>Descendants:</strong> бана́н 🇷🇺, бана́н 🇧🇬, banán
                      🇭🇺, бана́н 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ball.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ballet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "βάλλω" /bállō/ -- “to throw", "to cast", "to hurl” via
                      the Latin "ballō" -- “to dance”.
                      <div></div>
                      <strong>Ancestor:</strong> balletto 🇮🇹
                      <div></div>
                      <strong>Related to:</strong> pro<u>blème</u>, bal
                      <div></div>
                      <strong>Not related to:</strong> balle
                      <div></div>
                      <strong>Cognates:</strong> Ballett 🇩🇪, ballet 🇬🇧, ballet
                      🇳🇱, balé 🇵🇹, ballet 🇪🇸, baletas 🇱🇹, бале́т 🇧🇬, бале́т 🇲🇰,
                      balets 🇱🇻, ballett 🇪🇪, balett 🇭🇺, балет 🇷🇸, бале́т 🇺🇦,
                      бале́т 🇷🇺, balet 🇷🇴, μπαλλέτο 🇬🇷, ballett 🇳🇴, بیلے 🇵🇰,
                      بَالِيه 🇸🇦, باله 🇮🇷, バレエ 🇯🇵, <u>芭蕾</u>舞 🇨🇳, 발레 🇰🇷,
                      ບາເລ 🇱🇦, បាឡេ 🇰🇭, балет 🇲🇳, ba lê 🇻🇳, ဘဲလေး 🇲🇲, բալետ 🇦🇲,
                      ბალეტი 🇬🇪, บัลเล่ต์ 🇹🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/budget.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bdywn-WNYnw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;bouger (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "bulliō" --
                      "to bubble", "to boil" via the Vulgar Latin verb
                      "*bullicāre" -- "to boil", "to bubble up".
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bougie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/SRAX1HQCFcI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bougie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the phrase "chandelle de
                      Bougie". "Bougie" was the French-language version of the
                      city nowadays called "بجاية" /Béjaïa/, in Algeria. The
                      city's original name was the Kabyle "ⴱⴳⴰⵢⵜ" /bgayet/,
                      itself from the earlier Berber "*tabeɣayt" -- "brambles
                      and wild blackberries". The town was known as a top
                      producer and exporter of beeswax in the Middle Ages, most
                      of which was sold in Europe and used to make candles,
                      which were in high demand at the time, especially in
                      Christian churches.
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/brush.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;brosse"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*bruskaz" --
                      “tuft", "thicket", "underbrush” via the Old French
                      "broisse" -- "brush".
                      <div></div>
                      <strong>Cognates:</strong> brush 🇬🇧, brocha 🇪🇸, brocha 🇵🇹
                      <div></div>
                      <strong>Descendants:</strong> برس 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/budget.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bdywn-WNYnw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;budget"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰelǵʰ-" -- "to swell", via the Latin "bulga" --
                      "knapsack", "wallet" and the Old French "bougette" --
                      "small leather pouch", "wallet". In the 17th and 18th
                      centuries, politicians often used "budgets" for their
                      everyday affairs, including government officials, who used
                      them to carry important paperwork, including ones related
                      to finance (such as Prime Minister Robert Walpole, whose
                      tax policies were criticized in an 1833 pamphlet called
                      “the budget opened”).
                      <div></div>
                      <strong>Ancestors:</strong> budget 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buiséad 🇮🇪, bajeti 🇹🇿
                      <div></div>
                      <strong>Descendants:</strong> budget 🇩🇰, budget 🇸🇪, буџет
                      🇲🇰, bütçe 🇹🇷, բյուջե 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cafe.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;café"
                  hoverText={
                    <span>
                      <strong>
                        <u>"beverage made with coffee beans"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                        /qāhē/ -- "to become blunt", "to become dull", In the
                        Umayyad period, people considered coffee to be an
                        intoxicating drink that dulled the mind and deprived one
                        of appetite. Eventually the word developed into Arabic
                        as "قَهْوَة" -- "coffee" and then spread to Italian and
                        other European languages (and all around the world).
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Ancestors:</strong> قَهْوَة 🇸🇦, koffie 🇳🇱, caffè
                        🇮🇹
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> kahawa 🇹🇿, কফি 🇧🇩, ކޮފީ 🇲🇻,
                        ကော်ဖီ 🇲🇲, ყავა 🇬🇪, กาแฟ 🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, کافی
                        🇵🇰, кофе 🇰🇿, kafe 🇲🇬, қаҳва 🇹🇯, قهوه 🇮🇷, コーヒー 🇯🇵,
                        咖啡 🇨🇳, 커피 🇰🇷, кофе 🇲🇳, cà phê 🇻🇳, 咖啡 🇹🇼, kape 🇵🇭,
                        កាហ្វេ 🇰🇭, ກາເຟ 🇱🇦
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Descendants:</strong> coffee 🇬🇧, café 🇪🇸, Kaffee
                        🇩🇪, ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе
                        🇲🇰, kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва
                        🇺🇦, ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴
                      </div>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cage.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cage"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", and its derivative noun "cavea" – "hollow
                      place", "enclosure for animals", via the Old French "cage"
                      – "cage", "enclosure".
                      <div></div>
                      <strong>Related to:</strong> caverne, geôle, cajoler (
                      <i>v.</i>)<div></div>
                      <strong>Cognates:</strong> Käfig 🇩🇪, kooi 🇳🇱, gabbia 🇮🇹,
                      jaula 🇪🇸, cage 🇬🇧, gaiola 🇵🇹, Käfeg 🇱🇺, kou 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/calmar_fr.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;calmar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Ancestor:</strong> calamaro 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar
                      🇦🇿, calamar 🇪🇸, calamar 🇦🇩
                      <div></div>
                      <strong>Descendants:</strong> kałamarnica 🇵🇱, kalmar 🇸🇰,
                      кальма́р 🇷🇺, klamar 🇲🇹, kalmari 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;canal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/ --
                      "reed", via the Ancient Greek "κάννα" /kánna/ -- “reed”,
                      and the Latin "canna" -- "reed". The name comes from the
                      fact that a canal has a long cylindrical reed-like shape.
                      <div></div>
                      <strong>Related to:</strong> canyon, canon, caniveau,
                      canne
                      <div></div>
                      <strong>Not related to:</strong> cannabis, chaîne
                      <div></div>
                      <strong>Cognates:</strong> canal 🇬🇧, canal 🇵🇹, canal 🇪🇸,
                      kanal 🇸🇪, canale 🇮🇹, Kanal 🇩🇪, kanal 🇩🇰, канал 🇹🇯, кана́л
                      🇷🇺, kanał 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canicule.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9YJzi3P2Wto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;canicule"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "Canicula" (
                      <i>i.e.</i>, "small dog"), another name for the star
                      Sirius. In ancient Rome the "diēs caniculārēs" (
                      <i>i.e.</i>, "days of the small dog (star)") denoted the
                      period in late July until late August rises when Sirius
                      rose and set at the same time as the sun.
                      <div></div>
                      <strong>Related to:</strong> chien, chenille
                      <div></div>
                      <strong>Cognates:</strong> kánikula 🇭🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cannabis.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cannabis"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong>Probably from the Scythian
                      "*kanab" -- "hemp", via the Old Persian "کنب" -- "hemp"
                      and the Ancient Greek "κάνναβις" -- "hemp".
                      <div></div>
                      <strong>Not related to:</strong> canon, canyon, canal,
                      chaîne, canne
                      <div></div>
                      <strong>Cognates:</strong> cannabis 🇬🇧, cânabis 🇵🇹,
                      cannabis 🇪🇸, cannabis 🇸🇪, canapa 🇮🇹, Hanf 🇩🇪, hamp 🇩🇰,
                      конопля́ 🇷🇺, kanapė 🇱🇹, კანაფი 🇬🇪, قِنَّب 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canneberge.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;canneberge"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Low German
                      "Kraanbeere" -- "cranberry" (which itself is a combination
                      of "Kraan" -- "crane" - from the Proto-Germanic "*kranô"
                      -- "crane" - and "beere" -- "berry" - from the
                      Proto-West-Germanic "*baʀi" – "berry").
                      <div></div>
                      <strong>Possible Cognates:</strong> Cranberry 🇩🇪,
                      cranberry 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cannibale.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cannibale"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Caraïbes (<i>pl.</i>)
                      <div></div>
                      <strong>Not related to:</strong> canon, cannabis
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/casier.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;casier"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "cāseus" --
                      "cheese". Originally a "casier" was a bin or chest where
                      dairy products (including cheese) could be dried.
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nightmare.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cauchemar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin verb
                      "calcāre" -- "to trample", "to tread on", (via the Old
                      French "chauchier" -- "to press") and the Frankish "*marā"
                      -- "an evil spirit who sits on your chest while you sleep
                      and tries to suffocate you".
                      <div></div>
                      <strong>Cognates:</strong> night<u>mare</u> 🇬🇧, <u>mar</u>
                      dröm 🇸🇪, <u>mar</u>tröð 🇮🇸, <u>mare</u>ritt 🇳🇴
                      <div></div>
                      <strong>Descendants:</strong> кошма́р 🇷🇺, coșmar 🇷🇴,
                      koszmar 🇵🇱, კოშმარი 🇬🇪, košmaras 🇱🇹
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, incubo
                      🇮🇹, كابوس 🇸🇦, painajainen 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cave.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;caverne"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", and the suffix "-erna", a suffix used to form
                      a noun of place, which together formed "caverna" --
                      "cave". The word then evolved into the Old French
                      "caverne" -- "cave", and, later, the Middle English
                      "caverne" -- "cave".
                      <div></div>
                      <strong>Related to:</strong> cage, cavité, geôle, cajoler
                      (<i>v.</i>)<div></div>
                      <strong>Cognates:</strong> caverna 🇮🇹, cueva 🇪🇸, cave 🇬🇧,
                      caverna 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cedule.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cédule"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "σχέδη"
                      /skhédē/ -- “papyrus leaf” via the Latin "schedula" --
                      "strip of paper made out of 'skhede'", and the Old French
                      "cedule" -- "strip of paper with writing on it".
                      <div></div>
                      <strong>Cognates:</strong> Zettel 🇩🇪, cédula 🇵🇹, cédula 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cent.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cent"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Italic "*kentom" --
                      "100", and the Latin "centum" -- "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, hundred 🇬🇧, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chameau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chameau"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel", via the Ancient Greek "κᾰ́μηλος" /kắmēlos/ --
                      "camel" and the Old French "chamel" -- "camel".
                      <div></div>
                      <strong>Cognates:</strong> ޖަމަލު 🇲🇻, جَمَل 🇸🇦, ግመል 🇪🇹,
                      גמל 🇮🇱, ngamia 🇹🇿, Kamel 🇩🇪, camel 🇬🇧, cammello 🇮🇹, camelo
                      🇵🇹, camello 🇪🇸, kamel 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chenille.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9YJzi3P2Wto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chenille"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "canicula" (
                      <i>i.e.</i>, "small dog"). So called because a
                      "chenille"'s fuzzy oblong body was said to resemble the
                      body of a little dog.
                      <div></div>
                      <strong>Related to:</strong> chien, canicule
                      <div></div>
                      <strong>Descendant:</strong> chini 🇫🇷,
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chien.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9YJzi3P2Wto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chien"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "canis" -- "dog",
                      via the Old French "chien" -- "dog"
                      <div></div>
                      <strong>Related to:</strong> canicule, chenille
                      <div></div>
                      <strong>Cognates:</strong> cane 🇮🇹, cão 🇵🇹, سگ 🇮🇷, سپۍ 🇦🇫
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chocolat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chocolat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong>
                      សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦, chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮,
                      choklad 🇸🇪
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾, شکلات 🇮🇷,
                      チョコレート 🇯🇵, chocolate 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cementerio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cimetière"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "κοιμητήριον"
                      /koimētḗrĭon/ -- "place to sleep", "dormitory".
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cimitir 🇷🇴, cemitério 🇵🇹, cmentarz 🇵🇱, sementeryo 🇵🇭,
                      cemetery 🇬🇧, cementerio 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/climat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;climat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west.
                      <div></div>
                      <strong>Related to:</strong> incliner (v.)
                      <div></div>
                      <strong>Cognates:</strong> climate 🇬🇧, klimaat 🇳🇱, кли́мат
                      🇷🇺, κλίμα 🇬🇷, iklim 🇮🇩, iqlim 🇺🇿, iklim 🇹🇷, ַַאַקְלִים 🇮🇱,
                      اِقْلِیم 🇮🇷. clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cloche.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cloche"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Celtic
                      "*klokkos" -- "bell" via the Medieval Latin "clocca" --
                      "bell".
                      <div></div>
                      <strong>Cognates:</strong> cloch 🏴󠁧󠁢󠁷󠁬󠁳󠁿, klok 🇳🇱, klukka 🇮🇸,
                      clog 🇮🇪, Glocke 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/commere.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;commère"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Late Latin "commāter" --
                      "godmother", "female companion", which is a combination of
                      the prefix "com-" -- "together" and "māter" -- "mother".
                      Traditionally "commères" would attend a baptism or
                      christening together, during which they would talk about
                      other family members who weren’t there.
                      <div></div>
                      <strong>Related to:</strong> mère
                      <div></div>
                      <strong>Descendants:</strong> comadre 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/conscience.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/DJ-ABPy6Udw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;conscience"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cōnsciō" --
                      "to be conscious of", "have on one's conscience", which is
                      a combination of the prefix "con-" -- "together", "with"
                      and the verb "sciō" -- "to know". A "conscience" therefore
                      literally means "being with knowledge".
                      <div></div>
                      <strong>Related to:</strong> science, conscient (adj.)
                      <div></div>
                      <strong>Cognates:</strong> conciencia 🇪🇸, consciência 🇵🇹,
                      conscience 🇫🇷, coscienza 🇮🇹, conștiință 🇷🇴, coinsias 🇮🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/considerer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/OyZjPK6RSss"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;considérer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely a combination of the Latin
                      prefix "con-" -- "together", "with", and the noun "sīdus"
                      -- "star(s)". The origin of the word is linked to the
                      notion of ancient peoples looking at the sky and gaining
                      insight by considering the movements of the stars.
                      <div></div>
                      <strong>Likely related to:</strong> dé<u>sir</u>
                      <div></div>
                      <strong>Cognates:</strong> consider 🇬🇧, considerar 🇪🇸,
                      considerar 🇵🇹, considerare 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/corner.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;corne"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Latin “cornū” --
                      “horn”, and the Old French "corne".
                      <div></div>
                      <strong>Related to:</strong> li<u>corne</u>
                      <div></div>
                      <strong>Cognates:</strong> cuerno 🇪🇸, Horn 🇩🇪, horn 🇬🇧,
                      horn 🇮🇸, सींग 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/coude.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;coude"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cubō" -- "to
                      lie down", "to recline" and its descendant, the noun
                      "cubitum" which denoted the length from the edge of the
                      forearm (<i>i.e.</i>, the elbow) to the tip of the
                      outstretched hand. From there, the word entered modern
                      French via the Old French "coute" -- "elbow".
                      <div></div>
                      <strong>Cognates:</strong> cotovelo 🇵🇹, gomito 🇮🇹, codo 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/curfew.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/suyCgi6wEos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;couvre-feu"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Old French "cuevre-fu" (
                      <i>lit.</i> "cover fire"), from the medieval practice of
                      ringing a bell every evening to signal that fires should
                      be put out for the night.
                      <div></div>
                      <strong>Cognates:</strong> curfew 🇬🇧, coprifuoco 🇮🇹
                      <div></div>
                      <strong>Semantic equivalents:</strong> avondklok 🇳🇱, toque
                      de queda 🇪🇸, toque de recolher 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/danger1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qJKkaRTmYbs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;danger"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "dominus" --
                      "lord", "master" via the Vulgar Latin "*dominārium" --
                      “authority", "power”, the Old French "dangier" -- "power
                      (to harm)", "mastery", "authority", "control", and the
                      Middle English "daunger" -- "danger", "peril", "hazard".
                      The meaning of the word comes from the concept of being
                      under the power of someone else (<i>e.g.,</i> a feudal
                      lord), which, in the feudal Europe of the Middle Ages,
                      could definitely be hazardous.
                      <div></div>
                      <strong>Related to:</strong> donjon
                      <div></div>
                      <strong>Cognates:</strong> danger 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/defeat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/MWWZM7nhMIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;défaite"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "dis-" --
                      "(reversal)", "un-" + verb "faciō" -- “to do", "to make",
                      via the Old French verb "desfaire" -- "to undo".
                      <div></div>
                      <strong>Related to:</strong> fait
                      <div></div>
                      <strong>Cognates:</strong> defeat 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/disaster.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Gt0B3coiu7s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;désastre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "dis-" --
                      (used to convey negation/separation) and the noun
                      "-astrum". A "désastre" is literally a "negative (
                      <i>i.e.</i>, unlucky) star". In ancient times catastrophes
                      were often thought to be the results of misalignments of
                      planets and stars in the sky.
                      <div></div>
                      <strong>Related to:</strong> <u>astro</u>nomie
                      <div></div>
                      <strong>Cognates:</strong> desastre 🇪🇸, desastre 🇵🇹,
                      disaster 🇬🇧, dezastru 🇷🇴, disastro 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/desir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/OyZjPK6RSss"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;désir"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely a combination of the Latin
                      prefix "de-" -- "of", "from" and the genitive form
                      "sīderis" of the noun "sidus" -- "star(s)", "of the
                      star(s)", via the verb "dēsīderō" -- "to long for",
                      "desire", and the Old French verb "desirrer" -- "to
                      covet", "to desire". In ancient times, people would look
                      to the positions of stars to try to gain some insights on
                      the future, but at times it would be cloudy, and there
                      would be no stars, so they would get "desiderium", that
                      is, a yearning for their lost celestial guides.
                      <div></div>
                      <strong>Likely related to:</strong> con<u>sidér</u>er
                      <div></div>
                      <strong>(Possible) Cognates:</strong> desire 🇬🇧, desiderio
                      🇮🇹, (deseo 🇪🇸), (desejo 🇵🇹)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/detail1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;détail"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French prefix "de-"
                      -- (prefix indicating separation) and the verb "taillier"
                      -- "to cut". A "détail" is literally what you get when you
                      stop focusing on the big picture but instead "cut it up"
                      into dozens of individual segments and focus on those
                      instead.
                      <div></div>
                      <strong>Related to:</strong> taille
                      <div></div>
                      <strong>Cognates:</strong> detail 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> dettaglio 🇮🇹, detail 🇳🇱,
                      detalle 🇪🇸, detalhe 🇵🇹, detay 🇹🇷, detaliu 🇷🇴, detalj 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;deux"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Italic "*duō" -- "two" and the
                      Latin "duōs" -- "two".
                      <div></div>
                      <strong>Related to:</strong> <u>dou</u>ble
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      two 🇬🇧, to 🇳🇴, dwa 🇵🇱, dó 🇮🇪, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪, два
                      🇧🇬, երկու 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dinde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dinde"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "coq d'Inde" -- "rooster
                      from the Indies" (<i>i.e.</i> "the new world"). The first
                      word was eventually dropped and the second and third
                      combined into a single word in a process called
                      "rebracketing". The name derives from the mistaken idea
                      that turkeys come from the Indian Subcontinent.
                      <div></div>
                      <strong>Cognates:</strong> indyk 🇵🇱, индю́к 🇷🇺, hindi 🇹🇷
                      <div></div>
                      <strong>Partial semantic equivalents:</strong> kalkoen 🇳🇱,
                      kalakùtas 🇱🇹, kalkon 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/distance1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sJgO6bNR7x4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;distance"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the present participle of
                      the Latin verb "distō" -- "to stand apart", "to be
                      distant" (itself a combination of the prefix "dis-" --
                      "apart" "in two" and the verb "stō" -- "to stand"), via
                      the Old French "destance" -- "debate", "distinction",
                      "quarrel", "dispute". The concept comes from the idea that
                      when people argue, they’re not on the same page (or
                      really, in the same place). Therefore, they stand apart,
                      and there is "distance" between them.
                      <div></div>
                      <strong>Cognates:</strong> distancia 🇪🇸, distância 🇵🇹,
                      distance 🇬🇧, distanță 🇷🇴, distanza 🇮🇹
                      <div></div>
                      <strong>Semantic equivalents:</strong> afstand 🇩🇰, avstånd
                      🇸🇪, afstand 🇳🇱
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dungeon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qJKkaRTmYbs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;donjon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "dominus" --
                      "lord", "master" via the Old French "donjon" -- "tower
                      inside a fortress", "castle residence", "dominant building
                      -<i>i.e.</i>, home of the dominus".
                      <div></div>
                      <strong>Related to:</strong> danger
                      <div></div>
                      <strong>Cognates:</strong> dungeon 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/eau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ztj_kCMZFS8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;eau"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂ekʷeh₂" -- "water", via the Latin "aqua" -- "water",
                      and the Old French "ewe" -- "water".
                      <div></div>
                      <strong>Related to:</strong> é<u>gout</u>, é<u>vier</u>
                      <div></div>
                      <strong>Cognates:</strong> agua 🇪🇸, agua 🇵🇹, apă 🇷🇴, acqua
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/economy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;économie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "οἰκονομία"
                      /oikonomía/ -- "management of a household (a combination
                      of "οἶκος" /oîkos/ -- "house", "dwelling place" and the
                      verb "νέμω" /némō/ -- "to distribute", "to allocate”).
                      Originally, the word denoted the concept of properly
                      allocating and distributing the resources within one's
                      house.
                      <div></div>
                      <strong>Related to:</strong> <u>éco</u>logie
                      <div></div>
                      <strong>Cognates:</strong> economy 🇬🇧, economía 🇪🇸,
                      economia 🇵🇹, economia 🇮🇹, økonomi 🇳🇴, økonomi 🇩🇰,
                      οικονομία 🇬🇷
                      <div></div>
                      <strong>Descendants: </strong> economie 🇷🇴, эконо́мия 🇷🇺,
                      ეკონომია 🇬🇪, ekonomi 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ecraser.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;écraser (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old Norse verb "*krasa"
                      –- "to shatter" (which itself is likely of onomatopoeic
                      origin), via the Middle English verb "crasen" -– "to
                      crush", "to break (to pieces)", “to shatter", and the
                      Middle French verb "ecraser" -– "to squash".
                      <div></div>
                      <strong>Cognates:</strong> krasa (<i>v.</i>) 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ecureuil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/TN89d3tM1aY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;écureuil"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Ancient Greek
                      "σκίουρος" /skíouros/ -- “shadow-tail”, via the Old French
                      "escurel" -- "squirrel". So called because presumably a
                      squirrel makes shade with its own tail.
                      <div></div>
                      <strong>Cognates:</strong> squirrel 🇬🇧, esquilo 🇵🇹, սկյուռ
                      🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/elephant1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;éléphant"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek genitive
                      noun "ἐλέφαντος" /eléphăntos/ -- "(pertaining to) ivory",
                      via the Latin "elephantus" -- "elephant".
                      <div></div>
                      <strong>Cognates:</strong> elefante 🇪🇸, elephant 🇬🇧,
                      elefante 🇵🇹, elefant 🇩🇰, elefante 🇮🇹, Elefant 🇩🇪, olifant
                      🇳🇱, elefant 🇳🇴, elefant 🇸🇪, eliffant 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                      <strong>Descendants:</strong> elefant 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ennemi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ennemi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "inimīcus" (
                      <i>i.e.</i>, "in-" -- “not” + "amīcus" - “friend”) via the
                      Old French "enemi" -- "non-friend", "enemy".
                      <div></div>
                      <strong>Related to:</strong> ami
                      <div></div>
                      <strong>Cognates:</strong> enemy 🇬🇧, enemigo 🇪🇸, inimigo
                      🇵🇹, inamic 🇷🇴, nemico 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/strange.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;étrange (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a compound of the Latin
                      "extrā" -- "outside” and the suffix "-āneus" -- "of or
                      pertaining to". Literally, being "étrange" is akin to
                      being "outside (of the norm)".
                      <div></div>
                      <strong>Cognates:</strong> extraño 🇪🇸, strange 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/east.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;est"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₂ewsér" -- "in the direction of dawn", "east", via the
                      Proto-Germanic "*austrą" -- "east" and the Old English
                      "ēast" -- "east".
                      <div></div>
                      <strong>Cognates:</strong> Osten 🇩🇪, oosten 🇳🇱, east 🇬🇧,
                      øst 🇩🇰, este 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> est 🇮🇹, este 🇵🇹, est 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/star.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;étoile"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂stḗr" -- “star” via Proto-Italic "*stērlā" -- "star"
                      and the Latin "stēlla" -- "star".
                      <div></div>
                      <strong>Not related to:</strong> toile
                      <div></div>
                      <strong>Cognates:</strong> star 🇬🇧, Stern 🇩🇪, αστέρι 🇬🇷,
                      estrella 🇪🇸, estrela 🇵🇹, stjerne 🇩🇰, stjärna 🇸🇪, stella
                      🇮🇹, stea 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/evident.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;évident (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin
                      preposition "ē" -- "out", (in the sense "out in plain
                      view") and the verb "videō" -- "to see", via the adjective
                      "ēvidēns" -- "visible", "apparent", "clear", "plain", and
                      the Old French adjective "evident" -- "clear", "apparent".
                      <div></div>
                      <strong>Related to:</strong> en<u>vie</u>, pru<u>dent</u>{" "}
                      (<i>adj.</i>), visa, vision, visite, vidéo, a<u>vis</u>,
                      provi
                      <u>dence</u>
                      <div></div>
                      <strong>Cognates:</strong> evidente 🇪🇸, evidente 🇵🇹,
                      evident 🇬🇧, evident 🇷🇴, evident 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/faire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/MWWZM7nhMIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;faire (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "faciō" --
                      “to do", "to make".
                      <div></div>
                      <strong>Related to:</strong> façon, facture, facile (adj.)
                      <div></div>
                      <strong>Cognates:</strong> hacer (v.) 🇪🇸, fazer (v.) 🇵🇹,
                      face (v.) 🇷🇴, fare (v.) 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;famille"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Cognates:</strong> familia 🇪🇸, familja 🇲🇹, family
                      🇬🇧, familie 🇩🇰, familie 🇳🇴, pamilya 🇵🇭, Familie 🇩🇪,
                      famiglia 🇮🇹, família 🇵🇹, familie 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fenetre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fenêtre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "fenestra" --
                      "(glass) window", via the Old French "fenestre" --
                      "window".
                      <div></div>
                      <strong>Related to:</strong> défenestration
                      <div></div>
                      <strong>Cognates:</strong> finestra 🇮🇹, fönster 🇸🇪,
                      Fenster 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fleur.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fleur"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Latin "flōs" (and
                      its accusative form "flōrem") –- “flower”, “blossom”, and
                      the Old French "flor" – "the finest part (of the grain)".
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, flor 🇵🇹, flor 🇪🇸,
                      fiore 🇮🇹, flower 🇬🇧, blomst 🇳🇴, blomst 🇩🇰, blomma 🇸🇪,
                      Blume 🇩🇪, floare 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fraise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fraise"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "frāgum" --
                      "strawberry" (and specifically its nominative plural form
                      "frāga") via the Old French "freise" -- "strawberry".
                      <div></div>
                      <strong>Not related to:</strong> framboise
                      <div></div>
                      <strong>Cognates:</strong> fragola 🇮🇹, فراولة 🇸🇦
                      <div></div>
                      <strong>Descendants:</strong> fresa 🇪🇸, presa 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/framboise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;framboise"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West-Germanic
                      "brāmabaʀi" -- "blackberry" (which itself is a combination
                      of "*brāma" -- "bramble", "thorn bush", and "*baʀi" –
                      "berry"), via the Frankish "*brāmabasi" -– "blackberry",
                      and the Old French "framboise" -- "raspberry". The initial
                      "br-" and final "re" evolved into "fr" and "-se",
                      respectively, via dissimilation and likely due to the
                      influence of the similar sounding "fraise".
                      <div></div>
                      <strong>Not related to:</strong> fraise
                      <div></div>
                      <strong>Possibly related to:</strong> canneberge
                      <div></div>
                      <strong>Cognates:</strong> Him
                      <u>beere</u> 🇩🇪, Rasp<u>berry</u> 🇬🇧, rasi<u>beri</u> 🇹🇿,
                      framboos 🇳🇱, bringe<u>bær</u> 🇳🇴
                      <div></div>
                      <strong>Descendants:</strong> framboesa 🇵🇹, frambuesa 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fromage"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "(cāseum)
                      fōrmāticum" -- "curdled milk fit into a mold", via the Old
                      French "formage" -- "cheese" (which became "fromage"
                      through metathesis).
                      <div></div>
                      <strong>Related to:</strong> formation, forme
                      <div></div>
                      <strong>Cognates:</strong>
                      formaggio 🇮🇹, phô mai 🇻🇳, foromaas 🇸🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/left.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gauche"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French "gaucher" --
                      "to turn or walk awkwardly", "to stumble". From the belief
                      in many medieval societies that the left-hand side was
                      slower and disadvantageous compared to the right-hand
                      side.
                      <div></div>
                      <strong>Semantic equivalents:</strong> left 🇬🇧, sinistro
                      🇮🇹, ле́вый 🇷🇺, 왼쪽 🇰🇷, kreiss 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gaz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to:</strong> chaos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/grammar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/SGyesbKQod8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;grammaire"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "γραμματική" /grammatikḗ/ --“skilled in writing”.
                      <div></div>
                      <strong>Related to:</strong> grimoire
                      <div></div>
                      <strong>Cognates:</strong> grammar 🇬🇧, грамма́тика 🇷🇺,
                      Grammatik 🇩🇪, γραμματική 🇬🇷, grammatika 🇪🇪, gramática 🇪🇸,
                      gramática 🇵🇹, grammatik 🇸🇪, grammatica 🇮🇹, gramatika 🇱🇻,
                      grammatika 🇹🇲, gramatika 🇱🇹, gramadach 🇮🇪, ګرامر 🇦🇫
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guerre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;guerre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*werru" –- "confusion", "disorder", via the Frankish
                      "*werru" –- "confusion", "disorder", the Medieval Latin
                      "werra" -- "war", "strife", and the Old French "guerre" -–
                      "armed conflict", “war”.
                      <div></div>
                      <strong>Cognates:</strong> war 🇬🇧, guerra 🇮🇹, guerra 🇵🇹,
                      guerra 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/helice.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hélice"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "ἕλιξ" /hélix/
                      -- “spiral”.
                      <div></div>
                      <strong>Related to:</strong> <u>hélic</u>optère
                      <div></div>
                      <strong>Cognates:</strong> hélice 🇵🇹, hélice 🇪🇸, elica 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/helicopter.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hélicoptère"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ἕλιξ"
                      /hélix/ -- “spiral” + πτερόν /pterón/ -- “wing”, so called
                      because its inventor (in 1861) thought the propeller
                      looked like spiral-shaped wings.
                      <div></div>
                      <strong>Related to:</strong> <u>ptéro</u>dactyle, hélice
                      <div></div>
                      <strong>Descendants:</strong> helicóptero 🇪🇸, helicóptero
                      🇵🇹, helikopter 🇹🇷, helikopter 🇭🇺, helikopter 🇪🇪,
                      helikopter 🇸🇪, हेलिकॉप्टर 🇮🇳, เฮลิคอปเตอร์ 🇹🇭,
                      ヘリコプター 🇯🇵, ሄሊኮፕተር 🇪🇷, ሄሊኮፕተር 🇪🇹, ເຮລີກົບແຕ 🇱🇦,
                      ဟယ်လီကော့ပတာ 🇲🇲, 헬리콥터 🇰🇷, helikopta 🇵🇬, helicopter 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hippopotame"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ἱπποπόταμος" /hippopótamos/, which itself is a compound
                      of "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Related to:</strong> hippodrome
                      <div></div>
                      <strong>Cognates:</strong> xипопота́м 🇧🇬, hipopótamo 🇪🇸,
                      hipopótamo 🇵🇹, hippopotamus 🇬🇧, гиппопота́м 🇷🇺, ippopotamo
                      🇮🇹, ჰიპოპოტამი 🇬🇪
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, 河马 🇨🇳,
                      Nilpferd 🇩🇪, nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा
                      🇮🇳, dobhareach 🇮🇪, su aygırı 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/heure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;heure"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ὥρα"
                      /hṓra/ -- "any time or period, whether of the year, month,
                      or day”, via the Latin "hōra" -- "hour".
                      <div></div>
                      <strong>Related to:</strong> horloge, <u>horo</u>scope
                      <div></div>
                      <strong>Not related to:</strong> heureux
                      <div></div>
                      <strong>Cognates:</strong> hora 🇵🇹, hora 🇪🇸, hour 🇬🇧, ora
                      🇮🇹, uur 🇳🇱, oră 🇷🇴, hora 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/homme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;homme"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "hominem" (which
                      is likely a derivative of the noun "homō̆" -- "human
                      being"), via the Old French "home" -- "man".
                      <div></div>
                      <strong>Related to:</strong> on (pron.), <u>homo</u>sexuel
                      <div></div>
                      <strong>Cognates:</strong> hombre 🇪🇸, homem 🇵🇹, uomo 🇮🇹,
                      om 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/heure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;horloge"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ὡρολόγιον" /hōrológion/ -- "device for telling time"
                      (which itself comes partially from "ὥρα" /hṓra/ -- "any
                      period of time"), via the Latin "hōrologium" -- "device
                      used to measure the time of day", "sundial".
                      <div></div>
                      <strong>Related to:</strong> heure, <u>horo</u>scope
                      <div></div>
                      <strong>Cognates:</strong> reloj 🇪🇸, relógio 🇵🇹, orologio
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ospite.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1VA4S3AMxB4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hôte"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ghos-ti-" -- "stranger", "guest", "host", "someone with
                      whom one has reciprocal duties of hospitality" (the root,
                      when combined with root of the Latin adjective "potis" --
                      "capable of", eventually developed into the modern
                      contranym "hôte").
                      <div></div>
                      <strong>Related to:</strong> hôtel, hôpital, hostilité
                      <div></div>
                      <strong>Cognates:</strong> host 🇬🇧, <u>gos</u>podarz 🇵🇱,{" "}
                      <u>gost</u>itelj 🇸🇮, <u>Gast</u>geber 🇩🇪, <u>gast</u>heer
                      🇳🇱, <u>host</u>itel 🇨🇿, <u>os</u>pite 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/humain.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;humain"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "hominem" (which
                      is likely a derivative of the noun "homō̆" -- "human
                      being"), via the adjective "hūmānus" -- "human", and the
                      Middle French "humain" -- "human".
                      <div></div>
                      <strong>Likely related to:</strong> <u>homo</u>sexuel,
                      homme
                      <div></div>
                      <strong>Cognates:</strong> human 🇬🇧, humano 🇪🇸, humano 🇵🇹,
                      umano 🇮🇹, humà 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hypothèque"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Related to:</strong> biblio<u>thèque</u>, thèse
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, ipotek 🇹🇷,
                      hipoteca 🇵🇹, hipoteca 🇪🇸, hipoteka 🇵🇱, hipoteka 🇸🇮,
                      ипотека 🇰🇿, Hypothek 🇩🇪, ипотека 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idiot"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”, and the
                      Latin "idiōta" -- "uneducated or illiterate person". Like
                      the Greeks before them, the Romans used the word to refer
                      to someone lacking any professional skills, but they
                      placed emphasis on the fact that an “idiota” lacked
                      education and was therefore ignorant.
                      <div></div>
                      <strong>Related to:</strong> idiomatique (adj.)
                      <div></div>
                      <strong>Cognates:</strong> Idiot 🇩🇪, идиот 🇲🇰, идиот 🇷🇺,
                      идиот 🇧🇬, idiota 🇪🇸, idiota 🇵🇹, idiota 🇵🇱, idiot 🇬🇧,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/insect.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;insecte"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "īnsectus" (
                      <i>i.e.</i>, īn + sectus) -- "cut into sections". Borrowed
                      as a word-for-word translation of the Ancient Greek
                      "ἔντομον" /éntomon/ -- "cut into sections". From the
                      observation (first made by Aristotle) that insects are
                      physically separated (or "cut") into three separate
                      sections (head, thorax, abdomen).
                      <div></div>
                      <strong>Related to:</strong> sexe, <u>sect</u>ion
                      <div></div>
                      <strong>Not related to:</strong> inceste
                      <div></div>
                      <strong>Cognates:</strong> insecto 🇪🇸, insect 🇬🇧, inseto
                      🇵🇹, insetto 🇮🇹, insectă 🇷🇴, Insekt 🇩🇪, insect 🇳🇱, insekt
                      🇳🇴, insekt 🇩🇰, на<u>сек</u>о́мое 🇷🇺, на<u>сек</u>омо 🇧🇬
                      <div></div>
                      <strong>Semantic equivalents:</strong> έντομο 🇬🇷, rovar
                      🇭🇺, trychfil 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/inspirer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;inspirer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "in-" --
                      "in" and the verb "spīrō" -- "to breathe". When we are
                      "inspiré", we literally receive a breath from some divine
                      force that gives us not only life, but also, great ideas.
                      <div></div>
                      <strong>Related to:</strong> ésprit, ex<u>pirer</u>, tran
                      <u>spirer</u>, con<u>spirer</u>
                      <div></div>
                      <strong>Cognates:</strong> inspirar 🇪🇸, inspire 🇬🇧,
                      inspirar 🇵🇹, ispirare 🇮🇹, inspirieren 🇩🇪, inspirować 🇵🇱,
                      inspirera 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/investir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hZaC6v6pM0o"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;investir (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wéstis" -- "the act of dressing/clothing" via the Latin
                      "vestis" -- "garment", "gown", "robe", "vestment" and the
                      verb "investio" -- "to clothe", "to cover". The modern
                      financial sense of the word comes from the idea of giving
                      one's money a new form (<i>i.e.</i>, clothing it in a new
                      attire).
                      <div></div>
                      <strong>Related to:</strong> investiture, veste, vêtir
                      (v.)
                      <div></div>
                      <strong>Cognates:</strong> investeren 🇳🇱, investere 🇳🇴,
                      investere 🇩🇰, investera 🇸🇪, invest 🇬🇧, investir 🇵🇹,
                      investire 🇮🇹, investi 🇷🇴, investieren 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ile.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ztj_kCMZFS8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;île"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "insula" --
                      "island" via the Old French "île" -- "island".
                      <div></div>
                      <strong>Related to:</strong> pén<u>insule</u>, isoler (v.)
                      <div></div>
                      <strong>Cognates:</strong> isle 🇬🇧, isla 🇪🇸, ilha 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jeu.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jeu"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "iocus" -- "joke",
                      "amusement", "pastime", "sport", via the Old French "geu"
                      -- "game".
                      <div></div>
                      <strong>Cognates:</strong> juego 🇪🇸, jogo 🇵🇹, gioco 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/joy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;joie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "gaudium" --
                      "joy".
                      <div></div>
                      <strong>Related to:</strong> jouir (v.)
                      <div></div>
                      <strong>Cognates:</strong> joy 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dschungel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jungle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert". The word
                      was adopted by British colonists in the Indian
                      subcontinent to refer to any territory that was
                      inhospitable, and then gradually it evolved to denote a
                      place with “tangled thickets”, and then, from there, "any
                      area with lots of vegetation". From there it eventually
                      found its way into French.
                      <div></div>
                      <strong>Ancestors:</strong> جَنْگَل 🇵🇰, जंगल 🇮🇳, jungle 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> جَن٘گَل 🇮🇷, জঙ্গল 🇧🇩, जङ्गल 🇳🇵,
                      cəngəllik 🇦🇿, ځنګل 🇦🇫, ҷангал 🇹🇯, Dschungel 🇩🇪, джу́нгли
                      🇷🇺, jungle 🇫🇷, jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪, dżungla
                      🇵🇱, ջունգլի 🇦🇲, ჯუნგლი 🇬🇪, ジャングル 🇯🇵, džungla 🇸🇮,
                      džùngla 🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lVpHk6bQL_I"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;lire (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "legere" --
                      "to read", via the Old French "lire" -- "to read".
                      <div></div>
                      <strong>Related to:</strong> intel<u>li</u>gence, intel
                      <u>lec</u>tuel
                      <div></div>
                      <strong>Cognates:</strong> leer (v.) 🇪🇸, ler (v.) 🇵🇹,
                      leggere (v.) 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7fe2-UxXMI8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;main"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*manus" --
                      "hand", via the Latin "manus" -- "hand".
                      <div></div>
                      <strong>Related to:</strong> <u>man</u>œuvre, manipulation
                      <div></div>
                      <strong>Cognates:</strong> mano 🇪🇸, mão 🇵🇹, mano 🇮🇹, mână
                      🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/maire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ga15HCmlzig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;maire"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin comparative
                      adjective "maior" -- "bigger", "greater", "superior" via
                      the Old French "maire" -- "head of a city or town
                      government".
                      <div></div>
                      <strong>Related to:</strong> majeure (adj.)
                      <div></div>
                      <strong>Not related to:</strong> mère, mer
                      <div></div>
                      <strong>Cognates:</strong> mayor 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7fe2-UxXMI8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;manœuvre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Vulgar Latin verb
                      "*manuoperare" -- "to work by hand" (a compound of "manū"
                      -- "hand" + verb "operārī" -- "to work", "to toil"), via
                      the Old French verb "manouvrer" -- “to maneuver”.
                      <div></div>
                      <strong>Related to:</strong> main
                      <div></div>
                      <strong>Cognates:</strong> մանևր 🇦🇲, maneuver 🇬🇧, манёвр
                      🇷🇺, маневар 🇲🇰, maniobra 🇪🇸, manuver 🇮🇩, manewr 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mattress.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;matelas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Cognates:</strong> mattress 🇬🇧, materasso 🇮🇹,
                      matrac 🇸🇰, Matratze 🇩🇪, matras 🇳🇱, матра́с 🇷🇺, матрас 🇰🇬,
                      матрас 🇰🇿, materac 🇵🇱, madrass 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mathematiques.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mathématiques"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μάθημα"
                      /máthēma/ -- "something that is learned", "lesson",
                      "knowledge", whence the phrase "μαθηματικὴ τέχνη"
                      /mathēmatikḗ tékhnē/ -- "mathematical sciences”, "sciences
                      of matters that have been learned" was derived.
                      Originally, “mathematics” referred to the science of
                      learning in general. Only after the term was used by the
                      "mathematikoi" (<i>i.e.,</i> "those who love to learn"), a
                      group of scholars in Ancient Greece who studied the ideas
                      of Pythagoras, especially those pertaining to arithmetic
                      and geometry, did the term "mathematics" become closely
                      associated with its modern meaning.
                      <div></div>
                      <strong>Cognates:</strong> mathematics 🇬🇧, математика 🇰🇿,
                      matematik 🇹🇷, matematica 🇮🇹, matematika 🇸🇰, Mathematik 🇩🇪,
                      математика 🇰🇬, matematyka 🇵🇱, matematik 🇸🇪, matemáticas
                      🇪🇸, matematik 🇹🇷, математик 🇲🇳, матема́тика 🇷🇺, matematika
                      🇵🇭, matamaitic 🇮🇪, mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mint.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;menthe"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Mycenaean Greek "𐀖𐀲" /mi-ta/
                      -- "mint plant" via the Latin "menta" -- "mint (plant)".
                      <div></div>
                      <strong> Cognates:</strong> mint 🇬🇧, Minze 🇩🇪, menta 🇵🇹,
                      menta 🇪🇸, mięta 🇵🇱, мя́та 🇷🇺, menta 🇭🇺, mynte 🇳🇴, minttu 🇫🇮
                      <div></div>
                      <strong>Descendants:</strong> mentă 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/miracle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;miracle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", via the Latin
                      "mīrāculum" -- "something marveled at".
                      <div></div>
                      <strong>Related to:</strong> admirer (v.), miroir, mirage,
                      merveille
                      <div></div>
                      <strong>Cognates:</strong> miracle 🇬🇧, milagro 🇪🇸, milagre
                      🇵🇹, miracol 🇷🇴, miracolo 🇮🇹, milagro 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mirror.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;miroir"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", via the Old French
                      "mireor" -- “mirror” (<i>lit.</i> “one who looks”, "one
                      who watches"). The semantic link to the modern word comes
                      from the idea of people admiring their own reflection and
                      marveling at how good they look when looking into a mirror
                      (<i>i.e.</i>, the mirror makes one admire oneself).
                      <div></div>
                      <strong>Related to:</strong> admirer (v.), miracle, mirage
                      <div></div>
                      <strong>Cognates:</strong> mirror 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/map.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;monde"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Etruscan "𐌌𐌖𐌈"
                      /muθ/ -- “pit", "underworld", which may be the ancestor of
                      the Latin adjective (and, later, noun) "mundus" --
                      "clean", "pure", "neat", "order", "world". Eventually,
                      "mundus" evolved into the Old French "monde" -- "world".
                      <div></div>
                      <strong>Cognates:</strong> mundo 🇪🇸, mondo 🇵🇹, món 🇦🇩,
                      mondo 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/money.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;monnaie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "monēta" -- "place
                      for coining money" via the Old French "monoie" -- "money",
                      "coinage". In Roman times the temple honoring the Goddess
                      Juno Moneta in Rome was next to the site where coins were
                      minted.
                      <div></div>
                      <strong>Perhaps related to:</strong> monopole
                      <div></div>
                      <strong>Descendants:</strong> moneda 🇪🇸, moeda 🇵🇹, Münze
                      🇩🇪, mynt 🇮🇸, моне́та 🇷🇺, monēta 🇱🇻, moneta 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muerte.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mort"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "mortuus"-- "dead"
                      (a perfect active participle of the verb "morior" -- "to
                      die"), via the Old French "mort" -- "dead".
                      <div></div>
                      <strong>Related to:</strong> meurtre
                      <div></div>
                      <strong>Cognates:</strong> muerte 🇪🇸, morte 🇵🇹, մահ 🇦🇲,
                      mirtis 🇱🇹, смерть 🇷🇺, morte 🇮🇹, марг 🇹🇯
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/motto.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FamWPsuUjK8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mot"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "muttum" -- "a
                      mutter" "a grunt”. The word's origin is onomatopoeic -
                      originally, a "mot" was just an instance of something
                      muttered (because that's what it sounded like), regardless
                      of whether the muttering represented an actual word.
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muscle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", so
                      called because flexed arm muscles look like little mice.
                      <div></div>
                      <strong>Related to:</strong> moule
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇬🇧, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, Muskel 🇩🇪, muskel 🇩🇰, muskel
                      🇳🇴, muskel 🇸🇪, мышца 🇷🇺, mišića 🇭🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;musée"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)".
                      <div></div>
                      <strong>Related to:</strong> musique, muse (goddess)
                      <div></div>
                      <strong>Not related to:</strong> amusement
                      <div></div>
                      <div></div>
                      <strong>Cognates:</strong> museum 🇬🇧, museo 🇮🇹, museo 🇪🇸,
                      museu 🇵🇹, Museum 🇩🇪, muzium 🇲🇾, музе́й 🇧🇾, muzeum 🇦🇱, موزه
                      🇮🇷, muzej 🇸🇮, muzejs 🇱🇻, muzeum 🇨🇿, muuseum 🇪🇪, múzeum 🇭🇺,
                      מוּזֵיאוֹן 🇮🇱, muzeý 🇹🇲, музе́й 🇷🇺
                      <div></div>
                      <strong>Descendants:</strong> müze 🇹🇷, موزِه 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pregnant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;naître (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "*(g)nāscī"
                      -- "to be born", via the Old French verb "naistre" -- "to
                      be born".
                      <div></div>
                      <strong>Related to:</strong> naïf, nation, nature
                      <div></div>
                      <strong>Cognates:</strong> nacer (v.) 🇪🇸, nascer (v.) 🇵🇹,
                      nascere (v.) 🇮🇹, naște (v.) 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nappe.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nappe"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Phoenician "𐤌𐤀𐤐"
                      /mappē/ ⁠ -- "fine cloth" via the Latin "mappa" -- "a
                      tablecloth (or large napkin) that guests would often bring
                      and use at the dinner table to wrap items of food that
                      they wished to take away with them". From there the word
                      evolved into its modern form via the Old French "nape" --
                      "tablecloth".
                      <div></div>
                      <strong>Related to:</strong> napperon
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/napperon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;napperon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Phoenician "𐤌𐤀𐤐"
                      /mappē/ ⁠ -- "fine cloth" via the Latin "mappa" -- "a
                      tablecloth (or large napkin) that guests would often bring
                      and use at the dinner table to wrap items of food that
                      they wished to take away with them". From there the word
                      arrived in French via the Old French "napperon" -- "small
                      tablecloth"
                      <div></div>
                      <strong>Related to:</strong> nappe
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nom.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nom"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₁nómn̥" -- "name", via the Proto-Italic "*nōmn̥" --
                      "name" and the Latin "nōmen" -- "name", "noun".
                      <div></div>
                      <strong>Cognates:</strong> name 🇬🇧, naam 🇳🇱, nome 🇵🇹, navn
                      🇩🇰, نَام 🇮🇷, نوم 🇦🇫, Name 🇩🇪, nombre 🇪🇸, όνομα 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/uncle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hW6xrMIwfhI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;oncle"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "avus" -- "adult
                      male relative (other than one's father)" and its
                      diminutive form "avunculus", which gradually came to mean
                      "maternal uncle", (<i>lit.</i> “little grandfather"). Over
                      time people realized that you couldn’t use one word to
                      denote two different male relatives, so the diminutive
                      “-unculus” was adopted to differentiate the “avus” (
                      <i>i.e.</i>, "grandfather") from the “avunculus” (
                      <i>i.e.</i>, "little grandfather” or “uncle”).
                      <div></div>
                      <strong>Cognates:</strong> uncle 🇬🇧, uncail 🇮🇪, ankol 🇵🇬,
                      <div></div>
                      <strong>Descendants:</strong> Onkel 🇩🇪, onkel 🇳🇴, nonkel
                      🇧🇪, onkel 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/orange1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;orange"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", via the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange", the Arabic "نارنج"
                      /nāranj/ –- “bitter orange”, the Italian "narancia" (and,
                      after rebracketing, "arancia") -- "orange", and the Old
                      French "orenge" -- "orange".
                      <div></div>
                      <strong>Cognates:</strong> orange 🇬🇧, naranja 🇪🇸, arancia
                      🇮🇹, laranja 🇵🇹, на̀ра̄нча 🇷🇸, naranča 🇭🇷, نارَنْج 🇮🇷, नारंगी
                      🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/orphelin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;orphelin"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Ancient Greek adjective "ὀρφανός" /orphanós/ --
                      "without parents", "fatherless".
                      <div></div>
                      <strong>Related to:</strong> robot
                      <div></div>
                      <strong>Cognates:</strong> orphan 🇬🇧, huérfano 🇪🇸, orfano
                      🇮🇹, órfão 🇵🇹, orfan 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ours"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "ursus" -- "bear",
                      via the Old French "urs" -- "bear" and the Middle French
                      "ours" -- "bear".
                      <div></div>
                      <strong>Cognates:</strong> oso 🇪🇸, urso 🇵🇹, αρκούδα 🇬🇷,
                      arth 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pants.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pantalon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A word derived from the
                      funny-looking character in the Italian{" "}
                      <i>Commedia del Arte</i> named "Pantalone" who had skinny
                      legs and wore tight pants.
                      <div></div>
                      <strong>Cognates:</strong> pants 🇬🇧, pantalones 🇪🇸,
                      pantolon 🇹🇷, pantaloni 🇮🇹, παντελόνι 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pape.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pape"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πάππᾰς"
                      /páppăs/ -- "father".
                      <div></div>
                      <strong>Cognates:</strong> па́па 🇷🇺, پاپ 🇮🇷, papa 🇪🇸,
                      بَابَا 🇸🇦, پاپ 🇮🇷, papa 🇦🇿, պապ 🇦🇲, папа 🇧🇾, papež 🇨🇿,
                      pave 🇩🇰, paavi 🇫🇮, პაპი 🇬🇪, Papst 🇩🇪, πάπας 🇬🇷, पोप 🇮🇳,
                      paus 🇮🇩, pápa 🇮🇪, папа 🇰🇿, pāvests 🇱🇻, popiežius 🇱🇹,
                      Poopst 🇱🇺, пап 🇲🇳, papă 🇷🇴, papež 🇸🇮, papa 🇹🇿, papa 🇹🇲,
                      پوپ 🇵🇰, pab 🏴󠁧󠁢󠁷󠁬󠁳󠁿 بَابَا 🇸🇦
                      <div></div>
                      <strong>Descendants:</strong> پاپ 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paper.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;papier"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πᾰ́πῡρος"
                      /pắpūros/ -- "the papyrus plant", via the Latin "papȳrus"
                      -- "paper made from papyrus". Although related
                      etymologically, "papier" and "papyrus" are made from
                      different materials and use different production methods.
                      <div></div>
                      <strong>Related to:</strong> papyrus
                      <div></div>
                      <strong>Cognates:</strong> papel 🇪🇸, paper 🇬🇧, papel 🇵🇹,
                      Papier 🇩🇪, papier 🇳🇱, papper 🇸🇪, papīrs 🇱🇻, paperi 🇫🇮,
                      popierius 🇱🇹, papier 🇵🇱, papur 🏴󠁧󠁢󠁷󠁬󠁳󠁿, папі́р 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parole.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FamWPsuUjK8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parabole"
                  hoverText={
                    <span>
                      <strong>
                        <u>"parable"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Ancient Greek verb
                        "πᾰρᾰβάλλω" -- "to place side by side", via the Latin
                        "parabola" -- "comparison", and the Old French "parole"
                        -- "word".
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Related to:</strong> parole
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> parábola 🇵🇹, parábola 🇪🇸
                      </div>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paradis"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible.
                      <div></div>
                      <strong>Cognates:</strong> paradise 🇬🇧, paraíso 🇵🇹,
                      paraiso 🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸, paraíso
                      🇪🇸, paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parole.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FamWPsuUjK8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parole"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "πᾰρᾰβάλλω" -- "to place side by side", via the Latin
                      "parabola" -- "comparison", and the Old French "parole" --
                      "word".
                      <div></div>
                      <strong>Related to:</strong> parabole
                      <div></div>
                      <strong>Cognates:</strong> palavra 🇵🇹, palabra 🇪🇸, parola
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parapluie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the Ancient
                      Greek suffix "πᾰρᾰ-" /pără-/ -- "contrary to" (via the
                      Italian "para-" -- "guarding against") and the Latin
                      "pluvia" -- "rain".
                      <div></div>
                      <strong>Related to:</strong> <u>para</u>sol, <u>para</u>
                      vent
                      <div></div>
                      <strong>Cognates:</strong> parachuva 🇵🇹, <u>par</u>aguas
                      🇪🇸
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Regenschirm 🇩🇪,
                      lietussargs 🇱🇻, 雨伞 🇨🇳, deštník 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parasol"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Italian "parasole" --
                      "sun-blocker".
                      <div></div>
                      <strong>Related to:</strong> <u>para</u>pluie, <u>para</u>
                      vent
                      <div></div>
                      <strong>Cognates:</strong> parasol 🇵🇹, parasol 🇪🇸, parasol
                      🇩🇰, parasole 🇮🇹, parasol 🇵🇱, парасо́лька 🇺🇦
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      slunečník 🇨🇿, napernyő 🇭🇺, saulessargs 🇱🇻, 阳伞 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/peche.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pêche"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name. From Latin, the word entered
                      Modern French via the Old French "pesche" -- "peach".
                      <div></div>
                      <strong>Related to:</strong> Perse
                      <div></div>
                      <strong>Descendant:</strong> paiso 🇲🇬
                      <div></div>
                      <strong>Cognates:</strong> peach 🇬🇧, pêssego 🇵🇹, ferskja
                      🇮🇸, Pfirsich 🇩🇪, fersken 🇩🇰, fersken 🇳🇴, пе́рсик 🇷🇺, perzik
                      🇳🇱, persik 🇮🇩, piersică 🇷🇴, pjeshkë 🇦🇱, pichi 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/person.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LCiQz7vmiLY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;personne"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "persōna" -- "mask
                      used by actor", "role", "part", "character”. In the Roman
                      world, actors would wear “personae” during performances,
                      which would allow them “to portray a role” and “assume a
                      persona”. Gradually the word became associated both with
                      the mask itself and the actors wearing it, and eventually,
                      the mask meaning disappeared, and only the meaning related
                      to actors, and eventually, all human beings, remained.
                      <div></div>
                      <strong>Cognates:</strong> person 🇬🇧, Person 🇩🇪, persoon
                      🇳🇱, persona 🇪🇸, persona 🇮🇹, pessoa 🇵🇹, person 🏴󠁧󠁢󠁷󠁬󠁳󠁿, persuna
                      🇲🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pied.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pied"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk", via the Latin "pēs" --
                      "foot" and the Old French "pié" -- "foot".
                      <div></div>
                      <strong>Related to:</strong> pédale, pilote
                      <div></div>
                      <strong>Cognates:</strong> piede 🇮🇹, pié 🇪🇸, pé 🇵🇹, foot
                      🇬🇧, πόδι 🇬🇷, Fuß 🇩🇪, voet 🇳🇱, fot 🇸🇪, پا 🇮🇷, پَاؤُں 🇵🇰,
                      पैर 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pilote.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pilote"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Ancient Greek "πηδόν"
                      /pēdón/ -- "oar (blade)" and the Byzantine Greek
                      "*πηδώτης" /pēdṓtēs/ -- “helmsman”. Before the emergence
                      of the airplane, a “pilote” was the person at the helm of
                      a ship who steered it into and out of a harbor and
                      navigated it to its destination. The original meaning
                      "foot" comes from the fact that the "πηδόν" looked like
                      the boat’s foot due to its flat shape and position
                      underneath the boat’s body.
                      <div></div>
                      <strong>Related to:</strong> pédale, pied, piéton
                      <div></div>
                      <strong>Cognates:</strong> pilota 🇮🇹, piloto 🇪🇸, piloto
                      🇵🇹, pilot 🇬🇧, πιλότος 🇬🇷, Pilot 🇩🇪, piloot 🇳🇱
                      <div></div>
                      <strong>Descendants:</strong> pilot 🇦🇿, pilot 🇹🇷, пило́т
                      🇷🇺, пилот 🇲🇰, pilot 🇩🇰, pilot 🇹🇷, pilots 🇱🇻, piloot 🇳🇱,
                      pilot 🇨🇿, პილოტი 🇬🇪, pilot 🇦🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pinceau"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Medieval Latin "pincellus" --
                      "painter's brush", "hair-pencil," (<i>lit.</i> "little
                      tail") and the Old French "pincel" -- "paintbrush".
                      <div></div>
                      <strong>Related to:</strong> pénis
                      <div></div>
                      <strong>Not related to:</strong> pince
                      <div></div>
                      <strong>Cognates:</strong> pincel 🇵🇹, pincel 🇪🇸, penseel
                      🇳🇱, pensel 🇳🇴, pensel 🇩🇰, pędzel 🇵🇱, Pinsel 🇩🇪, pinzell 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/point.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mn09t2xE2QU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;point"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the perfect passive
                      participle form "pūnctus" ("a hole punched in") of the
                      Latin verb "pungō" -- "I prick", "I punch", via the Old
                      French "point" -- "dot", "tiny amount".
                      <div></div>
                      <strong>Related to:</strong> poing
                      <div></div>
                      <strong>Cognates:</strong> point 🇬🇧, punto 🇪🇸, ponto 🇵🇹,
                      Punkt 🇩🇪, пункт 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/poison.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;poison"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the accusative noun "pōtiōnem" --
                      "draught", "(magic) potion". The original word had a
                      double meaning of a liquid substance that was potable but
                      that also often had a little extra something that gave it
                      a little more flavor (and that was also likely harmful to
                      health).
                      <div></div>
                      <strong>Related to:</strong> potable (adj.), potion
                      <div></div>
                      <strong>Cognates:</strong> poison 🇬🇧, poizina 🇲🇬, peçonha
                      🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pomme de terre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i> a "calque") in the 15th century
                      from the Latin "malum terrae" -- "apple of the Earth".
                      <div></div>
                      <strong>Semantic Equivalents:</strong> aardappel 🇳🇱,
                      aartappel 🇿🇦, תַּפּוּחַ אֲדָמָה 🇮🇱, سیب‌زمینی 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/poison.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;potable (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the adjective "pōtābilis" --
                      “drinkable", "potable".
                      <div></div>
                      <strong>Related to:</strong> potion, poison
                      <div></div>
                      <strong>Cognates:</strong> potable 🇬🇧, potável 🇵🇹, potable
                      🇪🇸, potabile 🇮🇹, potabil 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/potion.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;potion"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the accusative noun "pōtiōnem" --
                      "draught", "(magic) potion".
                      <div></div>
                      <strong>Related to:</strong> potable (adj.), poison
                      <div></div>
                      <strong>Cognates:</strong> potion 🇬🇧, poção 🇵🇹, poción 🇪🇸,
                      pozione 🇮🇹, poţiune 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problème"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problème"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> ballet, bal
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problema 🇪🇸, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problēma 🇱🇻, probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸,
                      пробле́ма 🇺🇦, пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴,
                      problema 🇵🇭
                      <div></div>
                      <strong>Descendants:</strong> problem 🇵🇱, problem 🇹🇷,
                      Problem 🇱🇺, problemă 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pyjamas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pyjama"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "پایجامه" --
                      "pyjamas", "pants" (which is itself a combination of "پا"
                      /pâ/ -- “leg” and "جامه" /jâme/ -- "garment"), via the
                      Hindi "पैजामा" -- "pyjama" and the English "pyjama" --
                      "pyjama".
                      <div></div>
                      <strong>Ancestors:</strong> पैजामा 🇮🇳, پائِجامَہ 🇵🇰,
                      pyjama(s) 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> pijama 🇪🇸, pijama 🇵🇹, Pyjama
                      🇩🇪, пижама 🇰🇿, пижама 🇷🇺, пижама 🇰🇬, pijama 🇹🇷, pijama 🇷🇴,
                      πυτζάμα 🇬🇷, піжама 🇺🇦, pyžamo 🇨🇿, pyjama 🇫🇮, поҷома 🇹🇯,
                      پیژامه 🇦🇫, pidžama 🇭🇷, pijama 🇹🇲, פיג׳מה 🇮🇱, pižama 🇱🇹,
                      piama 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rival"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "rīvus" --
                      "brook", "small stream of water", via the adjectival noun
                      "rīvālis" -- "someone who uses the same stream as
                      another". The word originated from the idea of groups of
                      people occupying opposite sides of a river (or any body of
                      water) who were often vying for access to the same
                      resource (<i>e.g.</i>, the Romans and the Carthaginians in
                      the first millennium BC who were both active on opposite
                      sides of the Strait of Messina between Sicily and mainland
                      Italy.)
                      <div></div>
                      <strong>Related to:</strong> dériver (v.)
                      <div></div>
                      <strong>Not related to:</strong> rivière, arrivée
                      <div></div>
                      <strong>Cognates:</strong> rival 🇬🇧, rival 🇪🇸, rival 🇵🇹,
                      rivale 🇮🇹, rywal 🇵🇱, rival 🇷🇴, rival 🇳🇴, Rivale 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rivière"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "rīpa" -- "river
                      bank", "shore", via the Old French "rivere" -- "river".
                      <div></div>
                      <strong>Not related to:</strong> rival, dériver
                      <div></div>
                      <strong>Related to:</strong> arriver (v.)
                      <div></div>
                      <strong>Cognates:</strong> river 🇬🇧, rivier 🇳🇱
                      <div></div>
                      <strong>Not cognates:</strong> rio 🇵🇹, río 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/red.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;rouge (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European
                      "*h₁rewdʰ-" -- "red" via the Proto-Germanic "*raudaz" --
                      "red" via the Latin "rubeus" -- "red".
                      <div></div>
                      <strong>Related to:</strong> roux
                      <div></div>
                      <strong>Cognates:</strong> rojo 🇪🇸, red 🇬🇧, rosso 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/red.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;roux (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₁rewdʰ-" -- "red" via the Proto-Italic "*russos" --
                      "reddish brown" "red" and the Latin "russus" -- "reddish
                      brown"
                      <div></div>
                      <strong>Related to:</strong> rouge
                      <div></div>
                      <strong>Cognates:</strong> red 🇬🇧, ruivo 🇵🇹, rot 🇩🇪, rood
                      🇳🇱, röd 🇸🇪, raudonas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salaire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salaire"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "sal" -- "salt"
                      via the adjective "salārius" -- "related to salt" and the
                      derivative noun "salārium" -- "wages". In Roman times salt
                      was quite valuable, and soldiers who were "worth their
                      salt", so to speak, had to accumulate a hefty "salarium"
                      (or “salt stipend”) to be able to buy some.
                      <div></div>
                      <strong>Related to:</strong> sel
                      <div></div>
                      <strong>Cognates:</strong> salario 🇪🇸, salary 🇬🇧, salário
                      🇵🇹, salarju 🇲🇹
                      <div></div>
                      <strong>Descendants:</strong> salariu 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saluer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;saluer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "salūs" --
                      "health", "safety", "security", via the Old French
                      "saluder" -- "to salute".
                      <div></div>
                      <strong>Cognates:</strong> saluer 🇫🇷, saudar 🇵🇹, salute
                      🇬🇧, saludar 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sante.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;santé"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "sānus"
                      (<i>adj.</i>) –- "healthy", "whole", "well" via the noun
                      "sānitās" –- "health", "soundness of body” via the Old
                      French "santé" -- "health".
                      <div></div>
                      <strong>Descendants:</strong> sante 🇭🇹
                      <div></div>
                      <strong>Cognates:</strong> sanidade 🇵🇹, sanità 🇮🇹, sanity
                      🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sauce.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sauce"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Latin verb "*salō" -- (v.) –
                      “to salt” and its derivative "salsus" –- "salty",
                      "salted". From there, the word evolved into the Old French
                      "sause" -- "sauce", and the Middle English "sauce" --
                      "sauce".
                      <div></div>
                      <strong>Related to:</strong> saucisse, salade, sel,
                      salaire
                      <div></div>
                      <strong>Cognates:</strong> sauce 🇫🇷, salsa 🇪🇸, salsa 🇮🇹,
                      صلصة 🇸🇦, ソース 🇯🇵, 소스 🇰🇷
                      <div></div>
                      <strong>Descendants:</strong> σάλτσα 🇬🇷, sovs 🇩🇰, sos 🇵🇱,
                      sås 🇸🇪, Soße 🇩🇪, xốt 🇻🇳, соус 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saucisse.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;saucisse"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Latin verb "*salō" -- (v.) –
                      “to salt” and its derivative "salsus" –- "salty",
                      "salted". From there, combined with the adjective forming
                      suffix "-īcius", the word evolved into the Late Latin
                      adjective "salsīcius" –- "prepared with salt", the Old
                      French "saucice" -– "sausage", and, finally, the Modern
                      French word.
                      <div></div>
                      <strong>Related to:</strong> sauce, salade, sel, salaire
                      <div></div>
                      <strong>Cognates:</strong> sausage 🇬🇧, salchicha 🇪🇸,
                      salsiccia 🇮🇹, salsicha 🇵🇹, ソーセージ 🇯🇵, 소시지 🇰🇷
                      <div></div>
                      <strong>Descendants:</strong> سوسیس 🇮🇷, sosis 🇹🇷, xúc xích
                      🇻🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/science.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/DJ-ABPy6Udw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;science"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "sciō" -- "to
                      know", and its present participle "sciēns" via the Old
                      French noun "science" -- "knowledge", "awareness".
                      <div></div>
                      <strong>Related to:</strong> con
                      <u>science</u>
                      <div></div>
                      <strong>Cognates:</strong> ciencia 🇪🇸, ciência 🇵🇹, science
                      🇬🇧, sayansi 🇹🇿, sains 🇲🇾, scienza 🇮🇹, știință 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;soldat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army. From "solidus", the word eventually developed into
                      the Italian "soldo" -- "penny", cent", then "soldato" --
                      "soldier", "one who earns a 'soldo'", and then, finally,
                      the modern French word.
                      <div></div>
                      <strong>Ancestor:</strong> soldo 🇮🇹, soldato 🇮🇹,
                      <div></div>
                      <strong>Cognates:</strong> Soldat 🇩🇪, soldier 🇬🇧, soldat
                      🇩🇰, soldado 🇵🇹, cолда́т 🇷🇺, soldado 🇪🇸, soldat 🇸🇪, soldat
                      🇷🇴, soldaat 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/solitude.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;solitude"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "solus"
                      -- "only", "sole", via the noun "sōlitūdō" -- "solitude",
                      and the Old French "solitude" -- "solitude".
                      <div></div>
                      <strong>Related to:</strong> seul (<i>adj.</i>), solo
                      <div></div>
                      <strong>Cognates:</strong> solitude 🇵🇹, solitude 🇬🇧,
                      soledad 🇪🇸, solitudine 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      Originally the word was more closely associated with the
                      idea of people letting themselves get carried away in a
                      pleasant activity that allowed them to just relax and have
                      fun.
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, Sport 🇩🇪, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺,
                      ስፖርት 🇪🇹, šport 🇸🇰
                      <div></div>
                      <strong>Descendants:</strong> spor 🇹🇷, sport 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/azucar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sucre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel".
                      <div></div>
                      <strong>Ancestor:</strong> شکر 🇮🇷, سُكَّر 🇸🇦, zucchero 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> ζάχαρη 🇬🇷, са́хар 🇷🇺, sugar 🇬🇧,
                      azúcar 🇪🇸, sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪, suiker 🇳🇱,
                      cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲, suhkur 🇪🇪, ስኳር
                      🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/detail1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;taille"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old French "taille" --
                      "(act of) cutting" and the verb "taillier" -- "to cut".
                      <div></div>
                      <strong>Related to:</strong> détail
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tapestry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tapis"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Old Persian verb
                      "تَنبَسیدَن" /tanbasidan/ -- "to twist threads" via the
                      Ancient Greek "τάπης" /tápēs/ -- "carpet", "rug", and the
                      Old French "tapiz" -- "carpet", "rug"
                      <div></div>
                      <strong>Cognates:</strong> tappeto 🇮🇹, teppi 🇮🇸, Teppich
                      🇩🇪, tepih 🇷🇸, tapete 🇵🇹, teppe 🇳🇴, tapit 🇲🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/terre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/M2lknMW7HiI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;terre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ters-" -- "dry", via the Proto-Italic "*terzā" --
                      "earth" and the Latin "terra" -- "dry land".
                      <div></div>
                      <strong>Cognates:</strong> tierra 🇪🇸, terra 🇵🇹, terra 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/the.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;thé"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> tea 🇬🇧, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/toilettes.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;toile"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tēla" -- "web",
                      "loom", via the Old French "toile" -- "cloth", "net",
                      "web".
                      <div></div>
                      <strong>Related to:</strong> toilettes
                      <div></div>
                      <strong>Not related to:</strong> étoile
                      <div></div>
                      <strong>Descendants:</strong> tela 🇪🇸, tela 🇵🇹, teia 🇵🇹,
                      tela 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/toilettes.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;toilettes"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tēla" -- "web",
                      "loom", via the Old French "toile" -- "cloth", "net", and
                      the Middle French "toilette" -- "small cloth". Originally,
                      people wrapped the "toilette" around their shoulders to
                      protect their clothes while doing their grooming. Over
                      time the cloth went from being on shoulders to being
                      spread out on a dressing table on which people would put
                      toiletry items. Eventually, the word came to refer to the
                      whole area where the dressing table was located (which was
                      often close to where people did their modern-day "toilet"
                      business).
                      <div></div>
                      <strong>Related to:</strong> toile
                      <div></div>
                      <strong>Descendants:</strong> toilet 🇬🇧, Toilette 🇩🇪,
                      toilet 🇳🇱, туале́т 🇷🇺, toaleta 🇵🇱, toalett 🇸🇪, tualete 🇱🇻,
                      tuvalet 🇹🇷, toilet 🇿🇦, τουαλέτα 🇬🇷, туале́т 🇺🇦, toiled 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tomato.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tomate"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl "tomatl" --
                      "tomatillo", "tomato" via the Spanish "tomate" --
                      "tomato". The word was brought to Spain from the New World
                      and from there spread all over Europe and the rest of the
                      world.
                      <div></div>
                      <strong>Ancestors:</strong> tomate 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> tomato 🇬🇧, Tomate 🇩🇪, tomate
                      🇵🇹, дома́т 🇧🇬, домат 🇲🇰, tomāts 🇱🇻, ντομάτα 🇬🇷, トマト 🇯🇵,
                      토마토 🇰🇷, ቲማቲም 🇪🇹, टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat
                      🇲🇾, tomat 🇸🇪, domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/transpirer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;transpirer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin preposition
                      "trans" -- "across" and the verb "spīrō" -- "to breathe" (
                      <i>i.e.</i>, "breathing out (one's last breath")). The
                      original meaning refers to the way sweat passes across the
                      pores of the skin, like "breathing" through an opening.
                      <div></div>
                      <strong>Related to:</strong> ésprit, in<u>spirer</u>, ex
                      <u>pirer</u>, con<u>spir</u>er
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vacancy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vacances"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Latin verb "vacō" -- "to be free".
                      <div></div>
                      <strong>Related to:</strong> waste (v.), vacation, vacuum
                      <div></div>
                      <strong>Cognates:</strong> vacation 🇬🇧, vacaciones 🇪🇸,
                      vacanza 🇮🇹, vakantie 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/venir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/t4CwXz_CSU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;venir (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic verb
                      "*gʷənjō" -- "to come", via the Latin "venīo" -- "to
                      come", and the Old French "venir" -- "to come".
                      <div></div>
                      <strong>Related to:</strong> a<u>venture</u>
                      <div></div>
                      <strong>Cognates:</strong> venir 🇪🇸, venire 🇮🇹, vir 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/worm.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ver"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wr̥mis" -- "worm" via Latin "vermem", -- "worm" and the
                      Old French "ver" -- "worm".
                      <div></div>
                      <strong>Not related to:</strong> vert (<i>adj.</i>),
                      verre, vers (<i>prep.</i>)<div></div>
                      <strong>Cognates:</strong> worm 🇬🇧, Wurm 🇩🇪, verme 🇵🇹, orm
                      🇩🇰, verme 🇮🇹, vierme 🇷🇴, worm 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/verbe.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;verbe"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say", via the Proto-Italic
                      "*werβom" -- "word", and the the Latin "verbum" -- "spoken
                      word", "verb". The modern meaning was influenced by the
                      fact that the Romans considered the "verbum" to be the
                      most important word in a sentence from a grammatical
                      perspective.
                      <div></div>
                      <strong>Cognates:</strong> verb 🇬🇧, verbo 🇪🇸, verbo 🇵🇹,
                      Verb 🇩🇪
                      <div></div>
                      <strong>Semantic Equivalents:</strong> глагол 🇷🇸, глагол
                      🇧🇬, глагол 🇲🇰, глагол 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vers.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;vers (<i>prep.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "versus" --
                      "facing" (which is a past participle of the verb "vertere"
                      -- "to turn", "to change", "to overthrow").
                      <div></div>
                      <strong>Related to:</strong> verser (<i>v.</i>)<div></div>
                      <strong>Not related to:</strong> vert (<i>adj.</i>),
                      verre, ver
                      <div></div>
                      <strong>Cognates:</strong> verso 🇮🇹<div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hZaC6v6pM0o"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;veste"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wéstis" -- "the act of dressing/clothing" via the Latin
                      "vestis" -- "garment", "gown", "robe", "vestment"
                      <div></div>
                      <strong>Related to:</strong> investir (v.), investiture,
                      vêtir (v.)
                      <div></div>
                      <strong>Cognates:</strong> vest 🇳🇱, vest 🇳🇴, vest 🇩🇰, väst
                      🇸🇪, vest 🇬🇧, Weste 🇩🇪, vesta 🇨🇿, vesta 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vinegar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vinaigre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin
                      "vīnum" -- “wine” and the adjective "ācer" -- “sour”, so
                      literally "sour wine".
                      <div></div>
                      <strong>Related to:</strong> aigre (<i>adj</i>.)
                      <div></div>
                      <strong>Cognates:</strong> vinegar 🇬🇧, vinagre 🇵🇹, aceto
                      🇮🇹, oțet 🇷🇴, ocet 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/visa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;visa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "videō" --
                      "to see", via its perfect passive form "vīsa", which was
                      used together with the noun "charta" -- "paper" (
                      <i>i.e.,</i> "a signed page on a passport"), to denote a
                      "paper that has been seen".
                      <div></div>
                      <strong>Related to:</strong> évi<u>dent</u>, pru
                      <u>dent</u> (<i>adj</i>.), visite, vision, en<u>vie</u>,
                      vidéo, a<u>vis</u>
                      <div></div>
                      <strong>Descendants:</strong> visa 🇬🇧, visa 🇪🇸, visto 🇮🇹,
                      visto 🇵🇹, viză 🇷🇴, wiza 🇵🇱, visum 🇳🇱, visum 🇳🇴, visum 🇩🇰,
                      visum 🇸🇪, ви́за 🇧🇬, виза 🇲🇰, vīza 🇱🇻, vizë 🇦🇱, viisa 🇪🇪,
                      vízum 🇭🇺, ві́за 🇺🇦, ви́за 🇷🇺, βίζα 🇬🇷, وِیزا 🇵🇰, виза 🇰🇿,
                      वीज़ा 🇮🇳 виза 🇹🇯, ویزا 🇮🇷, ビザ 🇯🇵, 咖啡 🇨🇳, วีซา 🇹🇭, viza
                      🇹🇿, වීසා 🇱🇰, ভিসা 🇧🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vision.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vision"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the passive participle
                      "vīsus" -- "having been seen" of the Latin verb "videō" --
                      "to see", via the noun "vīsiō" -- "seeing", "vision", and
                      the Old French noun "vision" -- "vision".
                      <div></div>
                      <strong>Related to:</strong> évi<u>dent</u>, pru
                      <u>dent</u> (<i>adj</i>.), visa, visite, en<u>vie</u>,
                      vidéo, a<u>vis</u>
                      <div></div>
                      <strong>Cognates:</strong> visión 🇪🇸, visão 🇵🇹, vedere 🇷🇴,
                      widzenie 🇵🇱, visió 🇦🇩, vision 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/visite.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;visite"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "videō" --
                      "to see", via the verb "vīsō" -- "to behold", "to survey”,
                      and its frequentative derived form "vīsitō" -- "to go to
                      see", "to visit", and the Old French "visiter" -- "to
                      visit".
                      <div></div>
                      <strong>Related to:</strong> évi<u>dent</u>, pru
                      <u>dent</u> (<i>adj</i>.), visa, vision, en<u>vie</u>,
                      vidéo, a<u>vis</u>
                      <div></div>
                      <strong>Cognates:</strong> visit 🇬🇧, visita 🇪🇸, visita 🇮🇹,
                      visita 🇵🇹, vizită 🇷🇴, wizyta 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇬🇪 GEORGIAN 🇬🇪
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avtobus_ge.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ავტობუსი"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷, авто́бус 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, اتوبوس 🇮🇷,
                      otobüs 🇹🇷, автобус 🇲🇳, awtobus 🇹🇲, אוֹטוֹבּוּס 🇮🇱,
                      ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦,
                      বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avaria1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/cI0Fa9UD9S8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ავარია"
                  hoverText={
                    <span style={{ display: "block", maxWidth: "400px" }}>
                      <strong>Origin:</strong> Likely from the Arabic verb
                      "عَوِرَ" /ʕawira/ -- "to lose an eye" and the derived
                      "عَوَار" /ʕawār/ -- "blemish", "defect" via "عَوَارِيَّة"
                      /ʕawāriyya/ -- "damaged goods" and, later, the Italian
                      "avaria" -- "damage done to goods (that have been thrown
                      overboard) on a watercraft".
                      <div style={{ margin: "8px 0" }}></div>
                      <strong>Cognates:</strong> авария 🇷🇺, Havarie 🇩🇪
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;გაზი"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gaz 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ
                      🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass
                      🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷,
                      ガス 🇯🇵, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, גז 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/economy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ეკონომია"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "οἰκονομία"
                      /oikonomía/ -- "management of a household (a combination
                      of "οἶκος" /oîkos/ -- "house", "dwelling place" and the
                      verb "νέμω" /némō/ -- "to distribute", "to allocate”).
                      Originally, the word denoted the concept of properly
                      allocating and distributing the resources within one's
                      house.
                      <div></div>
                      <strong>Ancestor:</strong> économie 🇫🇷, экономия 🇷🇺
                      <div></div>
                      <strong>Related to:</strong> <u>ეკო</u>ლოგია
                      <div></div>
                      <strong>Cognates:</strong> economy 🇬🇧, economia 🇵🇹,
                      economia 🇮🇹, økonomi 🇳🇴, økonomi 🇩🇰, οικονομία 🇬🇷,
                      economie 🇷🇴, economía 🇪🇸, ekonomi 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;მუსიკა"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)"
                      <div></div>
                      <strong>Related to:</strong> მუზეუმი
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, music 🇬🇧, مُوسِيقَى
                      🇸🇦, му́зыка 🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik 🇮🇩, މިއުޒިކް
                      🇲🇻, muzik 🇲🇾, muziki 🇹🇿, musiikki 🇫🇮, musik 🇸🇪, музыка 🇰🇬,
                      му́зика 🇺🇦, ሙዚቃ 🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/psychiater.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ფსიქიატრი"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ψυχή" /psukhḗ/ -- "soul" and "ἰατρός" /iatrós/ --
                      “doctor”.
                      <div></div>
                      <strong>Cognates:</strong> psychiatrist 🇬🇧, psiquiatra 🇪🇸,
                      psiquiatra 🇵🇹, psikiyatrist 🇹🇷, психиа́тр 🇷🇺, psychiatre
                      🇫🇷, pszichiáter 🇭🇺, ψυχίατρος 🇬🇷, psühhiaater 🇪🇪, פסיכיאטר
                      🇮🇱, Psychiater 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sevda_g.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;სევდა"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "سوداء" /sawdāʔ/
                      -– "melancholy", "black bile", which itself is the
                      feminine form of the noun "أَسْوَد" /ʔaswad/ -- "black",
                      via the Old Georgian "სევდაჲ" /sevday/ -- "sorrow".
                      <div></div>
                      <strong>Ancestor:</strong> سوداء 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> sevdah 🇧🇦, sevda 🇦🇱, sevda 🇹🇷,
                      sevda 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;სპორტი"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, sport 🇫🇷, Sport 🇩🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺,
                      ስፖርት 🇪🇹, šport 🇸🇰, spor 🇹🇷, sport 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chaii.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ჩაი"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, çay 🇹🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý 🇹🇲, តែ
                      🇰🇭, شَاي 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chemodan2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ჩემოდანი"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "جامه‌دان"
                      /jâme-dân/ -- "suitcase", which is itself a combination of
                      "جامه" /jâme/, -- “cloth” and "دان" /dân/ -- "container",
                      via the Russian "чемодан" /čemodán/ -- "suitcase".
                      <div></div>
                      <strong>Ancestors:</strong> чемодан 🇷🇺, جامه‌دان 🇮🇷
                      <div></div>
                      <strong>Related to:</strong> პიჟამა
                      <div></div>
                      <strong>Cognates:</strong> шабадан 🇰🇿, çemedan 🇹🇲,
                      čemodāns 🇱🇻, чемодан 🇲🇳, чамадон 🇹🇯, чемодан 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇩🇪 GERMAN 🇩🇪
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/abend.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Abend"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*ēbanþs"
                      –- "evening", via the Old High German "āband" -–
                      "evening", "day before", "west".
                      <div></div>
                      <strong>Not related to:</strong> eben (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> evening 🇬🇧, avond 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adventure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/t4CwXz_CSU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Abenteuer"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "adventūrus" --
                      "to be about to arrive", a participle of the verb
                      "adveniō" -- "to arrive", "to come to a specific
                      location", via the Old French "aventure" -- "event",
                      "destiny", "fortune", and the Middle High German
                      "âventiure" -- "adventure", "event".
                      <div></div>
                      <strong>Not related to:</strong> Abend
                      <div></div>
                      <strong>Cognates:</strong> aventura 🇪🇸, adventure 🇬🇧,
                      avontuur 🇳🇱, aventure 🇫🇷, avventura 🇮🇹, aventura 🇵🇹,
                      äventyr 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/albtraum.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Albtraum"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "Alb" -- "evil
                      elf" (which itself is from the Proto-West-Germanic "albi"
                      -- "elf", "fairy") and "Traum" -- "dream" (which is from
                      the Proto-West-Germanic "draum" -- "dream", "joy") The
                      word "Albtraum" therefore literally means "elf dream" and
                      is derived from the belief in European folklore that
                      nightmares were caused by an evil spirit who sits on a
                      person's chest while they sleep and tries to suffocate
                      them.
                      <div></div>
                      <strong>Cognates:</strong> Alpdram 🇱🇺, mar<u>dröm</u> 🇸🇪
                      <div></div>
                      <strong>Semantic Equivalents:</strong> cauchemar 🇫🇷,
                      incubo 🇮🇹, كابوس 🇸🇦, painajainen 🇫🇮, coșmar 🇷🇴, koszmar
                      🇵🇱, კოშმარი 🇬🇪, košmaras 🇱🇹, кошма́р 🇷🇺, martröð 🇮🇸,
                      koszmar 🇵🇱, mareritt 🇳🇴, coșmar 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ananas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Ananas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Tupi-Guarani
                      "*nanã" -- "pineapple", via the Old Tupi "naná" --
                      "pineapple".
                      <div></div>
                      <strong>Cognates:</strong> ananas 🇫🇷, анана́с 🇷🇺, آناناس
                      🇮🇷, أَنَانَاس 🇸🇦, nanasi 🇹🇿, ананас 🇰🇿, ananāss 🇱🇻, ananas
                      🇫🇮, ananas 🇹🇷, နာနတ် 🇲🇲, ananas 🇩🇰, ananas 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/antwort.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VvZv83SW8Bg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Antwort"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*andawurdiją" -- "answer", "reply", which was itself a
                      compound of "*anda-" -- "against" and "*wurdiją" --
                      "speech", "conversation”.
                      <div></div>
                      <strong>Related to:</strong> Wort
                      <div></div>
                      <strong>Cognates:</strong> <u>an</u>swer 🇬🇧, antwoord 🇳🇱,
                      antwoord 🇿🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apfelsine.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Apfelsine"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the French "pomme de Sine"
                      🇫🇷 – “apple from China”. The word was calqued into the
                      Dutch "appelsien" -- "orange". The name reflects the fact
                      that the fruit originated from a region that encompasses
                      Southern China.
                      <div></div>
                      <strong>Cognates:</strong> sinaasappel 🇳🇱, апельсин 🇰🇿,
                      апельсин 🇰🇬, apelsin 🇸🇪, апельсин 🇷🇺, appelsin 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arbeit.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Arbeit"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", via the Proto-Germanic
                      "*arbaidiz" -- "labour", "work", "toil", the
                      Proto-West-Germanic "*arbaiþi" -- "toil", "hardship", and
                      the Old High German "arbeit" -- "toil", "suffering".
                      <div></div>
                      <strong>Related to:</strong> Erbe, Roboter
                      <div></div>
                      <strong>Cognates:</strong> arbeid 🇳🇱, arbeid 🇿🇦, arbete
                      🇸🇪, Aarbecht 🇱🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/architect.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Architekt"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ἀρχι-" /arkhi-/ -- “chief” and "τέκτων" /téktōn/ --
                      “builder”.
                      <div></div>
                      <strong>Related to:</strong> <u>Erz</u>feind, <u>Erz</u>
                      bischof
                      <div></div>
                      <strong>Cognates:</strong> architect 🇬🇧, arhitekts 🇱🇻,
                      architecte 🇫🇷, arquitecto 🇪🇸, arquiteto 🇵🇹, architetto 🇮🇹,
                      архіте́ктор 🇺🇦, arxitektor 🇺🇿, arsitèk 🇮🇩, arhitekt 🇸🇮,
                      argitek 🇿🇦, arkitekt 🇮🇸, архитектор 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arzt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Arzt (Ärztin)"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ἀρχιατρός" /arkhiatrós/ (a combination of "ἀρχι-"
                      /arkhi-/ -- "chief", "of primary importance" and "ῑ̓ᾱτρός"
                      /īātrós/ -- "physician", "doctor"), via the Latin
                      "archīāter" -- "chief physician (of a ruler)" and the
                      Middle High German "arzāt" -- "doctor".
                      <div></div>
                      <strong>Related to:</strong> <u>Erz</u>feind, Psych
                      <u>iater</u>, <u>Archi</u>tekt
                      <div></div>
                      <strong>Cognates:</strong> arst 🇪🇪, ιατρός 🇬🇷, ārsts 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/eye.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Auge"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃ekʷ-" -- "eye", "to see" via the Proto-Germanic
                      "*augô" -- “eye”, the Proto-West-Germanic "*augā" -- "eye"
                      and the Old High German "ouga" -- “eye”.
                      <div></div>
                      <strong>Cognates:</strong> ojo 🇪🇸, œil 🇫🇷, olho 🇵🇹, occhio
                      🇮🇹, ochi 🇷🇴, eye 🇬🇧, oog 🇳🇱, øye 🇩🇰, øye 🇳🇴, öga 🇸🇪, oko
                      🇵🇱, oko 🇸🇮, oko 🇭🇷, око́ 🇧🇬, acs 🇱🇻, akis 🇱🇹, sy 🇦🇱, աչք 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Bach.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PtZcAf8r9Ws"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Bach"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "bʰeg-" -- "flowing water", via the Proto-Germanic
                      "*bakiz" -- "brook", "stream", and the Old High German
                      "bah" -- "brook".
                      <div></div>
                      <strong>Cognates:</strong> bäck 🇸🇪, bekk 🇳🇴, beek 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/baer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Bär"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*bʰerH-" -- "brown", via the
                      Proto-Germanic "*berô" -- "the brown one". Most scholars
                      believe that early Germanic peoples called the animal “the
                      brown one”, in an effort to avoid calling it by its real
                      name, which, in those superstitious cultures, was
                      considered taboo, and could cause it to appear during a
                      hunt.
                      <div></div>
                      <strong>Related to:</strong> braun (adj.)
                      <div></div>
                      <strong>Cognates:</strong> bear 🇬🇧, beer 🇳🇱, bjørn 🇩🇰,
                      bjørn 🇳🇴
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong> медве́дь 🇷🇺,
                      niedźwiedź 🇵🇱, lokys 🇱🇹, lācis 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/beere.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Beere"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*bazją"
                      -- "berry", via the Proto-West-Germanic "*baʀi" – "berry",
                      the Old High German "beri" -- "berry", and the Middle High
                      German "bere" -- "berry".
                      <div></div>
                      <strong>Cognates:</strong> berry 🇬🇧, beri 🇹🇿, bes 🇳🇱, bær
                      🇳🇴, bär 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/blume.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Blume"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Proto-Germanic
                      "*blōmô" -- “flower”, via the Proto-West-Germanic "*blōmō"
                      -- "flower" and the Old High German "bluomo" –- "flower".
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, fleur 🇫🇷, flor 🇵🇹,
                      flor 🇪🇸, fiore 🇮🇹, flower 🇬🇧, blomst 🇳🇴, blomst 🇩🇰, blomma
                      🇸🇪, floare 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/brombeere.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Brombeere"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West-Germanic
                      "brāmabaʀi" -- "blackberry" (which itself is a combination
                      of "*brāma" -- "bramble", "thorn bush", and "*baʀi" –
                      "berry"), via the Old High German "brāmberi" --
                      "blackberry".
                      <div></div>
                      <strong>Cognates:</strong> braam 🇳🇱, bjørne
                      <u>bær</u> 🇳🇴, bromber 🇫🇴, brombær 🇩🇰, brómber 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/busde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Bus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dolmetscher.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/j2E_-Jyl6AM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Dolmetscher"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*tilmač"
                      -- "an intermediary in communication between two parties
                      using different languages".
                      <div></div>
                      <strong>Ancestor:</strong> dilmaç 🇹🇷
                      <div></div>
                      <strong>Cognates:</strong> tolmács 🇭🇺, tłumacz 🇵🇱, tolmač
                      🇸🇮, tlmočník 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Dschungel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Dschungel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert". The word
                      was adopted by British colonists in the Indian
                      subcontinent to refer to any territory that was
                      inhospitable, and then gradually it evolved to denote a
                      place with “tangled thickets”, and then, from there, "any
                      area with lots of vegetation".
                      <div></div>
                      <strong>Ancestors:</strong> جَنْگَل 🇵🇰, जंगल 🇮🇳, jungle 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> جَن٘گَل 🇮🇷, জঙ্গল 🇧🇩, जङ्गल 🇳🇵,
                      cəngəllik 🇦🇿, ځنګل 🇦🇫, ҷангал 🇹🇯, джу́нгли 🇷🇺, jungle 🇫🇷,
                      jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪, dżungla 🇵🇱, ջունգլի 🇦🇲,
                      ჯუნგლი 🇬🇪, ジャングル 🇯🇵, džungla 🇸🇮, džùngla 🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                      <strong>Descendants:</strong> dzsungel 🇭🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/eben.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;eben (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*ebnaz"
                      -- "even", "level", via the Proto-West-Germanic "*ebn" --
                      "even", "level" and the Old High German "eban" -- "plain",
                      "even".
                      <div></div>
                      <strong>Not related to:</strong> Abend
                      <div></div>
                      <strong>Cognates:</strong> even 🇬🇧, even 🇳🇱, jafn 🇮🇸, jämn
                      🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/elbow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Ellenbogen"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*alinō"
                      -- “forearm" + "*bugô" -- "bend", so literally, "place
                      where the forearm bends". From there, the word gradually
                      entered German through the Old High German "elinbogo" --
                      "elbow".
                      <div></div>
                      <strong>Related to:</strong> Bogen
                      <div></div>
                      <strong>Cognates:</strong> elbow 🇬🇧, elleboog 🇳🇱, albue
                      🇩🇰, albue 🇳🇴, ло́коть 🇷🇺, łokieć 🇵🇱, elmboog 🇿🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arbeit.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Erbe"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", via the Proto Germanic "*arbiją"
                      -- "heritage", "inheritance". and the Old High German
                      "erbi" -- "heritage".
                      <div></div>
                      <strong>Related to:</strong> Arbeit, Roboter
                      <div></div>
                      <strong>Cognates:</strong> <u>erfe</u>nis 🇳🇱, <u>erfe</u>
                      nis 🇿🇦, arv 🇩🇰, arv 🇸🇪, arv 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/erzfeind.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Erzfeind"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first element stems from the
                      Ancient Greek "ἀρχι-" /arkhi-/ -- "chief", "of primary
                      importance". The second element stems from the
                      Proto-Germanic "*fijandz" -- "enemy".
                      <div></div>
                      <strong>Cognates:</strong> <u>arch</u>enemy 🇬🇧, ærkefjende
                      🇩🇰, erkefiende 🇳🇴, aartsvijand 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/essig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Essig"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ak-" -- "sharp", via the Latin "acētum" -- "vinegar",
                      and the Proto-West-Germanic "*aket" -- "vinegar".
                      <div></div>
                      <strong>Cognates:</strong> vin<u>agre</u> 🇪🇸, vin
                      <u>aigre</u> 🇫🇷, vin<u>agre</u> 🇵🇹, aceto 🇮🇹, oțet 🇷🇴,
                      ocet 🇵🇱, azijn 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Familie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Cognates:</strong> familia 🇪🇸, familja 🇲🇹, family
                      🇬🇧, pamilya 🇵🇭, Familie 🇩🇪, famiglia 🇮🇹, família 🇵🇹,
                      familie 🇷🇴, famille 🇫🇷
                      <div></div>
                      <strong>Descendants:</strong> familie 🇩🇰, familie 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fenetre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Fenster"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "fenestra" --
                      "(glass) window", via the Proto-West Germanic "fenestr" --
                      "window", and the Old High German "fenstar" - "window".
                      <div></div>
                      <strong>Cognates:</strong> finestra 🇮🇹, fönster 🇸🇪,
                      fenêtre 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gleich.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;gleich (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*leyg-" -- "similar", "level", "even", via the
                      Proto-Germanic verb "*galīkōną" -- "to be like", "to
                      resemble", and the Old High German adjective "gilīh" --
                      "equal".
                      <div></div>
                      <strong>Not related to</strong>: Leiche
                      <div></div>
                      <strong>Cognates</strong>: like (<i>adj.</i>) 🇬🇧, gelijk (
                      <i>adj.</i>) 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/clock.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Glocke"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Celtic
                      "*klokkos" -- "bell", via the Medieval Latin "clocca" --
                      "bell", and the Old High German "klocca" -- "bell".
                      <div></div>
                      <strong>Cognates:</strong> cloch 🏴󠁧󠁢󠁷󠁬󠁳󠁿, klok 🇳🇱, klukka 🇮🇸,
                      clog 🇮🇪, cloche 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/god.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Gott"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ǵʰutós" -- "one who is invoked" via the Proto-Germanic
                      "gudą" -- "god", "deity", the Proto-West-Germanic "*god"
                      -- "god", and the Old High German "got" -- "god".
                      <div></div>
                      <strong>Related to:</strong> Abgott
                      <div></div>
                      <strong>Cognates:</strong> god 🇳🇱, gud 🇩🇰, gud 🇸🇪, gud 🇳🇴,
                      god 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Havarie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/cI0Fa9UD9S8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Havarie"
                  hoverText={
                    <span style={{ display: "block", maxWidth: "400px" }}>
                      <strong>Origin:</strong> Likely from the Arabic verb
                      "عَوِرَ" /ʕawira/ -- "to lose an eye" and the derived
                      "عَوَار" /ʕawār/ -- "blemish", "defect" via "عَوَارِيَّة"
                      /ʕawāriyya/ -- "damaged goods" and, later, the Italian
                      "avaria" -- "damage done to goods (that have been thrown
                      overboard) on a watercraft", and the Old French "avarie"
                      -- "damage done to goods thrown overboard on a
                      watercraft".
                      <div style={{ margin: "8px 0" }}></div>
                      <strong>Cognates:</strong> ავარია 🇬🇪, ава́рия 🇷🇺
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/himbeere.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Himbeere"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West-Germanic
                      "*hindibaʀi" -- "raspberry" (which itself is a combination
                      of "*hindi" -- "doe", and "*baʀi" – "berry"), via the Old
                      High German "hintberi" -- "raspberry".
                      <div></div>
                      <strong>Related to:</strong> Hinde
                      <div></div>
                      <strong>Cognates:</strong> bringe
                      <u>bær</u> 🇳🇴, hindber 🇫🇴, hindbær 🇩🇰, hindber 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobby.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Hobby"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Possibly related to:</strong> hüpfen (v.)
                      <div></div>
                      <strong>Ancestors:</strong> hobby 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> hobi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, xоби 🇲🇰, hobi 🇹🇷,
                      hobby 🇸🇪, хо́бби 🇷🇺, hobbi 🇭🇺, hobis 🇱🇹, hobbi 🇦🇿, hobijs
                      🇱🇻, хоби 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/horn.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Horn"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Proto-Germanic
                      "*hurną" -- "horn", the Proto-West-Germanic "*horn" --
                      "horn" and the Old High German "horn" -- "horn".
                      <div></div>
                      <strong>Cognates:</strong> horn 🇬🇧, cuerno 🇪🇸, corne 🇫🇷,
                      hoorn 🇳🇱, horn 🇳🇴, horn 🇩🇰
                      <div></div>
                      <strong>Semantic equivalents:</strong> 角 🇨🇳, tê{" "}
                      <u>giác</u> 🇻🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hundert.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Hundert"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*hundaradą" -- "a large number (usually equal to either
                      100 or 120)", via the Old High German "hundert" -- "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundred 🇬🇧, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, cent 🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Hypothek"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Related to:</strong> Biblio<u>thek</u>, These
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, ipotek 🇹🇷,
                      hipoteca 🇵🇹, hypothèque 🇫🇷, hipoteka 🇵🇱, hipoteka 🇸🇮,
                      ипотека 🇰🇿, hipoteca 🇪🇸, ипотека 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Idiot"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”.
                      <div></div>
                      <strong>Cognates:</strong> idiot 🇬🇧, идиот 🇲🇰, идиот 🇷🇺,
                      идиот 🇧🇬, idiota 🇪🇸, idiota 🇵🇹, idiota 🇵🇱, idiot 🇫🇷,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/insekt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Insekt"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "īnsectus" (
                      <i>i.e.</i>, īn + sectus) -- "cut into sections". Borrowed
                      as a word-for-word translation of the Ancient Greek
                      "ἔντομον" /éntomon/ -- "cut into sections". From the
                      observation (first made by Aristotle) that insects are
                      physically separated (or "cut") into three separate
                      sections (head, thorax, abdomen).
                      <div></div>
                      <strong>Related to:</strong> Sex
                      <div></div>
                      <strong>Not related to:</strong> Sekt
                      <div></div>
                      <strong>Cognates:</strong> insecto 🇪🇸, insecte 🇫🇷, inseto
                      🇵🇹, insetto 🇮🇹, insectă 🇷🇴, insect 🇬🇧, insect 🇳🇱, insekt
                      🇳🇴, insekt 🇩🇰, на<u>сек</u>о́мое 🇷🇺, на<u>сек</u>омо 🇧🇬
                      <div></div>
                      <strong>Semantic equivalents:</strong> έντομο 🇬🇷, rovar
                      🇭🇺, trychfil 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kafig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Käfig"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", and its derivative noun "cavea" – "hollow
                      place", "enclosure for animals", via the Old High German
                      "chevia" -- "cave", "cage".
                      <div></div>
                      <strong>Related to:</strong> Koje<div></div>
                      <strong>Descendants:</strong> Käfeg 🇱🇺<div></div>
                      <strong>Cognates:</strong> cage 🇬🇧, kooi 🇳🇱, gabbia 🇮🇹,
                      jaula 🇪🇸, cage 🇫🇷, gaiola 🇵🇹, kou 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chameau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Kamel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel", via the Arabic "جَمَل" /jamal/ -- "camel" and
                      the Middle High German "kemel" -- "camel".
                      <div></div>
                      <strong>Ancestors:</strong> جَمَل 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> ޖަމަލު 🇲🇻, جَمَل 🇸🇦, ግመል 🇪🇹,
                      גמל 🇮🇱, ngamia 🇹🇿, camello , camel 🇬🇧, cammello 🇮🇹, camelo
                      🇵🇹, chameau 🇫🇷, kamel 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Käse"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product".
                      <div></div>
                      <strong>Cognates:</strong> cheese 🇬🇧, kaas 🇳🇱, queso 🇪🇸,
                      keso 🇵🇭 queijo 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leiche.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;Leiche</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*līką"
                      -- "body", via the Old High German "līh" -- "body",
                      "figure" and the Middle High German "līche" -- "(dead)
                      body",
                      <div></div>
                      <strong>Not related to</strong>: gleich (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates</strong>: lig 🇩🇰, lijk 🇳🇱, lik 🇸🇪, lík 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/krieg.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Krieg"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*krīg" –- "strife", "endeavor", "struggle" via the Old
                      High German "krig" -– "persistence", "stubbornness" and
                      the Middle High German "kriec" –- "exertion", "enmity",
                      "opposition".
                      <div></div>
                      <strong>Likely related to:</strong> kriegen <i>v.</i>
                      <div></div>
                      <strong>Cognates:</strong> krig 🇩🇰, krig 🇳🇴, krig 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kriegen.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;kriegen (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*krīg" –- "strife", "endeavor", "struggle" via the Middle
                      High German "kriegen" -– "to wage war", "to conquer
                      territory".
                      <div></div>
                      <strong>Likely related to:</strong> Krieg
                      <div></div>
                      <strong>Cognates:</strong> krijgen 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lVpHk6bQL_I"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;lesen (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*leǵ-" -- "to gather", "to collect", via the Proto-Italic
                      "*legō" -- "to gather", "to collect" and the Latin
                      "legere" -- "to read".
                      <div></div>
                      <strong>Related to:</strong> Intel<u>li</u>genz, intel
                      <u>lekt</u>uell
                      <div></div>
                      <strong>Cognates:</strong> lire 🇫🇷, ler 🇵🇹, leggere 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/man1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;man (<i>pron.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*mann"
                      –- "human", "human being", via the Proto-West-Germanic
                      "*mann" –- "human", "human being" and Old High German
                      "man" -- "man".
                      <div></div>
                      <strong>Cognates:</strong> men 🇳🇱
                      <div></div>
                      <strong>Semantic Equivalents:</strong> on 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/man.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Mann"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*mann"
                      –- "human", "human being", via the Proto-West-Germanic
                      "*mann" –- "human", "human being" and Old High German
                      "man" -- "man"
                      <div></div>
                      <strong>Cognates:</strong> man 🇬🇧, man 🇸🇪, mann 🇳🇴, maður
                      🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/matematicas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Mathematik"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μάθημα"
                      /máthēma/ -- "something that is learned", "lesson",
                      "knowledge", whence the phrase "μαθηματικὴ τέχνη"
                      /mathēmatikḗ tékhnē/ -- "mathematical sciences”, "sciences
                      of matters that have been learned" was derived.
                      Originally, “mathematics” referred to the science of
                      learning in general. Only after the term was used by the
                      "mathematikoi" (<i>i.e.,</i> "those who love to learn"), a
                      group of scholars in Ancient Greece who studied the ideas
                      of Pythagoras, especially those pertaining to arithmetic
                      and geometry, did the term "mathematics" become closely
                      associated with its modern meaning.
                      <div></div>
                      <strong>Cognates:</strong> mathématiques 🇫🇷, математика
                      🇰🇿, matematik 🇹🇷, matematica 🇮🇹, matematika 🇸🇰,
                      mathematics 🇬🇧, математика 🇰🇬, matematyka 🇵🇱, matematik
                      🇸🇪, matemáticas 🇪🇸, matematik 🇹🇷, математик 🇲🇳, матема́тика
                      🇷🇺, matematika 🇵🇭, matamaitic 🇮🇪, mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik
                      🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mattress.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Matratze"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Cognates:</strong> mattress 🇬🇧, materasso 🇮🇹,
                      matrac 🇸🇰, matelas 🇫🇷, matras 🇳🇱, матра́с 🇷🇺, матрас 🇰🇬,
                      матрас 🇰🇿, materac 🇵🇱, madrass 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mint.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Minze"
                  hoverText={
                    <span>
                      <strong> Origin:</strong> From Mycenaean Greek "𐀖𐀲"
                      /mi-ta/ -- "mint plant" via the Latin "menta" -- "mint
                      (plant)", and the Proto-West-Germanic "mintā" -- "mint".
                      <div></div>
                      <strong>Not related to:</strong> Münze
                      <div></div>
                      <strong> Cognates:</strong> mint 🇬🇧, menta 🇵🇹, menthe 🇫🇷,
                      menta 🇪🇸, mięta 🇵🇱, мя́та 🇷🇺, menta 🇭🇺, mynte 🇳🇴, minttu
                      🇫🇮, mentă 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;morgen (<i>adv.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From via the Proto-Germanic
                      "*murginaz" -- "morning", via the Proto-West-Germanic
                      "*morgin" -- "morning" and the Old High German "morgane"
                      -- "morning".
                      <div></div>
                      <strong>Related to:</strong> Morgen
                      <div></div>
                      <strong>Cognates:</strong> morgen 🇳🇱, muer 🇱🇺, to
                      <u>morrow </u> 🇬🇧
                      <div></div>
                      <strong>Semantic equivalents:</strong> 明日 🇯🇵, заўтра 🇧🇾,
                      за́втра 🇺🇦, за́втра 🇷🇺, zítra 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/morgen1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Morgen"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*murginaz" – "morning", "tomorrow", via the
                      Proto-West-Germanic "*morgin" -- "morning", "tomorrow",
                      and the Old High German "morgan" -- "morning".
                      <div></div>
                      <strong>Related to:</strong> morgen (<i>adv.</i>),
                      morganatisch (<i>adj.</i>)<div></div>
                      <strong>Cognates:</strong> morning 🇬🇧, morgen 🇳🇱, morgen
                      🇳🇴, morgon 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Muskel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", so
                      called because flexed arm muscles look like little mice.
                      <div></div>
                      <strong>Related to:</strong> Maus, Muschel
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, muscle 🇬🇧, muskel 🇩🇰, muskel
                      🇳🇴, muskel 🇸🇪, мышца 🇷🇺, mišića 🇭🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nehmen.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;nehmen (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*nemaną"
                      -- "to take" via the Old High German "nëman" -- "to take"
                      <div></div>
                      <strong>Related to:</strong> Öko<u>nomie</u>
                      <div></div>
                      <strong>Cognates:</strong> nemen 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tonight.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Nacht"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*nahts"
                      -- "night", via the Old High German "naht" -- "night".
                      <div></div>
                      <strong>Cognates:</strong> nacht 🇳🇱, night 🇬🇧, Nuecht 🇱🇺,
                      natt 🇳🇴, natt 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Nilpferd"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "Nil" -- "Nile (River)" +
                      "Pferd" -- "horse".
                      <div></div>
                      <strong>Cognates:</strong> nijlpaard 🇳🇱, kuda <u>nil</u>{" "}
                      🇮🇩
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, 河马 🇨🇳,
                      فَرَس نَهْر 🇸🇦, दरियाई घोड़ा 🇮🇳, dobhareach 🇮🇪, su aygırı
                      🇹🇷, xипопота́м 🇧🇬, hipopótamo 🇪🇸, hipopótamo 🇵🇹,
                      hippopotamus 🇬🇧, гиппопота́м 🇷🇺, ippopotamo 🇮🇹, ჰიპოპოტამი
                      🇬🇪, virtahepo 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ecology.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Ökologie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1866 by naturalist
                      Ernst Haeckel. From the Ancient Greek "οἶκος" /oîkos/ --
                      "dwelling place", "house" and "-λογία" /-logía/ -- “study
                      of”.
                      <div></div>
                      <strong>Related to:</strong> <u>Öko</u>system
                      <div></div>
                      <strong>Descendants:</strong> écologie 🇫🇷, ecología 🇪🇸,
                      ecologia 🇵🇹, ecologie 🇷🇴, ecologia 🇮🇹, økologi 🇳🇴, økologi
                      🇩🇰, οικολογία 🇬🇷, ეკოლოგია 🇬🇪, эколо́гия 🇷🇺, ekologi 🇮🇩,
                      ekoloģija 🇱🇻, אקולוגיה 🇮🇱, էկոլոգիա 🇦🇲, ökológia 🇭🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/onkel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hW6xrMIwfhI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Onkel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "avus" -- "adult
                      male relative (other than one's father)" and its
                      diminutive form "avunculus", which gradually came to mean
                      "maternal uncle", (<i>lit.</i> “little grandfather"). Over
                      time people realized that you couldn’t use one word to
                      denote two different male relatives, so the diminutive
                      “-unculus” was adopted to differentiate the “avus” (
                      <i>i.e.</i>, "grandfather") from the “avunculus” (
                      <i>i.e.</i>, "little grandfather” or “uncle”).
                      <div></div>
                      <strong>Ancestors:</strong> oncle 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> uncle 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/east.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Osten"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₂ewsér" -- "in the direction of dawn", "east", via the
                      Proto-Germanic "*austrą" -- "east" and the Old High German
                      "ostan" -- "east".
                      <div></div>
                      <strong>Cognates:</strong> east 🇬🇧, oosten 🇳🇱, este 🇪🇸,
                      est 🇫🇷, est 🇮🇹, øst 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paper.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Papier"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πᾰ́πῡρος"
                      /pắpūros/ -- "the papyrus plant", via the Latin "papȳrus"
                      -- "paper made from papyrus". Although related
                      etymologically, "Papier" and "Papyrus" are made from
                      different materials and use different production methods.
                      <div></div>
                      <strong>Related to:</strong> Papyrus
                      <div></div>
                      <strong>Cognates:</strong> papel 🇪🇸, paper 🇬🇧, papel 🇵🇹,
                      papier 🇫🇷, papier 🇳🇱, papper 🇸🇪, papīrs 🇱🇻, paperi 🇫🇮,
                      popierius 🇱🇹, papier 🇵🇱, papur 🏴󠁧󠁢󠁷󠁬󠁳󠁿, папі́р 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradies.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Paradies"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible. From Greek
                      the word evolved into the Latin "paradīsus" -- "park",
                      "orchard", "yard", and eventually the Old German "paradīs"
                      -- "paradise".
                      <div></div>
                      <strong>Cognates:</strong> paradis 🇫🇷, paraíso 🇵🇹, paraiso
                      🇵🇭, paradise 🇬🇧, paradiso 🇹🇿, paradís 🇮🇸, paraíso 🇪🇸,
                      paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/person.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LCiQz7vmiLY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Person"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "persōna" -- "mask
                      used by actor", "role", "part", "character”. In the Roman
                      world, actors would wear “personae” during performances,
                      which would allow them “to portray a role” and “assume a
                      persona”. Gradually the word became associated both with
                      the mask itself and the actors wearing it, and eventually,
                      the mask meaning disappeared, and only the meaning related
                      to actors, and eventually, all human beings, remained.
                      <div></div>
                      <strong>Cognates:</strong> personne 🇫🇷, person 🇬🇧, persoon
                      🇳🇱, persona 🇪🇸, persona 🇮🇹, pessoa 🇵🇹, person 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pfirsich.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Pfirsich"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name. From Latin, the word entered
                      modern German via the Proto-West Germanic "*persik" –
                      “peach”, and Old High German "phërsih" -- "peach".
                      <div></div>
                      <strong>Related to:</strong> Persien
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, peach 🇬🇧, ferskja 🇮🇸,
                      fersken 🇩🇰, fersken 🇳🇴, пе́рсик 🇷🇺, perzik 🇳🇱, persik 🇮🇩,
                      piersică 🇷🇴, pjeshkë 🇦🇱, pichi 🇹🇿, pêssego 🇵🇹, праска 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Pinsel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Later Latin "pēnicillum" --
                      "painter's brush", and the Old French "pincel" --
                      "paintbrush".
                      <div></div>
                      <strong>Related to:</strong> Penis
                      <div></div>
                      <strong>Cognates:</strong> pincel 🇵🇹, penseel 🇳🇱, pensel
                      🇳🇴, pensel 🇩🇰, pędzel 🇵🇱, pincel 🇪🇸, pinzell 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Planet1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Planet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "
                      <u>πλάνητες</u> ἀστέρες" /plánētes astéres/, or "wandering
                      stars", so called because, compared to "απλανείς αστέρες"
                      /aplaneís astéres/, or "fixed stars", the stars that were
                      "πλάνητες" seemed to move around the sky a lot more.
                      <div></div>
                      <strong>Possibly related to:</strong> Plan
                      <div></div>
                      <strong>Cognates:</strong> planète 🇫🇷, pianeta 🇮🇹, planeta
                      🇪🇸, planeta 🇵🇹, planet 🇬🇧, плане́та 🇧🇾, planet 🇦🇱, planet
                      🇸🇮, planēta 🇱🇻, planeta 🇨🇿, planeet 🇪🇪, planeta 🇵🇭,
                      плане́та 🇷🇺, planeetta 🇫🇮, planeet 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Problem"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "Problem"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> Ballett, Ball (as in "Tanz")
                      <div></div>
                      <strong>Cognates:</strong> problem 🇬🇧, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problema 🇪🇸, problema 🇲🇹,
                      problema 🇱🇹, про́блем 🇲🇰, problème 🇫🇷, problēma 🇱🇻,
                      probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭, problem
                      🇵🇱, problem 🇹🇷, problemă 🇷🇴, problem 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                      <strong>Descendants:</strong> Problem 🇱🇺, пробле́м 🇧🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/psychiater.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Psychiater"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ψυχή" /psukhḗ/ -- "soul" and "ἰατρός" /iatrós/ --
                      “doctor”.
                      <div></div>
                      <strong>Cognates:</strong> psychiatrist 🇬🇧, psiquiatra 🇪🇸,
                      psiquiatra 🇵🇹, psikiyatrist 🇹🇷, ფსიქიატრი 🇬🇪, психиа́тр 🇷🇺,
                      psychiatre 🇫🇷, pszichiáter 🇭🇺, ψυχίατρος 🇬🇷, psühhiaater
                      🇪🇪, פסיכיאטר 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pyjamas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Pyjama"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "پایجامه" --
                      "pyjamas", "pants" (which is itself a combination of "پا"
                      /pâ/ -- “leg” and "جامه" /jâme/ -- "garment"), via the
                      Hindi "पैजामा" -- "pyjama" and the English "pyjama" --
                      "pyjama".
                      <div></div>
                      <strong>Ancestors:</strong> पैजामा 🇮🇳, پائِجامَہ 🇵🇰,
                      pyjama(s) 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> pijama 🇪🇸, pijama 🇵🇹,
                      pyjamas 🇫🇷, пижама 🇰🇿, пижама 🇷🇺, пижама 🇰🇬, pijama 🇹🇷,
                      pijama 🇷🇴, πυτζάμα 🇬🇷, піжама 🇺🇦, pyžamo 🇨🇿, pyjama 🇫🇮,
                      поҷома 🇹🇯, پیژامه 🇦🇫, pidžama 🇭🇷, pijama 🇹🇲, פיג׳מה 🇮🇱,
                      pižama 🇱🇹, piama 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Regenschirm"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A compound of "Regen" -- "rain"
                      and "Schirm" -- "screen".
                      <div></div>
                      <strong>Cognates:</strong> <u>regn</u>hlíf 🇮🇸
                      <div></div>
                      <strong>Semantic equivalents:</strong> paraguas 🇪🇸,
                      deštník 🇨🇿, esernyő 🇭🇺, lietussargs 🇱🇻, 雨伞 🇨🇳, parapluie
                      🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rival1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Rivale"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "rīvus" --
                      "brook", "small stream of water", via the adjectival noun
                      "rīvālis" -- "someone who uses the same stream as
                      another". The word originated from the idea of groups of
                      people occupying opposite sides of a river (or any body of
                      water) who were often vying for access to the same
                      resource (<i>e.g.</i>, the Romans and the Carthaginians in
                      the first millennium BC who were both active on opposite
                      sides of the Strait of Messina between Sicily and mainland
                      Italy.)
                      <div></div>
                      <strong>Cognates:</strong> rival 🇬🇧, rival 🇵🇹, rivale 🇮🇹,
                      rywal 🇵🇱, rival 🇷🇴, rival 🇳🇴, rival 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/roboter.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Roboter"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Proto-Slavic "*orbota" -- "work", "labor", and the Old
                      Czech "robota" -- "servitude", "enslavement", "hard
                      labor". The Czech word was coined in 1920 by the science
                      fiction writer Karel Čapek in 1920.
                      <div></div>
                      <strong>Related to:</strong> Arbeit, Erbe
                      <div></div>
                      <strong>Ancestors:</strong> robot 🇨🇿
                      <div></div>
                      <strong>Cognates:</strong> robot 🇫🇷, robot 🇪🇸, robot 🇬🇧,
                      ро́бот 🇷🇸, robot 🇵🇹, robot 🇷🇴, robotas 🇱🇹, ро́бот 🇧🇬, робот
                      🇲🇰, robot 🇩🇰, 🇲🇰, robots 🇱🇻, robots 🇦🇱, robot 🇦🇩 robot 🇪🇪,
                      robot 🇭🇺, ро́бот 🇺🇦, robot 🇹🇲, robot 🇿🇦, ро́бот 🇷🇺, robot
                      🏴󠁧󠁢󠁷󠁬󠁳󠁿, ρομπότ 🇬🇷, ሮቦት 🇪🇷, robot 🇳🇴, روبوٹ 🇵🇰, робот 🇰🇿, rôbô
                      🇲🇬, робот 🇹🇯, رُبات 🇮🇷, робот 🇲🇳, რობოტი 🇬🇪, රොබෝ 🇱🇰, রোবট
                      🇧🇩, ރޮބޮޓް 🇲🇻, ሮቦት 🇪🇹, ռոբոտ 🇦🇲, ро́бат 🇧🇾, robot 🇦🇿,
                      רוֹבּוֹט 🇮🇱, robot 🇸🇳, ロボット 🇯🇵, 로봇 🇰🇷, रोबोट 🇮🇳,
                      رُوبُوت 🇸🇦, roboti 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/red.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;rot (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European
                      "*h₁rewdʰ-" -- "red" via the Proto-Germanic "*raudaz" --
                      "red", and the Old High German "rōt" -- "red", "scarlet",
                      "purple-red".
                      <div></div>
                      <strong>Related to:</strong> Rubrik
                      <div></div>
                      <strong>Cognates:</strong> red 🇬🇧, rosso 🇮🇹, rouge 🇫🇷,
                      rojo 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Salz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Proto-Germanic "*saltą" --
                      "salt", the Proto-West-Germanic "*salt" -- "salt", and the
                      Old High German "salz".
                      <strong>Related to:</strong> sausage, salary, salad, sauce
                      <div></div>
                      <strong>Cognates:</strong> sel 🇫🇷, sal 🇪🇸, sale 🇮🇹, αλάτι
                      🇬🇷, salt 🇩🇰, sól 🇵🇱, salt 🇸🇪, salt 🇬🇧, соль 🇷🇺, sůl 🇨🇿,
                      sāls 🇱🇻, suola 🇫🇮, sool 🇪🇪, sal 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Schmetterling.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UrmfcQSPcqk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Schmetten 🇦🇹"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*sъmetana"
                      -- "whipped cream", via the Old Czech "smetana" --
                      "cream", and the Czech "smetana" -- "cream".
                      <div></div>
                      <strong>Ancestors:</strong> smetana 🇨🇿
                      <div></div>
                      <strong>Descendants:</strong> Schmetterling 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> śmietana 🇵🇱, smotana 🇸🇰,
                      смета́на 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Schmetterling.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UrmfcQSPcqk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Schmetterling"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first element is from the
                      Czech "smetana" -- "(dairy) cream" via the noun
                      "Schmetten" -- "cream". The second element is the suffix
                      "-ling" (a suffix used in forming personal pronouns). The
                      name perhaps derives from the belief in medieval Germanic
                      folklore that butterflies are actually witches in disguise
                      who shape-shift into butterflies and steal uncovered dairy
                      products out of homes.
                      <div></div>
                      <strong>Ancestor:</strong> smetana 🇨🇿
                      <div></div>
                      <strong>Semantic equivalents:</strong> butterfly 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sponge.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Schwamm"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "swombh-" -- "sponge", "tree fungus", "swamp", via the
                      Proto-Germanic "*swammaz" -- "tree fungus", "mushroom",
                      "sponge", and the Old High German "swamp" -- "fungus".
                      <div></div>
                      <strong>Related to:</strong> Sumpf
                      <div></div>
                      <strong>Cognates:</strong> esponja 🇪🇸, esponja 🇵🇹, éponge
                      🇫🇷, spugna 🇮🇹, sponge 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b51FXNHemec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sehr (<i>adv.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*seh₂yro" -- "hard", "rough", "painful" via the Old High
                      German "sēr" -- "sore", "painful", and Middle High German
                      "sēre" -- "painful (to a high degree)"
                      <div></div>
                      <strong>Related to:</strong> ver<u>sehr</u>en (v.)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gossip.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Sippe"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West-Germanic
                      "*sibbju" - "kinship", "relationship", via the Old High
                      German "sibba" -- "kin".
                      <div></div>
                      <strong>Cognates:</strong> sifjar 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldat1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Sold"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army.
                      <div></div>
                      <strong>Descendant:</strong> Söldner 🇩🇪
                      <div></div>
                      <strong>Related to:</strong> Soldat
                      <div></div>
                      <strong>Cognates:</strong> suweldo 🇵🇭, sueldo 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldat1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Soldat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army. From "solidus", the word eventually developed into
                      the Italian "soldo" -- "penny", cent", then "soldato" --
                      "soldier", "one who earns a 'soldo'", and then, finally,
                      the modern German word.
                      <div></div>
                      <strong>Ancestor:</strong> soldo 🇮🇹, soldato 🇮🇹
                      <div></div>
                      <strong>Related to:</strong> Sold, Söldner
                      <div></div>
                      <strong>Cognates:</strong> soldado 🇪🇸, soldier 🇬🇧, soldat
                      🇩🇰, soldado 🇵🇹, cолда́т 🇷🇺, soldat 🇫🇷, soldat 🇸🇪, soldat
                      🇷🇴, soldaat 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldat1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Söldner"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army.
                      <div></div>
                      <strong>Ancestor:</strong> Sold 🇩🇪
                      <div></div>
                      <strong>Related to:</strong> Soldat
                      <div></div>
                      <strong>Cognates:</strong> žoldák 🇨🇿, leje<u>soldat</u>{" "}
                      🇩🇰, zsoldos 🇭🇺, žoldnier 🇸🇰, lego<u>soldat</u> 🇸🇪, leie
                      <u>soldat</u> 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Sonnenschirm"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A compound of "Sonne" -- "sun"
                      and "Schirm" -- "screen".
                      <div></div>
                      <strong>Cognates:</strong> <u>slun</u>ečník 🇨🇿,{" "}
                      <u>Sonne</u>prabbeli 🇱🇺, para<u>sol</u> 🇪🇸, para<u>sol</u>{" "}
                      🇫🇷, <u>saules</u>sargs 🇱🇻
                      <div></div>
                      <strong>Semantic equivalents:</strong>
                      napernyő 🇭🇺, 阳伞 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, sport 🇫🇷, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺,
                      ስፖርት 🇪🇹, šport 🇸🇰, spor 🇹🇷, sport 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tag.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Tag"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*dagaz"
                      -- "day", via the Old High German "tag" -- "day", and the
                      Middle High German "tag" -- "day".
                      <div></div>
                      <strong>Related to:</strong> heu<u>te</u>
                      <div></div>
                      <strong>Cognates:</strong> dag 🇳🇱, day 🇬🇧, Dag 🇱🇺, dag 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tee1.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Tee"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸
                      <div></div>
                      <strong>Descendant:</strong> tee 🇪🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/teller.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Teller"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tālea" -- "a
                      slender stick", "rod", via the Old French "tailloir" --
                      "plate", "board for cutting food".
                      <div></div>
                      <strong>Descendants:</strong> talerz 🇵🇱, tallerken 🇩🇰,
                      tallerken 🇳🇴, таре́лка 🇷🇺, тарілка 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tapestry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Teppich"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Old Persian verb
                      "تَنبَسیدَن" /tanbasidan/ -- "to twist threads" via the
                      Ancient Greek "τάπης" /tápēs/ -- "carpet", "rug", the
                      Latin "tapēs" -- "(hanging) carpet", and the Middle High
                      German "tepich" -- "carpet".
                      <div></div>
                      <strong>Cognates:</strong> tapis 🇫🇷, tæppe 🇩🇰, teppi 🇮🇸,
                      тѐпих 🇷🇸, tapit 🇲🇹, тепих 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b51FXNHemec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;versehren (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*seh₂yro" -- "hard", "rough", "painful" via the Old High
                      German "sēr" -- "sore", "painful", and Middle High German
                      "sēre" -- "painful (to a high degree)"
                      <div></div>
                      <strong>Related to:</strong> sehr (adv.)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/verwirren.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;verwirren (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*werru" –- "confusion", "disorder", via the Old High
                      German "werra" –- "controversy", "complication".
                      <div></div>
                      <strong>Related to:</strong> Gewirr
                      <div></div>
                      <strong>Not related to:</strong> irren (<i>v.</i>)
                      <div></div>
                      <strong>Cognates:</strong> ver<u>warr</u>en 🇳🇱 (<i>v.</i>)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/weib.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Weib"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*wībą"
                      –- "woman", "wife", via the Proto-West-Germanic "*wīb" --
                      "woman", "wife" and the Old High German "wīb" -- "woman",
                      "wife".
                      <div></div>
                      <strong>Cognates:</strong> <u>wo</u>man 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/welt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Welt"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*weraldiz" -- "lifetime", "worldly existence", "mankind",
                      which was a combination of "*weraz" -- "man", "husband"
                      and "*alþi" -- "age", "generation, "lifetime". The "Welt"
                      therefore denotes the entire period of history during
                      which humans have inhabited the domain of mankind.
                      <div></div>
                      <strong>Related to:</strong> <u>Wer</u>wolf
                      <div></div>
                      <strong>Cognates:</strong> world 🇬🇧, wereld 🇳🇱, verden 🇳🇴,
                      verden 🇩🇰, värld 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/weird.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;werden (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wert-" -- "to turn", "to wind", via the Proto-Germanic
                      "*werþaną" -- "to become", "to come into existence", and
                      the Old High German "wërdan" -- "to be", "to become".
                      <div></div>
                      <strong>Related to:</strong> Würde, Wert
                      <div></div>
                      <strong>Cognates:</strong> worden (v.) 🇳🇱, verða (v.) 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/wort.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Wort"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say" via the Proto-Germanic
                      "*wurdą" -- "word", "saying", the Proto-West-Germanic
                      "*word" -- "word", and the Old High German "wort" --
                      "word".
                      <div></div>
                      <strong>Related to:</strong> Verb, Ad<u>verb</u>, Antwort
                      <div></div>
                      <strong>Cognates:</strong> ord 🇸🇪, ord 🇳🇴, ord 🇩🇰, woord
                      🇳🇱, Wuert 🇱🇺, vārds 🇱🇻, word 🇬🇧, woord 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/worm.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Wurm"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wr̥mis" -- "worm" via the Proto-Germanic "*wurmiz", --
                      "worm", and the Old High German "wurm" -- "snake", "worm",
                      "maggot".
                      <div></div>
                      <strong>Cognates:</strong> ver 🇫🇷, worm 🇬🇧, verme 🇵🇹, orm
                      🇩🇰, verme 🇮🇹, vierme 🇷🇴, worm 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/wuste.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;Wüste</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Proto-West-Germanic adjective "wōstī" -- "uninhabited",
                      and the Old High German "wuostī" -- "desert".
                      <div></div>
                      <strong>Related to:</strong> Vakuum
                      <div></div>
                      <strong>Cognates:</strong> woestijn 🇳🇱, woestyn 🇿🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zettel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Zettel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "σχέδη"
                      /skhédē/ -- “papyrus leaf” via the Latin "schedula" --
                      "strip of paper made out of 'skhede', and the Middle High
                      German "zedel" -- "strip of paper".
                      <div></div>
                      <strong>Descendants:</strong> cetli 🇭🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Zucker"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel", via the Middle Persian
                      "𐭱𐭪𐭥" /šakar/ -- "sugar", the Arabic "السُّكَّر"
                      /as-sukkar/ -- "sugar", and the Old Italian "zucchero" --
                      "sugar".
                      <div></div>
                      <strong>Ancestor:</strong> شکر 🇮🇷, سُكَّر 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> zucchero 🇮🇹, ζάχαρη 🇬🇷, са́хар
                      🇷🇺, sucre 🇫🇷, sugar 🇬🇧, sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪,
                      suiker 🇳🇱, cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲,
                      suhkur 🇪🇪, ስኳር 🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/twig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Zweig"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*dwóh₁" -- "two", via the Proto-Germanic "*twīgą" --
                      "forked branch", so called because branches are often two
                      pronged.
                      <div></div>
                      <strong>Related to:</strong> zwei, Zwilling, doppel (adj.)
                      <div></div>
                      <strong>Cognates:</strong> twijg 🇳🇱, twig 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇬🇷 GREEK 🇬🇷
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avaria2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/cI0Fa9UD9S8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;αβαρία"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Arabic verb
                      "عَوِرَ" /ʕawira/ -- “to lose an eye" and the derived
                      "عَوَار" /ʕawār/ -- "blemish", "defect" via "عَوَارِيَّة"
                      /ʕawāriyya/ -- “damaged goods" and, later, the Italian
                      "avaria" -- "damage done to goods (that have been thrown
                      overboard) on a watercraft."
                      <div></div>
                      <strong>Cognates:</strong> avería 🇪🇸, avaria 🇵🇹, avaria 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;αρκούδα"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂ŕ̥tḱos" -- "bear", via the Proto-Hellenic "*árktos" --
                      "bear" and the Byzantine Greek " Byzantine Greek ἀρκούδα
                      /arkoúda/" -- "bear".
                      <div></div>
                      <strong>Cognates:</strong> ours 🇫🇷, urso 🇵🇹, oso 🇪🇸, arth
                      🏴󠁧󠁢󠁷󠁬󠁳󠁿, արջ 🇦🇲, ariu 🇦🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/berikoko.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;βερίκοκο"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", and,
                      eventually, the modern Greek word.
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      apricot 🇬🇧, berquq 🇲🇹, Aprikose 🇩🇪, aibreog 🇮🇪, aprikoti
                      🇹🇿, aprikot 🇮🇩, abricot 🇫🇷, albaricoque 🇪🇸, абрикос 🇷🇺,
                      albercoc 🇦🇩, abrikoos 🇳🇱, абрико́с 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;δύο"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Hellenic "*dúwo" -- "two".
                      <div></div>
                      <strong>Related to:</strong> dubbel, twijg, tweeling
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      two 🇬🇧, to 🇳🇴, dwa 🇵🇱, dó 🇮🇪, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪, два
                      🇧🇬, երկու 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/psychiater.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;γιατρός"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ἰατρός"
                      /iatrós/ -- “doctor”.
                      <div></div>
                      <strong>Cognates:</strong> psych<u>iatrist</u> 🇬🇧, psiqu
                      <u>iatra</u> 🇪🇸, psiqu<u>iatra</u> 🇵🇹, psiki<u>yatrist</u>{" "}
                      🇹🇷, ფსიქ<u>იატრი</u>
                      🇬🇪, псих<u>иа́тр</u> 🇷🇺, psych<u>iatre</u> 🇫🇷, pszich
                      <u>iáter</u> 🇭🇺, ψυχ<u>ίατρος</u>
                      🇬🇷, psühh<u>iaater</u> 🇪🇪, פסיכ<u>יאטר</u> 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ekato.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;εκατό"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Italic "*kentom" -- "100"
                      and the Latin "centum" -- "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, сто 🇷🇺, सौ 🇮🇳, cад
                      🇹🇯, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto 🇵🇱, сто 🇧🇬,
                      сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ζάχαρη"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel".
                      <div></div>
                      <strong>Cognates:</strong> са́хар 🇷🇺, sucre 🇫🇷, azúcar 🇪🇸,
                      sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪, suiker 🇳🇱, cukrus 🇱🇹,
                      Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲, suhkur 🇪🇪, ስኳር 🇪🇹, zucchero
                      🇮🇹, شکر 🇮🇷, سُكَّر 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ιδιώτης"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”.
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canibal_gr.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;κανίβαλος"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Καραϊβική (<i>adj.</i>)
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/iklim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;κλίμα"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west.
                      <div></div>
                      <strong>Cognates:</strong> climate 🇺🇸, climat 🇫🇷, klimaat
                      🇳🇱, кли́мат 🇷🇺, iklim 🇮🇩, iqlim 🇺🇿, ַַאַקְלִים 🇮🇱, اِقْلِیم
                      🇮🇷, clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cementerio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;κοιμητήριο"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "κοιμητήριον" /koimētḗrĭon/ -- "place to sleep",
                      "dormitory".
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cemitério 🇵🇹, cmentarz 🇵🇱, sementeryo 🇵🇭, cimetière 🇫🇷,
                      cemetery 🇬🇧, cimitero 🇮🇹, cimitir 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/major.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ga15HCmlzig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;μεγάλος (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*méǵh₂-" -- "big", "great", via the Ancient Greek "μέγᾰς
                      /mégăs/ -- "big", "large", and the Byzantine Greek
                      "μεγάλος" /megálos/ -- "big".
                      <div></div>
                      <strong>Cognates:</strong> mayor 🇪🇸, maior 🇵🇹, major 🇬🇧,
                      մեծ 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mint.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;μέντα"
                  hoverText={
                    <span>
                      <strong> Origin:</strong> From Mycenaean Greek "𐀖𐀲"
                      /mi-ta/ -- "mint plant" via the Classical Greek "μίνθη"
                      /mínthē/ -- "mint (plant)"
                      <div></div>
                      <strong> Cognates:</strong> mint 🇬🇧, Minze 🇩🇪, menta 🇵🇹,
                      menta 🇪🇸, mięta 🇵🇱, мя́та 🇷🇺, menta 🇭🇺, mynte 🇳🇴, minttu
                      🇫🇮, mentă 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/monopoly.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;μονάδα"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the feminine form of the
                      Ancient Greek adjective "μονᾰ́ς" /mónos/ -- "alone",
                      "solitary", "isolated".
                      <div></div>
                      <strong>Related to:</strong> <u>μονο</u>πώλιο<div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;μπανάνα"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳, banana 🇵🇹
                      <div></div>
                      <strong>Cognates:</strong> banane 🇫🇷, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana
                      🇪🇸, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪, banaan 🇳🇱,
                      banan 🇸🇪, 바나나 🇰🇷, бана́н 🇷🇺, バナナ 🇯🇵, banana 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/necros.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;νεκρός (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the
                      Proto-Indo-European root "neḱ-" -- "to perish", "to
                      disappear".
                      <div></div>
                      <strong>Possibly Related to:</strong> νέκταρ
                      <div></div>
                      <strong>Cognates:</strong>
                      innocent 🇫🇷, inocente 🇵🇹, inocente 🇪🇸
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tomate.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ντομάτα"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl (Aztec) "tomatl"
                      -- "tomatillo", "tomato". The word was brought to Spain
                      from the New World and from there spread all over Europe
                      and the rest of the world.
                      <div></div>
                      <strong>Ancestor:</strong> tomate 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> tomate 🇫🇷, Tomate 🇩🇪, tomate
                      🇵🇹, дома́т 🇧🇬, домат 🇲🇰, tomāts 🇱🇻, トマト 🇯🇵, 토마토 🇰🇷,
                      ቲማቲም 🇪🇹, टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat 🇲🇾, tomat
                      🇸🇪, domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿, tomato 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/onoma.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;όνομα"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₁nómn̥" -- "name", via the Proto-Italic "*nōmn̥" --
                      "name" and the Latin "nōmen" -- "name", "noun".
                      <div></div>
                      <strong>Cognates:</strong> name 🇬🇧, naam 🇳🇱, nome 🇵🇹, navn
                      🇩🇰, نَام 🇮🇷, نوم 🇦🇫, Name 🇩🇪, nombre 🇪🇸, nom 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pants.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;παντελόνι"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A word derived from the
                      funny-looking character in the Italian{" "}
                      <i>Commedia del Arte</i> named "Pantalone" who had skinny
                      legs and wore tight pants.
                      <div></div>
                      <strong>Ancestor:</strong> pantaloni 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> pants 🇬🇧, pantolon 🇹🇷,
                      παντελόνι 🇬🇷, pantalon 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/portocali.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;πορτοκάλι"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Italian "portogallo" –
                      “orange (from Portugal)”. Portuguese traders brought the
                      fruit from East Asia to Europe, whence the name.
                      <div></div>
                      <strong>Descendant:</strong> portocală 🇷🇴
                      <div></div>
                      <strong>Cognates:</strong> ُرْتُقَال 🇸🇦, portakal 🇹🇷,
                      portağal 🇦🇿, портокал 🇲🇰, portokall
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;πρόβλημα"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "πρόβλημα"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problēma 🇱🇻, probleemi 🇪🇪, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, problem 🇳🇴, problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/attic.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/BBMUYDMWK_w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;σοφίτα"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      adverb "upó" -- "under" and verb "*dʰeygʷ-" -- "to stick",
                      "to set up", which together gradually evolved into the
                      Latin verb "suffīgō" -- "to fasten", "to fix onto" and its
                      past participle "*suffīctus", and, thence, eventually, the
                      Modern Italian word.
                      <div></div>
                      <strong> Ancestors:</strong> soffite 🇫🇷, soffitto 🇮🇹
                      <div></div>
                      <strong> Cognates:</strong> soffitta 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tsai.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;τσάι"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, tè 🇮🇹, tee 🇫🇮,
                      te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶
                      🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩,
                      té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, çay 🇹🇷, شَاي 🇸🇦, çaý 🇹🇲,
                      čaj 🇨🇿, çaj 🇦🇱, chá 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chaos.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;χάος"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> from the Ancient Greek "χάος"
                      /kháos/ -- “chasm", "void", "empty space”.
                      <div></div>
                      <strong>Related to:</strong> γκάζι
                      <div></div>
                      <strong>Cognates:</strong> chaos 🇨🇿, kaos 🇩🇰, ქაოსი 🇬🇪,
                      kaaos 🇫🇮, haos 🇷🇴, ха́ос 🇷🇺, caos 🇪🇸, chaos 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇭🇹 HAITIAN (CREOLE) 🇭🇹
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chokola.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chokola"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolat 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾, شکلات 🇮🇷,
                      チョコレート 🇯🇵, chocolate 🇬🇧, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇳🇬 HAUSA 🇳🇬
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, auto
                      <u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u> 🇪🇸,
                      auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u> 🇵🇱,
                      auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u> 🇦🇱,
                      auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u> 🇺🇦,
                      авто́
                      <u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>, 巴士 🇨🇳,
                      बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇲🇼, bhazi 🇿🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shayi.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;shayi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many Asian and
                      African languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, شَاي 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇮🇱 HEBREW 🇮🇱
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/iklim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;אקלים"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west. From Greek, the word developed into the Arabic
                      "إِقْلِيم" /ʔiqlīm/ -- "territory", before evolving into
                      the Modern Persian word.
                      <div></div>
                      <strong>Cognates:</strong> climate 🇺🇸, climat 🇫🇷, klimaat
                      🇳🇱, кли́мат 🇷🇺, κλίμα 🇬🇷, iklim 🇮🇩, iqlim 🇺🇿, اِقلیم 🇮🇷,
                      clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                      <strong>Descendants:</strong> اِقْلِیم 🇵🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/awtobus_he.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;אוֹטוֹבּוּס"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, awtobus 🇹🇲, ավտոբուս 🇦🇲, avtobus 🇺🇿, ավտոբուս 🇦🇲, buss
                      🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸,
                      bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿,
                      basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス
                      🇯🇵, ኣውቶቡስ 🇪🇷, авто́бус 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;גז"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gaz 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ
                      🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass
                      🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷,
                      ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jamal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;גמל"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel".
                      <div></div>
                      <strong>Cognates:</strong> ޖަމަލު 🇲🇻, Kamel 🇩🇪, ግመል 🇪🇹,
                      ngamia 🇹🇿, camello , camel 🇬🇧, cammello 🇮🇹, camelo 🇵🇹,
                      chameau 🇫🇷, kamel 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cennet.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;גן"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Classical Syriac "ܓܰܢܬܳܐ"
                      /gannəṯā/ -- "garden", "park".
                      <div></div>
                      <strong>Cognates:</strong> jennet 🇹🇲, جَنَّة 🇸🇦, cənnət 🇦🇿
                      <div></div>
                      <strong>Semantic Equivalents:</strong> paradis 🇫🇷, paraíso
                      🇵🇹, paraiso 🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸,
                      paraíso 🇪🇸, paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷,
                      فِرْدَوْس 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;הדיוט"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”.
                      <div></div>
                      <strong>Related to:</strong> אִידִיוֹט
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kherev.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;חֶרֶב"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*ḥarb-"
                      –- "blade", "knife", "sharp instrument".
                      <div></div>
                      <strong>Cognates:</strong> حربة 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kanibal_he.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;קָנִיבָּל"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> קריבי (<i>adj.</i>)
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, cannibale 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;מוּזֵיאוֹן"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)", via the Latin "mūsēum" -- "library", "study".{" "}
                      <div></div>
                      <strong>Related to:</strong> מוּסִיקָה
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      Museum 🇩🇪, музе́й 🇧🇾, muzeum 🇦🇱, موزه 🇮🇷, müze 🇹🇷, muzejs
                      🇱🇻, muzeum 🇨🇿, muuseum 🇪🇪, múzeum 🇭🇺, muzeý 🇹🇲, музе́й 🇷🇺,
                      muzium 🇲🇾, muzȇj 🇸🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manpah.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;מַפָּה"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*manpiy-"
                      - "fine cloth", "sieve", via the Mishnaic Hebrew מנָפָה
                      /manpah/ -- "streaming cloth", "banner".
                      <div></div>
                      <strong>Related to:</strong> מַפִּית
                      <div></div>
                      <strong>Likely cognates:</strong> map 🇬🇧, mapa 🇵🇱, mapa
                      🇨🇿, מַפָּה 🇮🇱, mapa 🇪🇸, mapa 🇵🇹, map 🇬🇧, mappa 🇲🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paridayjah.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;פרדס"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the
                      Proto-Indo-European "*per-" -- "before", "in front" and
                      "*dáyjah" -- "wall" via the Proto-Iranian "*paridayjah" --
                      "walled garden", and the Aramaic "פַּרְדַּיְסָא"
                      /pardaysā/ -- "park", "garden", "orchard".
                      <div></div>
                      <strong>Cognates:</strong> پالیز 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;קָנֶה"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/ --
                      "reed", via the Akkadian 𒂵𒉡𒌑𒌝 /qanûm/, “reed”, and the
                      Ancient Greek "κάννα" /kánna/ -- “reed”.
                      <div></div>
                      <strong>Cognates:</strong> cane 🇬🇧, canne 🇫🇷, caña 🇪🇸,
                      cana 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kehe.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;כהה (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull".
                      <div></div>
                      <strong>Possibly related to:</strong> קפה
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shokolad2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;שׁוֹקוֹלָד"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, cioccolato 🇮🇹,
                      шоколад 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, seacláid 🇮🇪, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      шакалод 🇹🇯, Schokolade 🇩🇪, czekolada 🇵🇱, chocolate 🇵🇹,
                      chocolate 🇬🇧, siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, shokolad 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;תַפּוחַ אדמה"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i>, a calque) of the French "pomme
                      de terre" -- "apple of the earth".
                      <div></div>
                      <strong>Semantic equivalents:</strong>aardappel 🇳🇱,
                      aartappel 🇿🇦, pomme de terre 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/teah.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;תה"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, tea 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇮🇳 HINDI 🇮🇳
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/qahva.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;क़हवा"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then eventually spread to the
                      Anatolian Peninsula via the Ottoman Turkish "قهوه" /kahve/
                      -- "coffee".
                      <div></div>
                      <strong>Ancestors:</strong> قَهْوَة 🇸🇦, قهوه 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> café 🇫🇷, café 🇪🇸, Kaffee 🇩🇪,
                      ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰,
                      kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦,
                      ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴, کافی 🇵🇰, кофе 🇰🇿,
                      kafe 🇲🇬, 咖啡 🇹🇼, コーヒー 🇯🇵, 咖啡 🇨🇳, 커피 🇰🇷, ກາເຟ 🇱🇦,
                      កាហ្វេ 🇰🇭, кофе 🇲🇳, cà phê 🇻🇳, ကော်ဖီ 🇲🇲, ყავა 🇬🇪, กาแฟ
                      🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, kahawa 🇹🇿, কফি 🇧🇩, ކޮފީ 🇲🇻, қаҳва
                      🇹🇯, قَهْوَه 🇦🇫
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/crimson.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;क़िरमिज़ी"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-Iranian noun
                      "*kŕ̥miš" -- "worm", via the Persian "کِرمِست" /kêrmêst/ --
                      "worm". The word comes from the crimson dye produced by a
                      worm-like insect called "kermes".
                      <div></div>
                      <strong>Ancestors:</strong> قِرْمِزِيّ 🇸🇦 (adj.), قرمزی 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> cramoisi 🇫🇷, cremisi 🇮🇹,
                      carmesim 🇵🇹, carmesim 🇵🇹, karmosin 🇸🇪, kırmızı 🇹🇷,
                      червоний 🇺🇦, czerwony 🇵🇱, червен 🇧🇬, црвен 🇲🇰, červený 🇸🇰,
                      чырво́ны 🇧🇾, crimson 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;गैस"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gas 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, گاز 🇮🇷, গ্যাস 🇧🇩, gas
                      🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ
                      🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass
                      🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gás 🇮🇪,
                      gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵, გაზი
                      🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, Gas 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kalam_in.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;क़लम"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, possibly
                      via the Ge'ez "ቀለም" /ḳäläm/ -- "reed".
                      <div></div>
                      <strong>Ancestor:</strong> قلم 🇸🇦
                      <div></div>
                      <strong>Descendant:</strong> कलम 🇳🇵
                      <div></div>
                      <strong>Cognates:</strong> калем 🇰🇬, कलम 🇳🇵, kalamu 🇹🇿,
                      қалам 🇹🇯, қалам 🇰🇿, কলম 🇧🇩, kalem 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Dschungel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;जंगल"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert".
                      <div></div>
                      <strong>Cognates:</strong> جَنْگَل 🇵🇰, জঙ্গল 🇧🇩, जङ्गल 🇳🇵,
                      ځنګل 🇦🇫, جَن٘گَل 🇮🇷
                      <div></div>
                      <strong>Descendants:</strong> cəngəllik 🇦🇿, ҷангал 🇹🇯,
                      джу́нгли 🇷🇺, jungle 🇫🇷, jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪,
                      dżungla 🇵🇱, ջունգլի 🇦🇲, ჯუნგლი 🇬🇪, ジャングル 🇯🇵, džungla
                      🇸🇮, džùngla 🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿, jungle 🇬🇧, Dschungel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/turkey.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;टर्की"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Most theories link the origin of
                      the word to commerce by Ottoman merchants in the port of
                      Constantinople in the 15th-16th centuries. These merchants
                      imported birds, called the Guinea fowl, which is endemic
                      to sub-Saharan Africa, and then sold them in European
                      markets, where they were known as "turkey cocks" (because
                      they were believed to come from "Turkey"). When British
                      settlers arrived in North America (where "turkeys" are
                      actually from), they saw these new birds but weren’t sure
                      what to call them, therefore giving them the same name as
                      the similar-looking bird they had known back in Europe.
                      <div></div>
                      <strong>Ancestor:</strong> turkey 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;दरियाई घोड़ा"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i> a "calque") of the Ancient Greek
                      "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Semantic equivalents:</strong> Nilpferd 🇩🇪,
                      nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, dobhareach 🇮🇪, 河马 🇨🇳, su
                      aygırı 🇹🇷, xипопота́м 🇧🇬, hipopótamo 🇪🇸, hipopótamo 🇵🇹,
                      hippopotamus 🇬🇧, hippopotame 🇫🇷, ippopotamo 🇮🇹, ჰიპოპოტამი
                      🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rang2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;रंग"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*reng-" – "to dye", via the Sanskrit "रङ्ग" /raṅga/ --
                      "color", "paint", "dye".
                      <div></div>
                      <strong>Not related to:</strong> नारंगी
                      <div></div>
                      <strong>Cognates:</strong> renk 🇹🇷, rəng 🇦🇿, رنگ 🇮🇷, رنګ
                      🇦🇫
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;दो"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Germanic "*twai" -- "two" and the
                      Old Norse "tvá" -- "two".
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, два 🇷🇺, two 🇬🇧,
                      dwa 🇵🇱, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪, два 🇧🇬, երկու 🇦🇲, to 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cayh.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;चाय"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many Central and
                      South Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, 茶 🇯🇵, 차
                      🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸,
                      thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý 🇹🇲, tea 🇬🇧, attaya
                      🇸🇳, اتاي 🇲🇷, شَاي 🇸🇦, шай 🇰🇿, çay 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pyjamas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;पैजामा"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "پایجامه" --
                      "pyjamas", "pants" (which is itself a combination of "پا"
                      /pâ/ -- “leg” and "جامه" /jâme/ -- "garment").
                      <div></div>
                      <strong>Ancestors:</strong> پائِجامَہ 🇵🇰
                      <div></div>
                      <strong>Cognates:</strong> pijama 🇪🇸, Pyjama 🇩🇪, пижама
                      🇰🇿, пижама 🇷🇺, пижама 🇰🇬, pijama 🇹🇷, pijama 🇷🇴, πυτζάμα
                      🇬🇷, піжама 🇺🇦, pyžamo 🇨🇿, pyjama 🇫🇮, поҷома 🇹🇯, پیژامه 🇦🇫,
                      pidžama 🇭🇷, pijama 🇹🇲, פיג׳מה 🇮🇱, pižama 🇱🇹, piama 🇮🇩,
                      pyjama(s) 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bas2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;बस"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, بس 🇦🇫, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;सौ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Indo-Iranian "*catám" -
                      "100", and the Middle Persian "𐭰𐭲" /čat/ -- "100".
                      <div></div>
                      <strong>Related to:</strong> सद
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, сто 🇷🇺, cад 🇹🇯,
                      εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto 🇵🇱,
                      сто 🇧🇬, сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹, صد
                      🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/narangi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;नारंगी"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", and the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange".
                      <div></div>
                      <strong>Not related to:</strong> रंग
                      <div></div>
                      <strong>Cognates:</strong> orange 🇬🇧, arancia 🇮🇹, orange
                      🇬🇧, naranja 🇪🇸, naranča 🇭🇷, laranja 🇵🇹, наранча 🇷🇸, نارنج
                      🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇺🇸 HOPI 🇺🇸
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paahu.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paahu"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Uto-Aztecan "*pa"
                      -- "water".
                      <div></div>
                      <strong>Cognates:</strong> atl 🇲🇽
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
            </Grid>

            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇭🇺 HUNGARIAN 🇭🇺
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autóbusz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autóbusz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus 🇹🇲,
                      אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪,
                      buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴,
                      bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi
                      🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Dschungel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dzsungel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert". The word
                      was adopted by British colonists in the Indian
                      subcontinent to refer to any territory that was
                      inhospitable, and then gradually it evolved to denote a
                      place with “tangled thickets”, and then, from there, "any
                      area with lots of vegetation".
                      <div></div>
                      <strong>Ancestors:</strong> جَنْگَل 🇵🇰, जंगल 🇮🇳, jungle
                      🇬🇧, Dschungel 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> جَن٘گَل 🇮🇷, জঙ্গল 🇧🇩, जङ्गल 🇳🇵,
                      cəngəllik 🇦🇿, ځنګل 🇦🇫, ҷангал 🇹🇯, джу́нгли 🇷🇺, jungle 🇫🇷,
                      jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪, dżungla 🇵🇱, ջունգլի 🇦🇲,
                      ჯუნგლი 🇬🇪, ジャングル 🇯🇵, džungla 🇸🇮, džùngla 🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;esernyő"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the verb
                      "esik" -- "to rain", and the noun "ernyő" -- "protective
                      device".
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Regenschirm 🇩🇪,
                      deštník 🇨🇿, lietussargs 🇱🇻, paraguas 🇪🇸, 雨伞 🇨🇳,
                      parachuva 🇵🇹, parapluie 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gáz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, Gas 🇩🇪
                      <div></div>
                      <strong>Related to:</strong> káosz
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵,
                      გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ham2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hám"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*hamô"
                      -- "shape", "physical form" via the Proto-West-Germanic
                      "*hamō" -- "casing", "wrapping", binding", the Old High
                      German "*hamo" –- "article of clothing", "garment", and
                      the Middle High German -- "hame" -- "harness".
                      <div></div>
                      <strong>Cognates</strong>: haam 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobbi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hobbi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Ancestor:</strong> hobby 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> hobi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, xоби 🇲🇰, hobi 🇹🇷,
                      hobby 🇸🇪, хо́бби 🇷🇺, Hobby 🇩🇪, hobis 🇱🇹, hobbi 🇦🇿, hobijs
                      🇱🇻, хоби 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;múzeum"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)", via the Latin "mūsēum" -- "library", "study".{" "}
                      <div></div>
                      <strong>Related to:</strong> múzsa
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      музе́й 🇧🇾, muzeum 🇦🇱, موزه 🇮🇷, müze 🇹🇷, muzȇj 🇸🇮, muzeum
                      🇨🇿, muuseum 🇪🇪, muzejs 🇱🇻, מוּזֵיאוֹן 🇮🇱, muzeý 🇹🇲, muzium
                      🇲🇾, musée 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;napernyő"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the noun
                      "nap" -- "sun", and the noun "ernyő" -- "protective
                      device".
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      slunečník 🇨🇿, saulessargs 🇱🇻, parasolka 🇵🇱, 阳伞 🇨🇳,
                      parasol 🇫🇷, parasole 🇮🇹, парасо́лька 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;probléma"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "probléma"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problēma 🇱🇻, probleemi 🇪🇪, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rovar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rovar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "rovátkolt" (a
                      derivative of the verb "rovátkol" -- "to striate", "put
                      notches into") and the noun "barom" -- "beast",
                      "creature". The word was borrowed as a word-for-word
                      translation of the Latin "īnsectus" (<i>i.e.</i>, īn +
                      sectus) -- "cut into sections", which itself was borrowed
                      as a word-for-word translation from the Ancient Greek
                      "ἔντομον" /éntomon/ -- "cut into sections" (from the
                      observation (first made by Aristotle) that insects are
                      physically separated (or "cut") into three separate
                      sections - head, thorax, abdomen).
                      <div></div>
                      <strong>Semantic equivalents:</strong> έντομο 🇬🇷, insecto
                      🇪🇸, trychfil 🏴󠁧󠁢󠁷󠁬󠁳󠁿, на<u>сек</u>о́мое 🇷🇺, insectă 🇷🇴, insect
                      🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tea1.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tea"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, tea 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tolmacs.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/j2E_-Jyl6AM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tolmács"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*tilmač"
                      -- "an intermediary in communication between two parties
                      using different languages", via the Proto-Slavic
                      "*tъlmáčь" -- "interpreter", "translator".
                      <div></div>
                      <strong>Cognates:</strong> тілмаш 🇰🇿, tolmač 🇸🇮, tłumacz
                      🇵🇱, dilmaç 🇹🇷, tlmočník 🇸🇰, Dolmetscher 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇮🇸 ICELANDIC 🇮🇸
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ferskja.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ferskja"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name.
                      <div></div>
                      <strong>Related to:</strong> Persía
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, peach 🇬🇧, fersken 🇳🇴,
                      perzik 🇳🇱, persik 🇮🇩, piersică 🇷🇴, pjeshkë 🇦🇱, pichi 🇹🇿,
                      pêssego 🇵🇹, праска 🇲🇰, Pfirsich 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hundrad.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hundrað"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*hundaradą" -- "a large number (usually equal to either
                      100 or 120)", via the Old Norse "hundrað" -- "120". The
                      amount associated with "hundre" was gradually reduced to
                      "100" due to the influence of Christianity, which had
                      introduced the "short hundred" (<i>i.e.</i> "100") during
                      the Middle Ages.
                      <div></div>
                      <strong>Distantly related to:</strong> pró<u>sent</u>
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundra 🇸🇪, hundert
                      🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад 🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿,
                      šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto 🇵🇱, сто 🇧🇬, сто 🇷🇺, cent
                      🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jafn.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;jafn (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*ebnaz"
                      -- "even", "level", via the Old Norse "jafn" -- "even",
                      "equal".
                      <div></div>
                      <strong>Cognates:</strong> even 🇬🇧, even 🇳🇱, eben 🇩🇪, jämn
                      🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/like.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;líka (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*galīkōną" -- "to be like", "to resemble", via the Old
                      Norse "líka" -- "to please".
                      <div></div>
                      <strong>Cognates:</strong> like (<i>v.</i>) 🇳🇴, lika (
                      <i>v.</i>) 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/morgunn.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;morgunn"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*murginaz" – "morning", "tomorrow", via the Old Norse
                      "morginn" -– “morning”.
                      <div></div>
                      <strong>Cognates:</strong> morning 🇬🇧, morgen 🇳🇱, morgen
                      🇳🇴, morgon 🇸🇪, Morgen 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/old.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;öld"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*alþi"
                      -- "age", "generation, "lifetime" via the Old Norse "ǫld"
                      -- "time", "age", "period".
                      <div></div>
                      <strong>Related to:</strong> ver<u>öld</u>
                      <div></div>
                      <strong>Cognates:</strong> øld 🇫🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/orlog.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Jl-keLpJSIA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;örlög"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*uzlagą"
                      -- "fate", "destiny” via the Old Norse "ørlǫg" -- "fate",
                      "doom".
                      <div></div>
                      <strong>Related to:</strong> <u>ör</u>vænting, <u>ör</u>
                      uggur (<i>adj.</i>), lög
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paradís"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible. The word
                      made its way into Icelandic via the Old Norse "paradís" --
                      "paradise".
                      <div></div>
                      <strong>Cognates:</strong> paradis 🇫🇷, paraíso 🇵🇹, paraiso
                      🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paraíso 🇪🇸, paradijs 🇳🇱,
                      پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦, paradise 🇬🇧
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tei.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;te"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, Tee 🇩🇪, tee 🇫🇮
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇫🇮, te 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇮🇩 INDONESIAN 🇮🇩
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/iklim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;iklim"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west. From Greek, the word developed into the Arabic
                      "إِقْلِيم" /ʔiqlīm/ -- "territory", before evolving into
                      the Modern Indonesian word.
                      <div></div>
                      <strong>Related to:</strong> klima
                      <div></div>
                      <strong>Cognates:</strong> climate 🇺🇸, climat 🇫🇷, klimaat
                      🇳🇱, кли́мат 🇷🇺, κλίμα 🇬🇷, iklim 🇮🇩, iqlim 🇺🇿, ַַאַקְלִים
                      🇮🇱, اِقْلِیم 🇮🇷, clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kanibal_in.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kanibal"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Karibia
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸, kannibaal 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, קָנִיבָּל 🇮🇱, kanibal 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;keju"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product", via the Old-Galician Portuguese "quiejo" --
                      "cheese".
                      <div></div>
                      <strong>Ancestor:</strong> queijo 🇵🇹,
                      <div></div>
                      <strong>Cognates:</strong> cheese 🇬🇧, queso 🇪🇸, Käse 🇩🇪,
                      kaas 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/coffee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kopi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then eventually made its way
                      into Malay (and then Indonesian) via Italian and then
                      Dutch.
                      <div></div>
                      <strong>Related to:</strong> kafe
                      <div></div>
                      <strong>Ancestors:</strong> قَهْوَة 🇸🇦, caffè 🇮🇹, koffie
                      🇳🇱, kopi 🇲🇾
                      <div></div>
                      <strong>Cognates:</strong> café 🇫🇷, café 🇪🇸, Kaffee 🇩🇪,
                      ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰,
                      kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦,
                      ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴, کافی 🇵🇰, кофе 🇰🇿,
                      kafe 🇲🇬, 咖啡 🇹🇼, қаҳва 🇹🇯, قهوه 🇮🇷, 咖啡 🇨🇳, ກາເຟ 🇱🇦,
                      កាហ្វេ 🇰🇭, кофе 🇲🇳, cà phê 🇻🇳, ကော်ဖီ 🇲🇲, ყავა 🇬🇪, กาแฟ
                      🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, কফি 🇧🇩, ކޮފީ 🇲🇻, kahve 🇹🇷, coffee
                      🇬🇧, コーヒー 🇯🇵, 커피 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/persik_in.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;persik"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name.
                      <div></div>
                      <strong>Related to:</strong> Persia
                      <div></div>
                      <strong>Ancestor:</strong> perzik 🇮🇩
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, peach 🇬🇧, ferskja 🇮🇸,
                      fersken 🇩🇰, fersken 🇳🇴, пе́рсик 🇷🇺, piersică 🇷🇴, pjeshkë
                      🇦🇱, pichi 🇹🇿, pêssego 🇵🇹, праска 🇲🇰, Pfirsich 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/teh.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;teh"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea".
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, teh 🇲🇾
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, té 🇪🇸, tee 🇫🇮, te 🇸🇪, tee 🇫🇮, Tee
                      🇩🇪, tea 🇬🇧, thee 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇮🇪 IRISH 🇮🇪
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/aibreog.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aibreog"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and eventually, the modern Irish word.
                      <div></div>
                      <strong>Ancestor:</strong> a(l)bercoc 🇦🇩, apricot 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      abrikoos 🇳🇱, berquq 🇲🇹, albaricoque 🇪🇸, абрико́с 🇷🇺,
                      абрико́с 🇺🇦, abricot 🇫🇷, apricot 🇬🇧, Aprikose 🇩🇪, aprikoti
                      🇹🇿, aprikot 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canablach.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;canablach"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Cairibeach (<i>adj.</i>)
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dó"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Germanic "*twai" -- "two" and the
                      Old Norse "tvá" -- "two".
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      two 🇬🇧, dwa 🇵🇱, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪, два 🇧🇬, երկու 🇦🇲,
                      to 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dobhareach"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i> a "calque") of the Ancient Greek
                      "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Semantic equivalents:</strong> Nilpferd 🇩🇪,
                      nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा 🇮🇳, 河马 🇨🇳 🇮🇪,
                      su aygırı 🇹🇷, xипопота́м 🇧🇬, hipopótamo 🇪🇸, hipopótamo 🇵🇹,
                      hippopotamus 🇬🇧, hippopotame 🇫🇷, ippopotamo 🇮🇹, ჰიპოპოტამი
                      🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fadhb"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Celtic "*odbos" --
                      "knot", "bulge", via the Old Irish "odb" -- "knot in a
                      tree", and the Middle Irish "fodb" -- "knot".
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gás"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇦🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ 🇹🇯, газ
                      🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass 🇳🇴, gaas 🇪🇪,
                      kaasu 🇫🇮, gas 🇬🇧, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz 🇭🇺, gás
                      🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, გაზი 🇬🇪, գազ 🇦🇲,
                      গ্যাস 🇧🇩, ගෑස් 🇱🇰, ガス 🇯🇵, , gaz 🇫🇷, газ 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/seacláid.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;seacláid"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tae.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tae"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, tea 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇫🇮, te 🇸🇪, tee
                      🇫🇮, Tee 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇮🇹 ITALIAN 🇮🇹
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/essig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aceto"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ak-" -- "sharp", via the Latin "acētum" -- "vinegar".
                      <div></div>
                      <strong>Related to:</strong> acre (adj.)
                      <div></div>
                      <strong>Cognates:</strong> vin<u>agre</u> 🇪🇸, vin
                      <u>aigre</u> 🇫🇷, vin<u>agre</u> 🇵🇹, aceto 🇮🇹, oțet 🇷🇴,
                      azijn 🇳🇱, Essig 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/eau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ztj_kCMZFS8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;acqua"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*akwa" -- "(flowing) water" via the Latin "aqua" --
                      "water".
                      <div></div>
                      <strong>Cognates:</strong> eau 🇫🇷, agua 🇵🇹, agua 🇪🇸, apă
                      🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/albicocca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;albicocca"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and finally, the modern Italian word.
                      <div></div>
                      <strong>Related to:</strong> precoce (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albaricoque 🇪🇸,
                      abrikoos 🇳🇱, apricot 🇬🇧, абрико́с 🇷🇺, абрико́с 🇺🇦, berquq
                      🇲🇹, Aprikose 🇩🇪, aibreog 🇮🇪, aprikoti 🇹🇿, aprikot 🇮🇩,
                      abricot 🇫🇷, albercoc 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ami.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;amico"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "amō" -- "I
                      love" via the adjective "amīcus" -- "friendly," "pleasant
                      to be around".
                      <div></div>
                      <strong>Related to:</strong> n<u>emico</u>
                      <div></div>
                      <strong>Cognates:</strong> amigo 🇪🇸, amigo 🇵🇹, amic 🇷🇴,
                      ami 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/animal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;animale"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "anima" -- "soul",
                      "spirit", "life", "air" , "breath" via the adjective
                      "animālis" -- "animate", "living."
                      <div></div>
                      <strong>Related to:</strong> animare (<i>v.</i>), anima
                      <div></div>
                      <strong>Cognates:</strong> animal 🇬🇧, animal 🇫🇷, annimal
                      🇲🇹, animal 🇪🇸, animal 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arancia.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;arancia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", via the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange", the Arabic "نارنج"
                      /nāranj/ –- “bitter orange”, and the Italian "narancia".
                      The initial "n" was eventually dropped due to
                      rebracketing.
                      <div></div>
                      <strong>Cognates:</strong> orange 🇬🇧, naranja 🇪🇸, orange
                      🇬🇧, laranja 🇵🇹, на̀ра̄нча 🇷🇸, naranča 🇭🇷, نارَنْج 🇮🇷, नारंगी
                      🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/assassin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zSk51b0WVHw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;assassino"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "أَسَاسِيِّين"
                      /ʔasāsiyyīn/ (the name for members of a fundamentalist
                      order in Shia Islam who made it their mission to protect
                      the Muslim faith in the Levant and Persia during the
                      Crusader Era). The word is traditionally thought to derive
                      from "حَشَّاشِين" /ḥaššāšīn/ -- "hashish users", as
                      members of the order were presumed (primarily by their
                      enemies) to be heavy users of hashish. It is, however,
                      more likely derived from "أَسَاس" /ʔasās/ -- “foundation",
                      "basis”.
                      <div></div>
                      <strong>Cognates:</strong> assassin 🇫🇷, assassin 🇬🇧,
                      assassino 🇵🇹, asesino 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_pl.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, авто́бус
                      🇷🇺, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus 🇹🇲,
                      אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪,
                      buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴,
                      bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi
                      🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/average.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/cI0Fa9UD9S8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avaria"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Arabic verb
                      "عَوِرَ" /ʕawira/ -- “to lose an eye" and the derived
                      "عَوَار" /ʕawār/ -- "blemish", "defect" via "عَوَارِيَّة"
                      /ʕawāriyya/ -- “damaged goods" and, later, the Italian
                      "avaria" -- "damage done to goods (that have been thrown
                      overboard) on a watercraft."
                      <div></div>
                      <strong>Descendants:</strong> avería 🇪🇸, avaria 🇵🇹, avaria
                      🇦🇩, αβαρία 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cafe.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;caffè"
                  hoverText={
                    <span>
                      <strong>
                        <u>"beverage made with coffee beans"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                        /qāhē/ -- "to become blunt", "to become dull", In the
                        Umayyad period, people considered coffee to be an
                        intoxicating drink that dulled the mind and deprived one
                        of appetite. Eventually the word developed into Arabic
                        as "قَهْوَة" -- "coffee" and then spread to Italian and
                        other European languages (and all around the world).
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Ancestors:</strong> قَهْوَة 🇸🇦, koffie 🇳🇱
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> kahawa 🇹🇿, কফি 🇧🇩, ކޮފީ 🇲🇻,
                        ကော်ဖီ 🇲🇲, ყავა 🇬🇪, กาแฟ 🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, کافی
                        🇵🇰, кофе 🇰🇿, kafe 🇲🇬, қаҳва 🇹🇯, قهوه 🇮🇷, コーヒー 🇯🇵,
                        咖啡 🇨🇳, 커피 🇰🇷, кофе 🇲🇳, cà phê 🇻🇳, 咖啡 🇹🇼, kape 🇵🇭,
                        កាហ្វេ 🇰🇭, ກາເຟ 🇱🇦
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Descendants:</strong>
                        coffee 🇬🇧, café 🇪🇸, Kaffee 🇩🇪, ка̀фа 🇷🇸, café 🇵🇹, cafea
                        🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰, kafija 🇱🇻, kafe 🇦🇱, cafè,
                        🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦, ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές
                        🇬🇷, kaffe 🇳🇴
                      </div>
                      <div></div>{" "}
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/calamaro.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;calamaro"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar
                      🇦🇿
                      <div></div>
                      <strong>Descendants:</strong> kalmari 🇫🇮, calamar 🇪🇸,
                      calamar 🇦🇩, kalmar 🇸🇰, kałamarnica 🇵🇱, calmar 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chameau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cammello"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel", via the Ancient Greek "κᾰ́μηλος" /kắmēlos/ --
                      "camel", and the Latin "camēlus" -- "camel".
                      <div></div>
                      <strong>Cognates:</strong> ޖަމަލު 🇲🇻, جَمَل 🇸🇦, ግመል 🇪🇹,
                      גמל 🇮🇱, ngamia 🇹🇿, Kamel 🇩🇪, camel 🇬🇧, camello 🇪🇸, camelo
                      🇵🇹, chameau 🇫🇷, kamel 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cane_it.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9YJzi3P2Wto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cane"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "canis" -- "dog".
                      <div></div>
                      <strong>Related to:</strong> canaglia
                      <div></div>
                      <strong>Cognates:</strong> chien 🇫🇷, cão 🇵🇹, سگ 🇮🇷, سپۍ 🇦🇫
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cento.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cento"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Italic "*kentom" -- "100"
                      and the Latin "centum" -- "100",
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, сто 🇷🇺, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/consider.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/OyZjPK6RSss"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;considerare (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely a combination of the Latin
                      prefix "con-" -- "together", "with", and the noun "sīdus"
                      -- "star(s)". The origin of the word is linked to the
                      notion of ancient peoples looking at the sky and gaining
                      insight by considering the movements of the stars.
                      <div></div>
                      <strong>Possibly related to:</strong> de<u>seo</u>
                      <div></div>
                      <strong>Cognates:</strong> considérer 🇫🇷, considerar 🇪🇸,
                      considerar 🇵🇹, considerare 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/curfew.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/suyCgi6wEos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;coprifuoco"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i> a "calque") from the Old French
                      "cuevre-fu" (<i>lit.</i> "cover fire"), which itself
                      derives from the medieval practice of ringing a bell every
                      evening to signal that fires should be put out for the
                      night.
                      <div></div>
                      <strong>Cognates:</strong> curfew 🇬🇧, couvre-feu 🇫🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> avondklok 🇳🇱, toque
                      de queda 🇪🇸, toque de recolher 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cementerio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cimitero"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "κοιμητήριον"
                      /koimētḗrĭon/ -- "place to sleep", "dormitory", via the
                      Late Latin "coemētērium" -- "graveyard", "cemetery".
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cemitério 🇵🇹, cmentarz 🇵🇱, sementeryo 🇵🇭, cimetière 🇫🇷,
                      cemetery 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> cimitir 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/desir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/OyZjPK6RSss"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;desiderio"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely a combination of the Latin
                      prefix "de-" -- "of", "from" and the genitive form
                      "sīderis" of the noun "sidus" -- "star(s)", "of the
                      star(s)", via the verb "dēsīderō" -- "to long for",
                      "desire", and the associated noun "dēsīderium" --
                      "longing", "desire", "wish".
                      <div></div>
                      <strong>Likely related to:</strong> con<u>sider</u>are
                      <div></div>
                      <strong>(Possible) Cognates:</strong> desire 🇬🇧, désir 🇫🇷,
                      (deseo 🇪🇸), (desejo 🇵🇹)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/helice.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;elica"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "ἕλιξ" /hélix/
                      -- “spiral” via the Latin "helix" -- "whorl", "helix".
                      <div></div>
                      <strong>Related to:</strong> elicottero
                      <div></div>
                      <strong>Cognates:</strong> hélice 🇵🇹, hélice 🇪🇸, hélice
                      🇫🇷, elica 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;famiglia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Cognates:</strong> family 🇬🇧, familja 🇲🇹, famille
                      🇫🇷, familie 🇩🇰, familie 🇳🇴, Familie 🇩🇪, familia 🇪🇸,
                      família 🇵🇹, familie 🇷🇴, pamilya 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fiore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fiore"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Latin "flōs" (and
                      its accusative form "flōrem") –- “flower”.
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, fleur 🇫🇷, flor 🇵🇹,
                      flor 🇪🇸, flower 🇬🇧, blomst 🇳🇴, blomst 🇩🇰, blomma 🇸🇪, Blume
                      🇩🇪, floare 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;formaggio"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "(cāseum)
                      fōrmāticum" -- "curdled milk fit into a mold", via the Old
                      French "formage" -- "cheese" (which became "fromage"
                      through metathesis).
                      <div></div>
                      <strong>Related to:</strong> formazione
                      <div></div>
                      <strong>Cognates:</strong> fromage 🇫🇷, phô mai 🇻🇳,
                      foromaas 🇸🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fragola.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fragola"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "frāgum" --
                      "strawberry" (and specifically its nominative plural form
                      "frāga") via the Vulgar Latin "*frāgula" -- "strawberry".
                      <div></div>
                      <strong>Cognates:</strong> fraise 🇫🇷, fresa 🇪🇸, فراولة 🇸🇦,
                      presa 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fenetre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;finestra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "fenestra" --
                      "(glass) window".
                      <div></div>
                      <strong>Cognates:</strong> Fenster 🇩🇪, fönster 🇸🇪, fenêtre
                      🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gabbia.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gabbia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", and its derivative noun "cavea" – "hollow
                      place", "enclosure for animals".
                      <div></div>
                      <strong>Related to:</strong> caverna, cavità
                      <div></div>
                      <strong>Cognates:</strong> Käfig 🇩🇪, kooi 🇳🇱, gaiola 🇵🇹,
                      cave 🇬🇧, cage 🇫🇷, jaula 🇪🇸, Käfeg 🇱🇺, kou 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/juego.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gioco"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "iocus" -- "joke",
                      "amusement", "pastime", "sport".
                      <div></div>
                      <strong>Cognates:</strong> jeu 🇫🇷, jogo 🇵🇹, gioco 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gomito.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gomito"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cubō" -- "to
                      lie down", "to recline" and its descendant, the noun
                      "cubitum" which denoted the length from the edge of the
                      forearm (<i>i.e.</i>, the elbow) to the tip of the
                      outstretched hand. From there, the word entered modern
                      Italian via the Old Italian "gombito" -- "elbow".
                      <div></div>
                      <strong>Related to:</strong> covare (v.)
                      <div></div>
                      <strong>Cognates:</strong> cotovelo 🇵🇹, codo 🇪🇸, coude 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guerra_it.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;guerra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*werru" –- "confusion", "disorder", via the Frankish
                      "*werru" –- "confusion", "disorder", the Medieval Latin
                      "werra" -- "war", "strife", and the Old-Galician
                      Portuguese "guerra" -– "armed conflict", “war”.
                      <div></div>
                      <strong>Cognates:</strong> war 🇬🇧, guerra 🇵🇹, guerra 🇪🇸,
                      guerre 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idioma.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idioma"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδίωμα" /idíōma/ -- "a peculiarity", "a property", "a
                      peculiar phraseology", "idiom".
                      <div></div>
                      <strong>Related to:</strong> idiota
                      <div></div>
                      <strong>Cognates:</strong> идио́м 🇲🇰, идио́ма 🇷🇺, idiom 🇵🇱,
                      idiom 🇮🇩, идиома 🇰🇿, идѝо̄м 🇷🇸, idiotisme 🇫🇷, idiomë 🇦🇱,
                      იდიომი 🇬🇪, idiom 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiota.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idiota"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”, and the
                      Latin "idiōta" -- "uneducated or illiterate person". Like
                      the Greeks before them, the Romans used the word to refer
                      to someone lacking any professional skills, but they
                      placed emphasis on the fact that an “idiota” lacked
                      education and was therefore ignorant.
                      <div></div>
                      <strong>Related to:</strong> idioma
                      <div></div>
                      <strong>Cognates:</strong> Idiot 🇩🇪, идиот 🇲🇰, идиот 🇷🇺,
                      идиот 🇧🇬, idiot 🇬🇧, idiota 🇵🇹, idiota 🇵🇱, idiot 🇫🇷,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kabus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;incubo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "incubō" --
                      "I lie upon", "I brood over", via the Late Latin "incubus"
                      -- "nightmare", "incubus", "evil spirit who sits on your
                      chest while you sleep and tries to suffocate you."
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, كابوس
                      🇸🇦, 🇮🇹, painajainen 🇫🇮, кошма́р 🇷🇺, coșmar 🇷🇴, koszmar 🇵🇱,
                      კოშმარი 🇬🇪, košmaras 🇱🇹, cauchemar 🇫🇷, nightmare 🇬🇧, mar
                      dröm 🇸🇪, martröð 🇮🇸, mareritt 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/investir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hZaC6v6pM0o"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;investire (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wéstis" -- "the act of dressing/clothing" via the Latin
                      "vestis" -- "garment", "gown", "robe", "vestment" and the
                      verb "investio" -- "to clothe", "to cover". The modern
                      financial sense of the word comes from the idea of giving
                      one's money a new form (<i>i.e.</i>, clothing it in a new
                      attire).
                      <div></div>
                      <strong>Related to:</strong> investitura, vestiti (
                      <i>pl</i>.)
                      <div></div>
                      <strong>Cognates:</strong> investeren 🇳🇱, investere 🇳🇴,
                      investere 🇩🇰, investera 🇸🇪, invest 🇬🇧, investir 🇵🇹,
                      investire 🇮🇹, investi 🇷🇴, investieren 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/map.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mappa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Phoenician "𐤌𐤀𐤐"
                      /mappē/ ⁠ -- "fine cloth" via the Latin "mappa" -- "a
                      tablecloth (or large napkin) that guests would often bring
                      and use at the dinner table to wrap items of food that
                      they wished to take away with them". People later started
                      to use these fine cloths as writing surfaces for elaborate
                      world maps, which they called "mappa mundi" or "cloth of
                      the earth". Eventually, the second component "mundi" was
                      dropped, leaving only "mappa".
                      <div></div>
                      <strong>Cognates:</strong> mapa 🇵🇱, mapa 🇨🇿, מַפָּה 🇮🇱,
                      mapa 🇪🇸, mapa 🇵🇹, map 🇬🇧, mappa 🇲🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mela.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mela"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the Doric Greek
                      "μᾶλον" /mâlon/ -- "apple" via the Latin "mālum" and the
                      Late Latin "mēla".
                      <div></div>
                      <strong>Cognates:</strong> mollë 🇦🇱, măr 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/money.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;moneta"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "monēta" -- "place
                      for coining money".
                      <div></div>
                      <strong>Perhaps related to:</strong> monopolio, monaco
                      <div></div>
                      <strong>Descendants:</strong> monnaie 🇫🇷, moeda 🇵🇹, Münze
                      🇩🇪, mynt 🇮🇸, моне́та 🇷🇺, monēta 🇱🇻, moneta 🇵🇱, moneda 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muerte.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;morte"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "mortuus"-- "dead"
                      (a perfect active participle of the verb "morior" -- "to
                      die").
                      <div></div>
                      <strong>Cognates:</strong> mort 🇫🇷, morte 🇵🇹, մահ 🇦🇲,
                      mirtis 🇱🇹, смерть 🇷🇺, morte 🇮🇹, марг 🇹🇯, muerte 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muscolo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", so
                      called because flexed arm muscles look like little mice.
                      <div></div>
                      <strong>Related to:</strong> Maus, Muschel
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, muscle 🇬🇧, muskel 🇩🇰, muskel
                      🇳🇴, muskel 🇸🇪, мышца 🇷🇺, mišića 🇭🇷, Muskel 🇩🇪
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pregnant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;nascere (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "*(g)nāscī"
                      -- "to be born".
                      <div></div>
                      <strong>Related to:</strong> nazione, natura
                      <div></div>
                      <strong>Cognates:</strong> naître (<i>v</i>.) 🇫🇷, nascer (
                      <i>v</i>.) 🇵🇹, nacer (<i>v</i>.) 🇪🇸, naște (<i>v</i>.) 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ennemi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nemico"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "inimīcus" (
                      <i>i.e.</i>, "in-" -- “not” + "amīcus" - “friend”).
                      <div></div>
                      <strong>Related to:</strong> amico
                      <div></div>
                      <strong>Cognates:</strong> enemy 🇬🇧, enemigo 🇪🇸, inimigo
                      🇵🇹, ennemi 🇫🇷, inamic 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nome.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nome"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₁nómn̥" -- "name", via the Proto-Italic "*nōmn̥" --
                      "name" and the Latin "nōmen" -- "name", "noun".
                      <div></div>
                      <strong>Cognates:</strong> nom 🇫🇷, naam 🇳🇱, nome 🇵🇹, navn
                      🇩🇰, نَام 🇮🇷, نوم 🇦🇫, Name 🇩🇪, nombre 🇪🇸, όνομα 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/umbrella.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ombrello"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "umbra" -- "shade"
                      + "-ella" (diminutive suffix), as in "device that gives
                      those beneath it a little shade".
                      <div></div>
                      <strong>Descendants:</strong> umbrella 🇬🇧
                      <div></div>
                      <strong>Semantic equivalents:</strong> مِظَلَّة 🇸🇦, ร่ม 🇹🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/orologio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ora"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ὥρα"
                      /hṓra/ -- "any time or period, whether of the year, month,
                      or day", via the Latin "hōra" -- "hour".
                      <div></div>
                      <strong>Related to:</strong> <u>oro</u>scopo
                      <div></div>
                      <strong>Cognates:</strong> hora 🇵🇹, hora 🇪🇸, heure 🇫🇷, ora
                      🇮🇹, uur 🇳🇱, oră 🇷🇴, hora 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/orologio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;orologio"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ὡρολόγιον" /hōrológion/ -- "device for telling time"
                      (which itself comes partially from "ὥρα" /hṓra/ -- "any
                      period of time"), via the Latin "hōrologium" -- "device
                      used to measure the time of day", "sundial".
                      <div></div>
                      <strong>Related to:</strong> ora, orario, <u>oro</u>scopo
                      <div></div>
                      <strong>Cognates:</strong> reloj 🇪🇸, relógio 🇵🇹, horloge
                      🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ospite.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1VA4S3AMxB4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ospite"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ghos-ti-" -- "stranger", "guest", "host", "someone with
                      whom one has reciprocal duties of hospitality". Via
                      different paths the root eventually developed into the
                      contronym "ospite".
                      <div></div>
                      <strong>Related to:</strong> ostello, hotel, ospedale,
                      ostilità, ospitalità, hospice
                      <div></div>
                      <strong>Cognates:</strong> gość 🇵🇱, hôte 🇫🇷, huésped 🇪🇸,
                      гость 🇷🇺, oaspete 🇷🇴, Gast 🇩🇪, gast 🇳🇱, hosť 🇸🇰, host 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pants.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pantaloni"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A word derived from the
                      funny-looking character in the Italian{" "}
                      <i>Commedia del Arte</i> named "Pantalone" who had skinny
                      legs and wore tight pants.
                      <div></div>
                      <strong>Cognates:</strong> pants 🇬🇧, pantolon 🇹🇷,
                      παντελόνι 🇬🇷, pantalon 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pape.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;papa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πάππᾰς"
                      /páppăs/ -- "father".
                      <div></div>
                      <strong>Cognates:</strong> па́па 🇷🇺, پاپ 🇮🇷, papa 🇪🇸,
                      بَابَا 🇸🇦, پاپ 🇮🇷, papa 🇦🇿, պապ 🇦🇲, папа 🇧🇾, papež 🇨🇿,
                      pave 🇩🇰, paavi 🇫🇮, პაპი 🇬🇪, Papst 🇩🇪, πάπας 🇬🇷, पोप 🇮🇳,
                      paus 🇮🇩, pápa 🇮🇪, папа 🇰🇿, pāvests 🇱🇻, popiežius 🇱🇹,
                      Poopst 🇱🇺, пап 🇲🇳, papă 🇷🇴, papež 🇸🇮, papa 🇹🇿, papa 🇹🇲,
                      پوپ 🇵🇰, pab 🏴󠁧󠁢󠁷󠁬󠁳󠁿 بَابَا 🇸🇦
                      <div></div>
                      <strong>Descendants:</strong> papa 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parasole.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parasole"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the Ancient
                      Greek suffix "πᾰρᾰ-" /pără-/ -- "contrary to" (via the
                      Italian "para-" -- "guarding against") and the Latin "sol"
                      -- "sun".
                      <div></div>
                      <strong>Cognates:</strong> parasol 🇵🇹, parasol 🇫🇷, parasol
                      🇩🇰, parasole 🇮🇹
                      <div></div>
                      <strong>Descendants:</strong> parasol 🇵🇱, парасо́лька 🇺🇦
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      slunečník 🇨🇿, napernyő 🇭🇺, saulessargs 🇱🇻, 阳伞 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parole.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FamWPsuUjK8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parola"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "πᾰρᾰβάλλω" -- "to place side by side", via the Latin
                      "parabola" -- "comparison", "speech".
                      <div></div>
                      <strong>Related to:</strong> parabola
                      <div></div>
                      <strong>Cognates:</strong> palavra 🇵🇹, parole 🇫🇷, palabra
                      🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pen.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;penna"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Latin "penna" -- "feather"
                      via Old French "penne" -- "feather", "quill pen".
                      <div></div>
                      <strong>Not related to:</strong> pene
                      <div></div>
                      <strong>Cognates:</strong> pen 🇬🇧, pen 🇩🇰, pen 🇳🇱, penni
                      🇮🇸, peann 🇮🇪, penna 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pericolo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qJKkaRTmYbs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pericolo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "perīculum" --
                      "attempt", "experiment", "risk", "danger".
                      <div></div>
                      <strong>Cognates:</strong> peril 🇬🇧, perigo 🇵🇹, peligro
                      🇪🇸, péril 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/person.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LCiQz7vmiLY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;persona"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "persōna" -- "mask
                      used by actor", "role", "part", "character”. In the Roman
                      world, actors would wear “personae” during performances,
                      which would allow them “to portray a role” and “assume a
                      persona”. Gradually the word became associated both with
                      the mask itself and the actors wearing it, and eventually,
                      the mask meaning disappeared, and only the meaning related
                      to actors, and eventually, all human beings, remained.
                      <div></div>
                      <strong>Cognates:</strong> personne 🇫🇷, Person 🇩🇪, persoon
                      🇳🇱, person 🇬🇧, pessoa 🇵🇹, person 🏴󠁧󠁢󠁷󠁬󠁳󠁿, persona 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pied.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;piede"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk", via the Latin "pēs" --
                      "foot" and the Old French "pié" -- "foot".
                      <div></div>
                      <strong>Related to:</strong> pedale, pilota
                      <div></div>
                      <strong>Cognates:</strong> pied 🇫🇷, pié 🇪🇸, pé 🇵🇹, foot
                      🇬🇧, πόδι 🇬🇷, Fuß 🇩🇪, voet 🇳🇱, fot 🇸🇪, پا 🇮🇷, پَاؤُں 🇵🇰,
                      पैर 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pilot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pilota"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Ancient Greek "πηδόν"
                      /pēdón/ -- "oar (blade)" and the Byzantine Greek
                      "*πηδώτης" /pēdṓtēs/ -- “helmsman”. Before the emergence
                      of the airplane, a “pilot” was the person at the helm of a
                      ship who steered it into and out of a harbor and navigated
                      it to its destination. The original meaning "foot" comes
                      from the fact that the "πηδόν" looked like the boat’s foot
                      due to its flat shape and position underneath the boat’s
                      body.
                      <div></div>
                      <strong>Related to:</strong> pedale, piede, pedone
                      <div></div>
                      <strong>Cognates:</strong> pilot 🇬🇧, piloto 🇪🇸, piloto 🇵🇹,
                      pilote 🇫🇷, πιλότος 🇬🇷, Pilot 🇩🇪, pilot 🇩🇰, pilot 🇦🇱,
                      pilots 🇱🇻, pilot 🇨🇿, piloot 🇪🇪, pilot 🇹🇷, piloot 🇳🇱,
                      პილოტი 🇬🇪, पायलट 🇮🇳, パイロット 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/polvo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hicuJlF5hew"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;polvere"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*pel-" -- "flour", "dust" via
                      the Latin "pulvis" -- "dust", "powder", and the Italian
                      "polvere" -- "dust", "powder".
                      <div></div>
                      <strong>Likely related to:</strong> polline
                      <div></div>
                      <strong>Cognates:</strong> poudre 🇫🇷, powder 🇬🇧, pulver
                      🇸🇪, pulver 🇩🇰, pulver 🇳🇴, Pulver 🇩🇪
                      <div></div>
                      <strong>Descendants:</strong> polvo 🇪🇸, pó 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pomodoro.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pomodoro"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the plural "pomi d'oro" of
                      the Italian "pomo d'oro" -- "golden apple".
                      <div></div>
                      <strong>Descendants:</strong> pomidoras 🇱🇹, بَنْدُورَة 🇸🇾,
                      помідор 🇺🇦, pomidor 🇦🇿, памідор 🇧🇾, помидор 🇰🇬, помидор
                      🇹🇯, pomidor 🇹🇲, pomidor 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problema"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problème"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> ballare (v.), balletto
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problēma 🇱🇻, probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸,
                      пробле́ма 🇺🇦, пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴,
                      problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rosso.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;rosso (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European
                      "*h₁rewdʰ-" -- "red" via the Latin "russeus" -- "dark
                      red".
                      <div></div>
                      <strong>Related to:</strong> rubio
                      <div></div>
                      <strong>Cognates:</strong> red 🇬🇧, rosso 🇮🇹, rouge 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salsiccia.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salsiccia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Latin verb "*salō" -- (v.) –
                      “to salt” and its derivative "salsus" –- "salty",
                      "salted". From there, combined with the adjective forming
                      suffix "-īcius", the word evolved into the Late Latin
                      adjective "salsīcius" –- "prepared with salt".
                      <div></div>
                      <strong>Related to:</strong> insalata, sale, salario,
                      salsa
                      <div></div>
                      <strong>Cognates:</strong> sausage 🇬🇧, saucisse 🇫🇷,
                      salsicha 🇵🇹, ソーセージ 🇯🇵, 소시지 🇰🇷, سوسیس 🇮🇷, sosis 🇹🇷,
                      xúc xích 🇻🇳
                      <div></div>
                      <strong>Descendant:</strong> salchicha 🇪🇸, salsitxa 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sano.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sano (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "sānus"
                      (<i>adj.</i>) –- "healthy", "whole", "well" via the noun
                      "sānitās" –- "health", "soundness of body”.
                      <div></div>
                      <strong>Cognates:</strong> sain 🇫🇷, são 🇵🇹, sano 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b51FXNHemec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sevo (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*seh₂yro" -- "hard", "rough", "painful" via the Latin
                      adjective "saevus" -- "furious", "ferocious".
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sinister.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sinistro (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "sinister" --
                      "left hand". In many medieval societies the left hand was
                      considered slower and disadvantageous compared to the
                      right hand, thus giving "sinistro" the connotation
                      "unfavorable" or "adverse".
                      <div></div>
                      <strong>Cognates:</strong> sinistre 🇫🇷, sinistro 🇵🇹,
                      sinister 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/star.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Gt0B3coiu7s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;stella"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂stḗr" -- “star” via Proto-Italic "*stērlā" -- "star",
                      via the Latin "stēlla" -- "star".
                      <div></div>
                      <strong>Related to:</strong> costellazione
                      <div></div>
                      <strong>Cognates:</strong> star 🇬🇧, Stern 🇩🇪, αστέρι 🇬🇷,
                      étoile 🇫🇷, estrela 🇵🇹, stjerne 🇩🇰, stjärna 🇸🇪, stella 🇮🇹,
                      stea 🇷🇴, estrella 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldado.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;soldato"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army. From "solidus", the word eventually developed into
                      the Italian "soldo" -- "penny", cent", and then,
                      eventually, the modern Italian word.
                      <div></div>
                      <strong>Ancestor:</strong> soldo 🇮🇹
                      <div></div>
                      <strong>Related to:</strong> soldi (<i>pl.</i>)<div></div>
                      <strong>Descendants:</strong> Soldat 🇩🇪, soldier 🇬🇧,
                      soldat 🇩🇰, soldado 🇵🇹, cолда́т 🇷🇺, soldat 🇫🇷, soldat 🇸🇪,
                      soldat 🇷🇴, soldaat 🇳🇱, soldado 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldado.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;soldi (<i>pl.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army. From "solidus", the word eventually developed into
                      the modern Italian word "soldo" (and its plural form).
                      <div></div>
                      <strong>Descendants:</strong> soldato 🇮🇹
                      <div></div>
                      <strong>Related to:</strong> sodo (<i>adj.</i>)<div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/attic.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/BBMUYDMWK_w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;soffitto"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      adverb "upó" -- "under" and verb "*dʰeygʷ-" -- "to stick",
                      "to set up", which together gradually evolved into the
                      Latin verb "suffīgō" -- "to fasten", "to fix onto" and its
                      past participle "*suffīctus", and, thence, eventually, the
                      Modern Italian word.
                      <div></div>
                      <strong> Related to:</strong> suffisso
                      <div></div>
                      <strong> Descendants:</strong> soffite 🇫🇷, σοφίτα 🇬🇷,
                      sufit 🇵🇱, soffitta 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/estar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sJgO6bNR7x4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;stare (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "stō" -- "to
                      stand", via the Old Spanish verb "estar" -- "to stand",
                      "to be".
                      <div></div>
                      <strong>Related to:</strong> stazione, stato
                      <div></div>
                      <strong>Cognates:</strong> estar 🇵🇹, estar 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/te1.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tè"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thé 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, thee 🇳🇱, té 🇪🇸, te 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/umano.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;umano"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "hominem" (which
                      is likely a derivative of the noun "homō̆" -- "human
                      being"), via the adjective "hūmānus" -- "human".
                      <div></div>
                      <strong>Likely related to:</strong> <u>omo</u>sessuale,
                      uomo
                      <div></div>
                      <strong>Cognates:</strong> human 🇬🇧, humano 🇪🇸, humano 🇵🇹,
                      umano 🇮🇹, humà 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/uomo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;uomo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "hominem" (which
                      is likely a derivative of the noun "homō̆" -- "human
                      being").
                      <div></div>
                      <strong>Probably related to:</strong> umano
                      <div></div>
                      <strong>Cognates:</strong> hombre 🇪🇸, homem 🇵🇹, homme 🇫🇷,
                      om 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vacation.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;vacanza</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Latin verb "vacō" -- "to be free", its participle "vacāns"
                      -- "empty", "unoccupied", and, later, the Medieval Latin
                      "vacantia" -- "free time", "leisure". The original
                      "vacanza" centered around the idea of being at leisure,
                      idle, and unoccupied, (<i>i.e.</i>, "empty").
                      <div></div>
                      <strong>Related to:</strong> vuoto (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> vacances (<i>pl.</i>) 🇫🇷,
                      vacation 🇬🇧, vacaciones (<i>pl.</i>) 🇪🇸, vakantie 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/worm.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;verme"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wr̥mis" -- "worm" via Latin "vermem", -- "worm".
                      <div></div>
                      <strong>Related to:</strong> cramoisi (adj.)
                      <div></div>
                      <strong>Cognates:</strong> worm 🇬🇧, Wurm 🇩🇪, verme 🇵🇹, orm
                      🇩🇰, verme 🇮🇹, vierme 🇷🇴, worm 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/visita.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;visita"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "videō" --
                      "to see", via the verb "vīsō" -- "to behold", "to survey”,
                      and its frequentative derived form "vīsitō" -- "to go to
                      see", "to visit", and, later, the Italian verb "visitare"
                      -- "to visit".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dente</u>, pru
                      <u>dente</u> (<i>adj</i>.), visa, visione, in<u>vidia</u>,
                      video, avviso
                      <div></div>
                      <strong>Cognates:</strong> visit 🇬🇧, visita 🇪🇸, visita 🇵🇹,
                      vizită 🇷🇴, wizyta 🇵🇱, visite 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;zucchero"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel".
                      <div></div>
                      <strong>Ancestors:</strong> شکر 🇮🇷, سُكَّر 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> ζάχαρη 🇬🇷, са́хар 🇷🇺, sucre 🇫🇷,
                      azúcar 🇪🇸, sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪, suiker 🇳🇱,
                      cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲, suhkur 🇪🇪, ስኳር
                      🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇯🇵 JAPANESE 🇯🇵
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ocha.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;茶"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Sino-Tibetan "*s-la" -- "leaf".
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té
                      🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý 🇹🇲, តែ 🇰🇭, شَاي
                      🇸🇦, çay 🇹🇷, ჩაი 🇬🇪, 茶 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;明日"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The characters (Kanji) were
                      borrowed from Chinese "明日" /míngrì/ -– "tomorrow" (
                      <i>lit.</i> "bright day") . The reading /ashita/ comes
                      from the earlier term "朝" /asa/ -- "morning" (derived
                      from the Proto-Japonic "*asa" -- "morning").
                      <div></div>
                      <strong>Cognates:</strong> 明天 🇨🇳
                      <div></div>
                      <strong>Semantic Equivalents:</strong> mañana 🇪🇸, morgen
                      🇩🇪, за́<u>ўтра</u> 🇧🇾, у́тре 🇧🇬, у́тре 🇲🇰, z<u>ítra</u> 🇨🇿,
                      за<u>втра</u> 🇷🇺, jutro 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saramontir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;音楽"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Middle Chinese "音樂" /'im
                      ngaewk/ -- "music".
                      <div></div>
                      <strong>Ancestor:</strong> 音乐 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> 음악 🇰🇷, âm nhạc 🇻🇳
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jiao.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;角"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*krəw" -- "horn", "angle", "corner", via the Middle
                      Chinese "角" /kaewk/ -- "horn", "angle", "corner".
                      <div></div>
                      <strong>Ancestor:</strong> 角 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> giác 🇻🇳, 각 🇰🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> horn 🇬🇧, cuerno 🇪🇸,
                      corne 🇫🇷, hoorn 🇳🇱, horn 🇳🇴, horn 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;河馬"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i> a "calque") of the Ancient Greek
                      "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Cognates:</strong> 河马 🇨🇳, 하마 🇰🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> Nilpferd 🇩🇪,
                      nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा 🇮🇳, dobhareach
                      🇮🇪, su aygırı 🇹🇷, xипопота́м 🇧🇬, hipopótamo 🇪🇸, hipopótamo
                      🇵🇹, hippopotamus 🇬🇧, hippopotame 🇫🇷, ippopotamo 🇮🇹,
                      ჰიპოპოტამი 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus5.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;バス"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, bas 🇲🇾, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼,
                      bus 🇳🇦, বাস 🇧🇩, 巴士 🇨🇳, بس 🇦🇫, 버스 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ガス"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gaz 🇫🇷, газ 🇷🇺
                      <div></div>
                      <strong>Related to:</strong> haoss
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇦🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ 🇹🇯, газ
                      🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass 🇳🇴, gaas 🇪🇪,
                      kaasu 🇫🇮, gas 🇬🇧, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz 🇭🇺, gás
                      🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, გაზი 🇬🇪, գազ
                      🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jungle2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ジャングル"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert". The word
                      was adopted by British colonists in the Indian
                      subcontinent to refer to any territory that was
                      inhospitable, and then gradually it evolved to denote a
                      place with “tangled thickets”, and then, from there, "any
                      area with lots of vegetation".
                      <div></div>
                      <strong>Ancestor:</strong> جَنْگَل 🇵🇰, जंगल 🇮🇳, jungle 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> Dschungel 🇩🇪, джу́нгли 🇷🇺,
                      jungle 🇫🇷, jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪, dżungla 🇵🇱,
                      ջունգլի 🇦🇲, ჯუნგლი 🇬🇪, džungla 🇸🇮, džùngla 🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿,
                      جَن٘گَل 🇮🇷, জঙ্গল 🇧🇩, जङ्गल 🇳🇵, cəngəllik 🇦🇿, ځنګل 🇦🇫,
                      ҷангал 🇹🇯
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chokoreto.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;チョコレート"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, 초콜릿 🇰🇷, چاکْلیٹ 🇵🇰,
                      tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦, chokola 🇭🇹, sokola 🇲🇬,
                      suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷, xocolata 🇦🇩, чокола́да
                      🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺, shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱,
                      шакалод 🇹🇯, Schokolade 🇩🇪, czekolada 🇵🇱, chocolate 🇵🇹,
                      coklat 🇲🇾, شکلات 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/towel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;タオル"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic verb
                      "*þwahaną" -- "to wash" via the Frankish verb "*þwahilu"
                      -- "cloth".
                      <div></div>
                      <strong>Ancestor:</strong> towel 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> toalla 🇪🇸, tuwalya 🇵🇭, tuala
                      🇲🇾, tuáille 🇮🇪, toalha 🇵🇹, taulo 🇹🇿, taul 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;チーズ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product".
                      <div></div>
                      <strong>Ancestor:</strong> cheese 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> Käse 🇩🇪, kaas 🇳🇱, queso 🇪🇸,
                      queijo 🇵🇹, චීස් 🇱🇰, 치즈 🇰🇷, चीज़ 🇮🇳, keju 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;バナナ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳, banana 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> banane 🇫🇷, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana
                      🇪🇸, banana 🇵🇹, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪,
                      banaan 🇳🇱, μπανάνα 🇬🇷, banan 🇸🇪, 바나나 🇰🇷, бана́н 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/matelasuse.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;マットレス"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Ancestor:</strong> mattress 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> matelas 🇫🇷, materasso 🇮🇹,
                      matrac 🇸🇰, Matratze 🇩🇪, matras 🇳🇱, матра́с 🇷🇺, матрас 🇰🇬,
                      матрас 🇰🇿, materac 🇵🇱, madrass 🇸🇪, 매트리스 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇰🇿 KAZAKH 🇰🇿
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avtobus_mg.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;автобус"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷, авто́бус 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, awtobus 🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿,
                      buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese
                      🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷,
                      バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apelsin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;апельсин"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the French "pomme de Sine"
                      🇫🇷 – “apple from China”. The word was calqued into the
                      Dutch "appelsien" -- "orange". The name reflects the fact
                      that the fruit originated from a region that encompasses
                      Southern China.
                      <div></div>
                      <strong>Ancestor:</strong> апельсин 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> sinaasappel 🇳🇱, apelsin 🇸🇪,
                      Apfelsine 🇩🇪, appelsin 🇳🇴, апельсин 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;газ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, газ 🇷🇺
                      <div></div>
                      <strong>Related to:</strong> хаос
                      <div></div>
                      <strong>Not related to:</strong> газет
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, gaz 🇫🇷, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ипотека"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Ancestor:</strong> ипоте́ка 🇷🇺
                      <div></div>
                      <strong>Related to:</strong> тезис
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, hipoteca 🇵🇹,
                      hipoteca 🇸🇮, ipotek 🇹🇷, hipoteka 🇸🇮, ипотека 🇰🇬,
                      hypothèque 🇫🇷, Hypothek 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kzalam.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;қалам"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, possibly
                      via the Ge'ez "ቀለም" /ḳäläm/ -- "reed".
                      <div></div>
                      <strong>Ancestor:</strong> قلم 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> калем 🇰🇬, kalem 🇹🇷, क़लम 🇮🇳,
                      कलम 🇳🇵, kalamu 🇹🇿, қалам 🇹🇯, ގަލަން 🇲🇻, কলম 🇧🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kyryk.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;қырық"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*kïrk" --
                      "40", via the Ottoman Turksih "قرق" /kırk/ -- "40".
                      <div></div>
                      <strong>Possible cognates:</strong> cорaк 🇧🇾, cо́рок 🇺🇦,
                      cорок 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> kyrk 🇹🇲, kırk 🇹🇷, кырк 🇰🇬, qirq
                      🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/matematika.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;математика"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μάθημα"
                      /máthēma/ -- "something that is learned", "lesson",
                      "knowledge", whence the phrase "μαθηματικὴ τέχνη"
                      /mathēmatikḗ tékhnē/ -- "mathematical sciences”, "sciences
                      of matters that have been learned" was derived.
                      Originally, “mathematics” referred to the science of
                      learning in general. Only after the term was used by the
                      "mathematikoi" (<i>i.e.,</i> "those who love to learn"), a
                      group of scholars in Ancient Greece who studied the ideas
                      of Pythagoras, especially those pertaining to arithmetic
                      and geometry, did the term "mathematics" become closely
                      associated with its modern meaning.
                      <div></div>
                      <strong>Ancestor:</strong> математика 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> mathematics 🇬🇧, математика 🇰🇿,
                      matematik 🇹🇷, matematica 🇮🇹, matematika 🇸🇰, Mathematik 🇩🇪,
                      математика 🇰🇬, matematyka 🇵🇱, matematik 🇸🇪, matemáticas
                      🇪🇸, matematik 🇹🇷, математик 🇲🇳, mathématiques 🇫🇷,
                      matematika 🇵🇭, matamaitic 🇮🇪, mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mateulasu.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;матрас"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Ancestor:</strong> матра́с 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> matelas 🇫🇷, materasso 🇮🇹,
                      matrac 🇸🇰, Matratze 🇩🇪, matras 🇳🇱, матрас 🇰🇬, materac 🇵🇱,
                      madrass 🇸🇪, マットレス 🇯🇵, 매트리스 🇰🇷, mattress 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shabadan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;шабадан"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "جامه‌دان"
                      /jâme-dân/ -- "suitcase", which is itself a combination of
                      "جامه" /jâme/, -- “cloth” and "دان" /dân/ -- "container".
                      Literally, a "шабадан" is a container for storing cloth or
                      clothing, especially one used while travelling.
                      <div></div>
                      <strong>Related to:</strong> пи<u>жама</u>
                      <div></div>
                      <strong>Cognates:</strong> çemedan 🇹🇲, čemodāns 🇱🇻, چمدان
                      🇮🇷, ჩემოდანი 🇬🇪, чемодан 🇲🇳, чамадон 🇹🇯, чемодан 🇰🇬,
                      чемодан 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shay.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;шай"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many Central and West
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, çay 🇹🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, 茶 🇯🇵, 차
                      🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸,
                      thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý 🇹🇲, tea 🇬🇧, attaya
                      🇸🇳, اتاي 🇲🇷, شَاي 🇸🇦, چای 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇰🇭 KHMER 🇰🇭
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tea11.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;តែ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea".
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇪🇪, thee 🇳🇱
                      <div></div>
                      <strong>Descendant:</strong>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/moenbaarang.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;មាន់បារាំង"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "មាន់" /mŏən/ --
                      "chicken" and "បារាំង" /baarang/ -- "from France".
                      Literally, a "មាន់បារាំង" is a French (Western) chicken,
                      which is where turkeys were traditionally thought to be
                      from.
                      <div></div>
                      <strong>Partial semantic equivalents:</strong> gà tây 🇻🇳,
                      دِيك رُومِيّ 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saramontir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;សារមន្ទីរ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "សារ" /saa/ --
                      "essence", "substance", "important part" (which itself is
                      a descendant of the Sanskrit सार /sāra/ -- “extract";
                      "essence") + "មន្ទីរ" /mŭəntii/ -- "public office",
                      "bureau" (which itself is a descendant of the Sanskrit
                      "मन्दिर" /mandira/ -- "building", "hall", "house",
                      "institution"). Literally, a "សារមន្ទីរ" is a "building
                      for valuable/important things".
                      <div></div>
                      <strong>Related to:</strong> ប័ណ្ណសារ
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soukoulaa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;សូកូឡា"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolat 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾, شکلات 🇮🇷,
                      チョコレート 🇯🇵, chocolate 🇬🇧, sokola 🇲🇬, suklaa 🇫🇮,
                      choklad 🇸🇪, ໂຊໂກລາ 🇱🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇰🇷 KOREAN 🇰🇷
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus4.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;버스"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼,
                      bus 🇳🇦, বাস 🇧🇩, 巴士 🇨🇳, بس 🇦🇫
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chaaa.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;차"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Sino-Tibetan "*s-la" -- "leaf".
                      <div></div>
                      <strong>Ancestor: </strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té
                      🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý 🇹🇲, តែ 🇰🇭, شَاي
                      🇸🇦, çay 🇹🇷, ჩაი 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chokollit.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;초콜릿"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭,
                      សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦, chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮,
                      choklad 🇸🇪, chocolat 🇫🇷, xocolata 🇦🇩, чокола́да 🇷🇸,
                      cioccolato 🇮🇹, шокола́д 🇷🇺, shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱,
                      шакалод 🇹🇯, Schokolade 🇩🇪, czekolada 🇵🇱, chocolate 🇵🇹,
                      coklat 🇲🇾, شکلات 🇮🇷, チョコレート 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;가스"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gas 🇬🇧
                      <div></div>
                      <strong>Related to :</strong> 카오스
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇦🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ 🇹🇯, газ
                      🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass 🇳🇴, gaas 🇪🇪,
                      kaasu 🇫🇮, gas 🇬🇧, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz 🇭🇺, gás
                      🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, ガス 🇯🇵, გაზი 🇬🇪, գազ
                      🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, gaz 🇫🇷, газ 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jiao.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;각"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*krəw" -- "horn", "angle", "corner", via the Middle
                      Chinese "角" /kaewk/ -- "horn", "angle", "corner".
                      <div></div>
                      <strong>Cognates:</strong> giác 🇻🇳, 角 🇯🇵, 角 🇨🇳
                      <div></div>
                      <strong>Semantic equivalents:</strong> horn 🇬🇧, cuerno 🇪🇸,
                      corne 🇫🇷, hoorn 🇳🇱, horn 🇳🇴, horn 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mateulasu.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;매트리스"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Ancestor:</strong> mattress 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> matelas 🇫🇷, materasso 🇮🇹,
                      matrac 🇸🇰, Matratze 🇩🇪, matras 🇳🇱, матра́с 🇷🇺, матрас 🇰🇬,
                      матрас 🇰🇿, materac 🇵🇱, madrass 🇸🇪, マットレス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;바나나"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Ancestor:</strong> banaana 🇸🇳, banana 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> banane 🇫🇷, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana
                      🇪🇸, banana 🇵🇹, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪,
                      banaan 🇳🇱, μπανάνα 🇬🇷, banan 🇸🇪, バナナ 🇯🇵, бана́н 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;치즈"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product".
                      <div></div>
                      <strong>Ancestor:</strong> cheese 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> Käse 🇩🇪, kaas 🇳🇱, queso 🇪🇸,
                      queijo 🇵🇹, චීස් 🇱🇰, チーズ 🇯🇵, चीज़ 🇮🇳, keju 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jungle2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;정글"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert". The word
                      was adopted by British colonists in the Indian
                      subcontinent to refer to any territory that was
                      inhospitable, and then gradually it evolved to denote a
                      place with “tangled thickets”, and then, from there, "any
                      area with lots of vegetation".
                      <div></div>
                      <strong>Ancestors:</strong> جَنْگَل 🇵🇰, जंगल 🇮🇳, jungle 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> جَن٘گَل 🇮🇷, জঙ্গল 🇧🇩, जङ्गल 🇳🇵,
                      cəngəllik 🇦🇿, ځنګل 🇦🇫, ҷангал 🇹🇯, Dschungel 🇩🇪, джу́нгли
                      🇷🇺, jungle 🇫🇷, jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪, dżungla
                      🇵🇱, ջունգլի 🇦🇲, ჯუნგლი 🇬🇪, ジャングル 🇯🇵, džungla 🇸🇮,
                      džùngla 🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿, 정글 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saramontir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;음악"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Middle Chinese "音樂" /'im
                      ngaewk/ -- "music".
                      <div></div>
                      <strong>Ancestor:</strong> 音乐 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> âm nhạc 🇻🇳, 音楽 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/left.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;왼쪽"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "왼" /oen/ -- "left" (which
                      itself is derived from the Middle Korean adjectival verb
                      "외다" /oeda/ -- "to be wrongly oriented") 쪽 /jjok/ --
                      "side".
                      <div></div>
                      <strong>Related to:</strong> 외다 (<i>v.</i>)<div></div>
                      <strong>Possible semantic equivalents:</strong> gauche 🇫🇷,
                      sinistro 🇮🇹, ле́вый 🇷🇺, 왼쪽 🇰🇷, left (<i>adj.</i>) 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇰🇬 KYRGYZ 🇰🇬
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apelsin1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;апельсин"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the French "pomme de Sine"
                      🇫🇷 – “apple from China”. The word was calqued into the
                      Dutch "appelsien" -- "orange". The name reflects the fact
                      that the fruit originated from a region that encompasses
                      Southern China.
                      <div></div>
                      <strong>Ancestor:</strong> апельсин 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> sinaasappel 🇳🇱, apelsin 🇸🇪,
                      Apfelsine 🇩🇪, appelsin 🇳🇴, апельсин 🇰🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ипотека"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Ancestor:</strong> ипоте́ка 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, hipoteca 🇵🇹,
                      hipoteca 🇸🇮, ipotek 🇹🇷, hipoteka 🇸🇮, ипотека 🇰🇿,
                      hypothèque 🇫🇷, Hypothek 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kyerk.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;кырк"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*kïrk" --
                      "40", via the Ottoman Turksih "قرق" /kırk/ -- "40".
                      <div></div>
                      <strong>Possible cognates:</strong> cорaк 🇧🇾, cо́рок 🇺🇦,
                      cорок 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> kyrk 🇹🇲, kırk 🇹🇷, qirq 🇺🇿,
                      қырық 🇰🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mateulasu.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;матрас"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Ancestor:</strong> матра́с 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> matelas 🇫🇷, materasso 🇮🇹,
                      matrac 🇸🇰, Matratze 🇩🇪, matras 🇳🇱, матрас 🇰🇿, materac 🇵🇱,
                      madrass 🇸🇪, マットレス 🇯🇵, 매트리스 🇰🇷, mattress 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇱🇦 LAO 🇱🇦
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saah.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ຊາ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Chinese "茶" /chá/ -- "tea",
                      the Persian "چای" /čây/ -- "tea" and the Proto-Thai
                      "*ɟaːᴬ" -- "tea" "چای" /çay/ -- "tea".
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲, chai 🇹🇿, شَاي 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sokl.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ໂຊໂກລາ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolat 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾, شکلات 🇮🇷,
                      チョコレート 🇯🇵, chocolate 🇬🇧, សូកូឡា 🇰🇭, sokola 🇲🇬,
                      suklaa 🇫🇮, choklad 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇱🇻 LATVIAN 🇱🇻
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/architect.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;arhitekts"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ἀρχι-" /arkhi-/ -- “chief” and "τέκτων" /téktōn/ --
                      “builder”.
                      <div></div>
                      <strong>Related to:</strong> <u>arhi</u>
                      bīskaps
                      <div></div>
                      <strong>Cognates:</strong> Architekt 🇩🇪, architecte 🇫🇷,
                      arquitecto 🇪🇸, arquiteto 🇵🇹, architetto 🇮🇹, архіте́ктор 🇺🇦,
                      arxitektor 🇺🇿, arsitèk 🇮🇩, arhitekt 🇸🇮, argitek 🇿🇦,
                      arkitekt 🇮🇸, архитектор 🇰🇬, architect 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chemodan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;čemodāns"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "جامه‌دان"
                      /jâme-dân/ -- "suitcase", which is itself a combination of
                      "جامه" /jâme/, -- “cloth” and "دان" /dân/ -- "container".
                      Literally, a "čemodāns" is a container for storing cloth
                      or clothing, especially one used while travelling.
                      <div></div>
                      <strong>Related to:</strong> pi<u>džama</u>
                      <div></div>
                      <strong>Ancestor:</strong> чемодан 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> čemodāns 🇱🇻, چمدان 🇮🇷, ჩემოდანი
                      🇬🇪, чемодан 🇲🇳, чамадон 🇹🇯, чемодан 🇰🇬, шабадан 🇰🇿,
                      çemedan 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;banāns"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳
                      <div></div>
                      <strong>Cognates:</strong> banana 🇵🇹, banane 🇫🇷, banana
                      🏴󠁧󠁢󠁷󠁬󠁳󠁿, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪, banaan 🇳🇱,
                      μπανάνα 🇬🇷, banan 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gāze"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gaz 🇫🇷, газ 🇷🇺
                      <div></div>
                      <strong>Related to:</strong> haoss
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇦🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ 🇹🇯, газ
                      🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass 🇳🇴, gaas 🇪🇪,
                      kaasu 🇫🇮, gas 🇬🇧, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz 🇭🇺, gás
                      🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵,
                      გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/left.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;kreiss (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*(s)ker-" -- "to turn", "to bend", via the Proto-Baltic
                      "*krei-" -- "twisted", "deformed". The word's historical
                      meaning is based on the popular notion in earlier
                      centuries that the left hand was weaker and less dexterous
                      than the right hand.
                      <div></div>
                      <strong>Cognates:</strong> skrīpāt (<u>v.</u>), šķirt (
                      <u>v.</u>), cirst (<u>v.</u>), cirvis
                      <div></div>
                      <strong>Possible semantic equivalents:</strong> gauche 🇫🇷,
                      sinistro 🇮🇹, ле́вый 🇷🇺, 왼쪽 🇰🇷, izquierda 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/lokys.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;lācis"
                  hoverText={
                    <span>
                      <strong> Origin:</strong> Likely from the
                      Proto-Indo-European verb "*tl-ek-" -- "to stomp", "to
                      kick", "to trample". Most scholars believe that early
                      Baltic peoples called the animal “the trampler", in an
                      effort to avoid calling it by its real name, which, in
                      those superstitious cultures, was considered taboo, and
                      could cause it to appear during a hunt.
                      <div></div>
                      <strong>Cognates:</strong> lokys 🇱🇹
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong>
                      bear 🇬🇧, Bär 🇩🇪, bjørn 🇩🇰, мядзве́дзь 🇧🇾, медведь 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;lietussargs"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the noun
                      "lietus" -- "rain", and the verb "sargāt" -- "to protect",
                      "to guard".
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Regenschirm 🇩🇪,
                      deštník 🇨🇿, esernyő 🇭🇺, paraguas 🇪🇸, 雨伞 🇨🇳, parachuva
                      🇵🇹, parapluie 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muzejs"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)", via the French "musée" -- "museum".
                      <div></div>
                      <strong>Related to:</strong> mūzika
                      <div></div>
                      <strong>Ancestors:</strong> музе́й 🇷🇺, Museum 🇩🇪
                      <div></div>
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      музе́й 🇧🇾, muzeum 🇦🇱, موزه 🇮🇷, müze 🇹🇷, muzȇj 🇸🇮, muzeum
                      🇨🇿, muuseum 🇪🇪, múzeum 🇭🇺, מוּזֵיאוֹן 🇮🇱, muzeý 🇹🇲, muzium
                      🇲🇾, musée 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problēma"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problēma"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problème 🇫🇷, probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸,
                      пробле́ма 🇺🇦, пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴,
                      problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sals.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sāls"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Proto-Slavic "*solь" --
                      "salt", via the Proto-Balto-Slavic "*sāˀlis" -- "salt",
                      and the Proto-Baltic "*sāl-" -- "salt".
                      <strong>Related to:</strong> salāti
                      <div></div>
                      <strong>Cognates:</strong> sel 🇫🇷, sal 🇪🇸, sale 🇮🇹, αλάτι
                      🇬🇷, salt 🇩🇰, sól 🇵🇱, salt 🇸🇪, salt 🇬🇧, Salz 🇩🇪, sůl 🇨🇿,
                      sāls 🇱🇻, suola 🇫🇮, sool 🇪🇪, sal 🇵🇹, соль 🇷🇺, sol 🇭🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;saulessargs"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the noun
                      "saule" -- "sun", and the verb "sargāt" -- "to protect",
                      "to guard".
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      slunečník 🇨🇿, napernyő 🇭🇺, parasolka 🇵🇱, 阳伞 🇨🇳, parasol
                      🇫🇷, parasole 🇮🇹, парасо́лька 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/simts.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;simts"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Balto-Slavic "*śímta" --
                      "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, сто 🇷🇺, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇹, stó 🇸🇮, sto 🇵🇱, сто 🇧🇬,
                      сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b51FXNHemec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sīvs (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely Ffom the
                      Proto-Indo-European "*seh₂yro" -- "hard", "rough",
                      "painful".
                      <div></div>
                      <strong>Cognates:</strong> sehr 🇩🇪, sore 🇬🇧, šaižùs 🇱🇹,
                      zeer 🇳🇱, sevo 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/teja.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tēja"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tae 🇮🇪, чай 🇷🇺, choy
                      🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱,
                      ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇫🇮, tee 🇪🇪, te 🇸🇪, herba
                      <u>ta</u> 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vards1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vārds"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say" via the Proto-Germanic
                      "*wurdą" -- "word", "saying", and the Old Norse "orð" --
                      "word", "saying".
                      <div></div>
                      <strong>Cognates:</strong> ord 🇸🇪, ord 🇳🇴, ord 🇩🇰, woord
                      🇳🇱, Wuert 🇱🇺, word 🇬🇧, woord 🇳🇦, Wort 🇩🇪, word 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇨🇩 LINGALA 🇨🇩
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bisi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bísi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, auto
                      <u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u> 🇪🇸,
                      auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u> 🇵🇱,
                      auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u> 🇦🇱,
                      auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u> 🇺🇦,
                      авто́
                      <u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>, 巴士 🇨🇳,
                      बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇲🇼, bhazi
                      🇿🇼, bus 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇱🇹 LITHUANIAN 🇱🇹
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobusas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobusas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>bús</u> 🇦🇩, auto<u>bús</u> 🇪🇸, auto<u>buz</u>{" "}
                      🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u> 🇵🇱, auto<u>bus</u>,
                      авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u> 🇵🇹,
                      巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস
                      🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;du"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Baltic "*d(u)u̯ō" -- "two".
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      two 🇬🇧, dwa 🇵🇱, dó 🇮🇪, twee 🇳🇱, to 🇳🇴, zwei 🇩🇪, два 🇧🇬,
                      երկու 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobby.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hobis"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Ancestor:</strong> hobby 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> hobi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, xоби 🇲🇰, hobi 🇹🇷,
                      hobby 🇸🇪, хо́бби 🇷🇺, Hobby 🇩🇪, hobbi 🇭🇺, hobbi 🇦🇿, hobijs
                      🇱🇻, хоби 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dinde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kalakùtas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Kalikutas (Calicut),
                      a city in India, where turkeys were traditionally believed
                      to come from.
                      <div></div>
                      <strong>Cognates:</strong> индюк 🇷🇺, dinde 🇬🇧, hindi 🇹🇷
                      <div></div>
                      <strong>Partial semantic equivalents:</strong> kalkoen 🇳🇱,
                      kalkon 🇸🇪, indyk 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/lokys.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;lokys"
                  hoverText={
                    <span>
                      <strong> Origin:</strong> Likely from the
                      Proto-Indo-European verb "*tl-ek-" -- "to stomp", "to
                      kick", "to trample". Most scholars believe that early
                      Baltic peoples called the animal “the trampler", in an
                      effort to avoid calling it by its real name, which, in
                      those superstitious cultures, was considered taboo, and
                      could cause it to appear during a hunt.
                      <div></div>
                      <strong>Cognates:</strong> lācis 🇱🇻
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong>
                      bear 🇬🇧, Bär 🇩🇪, bjørn 🇩🇰, мядзве́дзь 🇧🇾, медведь 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pomidoras.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pomidoras"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the plural "pomi d'oro" of
                      the Italian "pomo d'oro" -- "golden apple".
                      <div></div>
                      <strong>Ancestors:</strong> pomodoro 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> pomidor 🇵🇱, بَنْدُورَة 🇸🇾,
                      помідор 🇺🇦, pomidor 🇦🇿, памідор 🇧🇾, помидор 🇰🇬, помидор
                      🇹🇯, pomidor 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problema"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problēma"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problēma 🇱🇻, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problème 🇫🇷, probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸,
                      пробле́ма 🇺🇦, пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴,
                      problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sore.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b51FXNHemec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;šaižùs (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely Ffom the
                      Proto-Indo-European "*seh₂yro" -- "hard", "rough",
                      "painful".
                      <div></div>
                      <strong>Cognates:</strong> sehr 🇩🇪, sore 🇬🇧, sīvs 🇱🇻, zeer
                      🇳🇱, sevo 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/simtas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;šimtas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Balto-Slavic "*śímta" --
                      "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, сто 🇷🇺, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, simts 🇱🇻, stó 🇸🇮, sto 🇵🇱, сто 🇧🇬,
                      сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇺🇬 LUGANDA 🇺🇬
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/caayi.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;caayi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many Asian and
                      African languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, شَاي 🇸🇦, chai 🇹🇿
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇱🇺 LUXEMBOURGISH 🇱🇺
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dag1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Dag"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*dagaz"
                      -- "day", via the Old High German "*dag" -- "day", and the
                      Middle High German "dach" -- "day".
                      <div></div>
                      <strong>Related to:</strong> haut
                      <strong>Cognates:</strong> Tag 🇩🇪, day 🇬🇧, dag 🇳🇱, dag 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nuecht.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Nuecht"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*nókʷts" -- "night", via the Proto-Germanic "*nahts" --
                      "night", via the Old High German "naht" -- "night", and
                      the Middle High German "naht" -- "night".
                      <div></div>
                      <strong>Cognates:</strong> nacht 🇳🇱, night 🇬🇧, Nacht 🇩🇪,
                      natt 🇳🇴, natt 🇸🇪, nuit 🇫🇷, noche 🇪🇸, noite 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/wuert.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;Wuert"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say" via the Proto-Germanic
                      "*wurdą" -- "word", "saying", the Proto-West-Germanic
                      "*word" -- "word", and the Old High German "wort" --
                      "word".
                      <div></div>
                      <strong>Related to:</strong> Verb, Ad<u>verb</u>
                      <div></div>
                      <strong>Cognates:</strong> ord 🇸🇪, ord 🇳🇴, ord 🇩🇰, woord
                      🇳🇱, Wuert 🇱🇺, vārds 🇱🇻, word 🇬🇧, woord 🇳🇦, Wort 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇰 MACEDONIAN 🇲🇰
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;идиот"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”.
                      <div></div>
                      <strong>Ancestor:</strong> идиот 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> idiot 🇬🇧, идиот 🇲🇰, Idiot 🇩🇪,
                      идиот 🇧🇬, idiota 🇪🇸, idiota 🇵🇹, idiota 🇵🇱, idiot 🇫🇷,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/insekt1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;инсект"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "īnsectus" (
                      <i>i.e.</i>, īn + sectus) -- "cut into sections". Borrowed
                      as a word-for-word translation of the Ancient Greek
                      "ἔντομον" /éntomon/ -- "cut into sections". From the
                      observation (first made by Aristotle) that insects are
                      physically separated (or "cut") into three separate
                      sections (head, thorax, abdomen).
                      <div></div>
                      <strong>Related to:</strong> секс
                      <div></div>
                      <strong>Cognates:</strong> insecto 🇪🇸, insecte 🇫🇷, inseto
                      🇵🇹, insetto 🇮🇹, insectă 🇷🇴, insect 🇬🇧, insect 🇳🇱, insekt
                      🇳🇴, insekt 🇩🇰, на<u>сек</u>о́мое 🇷🇺, на<u>сек</u>омо 🇧🇬
                      <div></div>
                      <strong>Semantic equivalents:</strong> έντομο 🇬🇷, rovar
                      🇭🇺, trychfil 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kanibal_ma.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;канибал"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Карипски (<i>adj.</i>)
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nightmare.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;кошмар"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin verb
                      "calcāre" -- "to trample", "to tread on", (via the Old
                      French "chauchier" -- "to press") and the Frankish "*marā"
                      -- "an evil spirit who sits on your chest while you sleep
                      and tries to suffocate you".
                      <div></div>
                      <strong>Ancestor:</strong> cauchemar 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> night<u>mare</u> 🇬🇧, <u>mar</u>
                      dröm 🇸🇪, <u>mar</u>tröð 🇮🇸, <u>mare</u>ritt 🇳🇴, кошма́р 🇷🇺,
                      koszmar 🇵🇱, კოშმარი 🇬🇪, košmaras 🇱🇹
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, incubo
                      🇮🇹, كابوس 🇸🇦, painajainen 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/korova.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;крава"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Proto-Slavic "*kòrva"
                      -- "cow".
                      <div></div>
                      <strong>Related to:</strong> стршен
                      <div></div>
                      <strong>Cognates:</strong> krowa 🇵🇱, корова 🇺🇦, крава 🇧🇬,
                      корова 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/misirka.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;мисирка"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مِصْر" /miṣr/
                      via the Ottoman Turkish "مصر" /mısır/ -- "Egypt". The name
                      derives from the mistaken idea that turkeys come from
                      Egypt.
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;проблем"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "проблем"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> балет
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, problem 🇬🇧, problēma 🇱🇻,
                      probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦,
                      пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;спорт"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺, ስፖርት 🇪🇹,
                      šport 🇸🇰, sport 🇷🇴, sport 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobby.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;хоби"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Ancestor:</strong> hobby 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> hobi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, hobi 🇹🇷, hobby 🇸🇪,
                      хо́бби 🇷🇺, Hobby 🇩🇪, hobbi 🇭🇺, hobis 🇱🇹, hobbi 🇦🇿, hobijs
                      🇱🇻, хоби 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇬 MALAGASY 🇲🇬
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dite.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dite"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the French
                      phrase "du thé" -- "some tea". The second word element
                      comes from the Proto-Sino-Tibetan "*s-la" -- "leaf", via
                      the Hokkien Chinese "茶" /tê/ -- "tea". The drink and its
                      corresponding word was discovered by Dutch traders in the
                      early 17th century. The word made its way by sea to Europe
                      (and then parts of Africa) via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, tea 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶
                      🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩,
                      té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý 🇹🇲,
                      اتاي 🇲🇷, شَاي 🇸🇦, ítí 🇿🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sokola.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sokola"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolat 🇫🇷,
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾, شکلات 🇮🇷,
                      チョコレート 🇯🇵, chocolate 🇬🇧, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, suklaa 🇫🇮, choklad 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇾 MALAY 🇲🇾
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus_ml.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦,
                      বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/coklat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;coklat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid
                      �🇪, �🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート
                      🇯🇵, 초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ
                      🇱🇦, chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat
                      🇫🇷, xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kanibal_in.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kanibal"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> Karibia
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸, kannibaal 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇮🇩, קָנִיבָּל 🇮🇱, kanibal 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/teh2.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;teh"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe (and parts of the East Indies)
                      via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, tea 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶
                      🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩,
                      té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý 🇹🇲,
                      اتاي 🇲🇷, شَاي 🇸🇦, ítí 🇿🇦, dite 🇲🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇹 MALTESE 🇲🇹
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/animal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;annimal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "anima" -- "soul",
                      "spirit", "life", "air" , "breath" via the adjective
                      "animālis" -- "animate", "living."
                      <div></div>
                      <strong>Ancestor:</strong> animale 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> animal 🇫🇷, animal 🇪🇸, animal 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/berquq.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;berquq"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and, eventually, the modern Maltese word.
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      َرْقُوق 🇲🇷, albaricoque 🇪🇸, абрико́с 🇷🇺, абрико́с 🇺🇦,
                      abricot 🇫🇷, aibreog 🇮🇪, apricot 🇬🇧, Aprikose 🇩🇪, aprikoti
                      🇹🇿, aprikot 🇮🇩, abrikoos 🇳🇱
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;familja"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Ancestor:</strong> famiglia 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> familia 🇪🇸, family 🇬🇧, pamilya
                      🇵🇭, Familie 🇩🇪, família 🇵🇹, familie 🇷🇴, famille 🇫🇷,
                      familie 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gass"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Related to:</strong> kaos
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gas 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, গ্যাস 🇧🇩, gaz
                      🇫🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ 🇹🇯, газ
                      🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gaas 🇪🇪,
                      kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz 🇭🇺, gás
                      🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵,
                      გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, گاز 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/klamar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;klamar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Ancestor:</strong> calamaro 🇮🇹, calmar 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar
                      🇦🇿, kalmari 🇫🇮, calamar 🇪🇸, calamar 🇦🇩, kalmar 🇸🇰,
                      kałamarnica 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇳 MONGOLIAN 🇲🇳
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avtobus_mg.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ᠠᠦ᠋ᠲ᠋ᠣᠪᠦ᠋ᠰ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷, авто́бус 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, awtobus 🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿,
                      buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese
                      🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷,
                      バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/matematika.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ᠮᠠᠲ᠋ᠧᠮᠠᠲ᠋ᠢᠭ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μάθημα"
                      /máthēma/ -- "something that is learned", "lesson",
                      "knowledge", whence the phrase "μαθηματικὴ τέχνη"
                      /mathēmatikḗ tékhnē/ -- "mathematical sciences”, "sciences
                      of matters that have been learned" was derived.
                      Originally, “mathematics” referred to the science of
                      learning in general. Only after the term was used by the
                      "mathematikoi" (<i>i.e.,</i> "those who love to learn"), a
                      group of scholars in Ancient Greece who studied the ideas
                      of Pythagoras, especially those pertaining to arithmetic
                      and geometry, did the term "mathematics" become closely
                      associated with its modern meaning.
                      <div></div>
                      <strong>Ancestor:</strong> математика 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> mathematics 🇬🇧, математика 🇰🇿,
                      matematik 🇹🇷, matematica 🇮🇹, matematika 🇸🇰, Mathematik 🇩🇪,
                      математика 🇰🇬, matematyka 🇵🇱, matematik 🇸🇪, matemáticas
                      🇪🇸, matematik 🇹🇷, mathématiques 🇫🇷, matematika 🇵🇭,
                      matamaitic 🇮🇪, mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chemodan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ᠴᠧᠮᠣᠳᠠᠨ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "جامه‌دان"
                      /jâme-dân/ -- "suitcase", which is itself a combination of
                      "جامه" /jâme/, -- “cloth” and "دان" /dân/ -- "container".
                      Literally, a "чемодан" is a container for storing cloth or
                      clothing, especially one used while travelling.
                      <div></div>
                      <strong>Ancestor:</strong> чемодан 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> шабадан 🇰🇿, çemedan 🇹🇲,
                      čemodāns 🇱🇻, چمدان 🇮🇷, ჩემოდანი 🇬🇪, чамадон 🇹🇯, чемодан 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pshay.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ᠴᠠᠢ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea" and the Ottoman Turkish "چای" /çay/ -- "tea". The
                      drink and its corresponding word made its way into many
                      West and Central Asian languages via land-based trading
                      routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, çay
                      🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭,
                      teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, чай 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇲🇽 NAHUATL (CENTRAL) 🇲🇽
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/xokok.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;xokok (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Classical Nahuatl
                      "xokok" -- "sour". A common theory suggests that the word
                      is the first element in the unattested Classical Nahuatl
                      noun -- "xocoatl" -- "bitter water", whence the Modern
                      English word "chocolate".
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇳🇵 NEPALI 🇳🇵
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kalam_np.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;क़लम"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, possibly
                      via the Ge'ez "ቀለም" /ḳäläm/ -- "reed".
                      <div></div>
                      <strong>Ancestor:</strong> قلم 🇸🇦, क़लम 🇮🇳
                      <div></div>
                      <strong>Cognates:</strong> калем 🇰🇬, कलम 🇳🇵, kalamu 🇹🇿,
                      қалам 🇹🇯, қалам 🇰🇿, কলম 🇧🇩, kalem 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ciya.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;चिया"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲, شَاي 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jungle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;जङ्गल"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert". The word
                      was adopted by British colonists in the Indian
                      subcontinent to refer to any territory that was
                      inhospitable, and then gradually it evolved to denote a
                      place with “tangled thickets”, and then, from there, "any
                      area with lots of vegetation".
                      <div></div>
                      <strong>Cognates:</strong> Dschungel 🇩🇪, джу́нгли 🇷🇺,
                      jungle 🇫🇷, jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪, dżungla 🇵🇱,
                      ջունգլի 🇦🇲, ჯუნგლი 🇬🇪, ジャングル 🇯🇵, džungla 🇸🇮, džùngla
                      🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿, جَن٘گَل 🇮🇷, জঙ্গল 🇧🇩, जङ्गल 🇳🇵, cəngəllik
                      🇦🇿, ځنګل 🇦🇫, ҷангал 🇹🇯, جَنْگَل 🇵🇰, जंगल 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saramontir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;संग्रहालय"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "संग्रह"
                      /saṅgrah/ (which comes from the Sanskrit "संग्रह"
                      /saṃgraha/ -- "the act of collecting or bringing
                      together", via the Hindi "संग्रह" /saṅgraha/ --
                      "collection") and "आलय" /ālaya/ -- "house", "abode" (which
                      comes from the Sanskrit "आलय" /ā-laya/ -- "house",
                      "dwelling", via the Hindi "आलय" /ālay/ -- "place",
                      "home"). Literally, a "संग्रहालय" is “a house/place of
                      collection(s)”.
                      <div></div>
                      <strong>Cognates:</strong> संग्रहालय 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇳🇴 NORWEGIAN 🇳🇴
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/beek.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PtZcAf8r9Ws"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bekk"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "bʰeg-" -- "flowing water", via the Proto-Germanic
                      "*bakiz" -- "brook", "stream".
                      <div></div>
                      <strong>Cognates:</strong> bäck 🇸🇪, beek 🇳🇱, Bach 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bjørn"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*bʰerH-" -- "brown", via the
                      Proto-Germanic "*berô" -- "the brown one", and the Old
                      Norse "bjǫrn" -- "bear". Most scholars believe that early
                      Germanic peoples called the animal “the brown one”, in an
                      effort to avoid calling it by its real name, which, in
                      those superstitious cultures, was considered taboo, and
                      could cause it to appear during a hunt.
                      <div></div>
                      <strong>Related to:</strong> brun (<i>adj.</i>)<div></div>
                      <strong>Cognates:</strong> Bär 🇩🇪, beer 🇳🇱, bjørn 🇩🇰, bear
                      🇬🇧
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong> медве́дь 🇷🇺,
                      niedźwiedź 🇵🇱, lokys 🇱🇹, lācis 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/blume.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;blomst"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Proto-Germanic
                      "*blōmô" -- “flower”, and the Old Norse "blóm" --
                      "flower".
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, fleur 🇫🇷, flor 🇵🇹,
                      flor 🇪🇸, fiore 🇮🇹, flower 🇬🇧, blomst 🇩🇰, Blume 🇸🇪, floare
                      🇷🇴, blomma 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/buss.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;buss"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;familie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Ancestor:</strong> Familie 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> familia 🇪🇸, familja 🇲🇹, family
                      🇬🇧, pamilya 🇵🇭, Familie 🇩🇪, famiglia 🇮🇹, família 🇵🇹,
                      familie 🇷🇴, famille 🇫🇷, familie 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fersken.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fersken"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name.
                      <div></div>
                      <strong>Related to:</strong> Persia
                      <div></div>
                      <strong>Ancestor:</strong> Pfirsich 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, peach 🇬🇧, ferskja 🇮🇸,
                      fersken 🇩🇰, perzik 🇳🇱, persik 🇮🇩, piersică 🇷🇴, pjeshkë 🇦🇱,
                      pichi 🇹🇿, pêssego 🇵🇹, праска 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gass"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, গ্যাস 🇧🇩, gaz
                      🇫🇷, gas 🇬🇧, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ
                      🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gaas
                      🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz 🇭🇺,
                      gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵,
                      გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, گاز 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/god.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gud"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the via the Proto-Germanic
                      "gudą" - "god", "deity" via the Old Norse "goð" -- "god".
                      <div></div>
                      <strong>Cognates:</strong> god 🇳🇱, gud 🇩🇰, gud 🇸🇪, Gott
                      🇩🇪, god 🇬🇧, god 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hundre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hundre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*hundaradą" -- "a large number (usually equal to either
                      100 or 120)", via the Old Norse "hundrað" -- "120". The
                      amount associated with "hundre" was gradually reduced to
                      "100" due to the influence of Christianity, which had
                      introduced the "short hundred" (<i>i.e.</i> "100") during
                      the Middle Ages.
                      <div></div>
                      <strong>Distantly related to:</strong> pro<u>sent</u>
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundra
                      🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад 🇹🇯, εκατό
                      🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto 🇵🇱, сто 🇧🇬,
                      сто 🇷🇺, cent 🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/krig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;krig"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*krīg" –- "strife", "endeavor", "struggle" via the Middle
                      Low German "krîch" -– "battle", "fight", "dispute".
                      <div></div>
                      <strong>Cognates:</strong> Krieg 🇩🇪, krig 🇸🇪, krig 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/like.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;like (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*galīkōną" -- "to be like", "to resemble", via the Old
                      Norse "líka" -- "to please".
                      <div></div>
                      <strong>Cognates:</strong> líka (<i>v.</i>) 🇮🇸, lika (
                      <i>v.</i>) 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/morgen1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;morgen"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*murginaz" – "morning", "tomorrow", via the Old Norse
                      "morginn" -– “morning”.
                      <div></div>
                      <strong>Related to:</strong> morganatisk (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> morning 🇬🇧, morgen 🇳🇱, morgen
                      🇩🇰, morgon 🇸🇪, Morgen 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muskel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", so
                      called because flexed arm muscles look like little mice.
                      <div></div>
                      <strong>Related to:</strong> mus
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, muscle 🇬🇧, muskel 🇩🇰, muskel
                      🇸🇪, мышца 🇷🇺, mišića 🇭🇷, Muskel 🇩🇪
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/natt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;natt"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*nókʷts" -- "night", via the Old Norse "nátt" -- "night".
                      <div></div>
                      <strong>Cognates:</strong> Nuecht 🇱🇺, night 🇬🇧, Nacht 🇩🇪,
                      natt 🇸🇪, nuit 🇫🇷, noche 🇪🇸, noite 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/economy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;økonomi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "οἰκονομία"
                      /oikonomía/ -- "management of a household (a combination
                      of "οἶκος" /oîkos/ -- "house", "dwelling place" and the
                      verb "νέμω" /némō/ -- "to distribute", "to allocate”).
                      Originally, the word denoted the concept of properly
                      allocating and distributing the resources within one's
                      house.
                      <div></div>
                      <strong>Related to:</strong> <u>øko</u>logi
                      <div></div>
                      <strong>Cognates:</strong> economy 🇬🇧, economia 🇵🇹,
                      økonomi 🇩🇰, οικονομία 🇬🇷, economie 🇷🇴, economía 🇪🇸,
                      ekonomi 🇹🇷, экономия, économie 🇫🇷, ეკონომია 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ord.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ord"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say" via the Proto-Germanic
                      "*wurdą" -- "word", "saying", and the Old Norse "orð" --
                      "word", "saying".
                      <div></div>
                      <strong>Cognates:</strong> ord 🇸🇪, woord 🇳🇱, Wuert 🇱🇺,
                      vārds 🇱🇻, word 🇬🇧, woord 🇳🇦, Wort 🇩🇪, word 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pensel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Later Latin "pēnicillum" --
                      "painter's brush", and the Old French "pincel" --
                      "paintbrush".
                      <div></div>
                      <strong>Related to:</strong> penis
                      <div></div>
                      <strong>Ancestor:</strong> Pinsel 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> pincel 🇵🇹, penseel 🇳🇱, pensel
                      🇩🇰, pincel 🇪🇸, pinzell 🇦🇩, pędzel 🇵🇱, пэндзаль 🇧🇾, пензель
                      🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;potet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Taíno "b
                      <u>atata</u>" -- "sweet potato". The word's spelling may
                      also have been influenced by the Quechua "<u>p</u>
                      apa" -- "white potato". Both varieties of potato were
                      brought back to Europe from the Americas.
                      <div></div>
                      <strong>Cognates:</strong> بَطَاطَا 🇸🇦, patates 🇹🇷, batata
                      🇵🇹, potet 🇳🇴, patatas 🇵🇭, potatis 🇸🇪, patata 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      Originally the word was more closely associated with the
                      idea of people letting themselves get carried away in a
                      pleasant activity that allowed them to just relax and have
                      fun.
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, Sport 🇩🇪, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺,
                      ስፖርት 🇪🇹, šport 🇸🇰, spor 🇹🇷, sport 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/svar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VvZv83SW8Bg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;svar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*swarō"
                      -- "solemn statement or affirmation", "oath", "vow", via
                      the Old Norse "svar" -- "answer", "reply".
                      <div></div>
                      <strong>Cognates:</strong> svar 🇸🇪, svar 🇩🇰, svar 🇮🇸, an
                      <u>swer</u>
                      🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ten.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;te"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, Tee 🇩🇪, tee 🇫🇮
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇫🇮, te 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;to"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Germanic "*twai" -- "two" and the
                      Old Norse "tvá" -- "two".
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      two 🇬🇧, dwa 🇵🇱, dó 🇮🇪, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪, два 🇧🇬,
                      երկու 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/varld.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;verden"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*weraldiz" -- "lifetime", "worldly existence", "mankind",
                      which was a combination of "*weraz" -- "man", "husband"
                      and "*alþi" -- "age", "generation, "lifetime". The
                      "verden" therefore denotes the entire period of history
                      during which humans have inhabited the domain of mankind.
                      <div></div>
                      <strong>Related to:</strong> <u>var</u>ulv
                      <div></div>
                      <strong>Cognates:</strong> Welt 🇩🇪, wereld 🇳🇱, verden 🇩🇰,
                      world 🇬🇧, värld 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/window.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vindu"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old Norse "vindauga" (
                      <i>lit</i>. wind + eye) -- "eye (hole) for the wind". A
                      "vindauga" was an unglazed hole in the ceiling of a
                      building in Germanic cultures where smoke from fires could
                      be let out and wind could be let in. 
                      <div></div>
                      <strong>Related to:</strong> vind, øye
                      <div></div>
                      <strong>Cognates:</strong> window 🇬🇧, vindue 🇩🇰, ventana
                      🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇦🇫 PASHTO 🇦🇫
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bas3.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;بس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;دوه"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Iranian "*dwáH" -- "two", and the
                      Middle Iranian "*dwa" -- "two".
                      <div></div>
                      <strong>Cognates:</strong> dwa 🇵🇱, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      two 🇬🇧, to 🇳🇴, dwa 🇵🇱, dó 🇮🇪, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪, два
                      🇧🇬, երկու 🇦🇲, دو 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rang1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;رنګ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*reng-" – "to dye", via the Proto-Iranian "*rang-" – “to
                      colour", “to dye”, and the Classical Persian "رنگ" /rang/
                      –- “color”.
                      <div></div>
                      <strong>Cognates:</strong> renk 🇹🇷, रंग 🇮🇳, rəng 🇦🇿, رنگ
                      🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/spay.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;سپی"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱwṓ" -- "dog, via the Proto-Iranian "*cwā́" -- "dog".
                      <div></div>
                      <strong>Cognates:</strong> سگ 🇮🇷, chien 🇫🇷, cão 🇵🇹, cane
                      🇮🇹
                      <div></div>
                      <strong>Possible Cognates:</strong> сабака 🇧🇾, собака 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇮🇷 PERSIAN 🇮🇷
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              {" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/iklim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;اِقلیم"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west. From Greek, the word developed into the Arabic
                      "إِقْلِيم" /ʔiqlīm/ -- "territory", before evolving into
                      the Modern Persian word.
                      <div></div>
                      <strong>Cognates:</strong> climate 🇺🇸, climat 🇫🇷, klimaat
                      🇳🇱, кли́мат 🇷🇺, κλίμα 🇬🇷, iklim 🇮🇩, iqlim 🇺🇿, ַַאַקְלִים
                      🇮🇱, clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                      <strong>Descendants:</strong> اِقْلِیم 🇵🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ananas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;آناناس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Tupi-Guarani
                      "*nanã" -- "pineapple", via the Old Tupi "naná" --
                      "pineapple".
                      <div></div>
                      <strong>Ancestors:</strong> ananas 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> Ananas 🇩🇪, анана́с 🇷🇺, أَنَانَاس
                      🇸🇦, nanasi 🇹🇿, ананас 🇰🇿, ananāss 🇱🇻, ananas 🇫🇮, ananas
                      🇹🇷, နာနတ် 🇲🇲, ananas 🇩🇰, ananas 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/otobus_pe.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;اتوبوس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪 otobüs 🇹🇷, автобус 🇲🇳, awtobus 🇹🇲, אוֹטוֹבּוּס 🇮🇱, ,
                      авто́бус 🇷🇺, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪,
                      buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴,
                      bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi
                      🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pape.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;پاپ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πάππᾰς"
                      /páppăs/ -- "father".
                      <div></div>
                      <strong>Ancestors:</strong> pape 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> па́па 🇷🇺, papa 🇪🇸, بَابَا 🇸🇦,
                      پاپ 🇮🇷, papa 🇦🇿, պապ 🇦🇲, папа 🇧🇾, papež 🇨🇿, pave 🇩🇰, paavi
                      🇫🇮, პაპი 🇬🇪, Papst 🇩🇪, πάπας 🇬🇷, पोप 🇮🇳, paus 🇮🇩, pápa 🇮🇪,
                      папа 🇰🇿, pāvests 🇱🇻, popiežius 🇱🇹, Poopst 🇱🇺, пап 🇲🇳, papă
                      🇷🇴, papež 🇸🇮, papa 🇹🇿, papa 🇹🇲, پوپ 🇵🇰, pab 🏴󠁧󠁢󠁷󠁬󠁳󠁿 بَابَا 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paridayjah.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;پالیز"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the
                      Proto-Indo-European "*per-" -- "before", "in front" and
                      "*dáyjah" -- "wall" via the Proto-Iranian "*paridayjah" --
                      "walled garden", and the Sogdian "prδyz" /⁠parδēz⁠/ --
                      “fruit garden", "orchard".
                      <div></div>
                      <strong>Related to :</strong> پردیس, دژ, فردوس
                      <div></div>
                      <strong>Cognates:</strong> פַּרְדֵּס 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paridayjah.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;پردیس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the
                      Proto-Indo-European "*per-" -- "before", "in front" and
                      "*dáyjah" -- "wall" via the Proto-Iranian "*paridayjah" --
                      "walled garden".
                      <div></div>
                      <strong>Related to :</strong> پالیز, دژ, فردوس
                      <div></div>
                      <strong>Cognates:</strong> paradise 🇬🇧, paraíso 🇵🇹,
                      paraiso 🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸, paraíso
                      🇪🇸, paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲, גן 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chai1.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;چای"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰
                      <div></div>
                      <strong>Descendants:</strong> çay 🇹🇷, شَاي 🇸🇦, çaý 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chamedan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;چمدان"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "جامه‌دان"
                      /jâme-dân/ -- "suitcase", which is itself a combination of
                      "جامه" /jâme/, -- “cloth” and "دان" /dân/ -- "container",
                      via the Russian "чемодан" /čemodán/ -- "suitcase".
                      <div></div>
                      <strong>Ancestors:</strong> чемодан 🇷🇺
                      <div></div>
                      <strong>Related to:</strong> پی<u>ژامه</u>, جامه
                      <div></div>
                      <strong>Cognates:</strong> шабадан 🇰🇿, çemedan 🇹🇲
                      <div></div>
                      <strong>Descendants:</strong> čemodāns 🇱🇻, ჩემოდანი 🇬🇪,
                      чемодан 🇲🇳, чамадон 🇹🇯, чемодан 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rang.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;رنگ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*reng-" – "to dye", via the Proto-Iranian "*rang-" – “to
                      colour", “to dye”, and the Classical Persian "رنگ" /rang/
                      –- “color”.
                      <div></div>
                      <strong>Cognates:</strong> renk 🇹🇷, رنګ 🇦🇫, रंग 🇮🇳, rəng
                      🇦🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;سیب‌ زمینی"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i> a "calque") from the French
                      "pomme de terre", which was itself calqued in the 15th
                      century from the Latin "malum terrae" -- "apple of the
                      Earth".
                      <div></div>
                      <strong>Semantic Ancestor:</strong> pomme de terre 🇫🇷
                      <div></div>
                      <strong>Semantic Equivalents:</strong> aardappel 🇳🇱,
                      aartappel 🇿🇦, תַּפּוּחַ אֲדָמָה 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sag.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;سگ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱwṓ" -- "dog, via the Proto-Iranian "*cwā́" -- "dog".
                      <div></div>
                      <strong>Cognates:</strong> سپی 🇦🇫, chien 🇫🇷, cão 🇵🇹, cane
                      🇮🇹
                      <div></div>
                      <strong>Possible Cognates:</strong> сабака 🇧🇾, собака 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sheklat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;شکلات"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, チョコレート 🇯🇵, ချောကလက် 🇲🇲, 초콜릿 🇰🇷,
                      چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦, chokola
                      🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;شکر"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel", via the Middle Persian
                      "𐭱𐭪𐭥" /šakar/ -- "sugar".
                      <div></div>
                      <strong>Cognates:</strong> zucchero 🇮🇹, ζάχαρη 🇬🇷, са́хар
                      🇷🇺, sucre 🇫🇷, sugar 🇬🇧, sukker 🇳🇴, azúcar 🇪🇸, cukier 🇵🇱,
                      siúcra 🇮🇪, suiker 🇳🇱, cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬,
                      շաքար 🇦🇲, سُكَّر 🇸🇦, suhkur 🇪🇪, ስኳር 🇪🇹, zahăr 🇷🇴, сахар 🇷🇺
                      цукар 🇧🇾
                      <div></div>
                      <strong>Descendants:</strong> shakar 🇺🇿, şəkər 🇦🇿, şeker
                      🇹🇲, чихэр 🇲🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sadd.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;صد"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Indo-Iranian "*catám" -
                      "100", and the Middle Persian "𐭰𐭲" /čat/ -- "100".
                      <div></div>
                      <strong>Related to:</strong> سده
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, сто 🇷🇺, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/qahva.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;قهوه"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then eventually spread to the
                      Anatolian Peninsula via the Ottoman Turkish "قهوه" /kahve/
                      -- "coffee".
                      <div></div>
                      <strong>Ancestors:</strong> قَهْوَة 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> café 🇫🇷, café 🇪🇸, Kaffee 🇩🇪,
                      ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰,
                      kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦,
                      ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴, کافی 🇵🇰, кофе 🇰🇿,
                      kafe 🇲🇬, 咖啡 🇹🇼, コーヒー 🇯🇵, 咖啡 🇨🇳, 커피 🇰🇷, ກາເຟ 🇱🇦,
                      កាហ្វេ 🇰🇭, кофе 🇲🇳, cà phê 🇻🇳, ကော်ဖီ 🇲🇲, ყავა 🇬🇪, กาแฟ
                      🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, kahawa 🇹🇿, কফি 🇧🇩, ކޮފީ 🇲🇻
                      <div></div>
                      <strong>Descendants:</strong> қаҳва 🇹🇯, قَهْوَه 🇦🇫, क़हवा
                      🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;گاز"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, গ্যাস 🇧🇩, gaz
                      🇫🇷, gas 🇬🇧, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ
                      🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass
                      🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷,
                      ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/myshtsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ماهیچه"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A diminutive of ماهی /mâhi/ --
                      "fish", so literally "little fish".
                      <div></div>
                      <strong>Not related to:</strong> ماه
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong> muscle 🇫🇷,
                      muscolo 🇮🇹, mușchi 🇷🇴, músculo 🇪🇸, músculo 🇵🇹, Muskel 🇩🇪,
                      muskel 🇩🇰, muskel 🇳🇴, muskel 🇸🇪, мышца 🇷🇺, mišića 🇭🇷, ጭዋዳ
                      🇪🇷, عَضَلَة 🇸🇦, մկան 🇦🇲, ماهیچه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;موزه"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)", via the French "musée" -- "museum".
                      <div></div>
                      <strong>Related to:</strong> موسیقی
                      <div></div>
                      <strong>Ancestor:</strong> musée 🇫🇷
                      <div></div>
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      Museum 🇩🇪, музе́й 🇧🇾, muzeum 🇦🇱, muzej 🇸🇮, muzejs 🇱🇻,
                      muzeum 🇨🇿, muuseum 🇪🇪, múzeum 🇭🇺, מוּזֵיאוֹן 🇮🇱, muzeý 🇹🇲,
                      музе́й 🇷🇺, muzium 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nam.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;نام"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₁nómn̥" -- "name", via the Old Persian adverb "𐎴𐎠𐎶"
                      /⁠nāma⁠/ -- "named", "called".
                      <div></div>
                      <strong>Cognates:</strong> name 🇬🇧, naam 🇳🇱, nome 🇵🇹, navn
                      🇩🇰, نوم 🇦🇫, Name 🇩🇪, nombre 🇪🇸, nom 🇫🇷, όνομα 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/naranj.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;نارنج"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", and the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange".
                      <div></div>
                      <strong>Cognates:</strong> orange 🇬🇧, arancia 🇮🇹, orange
                      🇬🇧, naranja 🇪🇸, naranča 🇭🇷, नारंगी 🇮🇳. laranja 🇵🇹, наранча
                      🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇵🇱 POLISH 🇵🇱
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_pl.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇦🇱, autobus
                      🇮🇹, авто́бус 🇷🇺, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas
                      🇱🇹, ავტობუსი 🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus
                      🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cmentarz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cmentarz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "κοιμητήριον"
                      /koimētḗrĭon/ -- "place to sleep", "dormitory", via the
                      Medieval Latin "cimiterium" -- "cemetery", "burial
                      ground", and the Old Polish "cmyntarz" -- "cemetery".
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cimitir 🇷🇴, cemitério 🇵🇹, cementerio 🇪🇸, sementeryo 🇵🇭,
                      cimetière 🇫🇷, cemetery 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> цвинтар 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/two.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dwa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*dwóh₁"
                      -- "two", via the Proto-Italic "*duō" -- "two" and the
                      Latin "duōs" -- "two", via the Proto-Balto-Slavic "*duwōˀ"
                      -- "two" and the Proto-Slavic "*dъ̏va" -- "two".
                      <div></div>
                      <strong>Cognates:</strong> دوه 🇦🇫, δύο 🇬🇷, दो 🇮🇳, два 🇷🇺,
                      two 🇬🇧, to 🇳🇴, dwa 🇵🇱, dó 🇮🇪, twee 🇳🇱, du 🇱🇹, zwei 🇩🇪, два
                      🇧🇬, երկու 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/divan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dywan"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "دیوان" /dēwān/
                      -- "Council of State (which was held in a room with
                      cushioned seating along the walls), via the Ottoman
                      Turkish "دیوان" /dîvân/ -- "cushioned bench", "couch". In
                      Polish, the word focuses on the surface of the "دیوان",
                      whereas in other European languages that also borrowed the
                      word from Turkish and Persian, the word focuses on the
                      object itself (<i>e.g.</i>, диван 🇷🇺, and diván 🇪🇸)
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gaz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gaz 🇫🇷
                      <div></div>
                      <strong>Related to :</strong> chaos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇦🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ 🇹🇯, газ
                      🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass 🇳🇴, gaas
                      🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz 🇭🇺,
                      gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵,
                      გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/herbata.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;herbata"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "herba thea" --
                      "'tea' herb". The first element is from the Latin "herba"
                      -- "grass", "herb". The second element is derived from the
                      Proto-Sino-Tibetan "*s-la" -- "leaf", via the Hokkien
                      Chinese "茶" /tê/ -- "tea". The drink and its
                      corresponding word was discovered by Dutch traders in the
                      early 17th century. The word made its way by sea to Europe
                      via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇪🇪
                      <div></div>
                      <strong>Descendant:</strong> arbata 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hipoteka"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Ancestor:</strong> Hypothek 🇩🇪
                      <div></div>
                      <strong>Related to:</strong> teza, biblioteka
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, hipoteca 🇵🇹,
                      hipoteca 🇸🇮, ipotek 🇹🇷, hipoteka 🇸🇮, ипотека 🇰🇿, ипотека
                      🇰🇬, hypothèque 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dinde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;indyk"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Ἰνδῐ́ᾱ"
                      /Indĭ́ā/ -- "India", via the Ancient Greek, "ἰνδικός" -
                      /indikós/ -- "from India" and, from there, the Latin
                      "indicus" -- "from India". The name derives from the
                      mistaken idea that turkeys come from the Indian
                      Subcontinent.
                      <div></div>
                      <strong>Cognates:</strong> индюк 🇷🇺, dinde 🇬🇧, hindi 🇹🇷
                      <div></div>
                      <strong>Partial semantic equivalents:</strong> kalkoen 🇳🇱,
                      kalakùtas 🇱🇹, kalkon 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zavtrak.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jutro"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic noun
                      "*(j)utro" -- "morning", "dawn", via the Old Polish noun
                      "jutro" -- "morning". Over time "jutro" also came to mean
                      not just "the morning (of the coming day)", but also "the
                      entire day after today" (it also began to be used as an
                      adverb).
                      <div></div>
                      <strong>Related to:</strong> aura
                      <div></div>
                      <strong>Cognates:</strong> за́<u>ўтра</u> 🇧🇾, у́тре 🇧🇬, у́тре
                      🇲🇰, z<u>ítra</u> 🇨🇿, за<u>втра</u> 🇷🇺
                      <div></div>
                      <strong>Semantic Equivalents:</strong> mañana 🇪🇸, morgen
                      🇩🇪, 明日 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kalamarnica.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kałamarnica"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Ancestor:</strong> calamaro 🇮🇹, calmar 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar
                      🇦🇿, кальма́р 🇷🇺, klamar 🇲🇹, kalmari 🇫🇮, calamar 🇪🇸, calamar
                      🇦🇩, kalmar 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nightmare.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;koszmar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin verb
                      "calcāre" -- "to trample", "to tread on", (via the Old
                      French "chauchier" -- "to press") and the Frankish "*marā"
                      -- "an evil spirit who sits on your chest while you sleep
                      and tries to suffocate you".
                      <div></div>
                      <strong>Ancestor:</strong>
                      cauchemar 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> night<u>mare</u> 🇬🇧, <u>mar</u>
                      dröm 🇸🇪, <u>mar</u>tröð 🇮🇸, <u>mare</u>ritt 🇳🇴, кошма́р 🇷🇺,
                      coșmar 🇷🇴, კოშმარი 🇬🇪, košmaras 🇱🇹
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, incubo
                      🇮🇹, كابوس 🇸🇦, painajainen 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/korova.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;krowa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Proto-Slavic "*kòrva"
                      -- "cow".
                      <div></div>
                      <strong>Related to:</strong> шершень
                      <div></div>
                      <strong>Cognates:</strong> крава 🇲🇰, корова 🇺🇦, крава 🇧🇬,
                      корова 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/elbow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;łokieć"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*Heh₃l-" -- "forearm" via the Proto-Slavic "*ȍlkъtь" --
                      "elbow".
                      <div></div>
                      <strong>Cognates:</strong> elbow 🇬🇧, elleboog 🇳🇱, albue
                      🇩🇰, albue 🇳🇴, Ellenbogen 🇩🇪, локоть 🇷🇺, elmboog 🇿🇦, ло́каць
                      🇧🇾, ла́кът 🇧🇬, lakeť 🇸🇰, лі́коть 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/moneta.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;moneta"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "monēta" -- "place
                      for coining money".
                      <div></div>
                      <strong>Related to:</strong> mennica
                      <div></div>
                      <strong>Cognates:</strong> monnaie 🇫🇷, moeda 🇵🇹, Münze 🇩🇪,
                      mynt 🇮🇸, moneda 🇪🇸, monēta 🇱🇻
                      <div></div>
                      <strong>Descendants:</strong> монета 🇷🇺, moneta 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/medved.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;niedźwiedź"
                  hoverText={
                    <span>
                      <strong> Origin:</strong> From the Proto-Slavic "*medvě̀dь"
                      -- "honey eater" (a combination of "*medъ" -- "honey" and
                      "*(j)ěsti" -- "to eat”) via the Old Polish "niedźwiedź" --
                      "bear". Most scholars believe that early Slavic peoples
                      called the animal “the honey eater", in an effort to avoid
                      calling it by its real name, which, in those superstitious
                      cultures, was considered taboo, and could cause it to
                      appear during a hunt.
                      <div></div>
                      <strong>Related to:</strong> jeść (v.), miód
                      <div></div>
                      <strong>Cognates:</strong> мядзве́дзь 🇧🇾, medvěd 🇨🇿, medve
                      🇭🇺, ведмідь 🇺🇦, medved 🇸🇮, медвед 🇷🇸, медведь 🇷🇺
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong>
                      lokys 🇱🇹, lācis 🇱🇻, bear 🇬🇧, Bär 🇩🇪, bjørn 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/essig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ocet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ak-" -- "sharp", via the Latin "acētum" -- "vinegar",
                      and the Proto-Slavic "*ocьtъ" -- "vinegar".
                      <div></div>
                      <strong>Cognates:</strong> vin<u>agre</u> 🇪🇸, vin
                      <u>aigre</u> 🇫🇷, vin<u>agre</u> 🇵🇹, aceto 🇮🇹, oțet 🇷🇴,
                      azijn 🇳🇱, Essig 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/window.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;okno"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*h₃ekʷ"
                      -- "eye" via the Proto-Slavic "okъnò" -- "window".
                      <div></div>
                      <strong>Related to:</strong> oko
                      <div></div>
                      <strong>Cognates:</strong> okno 🇨🇿, wind<u>ow</u> 🇬🇧, vind
                      <u>u</u> 🇳🇴, акно 🇧🇾, okno 🇸🇮, oкно 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paper.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;papier"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πᾰ́πῡρος"
                      /pắpūros/ -- "the papyrus plant", via the Latin "papȳrus"
                      -- "paper made from papyrus". Although related
                      etymologically, "Papier" and "papirus" are made from
                      different materials and use different production methods.
                      <div></div>
                      <strong>Related to:</strong> papieros
                      <div></div>
                      <strong>Cognates:</strong> papel 🇪🇸, paper 🇬🇧, papel 🇵🇹,
                      papier 🇫🇷, papier 🇳🇱, papper 🇸🇪, paperi 🇫🇮, paper 🇬🇧,
                      papur 🏴󠁧󠁢󠁷󠁬󠁳󠁿, папі́р 🇺🇦
                      <div></div>
                      <strong>Descendants:</strong> папера 🇧🇾, popierius 🇱🇹,
                      papīrs 🇱🇻,
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parasolka"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the Ancient
                      Greek suffix "πᾰρᾰ-" /pără-/ -- "contrary to" (via the
                      Italian "para-" -- "guarding against") and the Latin "sol"
                      -- "sun".
                      <div></div>
                      <strong>Ancestor:</strong> parasol 🇫🇷, parasole 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> parasol 🇵🇹, parasol 🇩🇰, parasol
                      🇵🇱, парасо́лька 🇺🇦
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      slunečník 🇨🇿, napernyő 🇭🇺, saulessargs 🇱🇻, 阳伞 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pędzel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Later Latin "pēnicillum" --
                      "painter's brush", and the Old French "pincel" --
                      "paintbrush".
                      <div></div>
                      <strong>Related to:</strong> penis
                      <div></div>
                      <strong>Cognates:</strong> pincel 🇵🇹, penseel 🇳🇱, pensel
                      🇳🇴, pensel 🇩🇰, Pinsel 🇩🇪, pincel 🇪🇸, pinzell 🇦🇩
                      <div></div>
                      <strong>Descendants:</strong> пэндзаль 🇧🇾, пензель 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pomidor2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pomidor"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the plural "pomi d'oro" of
                      the Italian "pomo d'oro" -- "golden apple".
                      <div></div>
                      <strong>Ancestors:</strong> pomodoro 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> pomidoras 🇱🇹, بَنْدُورَة 🇸🇾,
                      помідор 🇺🇦, pomidor 🇦🇿, памідор 🇧🇾, помидор 🇰🇬, помидор
                      🇹🇯, pomidor 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/robic.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;robić (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Proto-Slavic "*orbota" -- "work", "labor", and the Old
                      Polish verb "robić" -- "to do", "to make".
                      <div></div>
                      <strong>Related to:</strong> robota, robot
                      <div></div>
                      <strong>Cognates:</strong> robiť 🇸🇰, рабіць 🇧🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      Originally the word was more closely associated with the
                      idea of people letting themselves get carried away in a
                      pleasant activity that allowed them to just relax and have
                      fun.
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, Sport 🇩🇪, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺,
                      ስፖርት 🇪🇹, šport 🇸🇰, spor 🇹🇷, sport 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/stop.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sto"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Slavic "*sъ̏to" - "100"
                      <div></div>
                      <strong>Related to:</strong> pro<u>cent</u>
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, сто
                      🇧🇬, сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/teller.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/wmGJL-ZCpv4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;talerz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tālea" -- "a
                      slender stick", "rod", via the Old French "tailloir" --
                      "plate", "board for cutting food".
                      <div></div>
                      <strong>Cognates:</strong> Teller 🇩🇪, tallerken 🇩🇰,
                      tallerken 🇳🇴
                      <div></div>
                      <strong>Descendants:</strong> таре́лка 🇷🇺, тарілка 🇺🇦,
                      тале́рка 🇧🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tlumacz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/j2E_-Jyl6AM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tłumacz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*tilmač"
                      -- "an intermediary in communication between two parties
                      using different languages".
                      <div></div>
                      <strong>Ancestor:</strong> dilmaç 🇹🇷
                      <div></div>
                      <strong>Cognates:</strong> tolmács 🇭🇺, Dolmetscher 🇩🇪,
                      tolmač 🇸🇮, tlmočník 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/wakat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;wakat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Latin verb "vacō" (and its third-person singular present
                      active form "vacat")-- "to be free", "to be empty".
                      <div></div>
                      <strong>Cognates:</strong> vacance 🇫🇷, vacancia 🇪🇸, vaga
                      🇮🇹, vakature 🇳🇱, ვაკანსია 🇬🇪, вака́нсія 🇺🇦, vacancy 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/verblyud.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;wielbłąd"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek genitive
                      noun "ἐλέφαντος" /eléphăntos/ -- "(pertaining to) ivory",
                      via the Latin "elephantus" -- "elephant", via the Gothic
                      "𐌿𐌻𐌱𐌰𐌽𐌳𐌿𐍃" /ulbandus/ -- "camel", and the Proto-Slavic
                      "*velьb(l)ǫdъ" -- "camel". Neither camels nor elephants
                      are native to Europe, and Europeans traditionally,
                      considered those animals pretty exotic, without always
                      being able to differentiate which one is which, which is
                      why over time some Europeans confused both animals and
                      some, like many Slavic language speakers, took a variation
                      of “elephas” to denote “camel”, whereas others, like
                      Romance and Germanic ones, took it to denote their word
                      for “elephant”.
                      <div></div>
                      <strong>Cognates:</strong> velbloud 🇨🇿, верблюд 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇵🇹 PORTUGUESE 🇵🇹
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;açúcar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel", via the Middle Persian
                      "𐭱𐭪𐭥" /šakar/ -- "sugar", and the Arabic "السُّكَّر"
                      /as-sukkar/ -- "sugar".
                      <div></div>
                      <strong>Ancestor:</strong> شکر 🇮🇷, سُكَّر 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> zucchero 🇮🇹, ζάχαρη 🇬🇷, са́хар
                      🇷🇺, sucre 🇫🇷, sugar 🇬🇧, sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪,
                      suiker 🇳🇱, cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲,
                      suhkur 🇪🇪, ስኳር 🇪🇹, azúcar 🇪🇸
                      <div></div>
                      <strong>Descendants:</strong> suku 🇨🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adolescent.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;adolescente"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "alescere" --
                      "to be nourished", "to grow up", via the Latin verb
                      "adolēscere" -- "to grow up", "to come to maturity", "to
                      ripen" and its present participle "adolescens" -- "growing
                      up", "maturing", "becoming an adult".
                      <div></div>
                      <strong>Related to:</strong> adulto, <u>alu</u>no,
                      alimento
                      <div></div>
                      <strong>Cognates:</strong> adolescent 🇬🇧, adolescent 🇫🇷,
                      adolescente 🇪🇸, adolescent 🇷🇴, adolescent 🇦🇩, adolescente
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/alumnus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;alimento"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "alimentum" --
                      "food", "nourishment", which itself is a combination of
                      the verb "alō" -- "to nourish" and the suffix "-mentum" --
                      "instrument", "medium", so literally an "alimento" is "a
                      medium of nourishment"
                      <div></div>
                      <strong>Related to:</strong> adulto, aluno, adolescente
                      <div></div>
                      <strong>Cognates:</strong> aliment 🇫🇷, alimento 🇪🇸,
                      alimento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/amigo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;amigo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "amō" -- "I
                      love" via the adjective "amīcus" -- "friendly," "pleasant
                      to be around", and the Old Galician-Portuguese "amigo" --
                      "friend".
                      <div></div>
                      <strong>Related to:</strong> in<u>imigo</u>
                      <div></div>
                      <strong>Cognates:</strong> ami 🇫🇷, amigo 🇪🇸, amico 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/assassin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zSk51b0WVHw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;assassino"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "أَسَاسِيِّين"
                      /ʔasāsiyyīn/ (the name for members of a fundamentalist
                      order in Shia Islam who made it their mission to protect
                      the Muslim faith in the Levant and Persia during the
                      Crusader Era). The word is traditionally thought to derive
                      from "حَشَّاشِين" /ḥaššāšīn/ -- "hashish users", as
                      members of the order were presumed (primarily by their
                      enemies) to be heavy users of hashish. It is, however,
                      more likely derived from "أَسَاس" /ʔasās/ -- “foundation",
                      "basis”.
                      <div></div>
                      <strong>Cognates:</strong> assassin 🇫🇷, assassin 🇬🇧,
                      asesino 🇪🇸, assassino 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/aviso.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aviso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin prefix
                      "ad-" -- "to", "in", and the passive participle "vīsus" --
                      "having been seen" of the verb "videō" -- "to see". The
                      combination was the basis of the latter part of the Old
                      French phrase "ce m'est a vis" – “it is my view”, which
                      eventually developed into the single word "avis" --
                      "opinion", and, from there, the Old Galician-Portuguese
                      "avisar" -- "to look at", "to consider".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dente</u>, pru
                      <u>dente</u> (<i>adj</i>.), visto, in<u>veja</u>, video,
                      aviso
                      <div></div>
                      <strong>Cognates:</strong> aviso 🇪🇸, avviso 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/abuelo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hW6xrMIwfhI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avô"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "avus" -- "adult
                      male relative (other than one's father)", via the Vulgar
                      Latin "*av(i)olus" -- "grandfather", and the Old
                      Galician-Portuguese "avoo" -- "grandfather".
                      <div></div>
                      <strong>Cognates:</strong> abuelo 🇪🇸, aïeul 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;batata"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Taíno "batata" -- "sweet
                      potato".
                      <div></div>
                      <strong>Ancestor:</strong> batata 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> بَطَاطَا 🇸🇦, patates 🇹🇷, potet
                      🇳🇴, patatas 🇵🇭, potatis 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chameau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;camelo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel", via the Ancient Greek "κᾰ́μηλος" /kắmēlos/ --
                      "camel", and the Latin "camēlus" -- "camel".
                      <div></div>
                      <strong>Cognates:</strong> ޖަމަލު 🇲🇻, جَمَل 🇸🇦, ግመል 🇪🇹,
                      גמל 🇮🇱, ngamia 🇹🇿, Kamel 🇩🇪, camel 🇬🇧, cammello 🇮🇹,
                      camello 🇪🇸, chameau 🇫🇷, kamel 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cano_pr.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cano"
                  hoverText={
                    <span>
                      <div>
                        <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/
                        -- "reed", via the Ancient Greek "κάννα" /kánna/ --
                        “reed”, the Latin "canna" -- "reed", and "caña" --
                        "reed", and the Old-Galician Portuguese "cana" -- "cane"
                        -- "reed".
                      </div>
                      <div>
                        <strong>Related to:</strong> canhão, cânion, canal, cana
                      </div>
                      <div>
                        <strong>Cognates:</strong> caño 🇪🇸
                      </div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cao.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9YJzi3P2Wto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cão"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "canis" -- "dog"
                      via the Old Galician-Portuguese "can" -- "dog".
                      <div></div>
                      <strong>Related to:</strong> canalha
                      <div></div>
                      <strong>Cognates:</strong> chien 🇫🇷, cane 🇮🇹, سگ 🇮🇷, سپۍ
                      🇦🇫, Hund 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/crimson.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;carmesim"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-Iranian noun
                      "*kŕ̥miš" -- "worm", via the Persian "کِرمِست" /kêrmêst/ --
                      "worm". The word comes from the crimson dye produced by a
                      worm-like insect called "kermes".
                      <div></div>
                      <strong>Ancestors:</strong> قِرْمِزِيّ 🇸🇦 (adj.)
                      <div></div>
                      <strong>Cognates:</strong> cramoisi 🇫🇷, cremisi 🇮🇹,
                      carmesim 🇵🇹, क़िरमिज़ी 🇮🇳, karmosin 🇸🇪, kırmızı 🇹🇷,
                      червоний 🇺🇦, czerwony 🇵🇱, червен 🇧🇬, црвен 🇲🇰, červený 🇸🇰,
                      чырво́ны 🇧🇾, crimson 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cedula.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cédula"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "σχέδη"
                      /skhédē/ -- “papyrus leaf” via the Latin "schedula" --
                      "strip of paper made out of 'skhede'.
                      <div></div>
                      <strong>Cognates:</strong> cédula 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cem.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cem"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Italic "*kentom" --
                      "100", and the Latin "centum" -- "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cien 🇪🇸, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cementerio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cemitério"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "κοιμητήριον"
                      /koimētḗrĭon/ -- "place to sleep", "dormitory".
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cimitir 🇷🇴, cementerio 🇪🇸, cmentarz 🇵🇱, sementeryo 🇵🇭,
                      cimetière 🇫🇷, cemetery 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cha.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chá"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, tè 🇮🇹, tee 🇫🇮,
                      te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶
                      🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩,
                      té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, çay 🇹🇷, شَاي 🇸🇦, çaý 🇹🇲,
                      čaj 🇨🇿, çaj 🇦🇱, چای 🇮🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ciencia.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/DJ-ABPy6Udw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ciência"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "sciō" -- "to
                      know", and its present participle "sciēns".
                      <div></div>
                      <strong>Related to:</strong> con
                      <u>sciência</u>
                      <div></div>
                      <strong>Cognates:</strong> science 🇫🇷, ciencia 🇪🇸, science
                      🇬🇧, sayansi 🇹🇿, sains 🇲🇾, scienza 🇮🇹, știință 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/codo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cotovelo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cubō" -- "to
                      lie down", "to recline" and its descendant, the noun
                      "cubitum" which denoted the length from the edge of the
                      forearm (<i>i.e.</i>, the elbow) to the tip of the
                      outstretched hand. From there, the word entered modern
                      Portuguese via the Old Galician-Portuguese "*covetelo" --
                      "elbow".
                      <div></div>
                      <strong>Cognates:</strong> coude 🇫🇷, gomito 🇮🇹, codo 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/estar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sJgO6bNR7x4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;distância"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the present participle of
                      the Latin verb "distō" -- "to stand apart", "to be
                      distant" (itself a combination of the prefix "dis-" --
                      "apart" "in two" and the verb "stō" -- "to stand"). The
                      concept comes from the idea that when people argue,
                      they’re not on the same page (or really, in the same
                      place). Therefore, they stand apart, and there is
                      "distance" between them.
                      <div></div>
                      <strong>Related to:</strong> estar (<i>v</i>.)
                      <div></div>
                      <strong>Cognates:</strong> distancia 🇪🇸, distance 🇬🇧,
                      distance 🇫🇷, distanță 🇷🇴, distanza 🇮🇹
                      <div></div>
                      <strong>Semantic equivalents:</strong> afstand 🇩🇰, avstånd
                      🇸🇪, afstand 🇳🇱
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/izquierda.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;esquerda"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Basque "ezkerra" (the
                      absolutive singular form of the adjective "ezker" --
                      "left", which itself is possibly derived from the noun
                      "esku" -- "hand", and the adjective "oker" -- "wrong").
                      The historical meaning is based on the popular notion in
                      earlier centuries that the left hand was weaker and less
                      dexterous than the right hand.
                      <div></div>
                      <strong>Cognates:</strong> izquierda 🇪🇸
                      <div></div>
                      <strong>Possible semantic equivalents:</strong> gauche 🇫🇷,
                      sinistro 🇮🇹, ле́вый 🇷🇺, 왼쪽 🇰🇷, kreiss 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/squirrel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/TN89d3tM1aY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;esquilo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Ancient Greek
                      "σκίουρος" /skíouros/ -- “shadow-tail”, via the Latin
                      "sciurus" -- "squirrel". So called because presumably an
                      "esquilo" makes shade with its own tail.
                      <div></div>
                      <strong>Cognates:</strong> écureuil 🇫🇷, squirrel 🇬🇧,
                      սկյուռ 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/estar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sJgO6bNR7x4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;estar (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "stō" -- "to
                      stand", via the Old Galician-Portuguese verb "estar" --
                      "to stand", "to be".
                      <div></div>
                      <strong>Related to:</strong> estação, distância
                      <div></div>
                      <strong>Cognates:</strong> estar 🇪🇸, stare 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/star.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Gt0B3coiu7s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;estrela"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂stḗr" -- “star” via Proto-Italic "*stērlā" -- "star",
                      via the Latin "stēlla" -- "star", and the Old
                      Galician-Portuguese "estrela" -- "star".
                      <div></div>
                      <strong>Cognates:</strong> star 🇬🇧, Stern 🇩🇪, αστέρι 🇬🇷,
                      étoile 🇫🇷, estrella 🇪🇸, stjerne 🇩🇰, stjärna 🇸🇪, stella 🇮🇹,
                      stea 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;família"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Cognates:</strong> family 🇬🇧, familja 🇲🇹, famille
                      🇫🇷, familie 🇩🇰, familie 🇳🇴, Familie 🇩🇪, famiglia 🇮🇹,
                      familia 🇪🇸, familie 🇷🇴, pamilya 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/flor.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;flor"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Latin "flōs" (and
                      its accusative form "flōrem") –- “flower”, “blossom”, and
                      the Old Galician-Portuguese "flor" -– "flower".
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, fleur 🇫🇷, flor 🇪🇸,
                      fiore 🇮🇹, flower 🇬🇧, blomst 🇳🇴, blomst 🇩🇰, blomma 🇸🇪,
                      Blume 🇩🇪, floare 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/framboesa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;framboesa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West-Germanic
                      "brāmabaʀi" -- "blackberry" (which itself is a combination
                      of "*brāma" -- "bramble", "thorn bush", and "*baʀi" –
                      "berry"), via the Frankish "*brāmabasi" -– "blackberry",
                      and the Old French "framboise" -- "raspberry". The initial
                      "br-" and final "re" evolved into "fr" and "-sa",
                      respectively, via dissimilation and likely due to the
                      influence of the similar sounding French noun "fraise".
                      <div></div>
                      <strong>Ancestor:</strong> framboise 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> Him<u>beere</u> 🇩🇪, Rasp
                      <u>berry</u> 🇬🇧, rasi<u>beri</u> 🇹🇿, framboos 🇳🇱, bringe
                      <u>bær</u> 🇳🇴, frambuesa 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaiola.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gaiola"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", via the Late Latin noun "caveola –- “little
                      cage".
                      <div></div>
                      <strong>Related to:</strong> caverna, cavidade
                      <div></div>
                      <strong>Cognates:</strong> Käfig 🇩🇪, kooi 🇳🇱, gabbia 🇮🇹,
                      cave 🇬🇧, cage 🇫🇷, jaula 🇪🇸, Käfeg 🇱🇺, kou 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gás"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to:</strong> caos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gas 🇪🇸, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gozo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gozo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "gaudium" --
                      "joy".
                      <div></div>
                      <strong>Possibly related to:</strong> joia
                      <div></div>
                      <strong>Cognates:</strong> gozo 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gravity.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;grávida (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "gravis"
                      -- "heavy", via the noun "gravidus" -- "pregnant".
                      <div></div>
                      <strong>Related to:</strong> grave, gravidade
                      <div></div>
                      <strong>Cognates:</strong> gravid 🇩🇰, gravid 🇳🇴, gravid
                      🇸🇪, gravidă 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guerra_pr.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;guerra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*werru" –- "confusion", "disorder", via the Frankish
                      "*werru" –- "confusion", "disorder", the Medieval Latin
                      "werra" -- "war", "strife", and the Old-Galician
                      Portuguese "guerra" -– "armed conflict", “war”.
                      <div></div>
                      <strong>Cognates:</strong> war 🇬🇧, guerra 🇮🇹, guerra 🇪🇸,
                      guerre 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/helice.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hélice"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "ἕλιξ" /hélix/
                      -- “spiral”.
                      <div></div>
                      <strong>Related to:</strong> <u>helic</u>óptero
                      <div></div>
                      <strong>Cognates:</strong> hélice 🇪🇸, hélice 🇫🇷, elica 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hipoteca"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Related to:</strong> biblio<u>teca</u>, tese
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, ipotek 🇹🇷,
                      hipoteca 🇪🇸, hypothèque 🇫🇷, hipoteka 🇵🇱, hipoteka 🇸🇮,
                      ипотека 🇰🇿, Hypothek 🇩🇪, ипотека 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/humano.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;humano"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "hominem" (which
                      is likely a derivative of the noun "homō̆" -- "human
                      being"), via the adjective "hūmānus" -- "human", and Old
                      Galician-Portuguese "humano" -- "human".
                      <div></div>
                      <strong>Likely related to:</strong> <u>homo</u>sexual,
                      homem
                      <div></div>
                      <strong>Cognates:</strong> human 🇬🇧, humain 🇫🇷, humano 🇬🇧,
                      umano 🇮🇹, humà 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idioma.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idioma"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδίωμα" /idíōma/ -- "a peculiarity", "a property", "a
                      peculiar phraseology", "idiom".
                      <div></div>
                      <strong>Related to:</strong> idiota
                      <div></div>
                      <strong>Cognates:</strong> idioma 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiota.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idiota"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”, and the
                      Latin "idiōta" -- "uneducated or illiterate person". Like
                      the Greeks before them, the Romans used the word to refer
                      to someone lacking any professional skills, but they
                      placed emphasis on the fact that an “idiota” lacked
                      education and was therefore ignorant.
                      <div></div>
                      <strong>Related to:</strong> idioma
                      <div></div>
                      <strong>Cognates:</strong> Idiot 🇩🇪, идиот 🇲🇰, идиот 🇷🇺,
                      идиот 🇧🇬, idiot 🇬🇧, idiota 🇪🇸, idiota 🇵🇱, idiot 🇫🇷,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/enemigo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;inimigo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "inimīcus" (
                      <i>i.e.</i>, "in-" -- “not” + "amīcus" - “friend”) via the
                      Old Galician-Portuguese "ẽemigo" -- "enemy".
                      <div></div>
                      <strong>Related to:</strong> amigo
                      <div></div>
                      <strong>Cognates:</strong> enemy 🇬🇧, ennemi 🇫🇷, enemigo
                      🇪🇸, inamic 🇷🇴, nemico 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/juego.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jogo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "iocus" -- "joke",
                      "amusement", "pastime", "sport".
                      <div></div>
                      <strong>Cognates:</strong> jeu 🇫🇷, juego 🇪🇸, gioco 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/joy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;joia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Latin "gaudium"
                      -- "joy", via the Old French "joyau" -- "jewel".
                      <div></div>
                      <strong>Possibly related to:</strong> gozo
                      <div></div>
                      <strong>Cognates:</strong> joya 🇪🇸, Juwel 🇩🇪, juweel 🇳🇱,
                      juvel 🇩🇰, juvel 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/laranja.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;laranja"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", via the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange", the Arabic "نارنج"
                      /nāranj/ –- “bitter orange”, and the Old
                      Galician-Portuguese "laranja" -- "orange". <div></div>
                      <strong>Cognates:</strong> orange 🇬🇧, arancia 🇮🇹, orange
                      🇬🇧, naranja 🇪🇸, на̀ра̄нча 🇷🇸, naranča 🇭🇷, نارَنْج 🇮🇷, नारंगी
                      🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lVpHk6bQL_I"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;ler (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*leǵ-" -- "to gather", "to collect", via the Proto-Italic
                      "*legō" -- "to gather", "to collect" and the Latin
                      "legere" -- "to read".
                      <div></div>
                      <strong>Related to:</strong> inte<u>li</u>gencia, inte
                      <u>lect</u>ual
                      <div></div>
                      <strong>Cognates:</strong> lire 🇫🇷, leer 🇪🇸, leggere 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/maior.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ga15HCmlzig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;maior (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "maior" (a
                      comparative of the adjective "magnus" -- "great", "large",
                      "noble", "important").
                      <div></div>
                      <strong>Cognates:</strong> major 🇬🇧, mayor 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mano.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7fe2-UxXMI8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mão"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*manus" --
                      "hand", via the Latin "manus" -- "hand".
                      <div></div>
                      <strong>Related to:</strong> <u>man</u>obra, <u>man</u>
                      ipulação
                      <div></div>
                      <strong>Cognates:</strong> main 🇫🇷, mano 🇪🇸, mano 🇮🇹, mână
                      🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/miracle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;milagre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", via the Latin
                      "mīrāculum" -- "something marveled at", and the Old
                      Galician-Portuguese "miragre".
                      <div></div>
                      <strong>Related to:</strong> admirar (<i>v.</i>), miragem
                      <div></div>
                      <strong>Cognates:</strong> miracle 🇫🇷, milagro 🇪🇸, miracol
                      🇷🇴, miracolo 🇮🇹, milagro 🇵🇭, miracle 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mirar1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;mirar (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", via the Old
                      Galician-Portuguese "mirar" -- "to look at".
                      <div></div>
                      <strong>Related to:</strong> milagre, ad<u>mirar</u>
                      <div></div>
                      <strong>Cognates:</strong> mirare 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mortgage.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;mortal (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "mortuus"-- "dead"
                      (a perfect active participle of the verb "morior" -- "to
                      die").
                      <div></div>
                      <strong>Cognates:</strong> mortel 🇫🇷, mortal 🇵🇹, mortal
                      🇪🇸, <u>mirst</u>īgs 🇱🇻, մահկանացու 🇦🇲, mirtingasis 🇱🇹,
                      сме́ртный 🇷🇺, mortale 🇮🇹, смртан 🇷🇸, mortal 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muerte.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;morte"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "mortuus"-- "dead"
                      (a perfect active participle of the verb "morior" -- "to
                      die").
                      <div></div>
                      <strong>Cognates:</strong> mort 🇫🇷, muerte 🇪🇸, մահ 🇦🇲,
                      mirtis 🇱🇹, смерть 🇷🇺, morte 🇮🇹, марг 🇹🇯
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/map.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mundo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Etruscan "𐌌𐌖𐌈"
                      /muθ/ -- “pit", "underworld", which may be the ancestor of
                      the Latin adjective (and, later, noun) "mundus" --
                      "clean", "pure", "neat", "order", "world". Eventually,
                      "mundus" evolved into the Old Galician-Portuguese "mundo"
                      -- "world".
                      <div></div>
                      <strong>Cognates:</strong> monde 🇫🇷, mundo 🇪🇸, món 🇦🇩,
                      mondo 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;música"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)" via the Latin "mūsica" --
                      "music".
                      <div></div>
                      <strong>Related to:</strong> museu, musa
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, music 🇬🇧, مُوسِيقَى
                      🇸🇦, му́зыка 🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik 🇮🇩, މިއުޒިކް
                      🇲🇻, muzik 🇲🇾, muziki 🇹🇿, musiikki 🇫🇮, musik 🇸🇪, музыка 🇰🇬,
                      му́зика 🇺🇦, მუსიკა 🇬🇪, ሙዚቃ 🇪🇹
                      <div></div>
                      <strong>Descendants:</strong> músika 🇨🇼
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;músculo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", and
                      the Vulgar Latin "*mūsclus" -- "muscle", so called because
                      flexed arm "músculos" look like little mice.
                      <div></div>
                      <strong>Related to:</strong> muque, mexilhão
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, músculo
                      🇪🇸, muscle 🇬🇧, muskel 🇩🇰, muskel 🇳🇴, muskel 🇸🇪, мышца 🇷🇺,
                      mišića 🇭🇷, mușchi 🇷🇴
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pregnant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;nascer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "*(g)nāscī"
                      -- "to be born", via the Old Galician-Portuguese verb
                      "nacer" -- "to be born".
                      <div></div>
                      <strong>Related to:</strong> natureza
                      <div></div>
                      <strong>Cognates:</strong> naître (v.) 🇫🇷, nacer (v.) 🇪🇸,
                      nascere (v.) 🇮🇹, naște (v.) 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nome.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;nome"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₁nómn̥" -- "name", via the Proto-Italic "*nōmn̥" --
                      "name" and the Latin "nōmen" -- "name", "noun".
                      <div></div>
                      <strong>Cognates:</strong> nom 🇫🇷, naam 🇳🇱, nome 🇮🇹, navn
                      🇩🇰, نَام 🇮🇷, نوم 🇦🇫, Name 🇩🇪, nombre 🇪🇸, όνομα 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parole.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FamWPsuUjK8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;palavra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "πᾰρᾰβάλλω" -- "to place side by side", via the Latin
                      "parabola" -- "comparison", "speech", and the Old
                      Galician-Portuguese "paravla" -- "word".
                      <div></div>
                      <strong>Related to:</strong> parábola
                      <div></div>
                      <strong>Cognates:</strong> palabra 🇪🇸, parole 🇫🇷, parola
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paper.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;papel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πᾰ́πῡρος"
                      /pắpūros/ -- "the papyrus plant", via the Latin "papȳrus"
                      -- "paper made from papyrus". Although related
                      etymologically, "papel" and "papiro" are made from
                      different materials and use different production methods.
                      <div></div>
                      <strong>Related to:</strong> papiro
                      <div></div>
                      <strong>Cognates:</strong> paper 🇬🇧, papier 🇫🇷, papel 🇪🇸,
                      Papier 🇩🇪, papier 🇳🇱, papper 🇸🇪, papīrs 🇱🇻, paperi 🇫🇮,
                      popierius 🇱🇹, papier 🇵🇱, papur 🏴󠁧󠁢󠁷󠁬󠁳󠁿, папі́р 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paraíso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible.
                      <div></div>
                      <strong>Cognates:</strong> paradis 🇫🇷, paraíso 🇪🇸, paraiso
                      🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸, paradise 🇬🇧,
                      paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pied.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pé"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk", via the Latin "pēs" --
                      "foot" and the Old French "pié" -- "foot".
                      <div></div>
                      <strong>Related to:</strong> pedal, piloto
                      <div></div>
                      <strong>Cognates:</strong> pied 🇫🇷, pié 🇪🇸, piede 🇮🇹, foot
                      🇬🇧, πόδι 🇬🇷, Fuß 🇩🇪, voet 🇳🇱, fot 🇸🇪, پا 🇮🇷, پَاؤُں 🇵🇰,
                      पैर 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/peligro.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qJKkaRTmYbs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;perigo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "perīculum" --
                      "attempt", "experiment", "risk", "danger", via the Old
                      Galician-Portuguese "perigoo" -- "danger".
                      <div></div>
                      <strong>Cognates:</strong> peril 🇬🇧, peligro 🇪🇸, pericolo
                      🇮🇹, péril 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/peru.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;peru"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Spanish "Perú" (country
                      in South America). In the 16th century, it was believed
                      that turkeys were exported to Portugal from the region of
                      "Peru" (at the time the term was often used to refer to
                      Spanish America as a whole).
                      <div></div>
                      <strong>Related to:</strong> Peru
                      <div></div>
                      <strong>Ancestor:</strong> Perú 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pessego.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pêssego"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name. From Latin, the word entered
                      Modern Portuguese via the Old Galician-Portuguese
                      "pessego" -- "peach".
                      <div></div>
                      <strong>Related to:</strong> Pérsia
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, peach 🇬🇧, ferskja 🇮🇸,
                      Pfirsich 🇩🇪, fersken 🇩🇰, fersken 🇳🇴, пе́рсик 🇷🇺, perzik 🇳🇱,
                      persik 🇮🇩, piersică 🇷🇴, pjeshkë 🇦🇱, pichi 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/person.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LCiQz7vmiLY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pessoa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "persōna" -- "mask
                      used by actor", "role", "part", "character”. In the Roman
                      world, actors would wear “personae” during performances,
                      which would allow them “to portray a role” and “assume a
                      persona”. Gradually the word became associated both with
                      the mask itself and the actors wearing it, and eventually,
                      the mask meaning disappeared, and only the meaning related
                      to actors, and eventually, all human beings, remained.
                      From Latin, the word eventually evolved into the
                      Old-Galician Portuguese "pessõa" -- "person".
                      <div></div>
                      <strong>Related to:</strong> personagem
                      <div></div>
                      <strong>Cognates:</strong> personne 🇫🇷, Person 🇩🇪, persoon
                      🇳🇱, person 🇬🇧, persona 🇮🇹, persona 🇪🇸, person 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pyjamas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pijama"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "پایجامه" --
                      "pyjamas", "pants" (which is itself a combination of "پا"
                      /pâ/ -- “leg” and "جامه" /jâme/ -- "garment").
                      <div></div>
                      <strong>Ancestors:</strong> पैजामा 🇮🇳, پائِجامَہ 🇵🇰,
                      pyjama(s) 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> pijama 🇪🇸, Pyjama 🇩🇪, пижама
                      🇰🇿, пижама 🇷🇺, пижама 🇰🇬, pijama 🇹🇷, pijama 🇷🇴, πυτζάμα
                      🇬🇷, піжама 🇺🇦, pyžamo 🇨🇿, pyjama 🇫🇮, поҷома 🇹🇯, پیژامه 🇦🇫,
                      pidžama 🇭🇷, pijama 🇹🇲, פיג׳מה 🇮🇱, pižama 🇱🇹, piama 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pincel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Later Latin "pēnicillum" --
                      "painter's brush".
                      <div></div>
                      <strong>Related to:</strong> pénis
                      <div></div>
                      <strong>Ancestor:</strong> pinzell 🇦🇩
                      <div></div>
                      <strong>Cognates:</strong> pincel 🇪🇸, penseel 🇳🇱, pensel
                      🇳🇴, pensel 🇩🇰, pędzel 🇵🇱, Pinsel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/piloto.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;piloto"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Ancient Greek "πηδόν"
                      /pēdón/ -- "oar (blade)" and the Byzantine Greek
                      "*πηδώτης" /pēdṓtēs/ -- “helmsman”. Before the emergence
                      of the airplane, a “pilot” was the person at the helm of a
                      ship who steered it into and out of a harbor and navigated
                      it to its destination. The original meaning "foot" comes
                      from the fact that the "πηδόν" looked like the boat’s foot
                      due to its flat shape and position underneath the boat’s
                      body.
                      <div></div>
                      <strong>Related to:</strong> pedal, pé, peão
                      <div></div>
                      <strong>Ancestors:</strong> pilota 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> pilot 🇬🇧, piloto 🇵🇹, pilote 🇫🇷,
                      πιλότος 🇬🇷, Pilot 🇩🇪, pilot 🇩🇰, pilot 🇦🇱, pilots 🇱🇻, pilot
                      🇨🇿, piloot 🇪🇪, pilot 🇹🇷, piloot 🇳🇱, პილოტი 🇬🇪, piloto 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/planeta.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;planeta"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "
                      <u>πλάνητες</u> ἀστέρες" /plánētes astéres/, or "wandering
                      stars", so called because, compared to "απλανείς αστέρες"
                      /aplaneís astéres/, or "fixed stars", the stars that were
                      "πλάνητες" seemed to move around the sky a lot more.
                      <div></div>
                      <strong>Possibly related to:</strong> plano, planície
                      <div></div>
                      <strong>Cognates:</strong> planète 🇫🇷, pianeta 🇮🇹, planet
                      🇬🇧, planeta 🇪🇸, Planet 🇩🇪, плане́та 🇧🇾, planet 🇦🇱, planet
                      🇸🇮, planēta 🇱🇻, planeta 🇨🇿, planeet 🇪🇪, planeta 🇵🇭,
                      плане́та 🇷🇺, planeetta 🇫🇮, planeet 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pocion.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;poção"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the accusative noun "pōtiōnem" --
                      "draught", "(magic) potion".
                      <div></div>
                      <strong>Related to:</strong> potável (<i>adj</i>.),
                      peçonha
                      <div></div>
                      <strong>Cognates:</strong> potion 🇫🇷, poción 🇪🇸, potion
                      🇬🇧, pozione 🇮🇹, poţiune 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/psychiatry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;psiquiatra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ψυχή" /psukhḗ/ -- "soul" and "ἰατρός" /iatrós/ --
                      “doctor”.
                      <div></div>
                      <strong>Cognates:</strong> Psychiater 🇩🇪, psychiatrist 🇬🇧,
                      psiquiatra 🇪🇸, psikiyatrist 🇹🇷, ფსიქიატრი 🇬🇪, психиа́тр 🇷🇺,
                      psychiatre 🇫🇷, pszichiáter 🇭🇺, ψυχίατρος 🇬🇷, psühhiaater
                      🇪🇪, פסיכיאטר 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;queijo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product", via the Old Galician-Portuguese "queijo" --
                      "cheese".
                      <div></div>
                      <strong>Cognates:</strong> Käse 🇩🇪, kaas 🇳🇱, queso 🇪🇸,
                      cheese 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> keju 🇲🇾, keju 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/relogio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;relógio"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ὡρολόγιον" /hōrológion/ -- "device for telling time"
                      (which itself comes partially from "ὥρα" /hṓra/ -- "any
                      period of time"), via the Latin "hōrologium" -- "device
                      used to measure the time of day", "sundial", and the Old
                      Catalan "orollotge" -- "timekeeping device".
                      <div></div>
                      <strong>Related to:</strong> hora, <u>horó</u>scopo
                      <div></div>
                      <strong>Ancestor:</strong> reloj 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> horloge 🇫🇷, orologio 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rio"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "rīvus" --
                      "brook", "small stream of water", via the Vulgar Latin
                      "rius" -- "river".
                      <div></div>
                      <strong>Related to:</strong> rival, derivar (<i>v.</i>)
                      <div></div>
                      <strong>Cognates:</strong> río 🇪🇸, râu 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rival"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "rīvus" --
                      "brook", "small stream of water", via the adjectival noun
                      "rīvālis" -- "someone who uses the same stream as
                      another". The word originated from the idea of groups of
                      people occupying opposite sides of a river (or any body of
                      water) who were often vying for access to the same
                      resource (<i>e.g.</i>, the Romans and the Carthaginians in
                      the first millennium BC who were both active on opposite
                      sides of the Strait of Messina between Sicily and mainland
                      Italy.)
                      <div></div>
                      <strong>Related to:</strong> rio, derivar (<i>v.</i>)
                      <div></div>
                      <strong>Cognates:</strong> rival 🇫🇷, rival 🇬🇧, rival 🇪🇸,
                      rivale 🇮🇹, rywal 🇵🇱, rival 🇷🇴, rival 🇳🇴, Rivale 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/red.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;roxo (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European
                      "*h₁rewdʰ-" -- "red" via the Latin "russeus" -- "dark red"
                      and the Old Galician-Portuguese "roxo" -- "dark red".
                      <div></div>
                      <strong>Related to:</strong> ruivo
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/red.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;ruivo (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European
                      "*h₁rewdʰ-" -- "red" via the Latin "rubeus" -- " red".
                      <div></div>
                      <strong>Related to:</strong> roxo
                      <div></div>
                      <strong>Cognates:</strong> roux 🇫🇷, rubio 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salaire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salário"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "sal" -- "salt"
                      via the adjective "salārius" -- "related to salt" and the
                      derivative noun "salārium" -- "wages". In Roman times salt
                      was quite valuable, and soldiers who were "worth their
                      salt", so to speak, had to accumulate a hefty "salarium"
                      (or “salt stipend”) to be able to buy some.
                      <div></div>
                      <strong>Related to:</strong> sal, saleiro
                      <div></div>
                      <strong>Cognates:</strong> salary 🇬🇧, salaire 🇫🇷, salario
                      🇪🇸, salarju 🇲🇹, salariu 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saudacao.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;saudação"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "salūs" --
                      "health", "safety", "security", via the verb "salūtō" (v.)
                      – "to greet", "to hail", and the Old Galician-Portuguese
                      "saudade" -- "salvation".
                      <div></div>
                      <strong>Related to:</strong> saúde, saudar (<i>v.</i>)
                      <div></div>
                      <strong>Not related to:</strong> saudade
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saudade.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;saudade"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "solus"
                      -- "only", "sole", via the accusative singular form
                      "sōlitātem" of the noun "sōlitās" -- "solitude", and the
                      Old Galician-Portuguese "soidade" –- “a feeling of
                      melancholy for something that is absent". The sound
                      evolution from "oi" to "au" was likely influenced by the
                      phonetically similar Old Galician-Portuguese "saudade" --
                      "salvation" and the semantically similar Arabic "سَوْدَاء"
                      /sawdāʔ/ -- "melancholy", "black bile".
                      <div></div>
                      <strong>Related to:</strong> solidão, solitude, só (
                      <i>adv.</i>)<div></div>
                      <div></div>
                      <strong>Not related to:</strong> saudação, saúde
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saude.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;saúde"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "salūs" --
                      "health", "safety", "security", via the verb "salūtō" (v.)
                      – "to greet", "to hail", and the Old Galician-Portuguese
                      "saude" -- "health".
                      <div></div>
                      <strong>Related to:</strong> saudação, saudar (<i>v.</i>)
                      <div></div>
                      <strong>Not related to:</strong> saudade
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/solidao.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;solidão"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "solus"
                      -- "only", "sole", via the accusative singular form
                      "sōlitātem" of the noun "sōlitās" -- "solitude",
                      <div></div>
                      <strong>Related to:</strong> solitude, saudade, só (
                      <i>adv.</i>)<div></div>
                      <strong>Cognates:</strong> solitude 🇬🇧, solitude 🇫🇷,
                      soledad 🇪🇸, solitudine 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/solitude.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;solitude"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "solus"
                      -- "only", "sole", via the noun "sōlitūdō" -- "solitude".
                      <div></div>
                      <strong>Related to:</strong> solidão, saudade, só (
                      <i>adv.</i>)<div></div>
                      <strong>Cognates:</strong> solitude 🇬🇧, solitude 🇫🇷,
                      soledad 🇪🇸, solitudine 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tela.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tela"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tēla" -- "web",
                      "loom".
                      <div></div>
                      <strong>Related to:</strong> teia
                      <div></div>
                      <strong>Cognates:</strong> toile 🇫🇷, tela 🇪🇸, tela 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/terre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/M2lknMW7HiI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;terra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ters-" -- "dry", via the Proto-Italic "*terzā" --
                      "earth", the Latin "terra" -- "dry land", the Old
                      Galician-Portuguese "terra" -- "land", "region",
                      "territory".
                      <div></div>
                      <strong>Cognates:</strong> terre 🇫🇷, tierra 🇪🇸, terra 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/towel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;toalha"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic verb
                      "*þwahaną" -- "to wash" via the Frankish verb "*þwahilu"
                      -- "cloth".
                      <div></div>
                      <strong>Cognates:</strong> towel 🇬🇧, toalla 🇪🇸, tuwalya
                      🇵🇭, tuala 🇲🇾, tuáille 🇮🇪, タオル 🇯🇵, taulo 🇹🇿, taul 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/toque.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/suyCgi6wEos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;toque de recolher"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first word is from the Vulgar
                      Latin "*tuccāre" -- "to touch", "to strike" (which is
                      itself likely of onomatopeic origin). The preposition "de"
                      is from the Latin preposition "de" -- "of", "concerning",
                      "about". The third word is from the Latin verb "recolligō"
                      -- "to recover", "to gather again", "to collect".
                      <div></div>
                      <strong>Partial cognates:</strong> <u>toque</u> de queda
                      🇪🇸
                      <div></div>
                      <strong>Semantic equivalents:</strong> avondklok 🇳🇱,
                      couvre-feu 🇫🇷, coprifuoco 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/varrer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;varrer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "verrō" --
                      "to sweep (away)", "to carry off", via the Old-Galician
                      Portuguese "varrer" -- "to sweep".
                      <div></div>
                      <strong>Related to:</strong> vassoura
                      <div></div>
                      <strong>Cognates:</strong> barrer 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vassoura.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vassoura"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "verrō" --
                      "to sweep (away)", "to carry off", via the Old-Galician
                      Portuguese "varrer" -- "to sweep".
                      <div></div>
                      <strong>Related to:</strong> varrer (<i>v</i>.)
                      <div></div>
                      <strong>Cognates:</strong> basora 🇨🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/venom.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;veleno"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wenh₁-" -- "to strive", "to wish", "to love", via the
                      Latin "venēnum" -- "(love) potion", "poison", "charm”.
                      <div></div>
                      <strong>Related to:</strong> Vénus
                      <div></div>
                      <strong>Cognates:</strong> venim 🇫🇷, venom 🇬🇧, veneno 🇪🇸,
                      veleno 🇮🇹, venin 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/worm.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;verme"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wr̥mis" -- "worm" via the Latin "vermem", -- "worm" and
                      the Old Galician-Portuguese "vermen" -- "worm".
                      <div></div>
                      <strong>Related to:</strong> vermelho (<i>adj</i>.)
                      <div></div>
                      <strong>Cognates:</strong> worm 🇬🇧, Wurm 🇩🇪, ver 🇫🇷, orm
                      🇩🇰, verme 🇮🇹, vierme 🇷🇴, worm 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/worm.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vermelho"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*wr̥mis" -- "worm" via the Latin "vermis" -- and its
                      derived form "vermiculus" -- "little worm", via the Old
                      Galician-Portuguese "vermelho" -- "red". The word comes
                      from the crimson dye produced by a worm-like insect called
                      "kermes vermilio".
                      <div></div>
                      <strong>Related to:</strong> verme
                      <div></div>
                      <strong>Semantic equivalents:</strong> cramoisi 🇫🇷,
                      cremisi 🇮🇹, carmesim 🇵🇹, क़िरमिज़ी 🇮🇳, karmosin 🇸🇪,
                      kırmızı 🇹🇷, червоний 🇺🇦, czerwony 🇵🇱, червен 🇧🇬, црвен 🇲🇰,
                      červený 🇸🇰, чырво́ны 🇧🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/venir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/t4CwXz_CSU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;vir (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic verb
                      "*gʷənjō" -- "to come", via the Latin "venīo" -- "to
                      come", and the Old Galician-Portuguese "viir" -- "to
                      come".
                      <div></div>
                      <strong>Related to:</strong> a<u>ventura</u>
                      <div></div>
                      <strong>Cognates:</strong> venir 🇫🇷, venire 🇮🇹, venir 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/visita.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;visita"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "videō" --
                      "to see", via the verb "vīsō" -- "to behold", "to survey”,
                      and its frequentative derived form "vīsitō" -- "to go to
                      see", "to visit", and, later, the Old Galician-Portuguese
                      verb "visitar" -- "to visit".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dente</u>, pru
                      <u>dente</u> (<i>adj</i>.), visto, in<u>veja</u>, video,
                      aviso
                      <div></div>
                      <strong>Cognates:</strong> visit 🇬🇧, visita 🇮🇹, visita 🇪🇸,
                      vizită 🇷🇴, wizyta 🇵🇱, visite 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇵🇪 QUECHUA 🇵🇪
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tiy.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tiy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch (and then eventually
                      also made its way to South America).
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, té 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶
                      🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩,
                      thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý 🇹🇲, اتاي 🇲🇷,
                      شَاي 🇸🇦, ítí 🇿🇦, tea 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇷🇴 ROMANIAN 🇷🇴
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ami.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;amic"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "amō" -- "I
                      love" via the adjective "amīcus" -- "friendly," "pleasant
                      to be around", and the Old French "amic" -- "friend"
                      <div></div>
                      <strong>Related to:</strong> in<u>amic</u>
                      <div></div>
                      <strong>Cognates:</strong> amigo 🇪🇸, amigo 🇵🇹, amico 🇮🇹,
                      ami 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobuz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobuz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>bús</u> 🇪🇸, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇱, auto<u>bus</u>, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺,
                      ôni<u>bus</u> 🇵🇹, auto<u>busas</u> 🇱🇹, 巴士 🇨🇳, बस 🇮🇳,
                      basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스
                      🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ceai.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ceai"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea" and the Ottoman Turkish "چای" /çay/ -- "tea". The
                      drink and its corresponding word made its way into many
                      West and Central Asian languages via land-based trading
                      routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, чай 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷,
                      ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай
                      🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦,
                      tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, čaj 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cementerio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cimitir"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "κοιμητήριον"
                      /koimētḗrĭon/ -- "place to sleep", "dormitory", via the
                      Medieval Latin "cimiterium" -- "cemetery", "burial
                      ground".
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cmentarz 🇵🇱, cemitério 🇵🇹, cementerio 🇪🇸, sementeryo 🇵🇭,
                      cimetière 🇫🇷, cemetery 🇬🇧, цвинтар 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nightmare.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;coșmar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin verb
                      "calcāre" -- "to trample", "to tread on", (via the Old
                      French "chauchier" -- "to press") and the Frankish "*marā"
                      -- "an evil spirit who sits on your chest while you sleep
                      and tries to suffocate you".
                      <div></div>
                      <strong>Ancestor:</strong> cauchemar 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> night<u>mare</u> 🇬🇧, <u>mar</u>
                      dröm 🇸🇪, <u>mar</u>tröð 🇮🇸, <u>mare</u>ritt 🇳🇴, кошма́р 🇷🇺,
                      koszmar 🇵🇱, კოშმარი 🇬🇪, košmaras 🇱🇹
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, incubo
                      🇮🇹, كابوس 🇸🇦, painajainen 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/disaster.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Gt0B3coiu7s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dezastru"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "dis-" --
                      (used to convey negation/separation) and the noun
                      "-astrum". A "disaster" is literally a "negative (
                      <i>i.e.</i>, unlucky) star". In ancient times catastrophes
                      were often thought to be the results of misalignments of
                      planets and stars in the sky.
                      <div></div>
                      <strong>Related to:</strong> <u>astro</u>nomie, stea
                      <div></div>
                      <strong>Cognates:</strong> disaster 🇬🇧, desastre 🇵🇹,
                      désastre 🇫🇷, desastre 🇪🇸, disastro 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/helice.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;elice"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "ἕλιξ" /hélix/
                      -- “spiral” via the Latin "helix" -- "whorl", "helix".
                      <div></div>
                      <strong>Ancestor:</strong> hélice 🇫🇷
                      <div></div>
                      <strong>Related to:</strong> elicopter
                      <div></div>
                      <strong>Cognates:</strong> hélice 🇵🇹, hélice 🇪🇸, elica 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gaz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gaz 🇫🇷
                      <div></div>
                      <strong>Related to:</strong> haos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇦🇱, gaz 🇵🇱, gaz 🇹🇲, газ 🇧🇾, газ 🇹🇯, газ
                      🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass 🇳🇴, gaas
                      🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿, gáz 🇭🇺,
                      gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵,
                      გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/enemigo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;inamic"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "inimīcus" (
                      <i>i.e.</i>, "in-" -- “not” + "amīcus" - “friend”).
                      <div></div>
                      <strong>Related to:</strong> amic
                      <div></div>
                      <strong>Cognates:</strong> enemy 🇬🇧, ennemi 🇫🇷, inimigo
                      🇵🇹, enemigo 🇪🇸, nemico 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/animal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;inimă"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "anima" -- "soul",
                      "spirit", "life", "air" , "breath".
                      <div></div>
                      <strong>Related to:</strong> anima
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/isle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ztj_kCMZFS8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;insulă"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "insula" --
                      "island".
                      <div></div>
                      <strong>Related to:</strong> izolare
                      <div></div>
                      <strong>Not related to:</strong> insultă
                      <div></div>
                      <strong>Cognates:</strong> isla 🇪🇸, île 🇫🇷, ilha 🇵🇹, isola
                      🇮🇹, isle 🇬🇧, Insel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/myshtsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mușchi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", and
                      the Vulgar Latin "*mūsclus" -- "muscle", so called because
                      flexed arm "mușchi" look like little mice.
                      <div></div>
                      <strong>Not related to:</strong> mușchi (meaning "moss")
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, músculo
                      🇪🇸, músculo 🇵🇹, muscle 🇬🇧, muskel 🇩🇰, muskel 🇳🇴, muskel
                      🇸🇪, мышца 🇷🇺, mišića 🇭🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pregnant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;naște (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "*(g)nāscī"
                      -- "to be born".
                      <div></div>
                      <strong>Cognates:</strong> naître (v.) 🇫🇷, nascer (v.) 🇵🇹,
                      nascere (v.) 🇮🇹, nacer (v.) 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/portocala.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;portocală"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Italian "portogallo" –
                      “orange (from Portugal)”. Portuguese traders brought the
                      fruit from East Asia to Europe, whence the name.
                      <div></div>
                      <strong>Ancestor:</strong> πορτοκάλι 🇬🇷
                      <div></div>
                      <strong>Cognates:</strong> ُرْتُقَال 🇸🇦, portakal 🇹🇷,
                      portağal 🇦🇿, портокал 🇲🇰, portokall
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problemă"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problemă"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> balet
                      <div></div>
                      <strong>Ancestor:</strong> problème 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> problem 🇬🇧, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problema 🇪🇸, problema 🇲🇹,
                      problema 🇱🇹, про́блем 🇲🇰, problēma 🇱🇻, probleemi 🇪🇪,
                      probléma 🇭🇺, про̀бле̄м 🇷🇸, пробле́ма 🇺🇦, пробле́ма 🇷🇺,
                      πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭, problem 🇵🇱, problem
                      🇹🇷, problem 🏴󠁧󠁢󠁷󠁬󠁳󠁿, Problem 🇱🇺, пробле́м 🇧🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧, sport 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺, ስፖርት 🇪🇹,
                      šport 🇸🇰, spor 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇷🇺 RUSSIAN 🇷🇺
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/abrikos_ru.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;абрикос"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and, eventually, the modern Spanish word.
                      <div></div>
                      <strong>Ancestor:</strong> albercoc 🇦🇩, abrikoos 🇳🇱,
                      <div></div>
                      <strong>Descendant:</strong> абрико́с 🇺🇦
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      apricot 🇬🇧, berquq 🇲🇹, Aprikose 🇩🇪, aibreog 🇮🇪, aprikoti
                      🇹🇿, aprikot 🇮🇩, abricot 🇫🇷, albaricoque 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avaria.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/cI0Fa9UD9S8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;авария"
                  hoverText={
                    <span style={{ display: "block", maxWidth: "400px" }}>
                      <strong>Origin:</strong> Likely from the Arabic verb
                      "عَوِرَ" /ʕawira/ -- "to lose an eye" and the derived
                      "عَوَار" /ʕawār/ -- "blemish", "defect" via "عَوَارِيَّة"
                      /ʕawāriyya/ -- "damaged goods" and, later, the Italian
                      "avaria" -- "damage done to goods (that have been thrown
                      overboard) on a watercraft".
                      <div style={{ margin: "8px 0" }}></div>
                      <strong>Cognates:</strong> ავარია 🇬🇪, Havarie 🇩🇪
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_ru.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;автобус"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas
                      🇱🇹, ავტობუსი 🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus
                      🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ananas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ананас"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Tupi-Guarani
                      "*nanã" -- "pineapple", via the Old Tupi "naná" --
                      "pineapple".
                      <div></div>
                      <strong>Cognates:</strong> Ananas 🇩🇪, ananas 🇫🇷, آناناس
                      🇮🇷, أَنَانَاس 🇸🇦, nanasi 🇹🇿, ананас 🇰🇿, ananāss 🇱🇻, ananas
                      🇫🇮, ananas 🇹🇷, နာနတ် 🇲🇲, ananas 🇩🇰, ananas 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apelsine.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;апельсин"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the French "pomme de Sine"
                      🇫🇷 – “apple from China”. The word was calqued into the
                      Dutch "appelsien" -- "orange". The name reflects the fact
                      that the fruit originated from a region that encompasses
                      Southern China.
                      <div></div>
                      <strong>Cognates:</strong> sinaasappel 🇳🇱, apelsin 🇸🇪,
                      Apfelsine 🇩🇪, appelsin 🇳🇴
                      <div></div>
                      <strong>Descendants:</strong> апельсин 🇰🇿, апельсин 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/britches.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;брюки (<i>pl.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*brōks"
                      -- "crotch", "hindquarters", "clothing that covers the
                      rear end", via the Frankish "*brōk" -- "leggings",
                      "pants".
                      <div></div>
                      <strong>Ancestor:</strong> broek 🇳🇱
                      <div></div>
                      <strong>Related to:</strong> фра́кция, фрагмент
                      <div></div>
                      <strong>Cognates:</strong> britches 🇺🇸, breeches 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/verblyud.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;верблюд"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek genitive
                      noun "ἐλέφαντος" /eléphăntos/ -- "(pertaining to) ivory",
                      via the Latin "elephantus" -- "elephant", via the Gothic
                      "𐌿𐌻𐌱𐌰𐌽𐌳𐌿𐍃" /ulbandus/ -- "camel", and the Proto-Slavic
                      "*velьb(l)ǫdъ" -- "camel". Neither camels nor elephants
                      are native to Europe, and Europeans traditionally,
                      considered those animals pretty exotic, without always
                      being able to differentiate which one is which, which is
                      why over time some Europeans confused both animals and
                      some, like many Slavic language speakers, took a variation
                      of “elephas” to denote “camel”, whereas others, like
                      Romance and Germanic ones, took it to denote their word
                      for “elephant”.
                      <div></div>
                      <strong>Cognates:</strong> velbloud 🇨🇿, wielbłąd 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/videt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;видеть (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*weyd-" -- "to see", via the Proto-Slavic verb "vìděti"
                      -- "to see".
                      <div></div>
                      <strong>Related to:</strong> зависть
                      <div></div>
                      <strong>Cognates:</strong> voir 🇫🇷, ver 🇪🇸, ver 🇵🇹, vedea
                      🇷🇴, ви́ждам 🇧🇬, widzieć 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vino.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;вино"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "vīnum" -- “wine”,
                      via the Old Church Slavonic "вино" /vino/ -- "wine".
                      <div></div>
                      <strong>Related to:</strong> <u>вино</u>град
                      <div></div>
                      <strong>Cognates:</strong> vin 🇫🇷, wine 🇬🇧, viini 🇫🇮,
                      vinho 🇵🇹, vino 🇮🇹, vin 🇷🇴, wino 🇵🇱, vino 🇪🇸, wijn 🇳🇱,
                      vynas 🇱🇹, wain 🇲🇾, víno 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vokzal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2tH2zWNLVow"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;вокзал"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the earlier Russian "воксал"
                      /voksal/, the name given in the nineteenth century to the
                      Railway Station in Pavlovsk, Russia, which was envisioned
                      by its designers as a place of entertainment for travelers
                      and revellers alike. The name "воксал" derives from
                      Vauxhall, the famous pleasure garden that had existed in
                      London since the Restoration period in the mid 17th
                      century and since that time had been well known for its
                      summer balls, performances, fireworks and other
                      entertainment.
                      <div></div>
                      <strong>Related to:</strong> зал, село
                      <div></div>
                      <strong>Descendants:</strong> вокзал 🇺🇦, вакзал 🇧🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vards.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;врать (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*werh₁-" -- "to speak", "to say"
                      via the Proto-Slavic "*vьrati" -- "to conjure", "to
                      chant".
                      <div></div>
                      <strong>Cognates:</strong> варати 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vremya.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;время</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wert-" -- "to turn", "to wind", via the "*vermę̀" --
                      "period of time", "hour", via the Old Church Slavonic
                      "врѣмѧ" -- "time".
                      <div></div>
                      <strong>Related to:</strong> верста
                      <div></div>
                      <strong>Cognates:</strong> време 🇷🇸, време 🇧🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;газ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to:</strong> хаос
                      <div></div>
                      <strong>Not related to:</strong> газета
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, gaz 🇫🇷, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;гиппопотам"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ἱπποπόταμος" /hippopótamos/, which itself is a compound
                      of "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Related to:</strong> ипподром
                      <div></div>
                      <strong>Cognates:</strong> xипопота́м 🇧🇬, hipopótamo 🇪🇸,
                      hipopótamo 🇵🇹, hippopotamus 🇬🇧, hippopotame 🇫🇷, ippopotamo
                      🇮🇹, ჰიპოპოტამი 🇬🇪
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, 河马 🇨🇳,
                      Nilpferd 🇩🇪, nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा
                      🇮🇳, dobhareach 🇮🇪, su aygırı 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/glagol.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;глагол"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*golgolъ"
                      -- "speech", "word” via the Old Church Slavonic "глаголъ"
                      -- "word", "speech", "teaching". The modern meaning was
                      calqued in the 17th century by the Ruthenian scholar
                      Meletius Smotrytsky from the Latin "verbum" -- "verb".
                      <div></div>
                      <strong>Related to:</strong> Глаголица, голого́лить (
                      <i>v.</i>), голос
                      <div></div>
                      <strong>Cognates:</strong> глагол 🇷🇸, глагол 🇧🇬, глагол 🇲🇰
                      <div></div>
                      <strong>Semantic Equivalents:</strong> verbe 🇫🇷, verbo 🇪🇸,
                      verbo 🇵🇹, Verb 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/golos.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;голос"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*golgolъ"
                      -- "speech", "word” via the Old Church Slavonic "глаголъ"
                      -- "word", "speech", "teaching". The modern meaning was
                      calqued in the 17th century by the Ruthenian scholar
                      Meletius Smotrytsky from the Latin "verbum" -- "verb".
                      <div></div>Глаголица
                      <strong>Related to:</strong> Глаголица, голого́лить (
                      <i>v.</i>), глагол
                      <div></div>
                      <strong>Cognates:</strong> глас 🇷🇸, глас 🇧🇬, глас 🇲🇰, głos
                      🇵🇱, голас 🇧🇾, голос 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dschungel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;джунгли (<i>pl.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert". The word
                      was adopted by British colonists in the Indian
                      subcontinent to refer to any territory that was
                      inhospitable, and then gradually it evolved to denote a
                      place with “tangled thickets”, and then, from there, "any
                      area with lots of vegetation". From there it eventually
                      found its way into French.
                      <div></div>
                      <strong>Ancestors:</strong> جَنْگَل 🇵🇰, जंगल 🇮🇳, jungle 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> جَن٘گَل 🇮🇷, জঙ্গল 🇧🇩, जङ्गल 🇳🇵,
                      cəngəllik 🇦🇿, ځنګل 🇦🇫, ҷангал 🇹🇯, Dschungel 🇩🇪, jungle 🇫🇷,
                      jungle 🇫🇷, jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪, dżungla 🇵🇱,
                      ジャングル 🇯🇵, džungla 🇸🇮, džùngla 🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                      <strong>Descendants:</strong> ջունգլի 🇦🇲, ჯუნგლი 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zavist.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;зависть"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Proto-Slavic
                      prefix за- “at” and the Proto-Slavic verb "vìděti" -- "to
                      see (which itself is from the Proto-Indo-European root
                      "*weyd-" -- "to see").
                      <div></div>
                      <strong>Related to:</strong> видеть (<u>v</u>.)
                      <div></div>
                      <strong>Cognates:</strong> envie 🇫🇷, envidia 🇪🇸, inveja
                      🇵🇹, invidie 🇷🇴, envy 🇬🇧, завист 🇧🇬, завист 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zavtrak.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;завтра"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "за" and "утро".
                      "завтра" was originally meant to signify a period that
                      would start as soon as we wake up from our night’s sleep
                      (i.e., in the next morning). Over time "завтра" also came
                      to mean not just "the morning", but also "the entire day
                      after today."
                      <div></div>
                      <strong>Related to:</strong> завтрак, утро
                      <div></div>
                      <strong>Cognates:</strong> за́ўтра 🇧🇾, у́тре 🇧🇬, у́тре 🇲🇰,
                      zítra 🇨🇿, jutro 🇵🇱
                      <div></div>
                      <strong>Semantic Equivalents:</strong> mañana 🇪🇸, morgen
                      🇩🇪, 明日 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zavtrak.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;завтрак"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*zautrъkъ"
                      -- "breakfast". "zautrъkъ" is itself a combination of "за"
                      and "утро", which together make "завтра". "завтрак" is
                      therefore, by literal definition, a meal that is eaten
                      early in the day.
                      <div></div>
                      <strong>Related to:</strong> завтра, утро
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Frühstück 🇩🇪,
                      πρωινό 🇬🇷, reggeli 🇭🇺, morgenmad 🇩🇰, frukost 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vokzal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2tH2zWNLVow"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;зал"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sel-" -- "human settlement", "village", "dwelling", via
                      the Proto-Germanic "*saliz" -- "house", "dwelling, "hall",
                      and the Old High German "sal" -- "hall", "large room".
                      <div></div>
                      <strong>Ancestor:</strong> Saal 🇩🇪
                      <div></div>
                      <strong>Related to:</strong> вокзал, село
                      <div></div>
                      <strong>Cognates:</strong> salle 🇫🇷, zaal 🇳🇱, sal 🇸🇪
                      <div></div>
                      <strong>Descendants:</strong> зал 🇺🇦, зала 🇧🇾, зал 🇰🇿, зал
                      🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zontik.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;зонтик"
                  hoverText={
                    <span>
                      <strong>Ancestor:</strong> zonnedek 🇳🇱
                      <div></div>
                      <strong>Distant cognates:</strong> <u>Sonnen</u>schirm 🇩🇪,
                      para<u>sole</u> 🇮🇹, para<u>sol</u>ka 🇵🇱
                      <div></div>
                      <strong>Distantly related to:</strong> солнце
                      <div></div>
                      <strong>Descendants:</strong> zontik 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiot1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;идиот"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”.
                      <div></div>
                      <strong>Cognates:</strong> idiot 🇬🇧, идиот 🇲🇰, Idiot 🇩🇪,
                      идиот 🇧🇬, idiota 🇪🇸, idiota 🇵🇹, idiota 🇵🇱, idiot 🇫🇷,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                      <strong>Descendants:</strong> идиот 🇧🇬, идиот 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dinde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;индюк"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Ἰνδῐ́ᾱ"
                      /Indĭ́ā/ -- "India", via the Ancient Greek, "ἰνδικός" -
                      /indikós/ -- "from India" and, from there, the Latin
                      "indicus" -- "from India". The name derives from the
                      mistaken idea that turkeys come from the Indian
                      Subcontinent.
                      <div></div>
                      <strong>Cognates:</strong> indyk 🇵🇱, dinde 🇬🇧, hindi 🇹🇷
                      <div></div>
                      <strong>Partial semantic equivalents:</strong> kalkoen 🇳🇱,
                      kalakùtas 🇱🇹, kalkon 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kalmar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;кальмар"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Ancestor:</strong> calamaro 🇮🇹, calmar 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar
                      🇦🇿, klamar 🇲🇹, kalmari 🇫🇮, calamar 🇪🇸, calamar 🇦🇩, kalmar
                      🇸🇰, kałamarnica 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kanikuly.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9YJzi3P2Wto"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;каникулы (<i>pl.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "Canicula" (
                      <i>i.e.</i>, "small dog"), another name for the star
                      Sirius. In ancient Rome the "diēs caniculārēs" (
                      <i>i.e.</i>, "days of the small dog (star)") denoted the
                      period in late July until late August rises when Sirius
                      rose and set at the same time as the sun. Over time the
                      word became associated with the feeling of leisure and
                      rest often associated with that time of year, and
                      eventually, leisure and rest enjoyed at any time of the
                      year.
                      <div></div>
                      <strong>Cognates:</strong> канікули 🇺🇦, kanikul 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cannibal_ru.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;каннибал"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> карибский (<i>adj.</i>)
                      <div></div>
                      <strong>Ancestor:</strong> caníbal 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪, kanibal 🇲🇾,
                      kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/klimat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;климат"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west.
                      <div></div>
                      <strong>Cognates:</strong> climate 🇬🇧, klimaat 🇳🇱, climat
                      🇫🇷, κλίμα 🇬🇷, iklim 🇮🇩, iqlim 🇺🇿, iklim 🇹🇷, ַַאַקְלִים 🇮🇱,
                      اِقْلِیم 🇮🇷. clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                      <strong>Descendants:</strong> климат 🇰🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/korova.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;корова"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Proto-Slavic "*kòrva"
                      -- "cow".
                      <div></div>
                      <strong>Related to:</strong> серна
                      <div></div>
                      <strong>Cognates:</strong> крава 🇲🇰, krowa 🇵🇱, корова 🇺🇦,
                      крава 🇧🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nightmare.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/4q0gMuVIIaM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;кошмар"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the French "cauchemar",
                      which itself is a combination of the Latin verb "calcāre"
                      -- "to trample", "to tread on", (via the Old French
                      "chauchier" -- "to press") and the Frankish "*marā" -- "an
                      evil spirit who sits on your chest while you sleep and
                      tries to suffocate you".
                      <div></div>
                      <strong>Cognates:</strong> night<u>mare</u> 🇬🇧, <u>mar</u>
                      dröm 🇸🇪, <u>mar</u>tröð 🇮🇸, <u>mare</u>ritt 🇳🇴, кошма́р 🇷🇺,
                      coșmar 🇷🇴, koszmar 🇵🇱, კოშმარი 🇬🇪, košmaras 🇱🇹
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Albtraum 🇩🇪, incubo
                      🇮🇹, كابوس 🇸🇦, painajainen 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/left.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;левый (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*leh₂-" -- "to be hidden (at a distance)", via the
                      Proto-Slavic "*lěvъ" -- "left", "wrong", "evil" and the
                      Old East Slavic "лѣвъ" -- "left", "weak". The historical
                      meaning is based on the popular notion in earlier
                      centuries that the left hand was weaker and less dexterous
                      than the right hand.
                      <div></div>
                      <strong>Cognates:</strong> lewy 🇵🇱, levý 🇨🇿, лев 🇲🇰, levi
                      🇸🇮
                      <div></div>
                      <strong>Possible semantic equivalents:</strong> gauche 🇫🇷,
                      sinistro 🇮🇹, 왼쪽 🇰🇷, kreiss 🇱🇻, left 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/elbow.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;локоть"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*Heh₃l-" -- "forearm" via the Proto-Slavic "*ȍlkъtь" --
                      "elbow".
                      <div></div>
                      <strong>Cognates:</strong> elbow 🇬🇧, elleboog 🇳🇱, albue
                      🇩🇰, albue 🇳🇴, Ellenbogen 🇩🇪, łokieć 🇵🇱, elmboog 🇿🇦, ло́каць
                      🇧🇾, ла́кът 🇧🇬, lakeť 🇸🇰, лі́коть 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7fe2-UxXMI8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;манёвр"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Vulgar Latin verb
                      "*manuoperare" -- "to work by hand" (a compound of "manū"
                      -- "hand" + verb "operārī" -- "to work", "to toil"), via
                      the Old French verb "manouvrer" -- “to maneuver”.
                      <div></div>
                      <strong>Ancestor:</strong> manœuvre 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> մանևր 🇦🇲, maneuver 🇬🇧, маневар
                      🇲🇰, maniobra 🇪🇸, manuver 🇮🇩, manewr 🇵🇱
                      <div></div>
                      <strong>Descendants:</strong> маневр 🇲🇳, маневр 🇺🇦, manevr
                      🇺🇿, маневр 🇰🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/matematika.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;математика"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μάθημα"
                      /máthēma/ -- "something that is learned", "lesson",
                      "knowledge", whence the phrase "μαθηματικὴ τέχνη"
                      /mathēmatikḗ tékhnē/ -- "mathematical sciences”, "sciences
                      of matters that have been learned" was derived.
                      Originally, “mathematics” referred to the science of
                      learning in general. Only after the term was used by the
                      "mathematikoi" (<i>i.e.,</i> "those who love to learn"), a
                      group of scholars in Ancient Greece who studied the ideas
                      of Pythagoras, especially those pertaining to arithmetic
                      and geometry, did the term "mathematics" become closely
                      associated with its modern meaning.
                      <div></div>
                      <strong>Cognates:</strong> mathematics 🇬🇧, математика 🇰🇿,
                      matematik 🇹🇷, matematica 🇮🇹, matematika 🇸🇰, Mathematik 🇩🇪,
                      математика 🇰🇬, matematyka 🇵🇱, matematik 🇸🇪, matemáticas
                      🇪🇸, matematik 🇹🇷, mathématiques 🇫🇷, matematika 🇵🇭,
                      matamaitic 🇮🇪, mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik 🇲🇾
                      <div></div>
                      <strong>Descendants:</strong> математика 🇰🇿, математик 🇲🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mattress.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;матрас"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Ancestor:</strong> Matratze 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> mattress 🇬🇧, materasso 🇮🇹,
                      matrac 🇸🇰, matras 🇳🇱, matelas 🇫🇷, матрас 🇰🇬, materac 🇵🇱,
                      madrass 🇸🇪
                      <div></div>
                      <strong>Descendants:</strong> матрас 🇰🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/medved.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;медведь"
                  hoverText={
                    <span>
                      <strong> Origin:</strong> From the Proto-Slavic "*medvě̀dь"
                      -- "honey eater" (a combination of "*medъ" -- "honey" and
                      "*(j)ěsti" -- "to eat”) via the Old Church Slavonic
                      "медвѣдь" -- "bear". Most scholars believe that early
                      Slavic peoples called the animal “the honey eater", in an
                      effort to avoid calling it by its real name, which, in
                      those superstitious cultures, was considered taboo, and
                      could cause it to appear during a hunt.
                      <div></div>
                      <strong>Related to:</strong> мёд
                      <div></div>
                      <strong>Cognates:</strong> мядзве́дзь 🇧🇾, medvěd 🇨🇿, medve
                      🇭🇺, ведмідь 🇺🇦, medved 🇸🇮, медвед 🇷🇸, niedźwiedź 🇵🇱
                      <div></div>
                      <strong>Partial Semantic Equivalents:</strong>
                      lokys 🇱🇹, lācis 🇱🇻, bear 🇬🇧, Bär 🇩🇪, bjørn 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mesti1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;мести (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic verb
                      "*mestì" -- "to throw", "to sweep".
                      <div></div>
                      <strong>Related to:</strong> метла
                      <div></div>
                      <strong>Cognates:</strong> (под)мести́ 🇺🇦, zamiatać 🇵🇱,
                      mesti 🇸🇮, помести 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/moneta.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;монета"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "monēta" -- "place
                      for coining money".
                      <div></div>
                      <strong>Perhaps related to:</strong> монополия, монах
                      <div></div>
                      <strong>Ancestor:</strong> moneta 🇵🇱
                      <div></div>
                      <strong>Cognates:</strong> monnaie 🇫🇷, moeda 🇵🇹, Münze 🇩🇪,
                      mynt 🇮🇸, moneda 🇪🇸, monēta 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/myshtsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;мышца"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Slavic "*mỳšь" --
                      "mouse". So called because flexed arm muscles look like
                      little mice.
                      <div></div>
                      <strong>Related to:</strong> под<u>мышка</u>, мускул
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, Muskel 🇩🇪, muskel 🇩🇰, muskel
                      🇳🇴, muskel 🇸🇪, mišića 🇭🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mint.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;мята"
                  hoverText={
                    <span>
                      <strong> Origin:</strong> From Mycenaean Greek "𐀖𐀲"
                      /mi-ta/ -- "mint plant" via the Latin "menta" -- "mint
                      (plant)", and the Proto-Slavi "*męta" -- "plant".
                      <div></div>
                      <strong>Not related to:</strong> мять (v.)
                      <div></div>
                      <strong> Cognates:</strong> mint 🇬🇧, Minze 🇩🇪, menta 🇵🇹,
                      menthe 🇫🇷, menta 🇪🇸, mięta 🇵🇱, menta 🇭🇺, mynte 🇳🇴, minttu
                      🇫🇮, mentă 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/nasekomoe.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;насекомое"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the French "insecte" --
                      "insect" which was itself borrowed as a word-for-word
                      translation of the Ancient Greek "ἔντομον" /éntomon/ --
                      "cut into sections". From the observation (first made by
                      Aristotle) that insects are physically separated (or
                      "cut") into three separate sections (head, thorax,
                      abdomen).
                      <div></div>
                      <strong>Related to:</strong> секс, сечение
                      <div></div>
                      <strong>Not related to:</strong> инцест
                      <div></div>
                      <strong>Cognates:</strong> in<u>secto</u> 🇪🇸, in
                      <u>sect</u> 🇬🇧, in<u>seto</u>
                      🇵🇹, in<u>setto</u> 🇮🇹, in<u>sectă</u> 🇷🇴, In<u>sekt</u>{" "}
                      🇩🇪, in<u>sect</u> 🇳🇱, in<u>sekt</u>
                      🇳🇴, in<u>sekt</u> 🇩🇰, насекомо 🇧🇬
                      <div></div>
                      <strong>Semantic equivalents:</strong> έντομο 🇬🇷, rovar
                      🇭🇺, trychfil 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/window.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;oкно"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*h₃ekʷ"
                      -- "eye" via the Proto-Slavic "okъnò" -- "window".
                      <div></div>
                      <strong>Related to:</strong> oко
                      <div></div>
                      <strong>Cognates:</strong> okno 🇨🇿, okno 🇵🇱, wind<u>ow</u>{" "}
                      🇬🇧, vind<u>u</u> 🇳🇴, акно 🇧🇾, okno 🇸🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pape.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;папа"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πάππᾰς"
                      /páppăs/ -- "father", via the Latin "pāpa" -- "pope",
                      "bishop".
                      <div></div>
                      <strong>Cognates:</strong> pape 🇫🇷, پاپ 🇮🇷, papa 🇪🇸, papa
                      🇦🇿, պապ 🇦🇲, папа 🇧🇾, papež 🇨🇿, pave 🇩🇰, paavi 🇫🇮, პაპი 🇬🇪,
                      Papst 🇩🇪, πάπας 🇬🇷, पोप 🇮🇳, paus 🇮🇩, pápa 🇮🇪, папа 🇰🇿,
                      pāvests 🇱🇻, popiežius 🇱🇹, Poopst 🇱🇺, пап 🇲🇳, papă 🇷🇴,
                      papež 🇸🇮, papa 🇹🇿, papa 🇹🇲, پوپ 🇵🇰, pab 🏴󠁧󠁢󠁷󠁬󠁳󠁿 بَابَا 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/persik.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;персик"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "mālum persicum" -- "Persian apple",
                      which itself comes from the Greek "μᾶλον περσικόν" /mâlon
                      persikón/. Peaches were brought to Europe from China via
                      Persia, so they were thought to come from the latter
                      region, hence the name. From Latin, the word entered
                      modern Russian via the Proto-West Germanic "*persik" –-
                      "peach" and the Middle High German "pfërsich" -- "peach".
                      <div></div>
                      <strong>Related to:</strong> Персия
                      <div></div>
                      <strong>Cognates:</strong> pêche 🇫🇷, peach 🇬🇧, ferskja 🇮🇸,
                      fersken 🇩🇰, fersken 🇳🇴, Pfirsich 🇩🇪, perzik 🇳🇱, persik 🇮🇩,
                      piersică 🇷🇴, pjeshkë 🇦🇱, pichi 🇹🇿, pêssego 🇵🇹, праска 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pijama1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;пижама"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "پایجامه" --
                      "pyjamas", "pants" (which is itself a combination of "پا"
                      /pâ/ -- “leg” and "جامه" /jâme/ -- "garment").
                      <div></div>
                      <strong>Ancestors:</strong> पैजामा 🇮🇳, پائِجامَہ 🇵🇰,
                      pyjama(s) 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> pijama 🇵🇹, Pyjama 🇩🇪, pijama
                      🇹🇷, pijama 🇷🇴, πυτζάμα 🇬🇷, піжама 🇺🇦, pyžamo 🇨🇿, pyjama
                      🇫🇮, поҷома 🇹🇯, پیژامه 🇦🇫, pidžama 🇭🇷, פיג׳מה 🇮🇱, pižama
                      🇱🇹, piama 🇮🇩
                      <div></div>
                      <strong>Descendants:</strong> pijama 🇦🇿, пижама 🇰🇬, pijama
                      🇹🇲, пижама 🇰🇿, პიჟამა 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/planeta1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;планета"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "
                      <u>πλάνητες</u> ἀστέρες" /plánētes astéres/, or "wandering
                      stars", so called because, compared to "απλανείς αστέρες"
                      /aplaneís astéres/, or "fixed stars", the stars that were
                      "πλάνητες" seemed to move around the sky a lot more.
                      <div></div>
                      <strong>Possibly related to:</strong> площадь, план,
                      плоский (adj.)
                      <div></div>
                      <strong>Cognates:</strong> planète 🇫🇷, pianeta 🇮🇹, planeta
                      🇪🇸, planeta 🇵🇹, Planet 🇩🇪, плане́та 🇧🇾, planet 🇦🇱, planet
                      🇸🇮, planēta 🇱🇻, planeta 🇨🇿, planeet 🇪🇪, planeta 🇵🇭,
                      плане́та 🇷🇺, planeetta 🇫🇮, planeet 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pomidor1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;помидор"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the plural "pomi d'oro" of
                      the Italian "pomo d'oro" -- "golden apple".
                      <div></div>
                      <strong>Ancestors:</strong> pomodoro 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> pomidoras 🇱🇹, بَنْدُورَة 🇸🇾,
                      pomidor 🇵🇱, помідор 🇺🇦
                      <div></div>
                      <strong>Descendants:</strong> pomidor 🇦🇿, памідор 🇧🇾,
                      помидор 🇰🇬, помидор 🇹🇯, pomidor 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;проблема"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "проблема"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> баллистика
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problema 🇪🇸,
                      problem 🇬🇧, problēma 🇱🇻, probleemi 🇪🇪, probléma 🇭🇺,
                      про̀бле̄м 🇷🇸, пробле́ма 🇺🇦, πρόβλημα 🇬🇷, problem 🇳🇴, problema
                      🇵🇭,
                      <div></div>
                      <strong>Descendants:</strong> პრობლემა 🇬🇪, проблема 🇰🇿,
                      проблема 🇰🇬, problema 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/psychiatry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;психиатр"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ψυχή" /psukhḗ/ -- "soul" and "ἰατρός" /iatrós/ --
                      “doctor”.
                      <div></div>
                      <strong>Cognates:</strong> Psychiater 🇩🇪, psychiatrist 🇬🇧,
                      psiquiatra 🇵🇹, psikiyatrist 🇹🇷, ფსიქიატრი 🇬🇪, psiquiatra
                      🇪🇸, psychiatre 🇫🇷, pszichiáter 🇭🇺, ψυχίατρος 🇬🇷,
                      psühhiaater 🇪🇪, פסיכיאטר 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rab.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;раб"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Proto-Slavic "*õrbъ" -- "servant", "slave", and the
                      Old Church Slavonic "рабъ" /rabŭ/ -- "slave", "servant".
                      <div></div>
                      <strong>Related to:</strong> работа, робот
                      <div></div>
                      <strong>Cognates:</strong> роб 🇧🇬, раб 🇺🇦, роб 🇲🇰, роб 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rabota.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;работа"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Proto-Slavic "*orbota" -- "work", "labor", and the Old
                      Church Slavonic "работа" /rabota/ -- "slavery",
                      "servitude".
                      <div></div>
                      <strong>Related to:</strong> раб, робот
                      <div></div>
                      <strong>Cognates:</strong> работа 🇧🇬, робота 🇺🇦, работа 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rastoyanie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sJgO6bNR7x4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;расстояние"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "раз" + стоя́ние", which was
                      borrowed as a word-for-word translation (<i>i.e.</i> a
                      "calque") of the French "distance" (which is itself a
                      combination of the Latin prefix "dis-" -- "apart" "in two"
                      and the Latin verb "stō" -- "to stand"). The concept comes
                      from the idea that when people argue, they’re not on the
                      same page (or really, in the same place). Therefore, they
                      stand apart, and there is "distance" between them.
                      <div></div>
                      <strong>Distant cognates:</strong> di<u>stancia</u> 🇪🇸, di
                      <u>stância</u> 🇵🇹, di<u>stance</u> 🇫🇷, di<u>stanță</u> 🇷🇴,
                      di<u>stanza</u> 🇮🇹, af<u>stand</u> 🇩🇰, av<u>stånd</u>
                      🇸🇪, af<u>stand</u> 🇳🇱, di<u>stance</u> 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;сахар"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel", via the Ancient Greek
                      "σάκχαρ" /sákkhar/ -- "sugar".
                      <div></div>
                      <strong>Cognates:</strong> zucchero 🇮🇹, ζάχαρη 🇬🇷, са́хар
                      🇷🇺, sucre 🇫🇷, sugar 🇬🇧, sukker 🇳🇴, azúcar 🇪🇸, cukier 🇵🇱,
                      siúcra 🇮🇪, suiker 🇳🇱, cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬,
                      շաքար 🇦🇲, شکر 🇮🇷, سُكَّر 🇸🇦, suhkur 🇪🇪, ስኳር 🇪🇹, zahăr 🇷🇴,
                      цукар 🇧🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/smeyatsya.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;cмеяться (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*smey-" -- "to laugh", "to be glad", via the Proto-Slavic
                      "*smьjàti" -- "to laugh".
                      <div></div>
                      <strong>Cognates:</strong> śmiać się 🇵🇱, смяяцца 🇧🇾, смея
                      се 🇧🇬, smát se 🇨🇿, smejati 🇸🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sobaka.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;собака"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Iranian
                      "*cwā" -- "dog", via the Proto-Medo-Parthian "*spā́kəh" --
                      "dog", the Proto-Slavic "*sobàka" -- "dog", and the Old
                      East Slavic "собака" -- "dog".
                      <div></div>
                      <strong>Cognates:</strong> сабака 🇧🇾, собака 🇺🇦
                      <div></div>
                      <strong>Probable cognates:</strong> سپی 🇦🇫, سگ 🇮🇷
                      <div></div>
                      <strong>Possible cognates:</strong> köpek 🇹🇷, köpek 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldat2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cолдат"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army. From "solidus", the word eventually developed into
                      the Italian "soldo" -- "penny", cent", then "soldato" --
                      "soldier", "one who earns a 'soldo'", and then, finally,
                      the modern Russian word.
                      <div></div>
                      <strong>Ancestor:</strong> soldo 🇮🇹, soldato 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> soldado 🇪🇸, soldier 🇬🇧, soldat
                      🇩🇰, soldado 🇵🇹, soldat 🇫🇷, soldat 🇸🇪, soldat 🇷🇴, Soldat
                      🇩🇪, soldaat 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sol.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;соль"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Proto-Slavic "*solь" --
                      "salt".
                      <strong>Related to:</strong> салат, сосиска, соус
                      <div></div>
                      <strong>Cognates:</strong> sel 🇫🇷, sal 🇪🇸, sale 🇮🇹, αλάτι
                      🇬🇷, salt 🇩🇰, sól 🇵🇱, salt 🇸🇪, salt 🇬🇧, Salz 🇩🇪, sůl 🇨🇿,
                      sāls 🇱🇻, suola 🇫🇮, sool 🇪🇪, sal 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sorok.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cорок"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old East Slavic verb
                      "cорокъ" -- "bunch (40) of sable pelts".
                      <div></div>
                      <strong>Likely related to:</strong> cорочка, cорока
                      <div></div>
                      <strong>Cognates:</strong> cорaк 🇧🇾, cо́рок 🇺🇦
                      <div></div>
                      <strong>Possible cognates:</strong> kırk 🇹🇷, кырк 🇰🇬, kyрк
                      🇹🇲, қырық 🇰🇿, qirq 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sorochka.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cорочка"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*sorka" --
                      "shirt", via the Old East Slavic "сорочька" --
                      "undershirt".
                      <div></div>
                      <strong>Likely related to:</strong> cорок, cорока
                      <div></div>
                      <strong>Cognates:</strong> särk 🇪🇪, særk 🇩🇰, särk 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/stor.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;сто"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Slavic "*sъ̏to" - "100"
                      <div></div>
                      <strong>Related to:</strong> про<u>це́нт</u>
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;спорт"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      Originally the word was more closely associated with the
                      idea of people letting themselves get carried away in a
                      pleasant activity that allowed them to just relax and have
                      fun.
                      <div></div>
                      <strong>Ancestor:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Related to:</strong> депортировать (v.)
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, sport
                      🇫🇷, Sport 🇩🇪, სპორტი 🇬🇪, spor 🇹🇷, ספּוֹרט 🇮🇱, sport 🇸🇪,
                      sport 🇭🇺, ስፖርት 🇪🇹, šport 🇸🇰
                      <div></div>
                      <strong>Descendants:</strong> спорт 🇲🇳, спорт 🇰🇿, սպորտ 🇦🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/toilettes.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;туалет"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tēla" -- "web",
                      "loom", via the Old French "toile" -- "cloth", "net", and
                      the Middle French "toilette" -- "small cloth". Originally,
                      people wrapped the "toilette" around their shoulders to
                      protect their clothes while doing their grooming. Over
                      time the cloth went from being on shoulders to being
                      spread out on a dressing table on which people would put
                      toiletry items. Eventually, the word came to refer to the
                      whole area where the dressing table was located (which was
                      often close to where people did their modern-day "toilet"
                      business).
                      <div></div>
                      <strong>Ancestor:</strong> toilettes 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> toilet 🇬🇧, Toilette 🇩🇪, toilet
                      🇳🇱, туале́т 🇷🇺, toaleta 🇵🇱, toalett 🇸🇪, tualete 🇱🇻, tuvalet
                      🇹🇷, toilet 🇿🇦, τουαλέτα 🇬🇷, туале́т 🇺🇦, toiled 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobby.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;хобби"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Ancestors:</strong> hobby 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> hobi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, xоби 🇲🇰, hobi 🇹🇷,
                      hobby 🇸🇪, Hobby 🇩🇪, hobbi 🇭🇺, hobis 🇱🇹, hobbi 🇦🇿, hobijs
                      🇱🇻, хоби 🇷🇸
                      <div></div>
                      <strong>Descendants:</strong> хобби 🇲🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chai.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;чай"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea" and the Ottoman Turkish "چای" /çay/ -- "tea". The
                      drink and its corresponding word made its way into many
                      West and Central Asian languages via land-based trading
                      routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy
                      🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱,
                      ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴,
                      čaj 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chemodan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;чемодан"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "جامه‌دان"
                      /jâme-dân/ -- "suitcase", which is itself a combination of
                      "جامه" /jâme/, -- “cloth” and "دان" /dân/ -- "container".
                      Literally, a "чемодан" is a container for storing cloth or
                      clothing, especially one used while travelling.
                      <div></div>
                      <strong>Related to:</strong> пи<u>жама</u>
                      <div></div>
                      <strong>Cognates:</strong> шабадан 🇰🇿, çemedan 🇹🇲
                      <div></div>
                      <strong>Descendants:</strong> čemodāns 🇱🇻, چمدان 🇮🇷,
                      ჩემოდანი 🇬🇪, чемодан 🇲🇳, чамадон 🇹🇯, чемодан 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shokolad.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;шоколад"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, cioccolato 🇮🇹
                      <div></div>
                      <strong>Descendants:</strong> shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱,
                      шакалод 🇹🇯,
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, seacláid 🇮🇪, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, шокола́д 🇷🇺, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, chocolate 🇬🇧, xocolata 🇦🇩,
                      чоколада 🇷🇸, çikolata 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/economy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;экономия"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "οἰκονομία"
                      /oikonomía/ -- "management of a household (a combination
                      of "οἶκος" /oîkos/ -- "house", "dwelling place" and the
                      verb "νέμω" /némō/ -- "to distribute", "to allocate”).
                      Originally, the word denoted the concept of properly
                      allocating and distributing the resources within one's
                      house.
                      <div></div>
                      <strong>Ancestor:</strong> économie 🇫🇷
                      <div></div>
                      <strong>Related to:</strong> <u>эко</u>логия
                      <div></div>
                      <strong>Cognates:</strong> economy 🇬🇧, economia 🇵🇹,
                      economia 🇹, økonomi 🇳🇴, økonomi 🇩🇰, οικονομία 🇬🇷,
                      economie 🇷🇴, economía 🇪🇸, ekonomi 🇹🇷
                      <div></div>
                      <strong>Descendant:</strong> ეკონომია 🇬🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇷🇸 SERBIAN 🇷🇸
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/narancha.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;наранча"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", via the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange", the Arabic "نارنج"
                      /nāranj/ –- “bitter orange”, and the Ottoman Turkish
                      "نارنج" /narenc/.
                      <div></div>
                      <strong>Cognates:</strong> orange 🇬🇧, arancia 🇮🇹, orange
                      🇬🇧, naranja 🇪🇸, naranča 🇭🇷, نارَنْج 🇮🇷, नारंगी 🇮🇳. laranja
                      🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;проблем"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "про̀бле̄м"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> балет
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problēma 🇱🇻, probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸,
                      пробле́ма 🇺🇦, пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴,
                      problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/smeche.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;смеће"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic verb
                      "*mestì" -- "to throw", "to sweep", via the noun "*sъ̏metь"
                      -- "sweepings", "trash".
                      <div></div>
                      <strong>Related to:</strong> по̀мести (<i>v</i>.), метла
                      <div></div>
                      <strong>Cognates:</strong> śmieci (<i>pl</i>.) 🇵🇱, cме́цце
                      🇧🇾, smeti 🇸🇮, сміття́ 🇺🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> basura 🇵🇭, basura
                      🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chokolada.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;чоколада"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, cioccolato 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, seacláid 🇮🇪, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, шокола́д 🇷🇺, shokolad 🇺🇿,
                      שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪, czekolada 🇵🇱,
                      chocolate 🇵🇹, chocolate 🇬🇧, xocolata 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇿🇼 SHONA 🇿🇼
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bhazi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bhazi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, auto
                      <u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u> 🇪🇸,
                      auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u> 🇵🇱,
                      auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u> 🇦🇱,
                      auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u> 🇺🇦,
                      авто́
                      <u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>, 巴士 🇨🇳,
                      बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇲🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇱🇰 SINHALA 🇱🇰
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cokalat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;චොකලට්"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid
                      🇮🇪, coklat 🇲🇾, 巧克力 🇨🇳, チョコレート 🇯🇵, ချောကလက် 🇲🇲,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sina.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;තේ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té
                      🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý 🇹🇲, اتاي
                      🇲🇷, شَاي 🇸🇦, ítí 🇿🇦, tea 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇸🇰 SLOVAK 🇸🇰
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_pl.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇦🇱, autobus
                      🇮🇹, авто́бус 🇷🇺, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas
                      🇱🇹, ავტობუსი 🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus
                      🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kalmar_sk.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kalmar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Ancestor:</strong> calamaro 🇮🇹, calmar 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar
                      🇦🇿, kałamarnica 🇵🇱, кальма́р 🇷🇺, klamar 🇲🇹, kalmari 🇫🇮,
                      calamar 🇪🇸, calamar 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/korova.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;krava"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Proto-Slavic "*kòrva"
                      -- "cow".
                      <div></div>
                      <strong>Cognates:</strong> крава 🇲🇰, корова 🇺🇦, крава 🇧🇬,
                      корова 🇷🇺, krava 🇸🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mattress.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;matrac"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "مَطْرَح"
                      /maṭraḥ/ -- "place where things are thrown". In the Middle
                      Ages the word was brought back to Europe by Crusaders who
                      had discovered the Middle Eastern practice of sleeping on
                      cushions that had been thrown onto the floor of a room.
                      <div></div>
                      <strong>Cognates:</strong> matelas 🇫🇷, materasso 🇮🇹,
                      mattress 🇬🇧, Matratze 🇩🇪, matras 🇳🇱, матра́с 🇷🇺, матрас 🇰🇬,
                      матрас 🇰🇿, materac 🇵🇱, madrass 🇸🇪, 매트리스 🇰🇷, マットレス
                      🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/robic.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;robiť (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Proto-Slavic "*orbota" -- "work", "labor".
                      <div></div>
                      <strong>Related to:</strong> robota, robot
                      <div></div>
                      <strong>Cognates:</strong> robić 🇵🇱, рабіць 🇧🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tlumacz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/j2E_-Jyl6AM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tlmočník"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*tilmač"
                      -- "an intermediary in communication between two parties
                      using different languages".
                      <div></div>
                      <strong>Ancestor:</strong> dilmaç 🇹🇷
                      <div></div>
                      <strong>Cognates:</strong> tolmács 🇭🇺, Dolmetscher 🇩🇪,
                      tolmač 🇸🇮, tłumacz 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇸🇮 SLOVENE 🇸🇮
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avtobus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avtobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇦🇱, autobus
                      🇮🇹, авто́бус 🇷🇺, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas
                      🇱🇹, ავტობუსი 🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus
                      🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hipoteka"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Ancestor:</strong> Hypothek 🇩🇪
                      <div></div>
                      <strong>Related to:</strong> teza
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, hipoteca 🇵🇹,
                      hipoteca 🇸🇮, ipotek 🇹🇷, ипотека 🇰🇿, ипотека 🇰🇬, hypothèque
                      🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/korova.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;krava"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Proto-Slavic "*kòrva"
                      -- "cow".
                      <div></div>
                      <strong>Related to:</strong> sŕna
                      <div></div>
                      <strong>Cognates:</strong> крава 🇲🇰, корова 🇺🇦, крава 🇧🇬,
                      корова 🇷🇺, krava 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muzȇj"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)", via the French "musée" -- "museum".
                      <div></div>
                      <strong>Ancestor:</strong> musée 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      Museum 🇩🇪, музе́й 🇧🇾, muzeum 🇦🇱, موزه 🇮🇷, müze 🇹🇷, muzejs
                      🇱🇻, muzeum 🇨🇿, muuseum 🇪🇪, múzeum 🇭🇺, מוּזֵיאוֹן 🇮🇱, muzeý
                      🇹🇲, музе́й 🇷🇺, muzium 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/stos.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sto"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Slavic "*sъ̏to" - "100"
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, сто 🇧🇬, сто
                      🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹, sto 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dolmetscher.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/j2E_-Jyl6AM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tolmač"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*tilmač"
                      -- "an intermediary in communication between two parties
                      using different languages", via the Proto-Slavic
                      "*tъlmáčь" -- "interpreter", "translator".
                      <div></div>
                      <strong>Cognates:</strong> тілмаш 🇰🇿, tolmács 🇭🇺, tłumacz
                      🇵🇱, dilmaç 🇹🇷, tlmočník 🇸🇰, Dolmetscher 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇸🇴 SOMALI 🇸🇴
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, auto
                      <u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u> 🇪🇸,
                      auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u> 🇵🇱,
                      auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u> 🇦🇱,
                      auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u> 🇺🇦,
                      авто́
                      <u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>, 巴士 🇨🇳,
                      बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇲🇼, bhazi 🇿🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shaah.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;shaah"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, شَاي 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶 🇯🇵, 차
                      🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸,
                      thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý 🇹🇲, chai 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇱🇸 SOTHO 🇱🇸
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bese"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, auto
                      <u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u> 🇪🇸,
                      auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u> 🇵🇱,
                      auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u> 🇦🇱,
                      auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u> 🇺🇦,
                      авто́
                      <u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>, 巴士 🇨🇳,
                      बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇲🇼, bhazi 🇿🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇪🇸 SPANISH 🇪🇸
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/abuelo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hW6xrMIwfhI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;abuelo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "avus" -- "adult
                      male relative (other than one's father)", via the Vulgar
                      Latin "*av(i)olus" -- "grandfather", and the Old Spanish
                      "avuelo" -- "grandfather".
                      <div></div>
                      <strong>Cognates:</strong> avô 🇵🇹, aïeul 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adolescent.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;adolescente"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "alescere" --
                      "to be nourished", "to grow up", via the Latin verb
                      "adolēscere" -- "to grow up", "to come to maturity", "to
                      ripen" and its present participle "adolescens" -- "growing
                      up", "maturing", "becoming an adult".
                      <div></div>
                      <strong>Related to:</strong> adulto, <u>alu</u>mno,
                      alimento
                      <div></div>
                      <strong>Cognates:</strong> adolescent 🇬🇧, adolescent 🇫🇷,
                      adolescente 🇵🇹, adolescent 🇷🇴, adolescent 🇦🇩, adolescente
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/eau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ztj_kCMZFS8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;agua"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*akwa" -- "(flowing) water" via the Latin "aqua" --
                      "water", and the Old Spanish "agua" -- "water".
                      <div></div>
                      <strong>Related to:</strong> acuario
                      <div></div>
                      <strong>Cognates:</strong> eau 🇫🇷, agua 🇵🇹, acqua 🇮🇹, apă
                      🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/albaricoque.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;albaricoque"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and finally, the modern Spanish word.
                      <div></div>
                      <strong>Related to:</strong> precoz (<i>adj.</i>)
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      abrikoos 🇳🇱, apricot 🇬🇧, абрико́с 🇷🇺, абрико́с 🇺🇦, berquq
                      🇲🇹, Aprikose 🇩🇪, aibreog 🇮🇪, aprikoti 🇹🇿, aprikot 🇮🇩,
                      abricot 🇫🇷, albercoc 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/alfombra.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lPqw4UFEXcg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;alfombra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*ḥabl-"
                      -- "rope" via the Arabic "حَنْبَل" -- "ceremonial
                      tapestry" and the Andalusian Arabic "الحنبل" --
                      "ceremonial flatweave tapestry".
                      <div></div>
                      <strong>Descendants:</strong> alpombra 🇵🇭
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/alumnus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lwVC7JMn0GY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;alimento"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "alimentum" --
                      "food", "nourishment", which itself is a combination of
                      the verb "alō" -- "to nourish" and the suffix "-mentum" --
                      "instrument", "medium", so literally an "alimento" is "a
                      medium of nourishment"
                      <div></div>
                      <strong>Related to:</strong> adulto, alumno
                      <div></div>
                      <strong>Cognates:</strong> aliment 🇫🇷, alimento 🇵🇹,
                      alimento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/animal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1uHUljh72FM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;alma"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "anima" -- "soul",
                      "spirit", "life", "air" , "breath" via the Old French
                      "ame"
                      <div></div>
                      <strong>Related to:</strong> animar (<i>v.</i>)<div></div>
                      <strong>Cognates:</strong> anima 🇮🇹, âme 🇫🇷, alma 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/amigo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;amigo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "amō" -- "I
                      love" via the adjective "amīcus" -- "friendly," "pleasant
                      to be around", and the Old Spanish "amigo" -- "friend".
                      <div></div>
                      <strong>Related to:</strong> en<u>emigo</u>
                      <div></div>
                      <strong>Cognates:</strong> ami 🇫🇷, amigo 🇵🇹, amico 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/assassin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zSk51b0WVHw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;asesino"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "أَسَاسِيِّين"
                      /ʔasāsiyyīn/ (the name for members of a fundamentalist
                      order in Shia Islam who made it their mission to protect
                      the Muslim faith in the Levant and Persia during the
                      Crusader Era). The word is traditionally thought to derive
                      from "حَشَّاشِين" /ḥaššāšīn/ -- "hashish users", as
                      members of the order were presumed (primarily by their
                      enemies) to be heavy users of hashish. It is, however,
                      more likely derived from "أَسَاس" /ʔasās/ -- “foundation",
                      "basis”.
                      <div></div>
                      <strong>Cognates:</strong> assassin 🇫🇷, assassin 🇬🇧,
                      assassino 🇵🇹, assassino 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobús.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;autobús"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>bús</u> 🇦🇩, auto<u>buz</u> 🇷🇴, avto<u>bus</u>{" "}
                      🇸🇮, auto<u>bus</u> 🇵🇱, auto<u>bus</u>, авто́<u>бус</u> 🇷🇺,
                      autó<u>busz</u> 🇭🇺, ôni<u>bus</u> 🇵🇹, auto<u>busas</u> 🇱🇹,
                      巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস
                      🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/adventure.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/t4CwXz_CSU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aventura"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "adventūrus" --
                      "to be about to arrive", a participle of the verb
                      "adveniō" -- "to arrive", "to come to a specific
                      location". The original sense of "aventure" is therefore
                      "something that is about to happen (no matter how mundane
                      or exciting)."
                      <div></div>
                      <strong>Related to:</strong> venir (v.)
                      <div></div>
                      <strong>Cognates:</strong> Abenteuer 🇩🇪, adventure 🇬🇧,
                      avontuur 🇳🇱, aventure 🇫🇷, avventura 🇮🇹, aventura 🇵🇹,
                      äventyr 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/aviso.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;aviso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Latin prefix
                      "ad-" -- "to", "in", and the passive participle "vīsus" --
                      "having been seen" of the verb "videō" -- "to see". The
                      combination was the basis of the latter part of the Old
                      French phrase "ce m'est a vis" – “it is my view”, which
                      eventually developed into the single word "avis" --
                      "opinion", and, from there, the Old Spanish "avisar" --
                      "to look at", "to consider".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dente</u>, pru
                      <u>dente</u> (<i>adj</i>.), visa, visión, en<u>vidia</u>,
                      video
                      <div></div>
                      <strong>Cognates:</strong> aviso 🇵🇹, avviso 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;azúcar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel", via the Middle Persian
                      "𐭱𐭪𐭥" /šakar/ -- "sugar", and the Arabic "السُّكَّر"
                      /as-sukkar/ -- "sugar".
                      <div></div>
                      <strong>Ancestor:</strong> شکر 🇮🇷, سُكَّر 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> zucchero 🇮🇹, ζάχαρη 🇬🇷, са́хар
                      🇷🇺, sucre 🇫🇷, sugar 🇬🇧, sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪,
                      suiker 🇳🇱, cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲,
                      suhkur 🇪🇪, ስኳር 🇪🇹
                      <div></div>
                      <strong>Descendants:</strong> asukal 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ball.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;baile"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "βάλλω" /bállō/ -- “to throw", "to cast", "to hurl” via
                      the Latin "ballō" -- “to dance”.
                      <div></div>
                      <strong>Related to:</strong> pro<u>blema</u>
                      <div></div>
                      <strong>Cognates:</strong> Ball 🇩🇪, bal 🇳🇱, baile 🇵🇹, ball
                      🇬🇧, ballo 🇮🇹, бал 🇧🇬, бал 🇲🇰, bal 🇺🇿, ball 🇮🇸, бал 🇺🇦, бал
                      🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;banana"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳
                      <div></div>
                      <strong>Cognates:</strong> banana 🇵🇹
                      <div></div>
                      <strong>Likely Descendants:</strong> banane 🇫🇷, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿,
                      banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪, banaan 🇳🇱,
                      μπανάνα 🇬🇷, banan 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/barrer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;barrer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "verrō" --
                      "to sweep (away)", "to carry off".
                      <div></div>
                      <strong>Related to:</strong> basura
                      <div></div>
                      <strong>Cognates</strong> varrer 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/basura.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;basura"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "verrō" --
                      "to sweep (away)", "to carry off", via the Vulgar Latin
                      "*versūra" –- “sweepings”, "rubbish", and the Old Spanish
                      "vassura" -- "trash".
                      <div></div>
                      <strong>Related to:</strong> barrer (<i>v</i>.)
                      <div></div>
                      <strong>Descendants:</strong> basura 🇵🇭
                      <div></div>
                      <strong>Semantic equivalents:</strong> śmieci (<i>pl</i>.)
                      🇵🇱, cме́цце 🇧🇾, смѐће 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/brush.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;brocha"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*bruskaz" --
                      “tuft", "thicket", "underbrush” via the Old French
                      "broisse" -- "brush".
                      <div></div>
                      <strong>Ancestor:</strong> brosse 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> brush 🇬🇧, brocha 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/calamar_es.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;calmar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, via the
                      Latin "calamus –- “reed”, “cane”.
                      <div></div>
                      <strong>Ancestors:</strong> calamaro 🇮🇹, calamar 🇦🇩
                      <div></div>
                      <strong>Cognates:</strong> кальмар 🇰🇬, kalamar 🇹🇷, kalmar
                      🇦🇿, calamar 🇪🇸, kałamarnica 🇵🇱, kalmar 🇸🇰, кальма́р 🇷🇺,
                      klamar 🇲🇹, kalmari 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chameau.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;camello"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel", via the Ancient Greek "κᾰ́μηλος" /kắmēlos/ --
                      "camel", and the Latin "camēlus" -- "camel".
                      <div></div>
                      <strong>Cognates:</strong> ޖަމަލު 🇲🇻, جَمَل 🇸🇦, ግመል 🇪🇹,
                      גמל 🇮🇱, ngamia 🇹🇿, Kamel 🇩🇪, camel 🇬🇧, cammello 🇮🇹, camelo
                      🇵🇹, chameau 🇫🇷, kamel 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canibal_es.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RRJ0iVch70s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;caníbal"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> Likely from the
                      Proto-Cariban "*karipona" -- "person", via the Taíno
                      "Cariba" -- "member of the Carib tribe". At the time of
                      Columbus’s arrival in the Americas, the Caribs were
                      described by other tribes as ferocious maneaters, a
                      depiction that later became closely associated with their
                      name.
                      <div></div>
                      <strong>Related to:</strong> caribe (<i>adj.</i>)
                      <div></div>
                      <strong>Descendants:</strong> cannibal 🇬🇧, canibal 🇵🇹,
                      kannibal 🇸🇪, cannibale 🇮🇹, Kannibale 🇩🇪, kannibal 🇩🇰,
                      канниба́л 🇷🇺, kanibalas 🇱🇹, კანიბალი 🇬🇪, kannibal 🇪🇪,
                      kanibal 🇲🇾, kanibal 🇮🇩, קָנִיבָּל 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canyon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;caña"
                  hoverText={
                    <span>
                      <div>
                        <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/
                        -- "reed", via the Ancient Greek "κάννα" /kánna/ --
                        “reed”, and the Latin "canna" -- "reed".
                      </div>
                      <div>
                        <strong>Related to:</strong> cañón (weapon), cañón
                        (valley), canal, caño
                      </div>
                      <div>
                        <strong>Descendants:</strong> canne 🇫🇷, cana 🇵🇹
                      </div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canyon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;caño"
                  hoverText={
                    <span>
                      <div>
                        <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/
                        -- "reed", via the Ancient Greek "κάννα" /kánna/ --
                        “reed”, and the Latin "canna" -- "reed", and "caña" --
                        "reed".
                      </div>
                      <div>
                        <strong>Ancestor:</strong> cana 🇵🇹
                      </div>
                      <div>
                        <strong>Related to:</strong> cañón (weapon), cañón
                        (valley), canal, caña
                      </div>
                      <div>
                        <strong>Cognates:</strong> cano 🇵🇹
                      </div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/canyon.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/panxjCBMm6Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cañón"
                  hoverText={
                    <span>
                      <strong>
                        <u>"valley"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/
                        -- "reed", via the Ancient Greek "κάννα" /kánna/ --
                        “reed”, the Latin "canna" -- "reed", and "caño" --
                        "pipe", "tube". The name comes from the fact that a
                        "cañón" has a long cylindrical reed-like shape (
                        <i>i.e.</i>, it is an elongated and semicylindrical
                        surface that conducts water, like a pipe or a tube).
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Related to:</strong> cañón (weapon), canal,
                        caña, caño
                        <div></div>
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Not related to:</strong> canabis
                        <div></div>
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> canhão 🇵🇹, kanjon 🇸🇪
                        <div></div>
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Descendants:</strong> canyon 🇬🇧, canyon 🇫🇷,
                        каньо́н 🇷🇺, kanion 🇵🇱, kanjon 🇸🇮, каньо́н 🇧🇬, kanjons 🇱🇻,
                        каньон 🇰🇿
                        <div></div>
                      </div>
                      <strong>
                        <u>"weapon"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Sumerian "𒄀𒈾" /gi.na/
                        -- "reed", via Ancient Greek "κάννα" /kánna/ -- “reed”,
                        and the Latin "canna" -- "reed". The name comes from the
                        fact that a "cañón" has a long cylindrical reed-like
                        shape.
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Related to:</strong> cañón (valley), canal,
                        caña, caño
                        <div></div>
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Not related to:</strong> canabis
                        <div></div>
                      </div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> canon 🇫🇷, cannon 🇬🇧, kanon
                        🇸🇪, cannone 🇮🇹, Kanone 🇩🇪, kanon 🇩🇰
                        <div></div>
                      </div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cedula.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cédula"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "σχέδη"
                      /skhédē/ -- “papyrus leaf” via the Latin "schedula" --
                      "strip of paper made out of 'skhede'.
                      <div></div>
                      <strong>Cognates:</strong> cédula 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cementerio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cementerio"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "κοιμητήριον"
                      /koimētḗrĭon/ -- "place to sleep", "dormitory".
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cimitir 🇷🇴, cemitério 🇵🇹, cmentarz 🇵🇱, cimetière 🇫🇷,
                      cemetery 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> sementeryo 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cien.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cien"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" -- "100", via the Proto-Italic "*kentom" --
                      "100", and the Latin "centum" -- "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, hundred 🇬🇧, cent 🇫🇷, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ciencia.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/DJ-ABPy6Udw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ciencia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "sciō" -- "to
                      know", and its present participle "sciēns" via the Old
                      French noun "science" -- "knowledge", "awareness".
                      <div></div>
                      <strong>Related to:</strong> con
                      <u>ciencia</u>
                      <div></div>
                      <strong>Cognates:</strong> science 🇬🇧, science 🇫🇷, ciência
                      🇵🇹, sayansi 🇹🇿, sains 🇲🇾, scienza 🇮🇹, știință 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/codo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7wJGY2oYJMU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;codo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "cubō" -- "to
                      lie down", "to recline" and its descendant, the noun
                      "cubitum" which denoted the length from the edge of the
                      forearm (<i>i.e.</i>, the elbow) to the tip of the
                      outstretched hand. From there, the word entered modern
                      Spanish via the Old Spanish "cobdo" -- "elbow".
                      <div></div>
                      <strong>Cognates:</strong> cotovelo 🇵🇹, gomito 🇮🇹, coude
                      🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/consider.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/OyZjPK6RSss"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;considerar (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely a combination of the Latin
                      prefix "con-" -- "together", "with", and the noun "sīdus"
                      -- "star(s)". The origin of the word is linked to the
                      notion of ancient peoples looking at the sky and gaining
                      insight by considering the movements of the stars.
                      <div></div>
                      <strong>Cognates:</strong> considérer 🇫🇷, considerar 🇵🇹,
                      considerare 🇮🇹, consider 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/horn.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cuerno"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ḱerh₂-" -- "horn", "head", via the Latin “cornū” --
                      “end”, “horn”, “place where two converging lines meet”.
                      <div></div>
                      <strong>Cognates:</strong> Horn 🇩🇪, horn 🇬🇧, corne 🇫🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> 角 🇨🇳, tê{" "}
                      <u>giác</u> 🇻🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;deporte"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along".
                      Originally the word was more closely associated with the
                      idea of people letting themselves get carried away in a
                      pleasant activity that allowed them to just relax and have
                      fun.
                      <div></div>
                      <strong>Related to:</strong> deportar (v.)
                      <div></div>
                      <strong>Cognates:</strong> sport 🇬🇧, спорт 🇷🇺, Sport 🇩🇪,
                      სპორტი 🇬🇪, spor 🇹🇷, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺, ስፖርት
                      🇪🇹, šport 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/disaster.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Gt0B3coiu7s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;desastre"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "dis-" --
                      (used to convey negation/separation) and the noun
                      "-astrum". A "disaster" is literally a "negative (
                      <i>i.e.</i>, unlucky) star". In ancient times catastrophes
                      were often thought to be the results of misalignments of
                      planets and stars in the sky.
                      <div></div>
                      <strong>Related to:</strong> <u>astro</u>nomía, estrella
                      <div></div>
                      <strong>Cognates:</strong> disaster 🇬🇧, desastre 🇵🇹,
                      désastre 🇫🇷, dezastru 🇷🇴, disastro 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/divan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QvEelikIifk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;diván"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "دیوان" /dēwān/
                      -- "Council of State (which was held in a room with
                      cushioned seating along the walls), via the Ottoman
                      Turkish "دیوان" /dîvân/ -- "cushioned bench", "couch".
                      <div></div>
                      <strong>Related to:</strong> aduana
                      <div></div>
                      <strong>Cognates:</strong> диван 🇺🇦, diivan 🇪🇪, дива́н 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/double.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/uV1XopnC5vQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;doble (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*dwóh₁" -- "two", likely via the Latin "duplus" --
                      “twofold”, "double".
                      <div></div>
                      <strong>Related to:</strong> dos
                      <div></div>
                      <strong>Cognates:</strong> double 🇫🇷, double 🇬🇧, doppio
                      🇵🇹, dubbel 🇳🇱, doppel 🇩🇪, подвійний 🇺🇦, dvojitý 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/economy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;economía"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "οἰκονομία"
                      /oikonomía/ -- "management of a household (a combination
                      of "οἶκος" /oîkos/ -- "house", "dwelling place" and the
                      verb "νέμω" /némō/ -- "to distribute", "to allocate”).
                      Originally, the word denoted the concept of properly
                      allocating and distributing the resources within one's
                      house.
                      <div></div>
                      <strong>Related to:</strong> <u>eco</u>logía
                      <div></div>
                      <strong>Cognates:</strong> economy 🇬🇧, économie 🇫🇷,
                      economia 🇵🇹, economia 🇮🇹, økonomi 🇳🇴, økonomi 🇩🇰,
                      οικονομία 🇬🇷, economie 🇷🇴, эконо́мия 🇷🇺, ეკონომია 🇬🇪,
                      ekonomi 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/enemigo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fs3Nw4lQxVM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;enemigo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "inimīcus" (
                      <i>i.e.</i>, "in-" -- “not” + "amīcus" - “friend”) via the
                      Old Spanish "enemigo" -- "fiend".
                      <div></div>
                      <strong>Related to:</strong> amigo
                      <div></div>
                      <strong>Cognates:</strong> enemy 🇬🇧, ennemi 🇫🇷, inimigo
                      🇵🇹, inamic 🇷🇴, nemico 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/estar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sJgO6bNR7x4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;estar (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "stō" -- "to
                      stand", via the Old Spanish verb "estar" -- "to stand",
                      "to be".
                      <div></div>
                      <strong>Related to:</strong> estación
                      <div></div>
                      <strong>Cognates:</strong> estar 🇵🇹, stare 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/spirit.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;espíritu"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "spīritus" --
                      "breath". A "espíritu" is therefore an entity that
                      "breathes" within us.
                      <div></div>
                      <strong>Related to:</strong> in<u>spirar</u> (v.), trans
                      <u>spirar</u> (v.), ex<u>pirar</u>, con<u>spir</u>ación
                      <div></div>
                      <strong>Cognates:</strong> esprit 🇫🇷, spirito 🇮🇹, spirit
                      🇬🇧, espírito 🇵🇹, espiritu 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/east.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;este"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₂ewsér" -- "in the direction of dawn", "east", via the
                      Proto-Germanic "*austrą" -- "east", and the Old English
                      "ēast".
                      <div></div>
                      <strong>Cognates:</strong> Osten 🇩🇪, oosten 🇳🇱, east 🇬🇧,
                      øst 🇩🇰, est 🇲🇹, est 🇮🇹, este 🇵🇹, est 🇷🇴, est 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/star.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Gt0B3coiu7s"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;estrella"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂stḗr" -- “star” via Proto-Italic "*stērlā" -- "star",
                      via the Latin "stēlla" -- "star", and the Old Spanish
                      "estrella" -- "star".
                      <div></div>
                      <strong>Cognates:</strong> star 🇬🇧, Stern 🇩🇪, αστέρι 🇬🇷,
                      étoile 🇫🇷, estrela 🇵🇹, stjerne 🇩🇰, stjärna 🇸🇪, stella 🇮🇹,
                      stea 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/strange.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;extraño (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a compound of the Latin
                      "extrā" -- "outside” and the suffix "-āneus" -- "of or
                      pertaining to". Literally, being "extraño" is akin to
                      being "outside (of the norm)".
                      <div></div>
                      <strong>Cognates:</strong> étrange 🇪🇸, strange 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;familia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Cognates:</strong> family 🇬🇧, familja 🇲🇹, famille
                      🇫🇷, familie 🇩🇰, familie 🇳🇴, Familie 🇩🇪, famiglia 🇮🇹,
                      família 🇵🇹, familie 🇷🇴
                      <div></div>
                      <strong>Descendants:</strong> pamilya 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/flor.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;flor"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Latin "flōs" (and
                      its accusative form "flōrem") –- “flower”, “blossom”, and
                      the Old Spanish "flor" -– "flower".
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, fleur 🇫🇷, flor 🇵🇹,
                      fiore 🇮🇹, flower 🇬🇧, blomst 🇳🇴, blomst 🇩🇰, blomma 🇸🇪,
                      Blume 🇩🇪, floare 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/frambuesa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;frambuesa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West-Germanic
                      "brāmabaʀi" -- "blackberry" (which itself is a combination
                      of "*brāma" -- "bramble", "thorn bush", and "*baʀi" –
                      "berry"), via the Frankish "*brāmabasi" -– "blackberry",
                      and the Old French "framboise" -- "raspberry". The initial
                      "br-" and final "re" evolved into "fr" and "-sa",
                      respectively, via dissimilation and likely due to the
                      influence of the similar sounding French noun "fraise".
                      <div></div>
                      <strong>Not related to:</strong> fresa
                      <div></div>
                      <strong>Ancestor:</strong> framboise 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> Him<u>beere</u> 🇩🇪, Rasp
                      <u>berry</u> 🇬🇧, rasi<u>beri</u> 🇹🇿, framboos 🇳🇱, bringe
                      <u>bær</u> 🇳🇴, framboesa 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fresa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fresa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "frāgum" --
                      "strawberry" (and specifically its nominative plural form
                      "frāga") via the Old French "freise" -- "strawberry".
                      <div></div>
                      <strong>Not related to:</strong> frambuesa
                      <div></div>
                      <strong>Cognates:</strong> fragola 🇮🇹, فراولة 🇸🇦
                      <div></div>
                      <strong>Ancestor:</strong> fraise 🇫🇷
                      <div></div>
                      <strong>Descendants:</strong> presa 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gozo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gozo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "gaudium" --
                      "joy".
                      <div></div>
                      <strong>Possibly related to:</strong> joya
                      <div></div>
                      <strong>Cognates:</strong> gozo 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guerra.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;guerra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*werru" –- "confusion", "disorder", via the Frankish
                      "*werru" –- "confusion", "disorder", the Medieval Latin
                      "werra" -- "war", "strife", and the Old Spanish "guerra"
                      -– "armed conflict", “war”.
                      <div></div>
                      <strong>Cognates:</strong> war 🇬🇧, guerra 🇮🇹, guerra 🇵🇹,
                      guerre 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/helice.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LNKXB8lvtlg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hélice"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "ἕλιξ" /hélix/
                      -- “spiral”.
                      <div></div>
                      <strong>Related to:</strong> <u>helic</u>óptero
                      <div></div>
                      <strong>Cognates:</strong> hélice 🇵🇹, hélice 🇫🇷, elica 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hipopótamo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ἱπποπόταμος" /hippopótamos/, which itself is a compound
                      of "ἵππος" /híppos/ -- “horse” and "ποταμός" /potamós/ --
                      "river". The word was coined by Herodotus based on
                      accounts he had heard about the animal's physical
                      characteristics and natural habitat.
                      <div></div>
                      <strong>Related to:</strong> hippodrome
                      <div></div>
                      <strong>Cognates:</strong> xипопота́м 🇧🇬, hippopotamus 🇬🇧,
                      hipopótamo 🇵🇹, hippopotamus 🇬🇧, гиппопота́м 🇷🇺, ippopotamo
                      🇮🇹, ჰიპოპოტამი 🇬🇪
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, 河马 🇨🇳,
                      Nilpferd 🇩🇪, nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा
                      🇮🇳, dobhareach 🇮🇪, su aygırı 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hipoteca"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Related to:</strong> biblio<u>teca</u>, tesis
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, ipotek 🇹🇷,
                      hipoteca 🇵🇹, hypothèque 🇫🇷, hipoteka 🇵🇱, hipoteka 🇸🇮,
                      ипотека 🇰🇿, Hypothek 🇩🇪, ипотека 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fungus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hongo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "σφόγγος"
                      /sphóngos/ -- "sponge", via the Latin "fungus" --
                      "mushroom", "fungus".
                      <div></div>
                      <strong>Related to:</strong> esponja
                      <div></div>
                      <strong>Cognates:</strong> fungus 🇬🇧, fungo 🇵🇹
                      <div></div>
                      <strong>Semantic Equivalents:</strong> svamp 🇩🇰, svamp 🇸🇪,
                      zwam 🇳🇱
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/orphelin.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AvWf8R3DSLo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;huérfano"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₃órbʰos" -- "orphan", "servant", "slave", "worker", via
                      the Ancient Greek adjective "ὀρφανός" /orphanós/ --
                      "without parents", "fatherless", and the Latin "orphanos"
                      -- "orphan".
                      <div></div>
                      <strong>Related to:</strong> robot
                      <div></div>
                      <strong>Cognates:</strong> orphan 🇬🇧, orphelin 🇫🇷, orfano
                      🇮🇹, órfão 🇵🇹, orfan 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ospite.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1VA4S3AMxB4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;huésped"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ghos-ti-" -- "stranger", "guest", "host", "someone with
                      whom one has reciprocal duties of hospitality". Via
                      different paths the root eventually developed into the
                      antonym pair "guest" and "host".
                      <div></div>
                      <strong>Related to:</strong> hostal, hotel, hospital,
                      hostilidad, hospitalidad, hospicio
                      <div></div>
                      <strong>Cognates:</strong> gość 🇵🇱, hôte 🇫🇷, ospite 🇮🇹,
                      гость 🇷🇺, oaspete 🇷🇴, Gast 🇩🇪, gast 🇳🇱, hosť 🇸🇰, host 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/reloj.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hora"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "ὥρα"
                      /hṓra/ -- "any time or period, whether of the year, month,
                      or day", via the Latin "hōra" -- "hour".
                      <div></div>
                      <strong>Related to:</strong> <u>horó</u>scopo, <u>oro</u>
                      logio
                      <div></div>
                      <strong>Cognates:</strong> hora 🇵🇹, heure 🇫🇷, ora 🇮🇹, uur
                      🇳🇱, oră 🇷🇴, hora 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/guest.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1VA4S3AMxB4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hotel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ghos-ti-" -- "stranger", "guest", "host", "someone with
                      whom one has reciprocal duties of hospitality". In the
                      Middle Ages the Old French "hostel", a distant descendant
                      of the Proto-Indo European root which later became the
                      English "hotel", was a guesthouse or inn for lodgers.
                      <div></div>
                      <strong>Related to:</strong> hostel, hospital, hostility,
                      hospitality, hospice, host, guest
                      <div></div>
                      <strong>Cognates:</strong> hotel 🇪🇸, hotel 🇵🇹, hotel 🇵🇱,
                      hôtel 🇫🇷, hotelli 🇫🇮, hotel 🇳🇱, hotel 🇩🇰, hotel 🇵🇭, hotell
                      🇳🇴
                      <div></div>
                      <strong>Descendants:</strong> ホテル 🇯🇵, هُتِل 🇮🇷, होटल
                      🇮🇳, 호텔 🇰🇷, হোটেল 🇧🇩, ဟိုတယ် 🇲🇲, होटल 🇳🇵, готель 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/humano.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/l9FXik2QA8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;humano"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "hominem" (which
                      is likely a derivative of the noun "homō̆" -- "human
                      being"), via the adjective "hūmānus" -- "human", and the
                      Middle French "humain" -- "human".
                      <div></div>
                      <strong>Likely related to:</strong> <u>homo</u>sexual,
                      hombre
                      <div></div>
                      <strong>Cognates:</strong> human 🇬🇧, humain 🇫🇷, humano 🇵🇹,
                      umano 🇮🇹, humà 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idioma.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idioma"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδίωμα" /idíōma/ -- "a peculiarity", "a property", "a
                      peculiar phraseology", "idiom".
                      <div></div>
                      <strong>Related to:</strong> idiota
                      <div></div>
                      <strong>Cognates:</strong> idioma 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇮🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/idiota.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gk5jcpjgeww"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "SlateBlue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;idiota"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek adjective
                      "ἴδιος" /ídios/ -- "pertaining to oneself", "private”, via
                      "ἰδιώτης" /idiṓtēs/ -- “a private citizen (<i>i.e.</i>,
                      one who has no professional knowledge)", "layman”, and the
                      Latin "idiōta" -- "uneducated or illiterate person". Like
                      the Greeks before them, the Romans used the word to refer
                      to someone lacking any professional skills, but they
                      placed emphasis on the fact that an “idiota” lacked
                      education and was therefore ignorant.
                      <div></div>
                      <strong>Related to:</strong> idioma
                      <div></div>
                      <strong>Cognates:</strong> Idiot 🇩🇪, идиот 🇲🇰, идиот 🇷🇺,
                      идиот 🇧🇬, idiot 🇬🇧, idiota 🇵🇹, idiota 🇵🇱, idiot 🇫🇷,
                      idiootti 🇫🇮, idioot 🇳🇱, idiot 🇩🇰, idiot 🇳🇴, אִידְיוֹט 🇮🇱,
                      idioot 🇪🇪, იდიოტი 🇬🇪, idiot 🇸🇮, idiot 🇦🇱, idiotas 🇱🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/inspire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vLoHAJNRouQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;inspirar (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin prefix "in-" --
                      "in" and the verb "spīrō" -- "to breathe". When we are
                      "inspirado", we literally receive a breath from some
                      divine force that gives us not only life, but also, great
                      ideas.
                      <div></div>
                      <strong>Related to:</strong> espíritu, ex<u>pirar</u>,
                      trans
                      <u>spirar</u>, con<u>spir</u>ación
                      <div></div>
                      <strong>Cognates:</strong> inspire 🇬🇧, inspirer 🇫🇷,
                      inspirar 🇵🇹, ispirare 🇮🇹, inspirieren 🇩🇪, inspirować 🇵🇱,
                      inspirera 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/izquierda.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;izquierda"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Basque "ezkerra" (the
                      absolutive singular form of the adjective "ezker" --
                      "left", which itself is possibly derived from the noun
                      "esku" -- "hand", and the adjective "oker" -- "wrong").
                      The historical meaning is based on the popular notion in
                      earlier centuries that the left hand was weaker and less
                      dexterous than the right hand.
                      <div></div>
                      <strong>Cognates:</strong> esquerda 🇵🇹
                      <div></div>
                      <strong>Possible semantic equivalents:</strong> gauche 🇫🇷,
                      sinistro 🇮🇹, ле́вый 🇷🇺, 왼쪽 🇰🇷, kreiss 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jaula.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PNsDhV9IweI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jaula"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "cavus"
                      -- "hollow", via the Late Latin noun "caveola –- “little
                      cage", the Old French "jaiole" – “cage”, “jail”, and the
                      Old Spanish "javola" -- "cage".
                      <div></div>
                      <strong>Related to:</strong> cueva, cavidad
                      <div></div>
                      <strong>Cognates:</strong> Käfig 🇩🇪, kooi 🇳🇱, gabbia 🇮🇹,
                      cave 🇬🇧, cage 🇫🇷, gaiola 🇵🇹, Käfeg 🇱🇺, kou 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/joy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;joya"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Latin "gaudium"
                      -- "joy", via the Old Galician-Portuguese "joya" --
                      "jewel".
                      <div></div>
                      <strong>Possibly related to:</strong> gozo
                      <div></div>
                      <strong>Cognates:</strong> joia 🇵🇹, Juwel 🇩🇪, juweel 🇳🇱,
                      juvel 🇩🇰, juvel 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/juego.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/pJ213AlKfR4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;juego"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "iocus" -- "joke",
                      "amusement", "pastime", "sport".
                      <div></div>
                      <strong>Cognates:</strong> jeu 🇫🇷, jogo 🇵🇹, gioco 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leer.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lVpHk6bQL_I"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;leer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*leǵ-" -- "to gather", "to collect", via the Proto-Italic
                      "*legō" -- "to gather", "to collect" and the Latin
                      "legere" -- "to read".
                      <div></div>
                      <strong>Related to:</strong> inte<u>li</u>gencia, inte
                      <u>lect</u>ual
                      <div></div>
                      <strong>Cognates:</strong> lire 🇫🇷, ler 🇵🇹, leggere 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/manana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mañana"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Vulgar Latin "*māneāna"
                      -- "in the (early) morning" (which itself is a combination
                      of the noun "māne" -- "morning" and the suffix "-ānum",
                      and over time became the Old Spanish "mannana" --
                      "tomorrow morning").
                      <div></div>
                      <strong>Cognates:</strong> do<u>mani</u> 🇮🇹, manhã 🇵🇹,
                      mâine 🇷🇴, de<u>main</u> 🇫🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> morgen 🇩🇪, morgen
                      🇳🇱, 明日 🇯🇵, заўтра 🇧🇾, за́втра 🇺🇦, за́втра 🇷🇺, zítra 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mano.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/7fe2-UxXMI8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mano"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*manus" --
                      "hand", via the Latin "manus" -- "hand".
                      <div></div>
                      <strong>Related to:</strong> <u>man</u>iobra, manipulación
                      <div></div>
                      <strong>Cognates:</strong> main 🇫🇷, mão 🇵🇹, mano 🇮🇹, mână
                      🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/map.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mapa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from Phoenician "𐤌𐤀𐤐"
                      /mappē/ ⁠ -- "fine cloth" via the Latin "mappa" -- "a
                      tablecloth (or large napkin) that guests would often bring
                      and use at the dinner table to wrap items of food that
                      they wished to take away with them". People later started
                      to use these fine cloths as writing surfaces for elaborate
                      world maps, which they called "mappa mundi" or "cloth of
                      the earth". Eventually, the second component "mundi" was
                      dropped, leaving only "mappa".
                      <div></div>
                      <strong>Cognates:</strong> mapa 🇵🇱, mapa 🇨🇿, מַפָּה 🇮🇱,
                      mapa 🇪🇸, mapa 🇵🇹, mappa 🇮🇹, mappa 🇲🇹
                      <div></div>
                      <strong>Descendants:</strong> mapa 🇵🇭󠁧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mathematik.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;matemáticas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μάθημα"
                      /máthēma/ -- "something that is learned", "lesson",
                      "knowledge", whence the phrase "μαθηματικὴ τέχνη"
                      /mathēmatikḗ tékhnē/ -- "mathematical sciences”, "sciences
                      of matters that have been learned" was derived.
                      Originally, “mathematics” referred to the science of
                      learning in general. Only after the term was used by the
                      "mathematikoi" (<i>i.e.,</i> "those who love to learn"), a
                      group of scholars in Ancient Greece who studied the ideas
                      of Pythagoras, especially those pertaining to arithmetic
                      and geometry, did the term "mathematics" become closely
                      associated with its modern meaning.
                      <div></div>
                      <strong>Cognates:</strong> mathématiques 🇫🇷, математика
                      🇰🇿, matematik 🇹🇷, matematica 🇮🇹, matematika 🇸🇰,
                      mathematics 🇬🇧, математика 🇰🇬, matematyka 🇵🇱, matematik
                      🇸🇪, Mathematik 🇩🇪, matematik 🇹🇷, математик 🇲🇳, матема́тика
                      🇷🇺, matematika 🇵🇭, matamaitic 🇮🇪, mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik
                      🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mayor1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Ga15HCmlzig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;mayor (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "maior" (a
                      comparative of the adjective "magnus" -- "great", "large",
                      "noble", "important").
                      <div></div>
                      <strong>Cognates:</strong> major 🇬🇧, maior 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mirar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/2HFA_R52NJI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;mirar (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "mīror" --
                      "to be astonished at", "marvel at", via the Old Spanish
                      "mirar" -- "to look at".
                      <div></div>
                      <strong>Related to:</strong> milagro, ad<u>mirar</u>
                      <div></div>
                      <strong>Cognates:</strong> mirar 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/money.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;moneda"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "monēta" -- "place
                      for coining money", via the Old Spanish "moneda" --
                      "currency", "coinage".
                      <div></div>
                      <strong>Perhaps related to:</strong> monopolio, monja
                      <div></div>
                      <strong>Descendants:</strong> monnaie 🇫🇷, moeda 🇵🇹, Münze
                      🇩🇪, mynt 🇮🇸, моне́та 🇷🇺, monēta 🇱🇻, moneta 🇵🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muerte.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muerte"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "mortuus"-- "dead"
                      (a perfect active participle of the verb "morior" -- "to
                      die").
                      <div></div>
                      <strong>Cognates:</strong> mort 🇫🇷, morte 🇵🇹, մահ 🇦🇲,
                      mirtis 🇱🇹, смерть 🇷🇺, morte 🇮🇹, марг 🇹🇯
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/map.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VKvwQjEEMIo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;mundo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Etruscan "𐌌𐌖𐌈"
                      /muθ/ -- “pit", "underworld", which may be the ancestor of
                      the Latin adjective (and, later, noun) "mundus" --
                      "clean", "pure", "neat", "order", "world". Eventually,
                      "mundus" evolved into the Old Spanish "mundo" -- "world".
                      <div></div>
                      <strong>Cognates:</strong> monde 🇫🇷, mundo 🇵🇹, món 🇦🇩,
                      mondo 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;música"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)"
                      <div></div>
                      <strong>Related to:</strong> museo, musa, murga
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, music 🇬🇧, مُوسِيقَى
                      🇸🇦, му́зыка 🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik 🇮🇩, މިއުޒިކް
                      🇲🇻, muzik 🇲🇾, muziki 🇹🇿, musiikki 🇫🇮, musik 🇸🇪, музыка 🇰🇬,
                      му́зика 🇺🇦, მუსიკა 🇬🇪, ሙዚቃ 🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pregnant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;nacer (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "*(g)nāscī"
                      -- "to be born", via the Old French verb "naistre" -- "to
                      be born".
                      <div></div>
                      <strong>Related to:</strong> naturaleza
                      <div></div>
                      <strong>Cognates:</strong> naître (v.) 🇫🇷, nascer (v.) 🇵🇹,
                      nascere (v.) 🇮🇹, naște (v.) 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/naranja.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;naranja"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "नारङ्ग"
                      /nāraṅga/ -- "orange tree", via the Classical Persian
                      "نارنگ" /nārang/ -- "bitter orange", the Arabic "نارنج"
                      /nāranj/ –- “bitter orange”, and the Old Spanish "naranja"
                      -- "orange". <div></div>
                      <strong>Cognates:</strong> orange 🇬🇧, arancia 🇮🇹, orange
                      🇬🇧, laranja 🇵🇹, на̀ра̄нча 🇷🇸, naranča 🇭🇷, نارَنْج 🇮🇷, नारंगी
                      🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;oso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "ursus" -- "bear",
                      via the Old Spanish "osso" -- "bear".
                      <div></div>
                      <strong>Cognates:</strong> ours 🇫🇷, urso 🇵🇹, αρκούδα 🇬🇷,
                      arth 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parole.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FamWPsuUjK8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;palabra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "πᾰρᾰβάλλω" -- "to place side by side", via the Latin
                      "parabola" -- "comparison", "speech", and the Old Spanish
                      "parabla" -- "word".
                      <div></div>
                      <strong>Related to:</strong> parábola
                      <div></div>
                      <strong>Cognates:</strong> palavra 🇵🇹, parole 🇫🇷, parola
                      🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pants.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Qzd-XTI848w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pantalones"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A word derived from the
                      funny-looking character in the Italian{" "}
                      <i>Commedia del Arte</i> named "Pantalone" who had skinny
                      legs and wore tight pants.
                      <div></div>
                      <strong>Ancestor:</strong> pantalon 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> pants 🇬🇧, pantolon 🇹🇷,
                      pantaloni 🇮🇹, παντελόνι 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;papa"
                  hoverText={
                    <span>
                      <strong>
                        <u>"potato"</u>
                      </strong>{" "}
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Quechua "papa" --
                        "white potato".
                      </div>
                      <strong>
                        <u>"head of Catholic Church"</u>
                      </strong>{" "}
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Origin:</strong> From the Ancient Greek "πάππᾰς"
                        /páppăs/ -- "father".
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Cognates:</strong> pape 🇫🇷, پاپ 🇮🇷, papa 🇪🇸,
                        papa 🇦🇿, պապ 🇦🇲, папа 🇧🇾, papež 🇨🇿, pave 🇩🇰, paavi 🇫🇮,
                        პაპი 🇬🇪, Papst 🇩🇪, πάπας 🇬🇷, पोप 🇮🇳, paus 🇮🇩, pápa 🇮🇪,
                        папа 🇰🇿, pāvests 🇱🇻, popiežius 🇱🇹, Poopst 🇱🇺, пап 🇲🇳,
                        papă 🇷🇴, papež 🇸🇮, papa 🇹🇿, papa 🇹🇲, پوپ 🇵🇰, pab 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                        بَابَا 🇸🇦
                      </div>
                      <div></div>
                      <div style={{ marginLeft: "20px" }}>
                        <strong>Descendants:</strong> papa 🇵🇭
                      </div>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paper.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yGvpX2ts5WU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;papel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "πᾰ́πῡρος"
                      /pắpūros/ -- "the papyrus plant", via the Latin "papȳrus"
                      -- "paper made from papyrus". Although related
                      etymologically, "papel" and "papiro" are made from
                      different materials and use different production methods.
                      <div></div>
                      <strong>Related to:</strong> papiro
                      <div></div>
                      <strong>Cognates:</strong> paper 🇬🇧, papier 🇫🇷, papel 🇵🇹,
                      Papier 🇩🇪, papier 🇳🇱, papper 🇸🇪, papīrs 🇱🇻, paperi 🇫🇮,
                      popierius 🇱🇹, papier 🇵🇱, papur 🏴󠁧󠁢󠁷󠁬󠁳󠁿, папі́р 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paraguas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the Ancient
                      Greek suffix "πᾰρᾰ-" /pără-/ -- "contrary to" (via the
                      Italian "para-" -- "guarding against") and the Latin
                      "aqua" -- "rain".
                      <div></div>
                      <strong>Related to:</strong> <u>para</u>sol
                      <div></div>
                      <strong>Cognates:</strong> parachuva 🇵🇹, <u>para</u>pluie
                      🇫🇷
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Regenschirm 🇩🇪,
                      deštník 🇨🇿, esernyő 🇭🇺, lietussargs 🇱🇻, 雨伞 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paraíso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible.
                      <div></div>
                      <strong>Cognates:</strong> paradis 🇫🇷, paraíso 🇵🇹, paraiso
                      🇵🇭, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸, paradise 🇬🇧,
                      paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/parapluie.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;parasol"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From a combination of the Ancient
                      Greek suffix "πᾰρᾰ-" /pără-/ -- "contrary to" (via the
                      Italian "para-" -- "guarding against") and the Latin "sol"
                      -- "sun".
                      <div></div>
                      <strong>Related to:</strong> <u>para</u>guas
                      <div></div>
                      <strong>Cognates:</strong> parasol 🇵🇹, parasol 🇫🇷, parasol
                      🇩🇰, parasole 🇮🇹, parasol 🇵🇱, парасо́лька 🇺🇦
                      <div></div>
                      <strong>Semantic Equivalents:</strong> Sonnenschirm 🇩🇪,
                      slunečník 🇨🇿, napernyő 🇭🇺, saulessargs 🇱🇻, 阳伞 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pommedeterre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;patata"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Taíno "b
                      <u>atata</u>" -- "sweet potato". The word's spelling may
                      also have been influenced by the Quechua "<u>p</u>
                      apa" -- "white potato". Both varieties of potato were
                      brought back to Europe from the Americas.
                      <div></div>
                      <strong>Cognates:</strong> بَطَاطَا 🇸🇦, patates 🇹🇷, batata
                      🇵🇹, potet 🇳🇴, patatas 🇵🇭, potatis 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/peligro.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/qJKkaRTmYbs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;peligro"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "perīculum" --
                      "attempt", "experiment", "risk", "danger", via the Old
                      Spanish "periglo" -- "danger".
                      <div></div>
                      <strong>Cognates:</strong> peril 🇬🇧, perigo 🇵🇹, pericolo
                      🇮🇹, péril 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/person.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/LCiQz7vmiLY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;persona"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "persōna" -- "mask
                      used by actor", "role", "part", "character”. In the Roman
                      world, actors would wear “personae” during performances,
                      which would allow them “to portray a role” and “assume a
                      persona”. Gradually the word became associated both with
                      the mask itself and the actors wearing it, and eventually,
                      the mask meaning disappeared, and only the meaning related
                      to actors, and eventually, all human beings, remained.
                      <div></div>
                      <strong>Cognates:</strong> personne 🇫🇷, Person 🇩🇪, persoon
                      🇳🇱, person 🇬🇧, persona 🇮🇹, pessoa 🇵🇹, person 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pied.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pie"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Latin "pēs" --
                      "foot", and the Old Spanish "pie" -- "foot".
                      <div></div>
                      <strong>Related to:</strong> pedal, piloto, peatón
                      <div></div>
                      <strong>Cognates:</strong> Fuß 🇩🇪, voet 🇳🇱, foot 🇬🇧, pied
                      🇫🇷, πόδι 🇬🇷, fot 🇸🇪, پا 🇮🇷, پَاؤُں 🇵🇰, पैर 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pyjamas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pijama"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "پایجامه" --
                      "pyjamas", "pants" (which is itself a combination of "پا"
                      /pâ/ -- “leg” and "جامه" /jâme/ -- "garment").
                      <div></div>
                      <strong>Ancestors:</strong> पैजामा 🇮🇳, پائِجامَہ 🇵🇰,
                      pyjama(s) 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> pijama 🇵🇹, Pyjama 🇩🇪, пижама
                      🇰🇿, пижама 🇷🇺, пижама 🇰🇬, pijama 🇹🇷, pijama 🇷🇴, πυτζάμα
                      🇬🇷, піжама 🇺🇦, pyžamo 🇨🇿, pyjama 🇫🇮, поҷома 🇹🇯, پیژامه 🇦🇫,
                      pidžama 🇭🇷, pijama 🇹🇲, פיג׳מה 🇮🇱, pižama 🇱🇹, piama 🇮🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/piloto.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;piloto"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Ancient Greek "πηδόν"
                      /pēdón/ -- "oar (blade)" and the Byzantine Greek
                      "*πηδώτης" /pēdṓtēs/ -- “helmsman”. Before the emergence
                      of the airplane, a “pilot” was the person at the helm of a
                      ship who steered it into and out of a harbor and navigated
                      it to its destination. The original meaning "foot" comes
                      from the fact that the "πηδόν" looked like the boat’s foot
                      due to its flat shape and position underneath the boat’s
                      body.
                      <div></div>
                      <strong>Related to:</strong> pedal, pie, peatón
                      <div></div>
                      <strong>Ancestors:</strong> pilota 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> pilot 🇬🇧, piloto 🇵🇹, pilote 🇫🇷,
                      πιλότος 🇬🇷, Pilot 🇩🇪, pilot 🇩🇰, pilot 🇦🇱, pilots 🇱🇻, pilot
                      🇨🇿, piloot 🇪🇪, pilot 🇹🇷, piloot 🇳🇱, პილოტი 🇬🇪
                      <div></div>
                      <strong>Descendants:</strong> piloto 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pencil.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3WFpvcr9kU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pincel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "peniculus" --
                      "small penis," via the Later Latin "pēnicillum" --
                      "painter's brush".
                      <div></div>
                      <strong>Related to:</strong> pene
                      <div></div>
                      <strong>Cognates:</strong> pincel 🇵🇹, penseel 🇳🇱, pensel
                      🇳🇴, pensel 🇩🇰, pędzel 🇵🇱, Pinsel 🇩🇪, pinzell 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/planeta.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/lFf4Oj6xvCU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;planeta"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "
                      <u>πλάνητες</u> ἀστέρες" /plánētes astéres/, or "wandering
                      stars", so called because, compared to "απλανείς αστέρες"
                      /aplaneís astéres/, or "fixed stars", the stars that were
                      "πλάνητες" seemed to move around the sky a lot more.
                      <div></div>
                      <strong>Possibly related to:</strong> plan, planicie
                      <div></div>
                      <strong>Cognates:</strong> planète 🇫🇷, pianeta 🇮🇹, planet
                      🇬🇧, planeta 🇵🇹, Planet 🇩🇪, плане́та 🇧🇾, planet 🇦🇱, planet
                      🇸🇮, planēta 🇱🇻, planeta 🇨🇿, planeet 🇪🇪, planeta 🇵🇭,
                      плане́та 🇷🇺, planeetta 🇫🇮, planeet 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pocion.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;poción"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the accusative noun "pōtiōnem" --
                      "draught", "(magic) potion".
                      <div></div>
                      <strong>Related to:</strong> potable (<i>adj.</i>),
                      ponzoña
                      <div></div>
                      <strong>Cognates:</strong> potion 🇫🇷, poção 🇵🇹, potion 🇬🇧,
                      pozione 🇮🇹, poţiune 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/polvo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/hicuJlF5hew"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;polvo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Indo-European root "*pel-" -- "flour", "dust" via
                      the Latin "pulvis" -- "dust", "powder", and the Italian
                      "polvere" -- "dust", "powder".
                      <div></div>
                      <strong>Ancestor:</strong> polvere 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> poudre 🇫🇷, powder 🇬🇧, pó 🇵🇹,
                      pulver 🇸🇪, pulver 🇩🇰, pulver 🇳🇴, Pulver 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/poison.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;potable (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "pōtō" -- "to
                      drink (alcohol)", via the adjective "pōtābilis" --
                      “drinkable", "potable".
                      <div></div>
                      <strong>Related to:</strong> poción, ponzoña
                      <div></div>
                      <strong>Cognates:</strong> potable 🇫🇷, potável 🇵🇹, potable
                      🇬🇧, potabile 🇮🇹, potabil 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;problema"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "problème"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> baile, ballet
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problem 🇬🇧,
                      problēma 🇱🇻, probleemi 🇪🇪, probléma 🇭🇺, про̀бле̄м 🇷🇸,
                      пробле́ма 🇺🇦, пробле́ма 🇷🇺, πρόβλημα 🇬🇷, problem 🇳🇴
                      <div></div>
                      <strong>Descendants:</strong> problema 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/psychiatry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;psiquiatra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ψυχή" /psukhḗ/ -- "soul" and "ἰατρός" /iatrós/ --
                      “doctor”.
                      <div></div>
                      <strong>Cognates:</strong> Psychiater 🇩🇪, psychiatrist 🇬🇧,
                      psiquiatra 🇵🇹, psikiyatrist 🇹🇷, ფსიქიატრი 🇬🇪, психиа́тр 🇷🇺,
                      psychiatre 🇫🇷, pszichiáter 🇭🇺, ψυχίατρος 🇬🇷, psühhiaater
                      🇪🇪, פסיכיאטר 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/point.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mn09t2xE2QU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;punto"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the perfect passive
                      participle form "pūnctus" ("a hole punched in", "a
                      puncture") of the Latin verb "pungō" -- "I prick", "I
                      punch".
                      <div></div>
                      <strong>Related to:</strong> puño
                      <div></div>
                      <strong>Cognates:</strong> point 🇫🇷, point 🇬🇧, ponto 🇵🇹,
                      Punkt 🇩🇪, пункт 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;queso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product".
                      <div></div>
                      <strong>Cognates:</strong> Käse 🇩🇪, kaas 🇳🇱, cheese 🇬🇧,
                      queijo 🇵🇹
                      <div></div>
                      <strong>Descendants:</strong> keso 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/reloj.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;reloj"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek
                      "ὡρολόγιον" /hōrológion/ -- "device for telling time"
                      (which itself comes partially from "ὥρα" /hṓra/ -- "any
                      period of time"), via the Latin "hōrologium" -- "device
                      used to measure the time of day", "sundial", and the Old
                      Catalan "orollotge" -- "timekeeping device".
                      <div></div>
                      <strong>Related to:</strong> hora, <u>horó</u>scopo
                      <div></div>
                      <strong>Cognates:</strong> horloge 🇫🇷, relógio 🇵🇹,
                      orologio 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;río"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "rīvus" --
                      "brook", "small stream of water", via the Vulgar Latin
                      "rius" -- "river".
                      <div></div>
                      <strong>Related to:</strong> rival, derivar
                      <div></div>
                      <strong>Not related to:</strong> arriba
                      <div></div>
                      <strong>Cognates:</strong> rio 🇵🇹, râu 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/arrive.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6kiVFBOrMN0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;rival"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "rīvus" --
                      "brook", "small stream of water", via the adjectival noun
                      "rīvālis" -- "someone who uses the same stream as
                      another". The word originated from the idea of groups of
                      people occupying opposite sides of a river (or any body of
                      water) who were often vying for access to the same
                      resource (<i>e.g.</i>, the Romans and the Carthaginians in
                      the first millennium BC who were both active on opposite
                      sides of the Strait of Messina between Sicily and mainland
                      Italy.)
                      <div></div>
                      <strong>Related to:</strong> río, derivar
                      <div></div>
                      <strong>Not related to:</strong> arriba
                      <div></div>
                      <strong>Cognates:</strong> rival 🇫🇷, rival 🇬🇧, rival 🇵🇹,
                      rivale 🇮🇹, rywal 🇵🇱, rival 🇷🇴, rival 🇳🇴, Rivale 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/red.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;rojo (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European
                      "*h₁rewdʰ-" -- "red" via the Latin "russeus" -- "dark
                      red".
                      <div></div>
                      <strong>Related to:</strong> rubio
                      <div></div>
                      <strong>Cognates:</strong> red 🇬🇧, rosso 🇮🇹, rouge 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/red.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;rubio (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European
                      "*h₁rewdʰ-" -- "red" via the Latin "rubeus" -- " red".
                      <div></div>
                      <strong>Related to:</strong> rojo
                      <div></div>
                      <strong>Cognates:</strong> roux 🇫🇷, ruivo 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salaire.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salario"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "sal" -- "salt"
                      via the adjective "salārius" -- "related to salt" and the
                      derivative noun "salārium" -- "wages". In Roman times salt
                      was quite valuable, and soldiers who were "worth their
                      salt", so to speak, had to accumulate a hefty "salarium"
                      (or “salt stipend”) to be able to buy some.
                      <div></div>
                      <strong>Related to:</strong> sal
                      <div></div>
                      <strong>Cognates:</strong> salary 🇬🇧, salaire 🇫🇷, salário
                      🇵🇹, salarju 🇲🇹, salariu 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salchicha.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salchicha"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Latin verb "*salō" -- (v.) –
                      “to salt” and its derivative "salsus" –- "salty",
                      "salted". From there, combined with the adjective forming
                      suffix "-īcius", the word evolved into the Late Latin
                      adjective "salsīcius" –- "prepared with salt".
                      <div></div>
                      <strong>Related to:</strong> salchicha, ensalada, sal,
                      salario
                      <div></div>
                      <strong>Ancestor:</strong> salsiccia 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> sausage 🇬🇧, saucisse 🇫🇷,
                      salsicha 🇵🇹, ソーセージ 🇯🇵, 소시지 🇰🇷, سوسیس 🇮🇷, sosis 🇹🇷,
                      xúc xích 🇻🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salsa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*sḗh₂l" –- "salt", via the Latin verb "*salō" -- (v.) –
                      “to salt” and its derivative "salsus" –- "salty",
                      "salted". The feminine form of the adjective evolved into
                      the Vulgar Latin "*salsa" -- "salsa", which over time
                      developed into the modern Spanish word.
                      <div></div>
                      <strong>Related to:</strong> salchicha, ensalada, sal,
                      salario
                      <div></div>
                      <strong>Cognates:</strong> sauce 🇫🇷, sauce 🇬🇧, salsa 🇪🇸,
                      salsa 🇮🇹, σάλτσα 🇬🇷, sovs 🇩🇰, sos 🇵🇱, sås 🇸🇪, Soße 🇩🇪, xốt
                      🇻🇳, соус 🇷🇺, صلصة 🇸🇦, ソース 🇯🇵, 소스 🇰🇷
                      <div></div>
                      <strong>Descendants:</strong>
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salud.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;salud"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "salūs" --
                      "health", "safety", "security".
                      <div></div>
                      <strong>Related to:</strong> saludar (<i>v.</i>)
                      <div></div>
                      <strong>Cognates:</strong> salute 🇮🇹, saúde 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saludar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;saludar (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "salūs" --
                      "health", "safety", "security".
                      <div></div>
                      <strong>Related to:</strong> salud
                      <div></div>
                      <strong>Cognates:</strong> saluer 🇫🇷, saudar 🇵🇹, salute 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sano.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;sano (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "sānus"
                      (<i>adj.</i>) –- "healthy", "whole", "well" via the noun
                      "sānitās" –- "health", "soundness of body”.
                      <div></div>
                      <strong>Cognates:</strong> sain 🇫🇷, são 🇵🇹, sano 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sinister.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/9_uIJ9afIFs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;siniestro (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "sinister" --
                      "left hand". In many medieval societies the left hand was
                      considered slower and disadvantageous compared to the
                      right hand, thus giving "siniestro" the connotation
                      "unfavorable" or "adverse".
                      <div></div>
                      <strong>Cognates:</strong> sinistre 🇫🇷, sinistro 🇵🇹,
                      sinister 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/soldado.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;soldado"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army. From "solidus", the word eventually developed into
                      the Italian "soldo" -- "penny", cent", then "soldato" --
                      "soldier", "one who earns a 'soldo'", and then, finally,
                      the modern Spanish word.
                      <div></div>
                      <strong>Ancestor:</strong> soldo 🇮🇹, soldato 🇮🇹
                      <div></div>
                      <strong>Related to:</strong> sueldo, sólido (<i>adj</i>.)
                      <div></div>
                      <strong>Cognates:</strong> Soldat 🇩🇪, soldier 🇬🇧, soldat
                      🇩🇰, soldado 🇵🇹, cолда́т 🇷🇺, soldat 🇫🇷, soldat 🇸🇪, soldat
                      🇷🇴, soldaat 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/salud.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XdYhAkhv6DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;soledad"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "solus"
                      -- "only", "sole", via the accusative singular form
                      "sōlitātem" of the noun "sōlitās" -- "solitude".
                      <div></div>
                      <strong>Related to:</strong> solo (<i>adj.</i>)<div></div>
                      <strong>Cognates:</strong> solitude 🇬🇧, solitude 🇫🇷,
                      soledad 🇪🇸, solitudine 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sueldo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/V6XYYNGBZec"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sueldo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "solidus" -- (23k
                      gold coin paid to Roman soldiers in late Roman Empire),
                      via "soldarius" -- "soldier", "one having pay". The
                      "solidus" became the official solid gold coin of the Roman
                      Empire in 312 AD during the reign of Emperor Constantine,
                      at which time it was also used to pay members of the Roman
                      army.
                      <div></div>
                      <strong>Related to:</strong> soldado
                      <div></div>
                      <strong>Descendants:</strong> suweldo 🇵🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/te.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;té"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, thee 🇳🇱
                      <div></div>
                      <strong>Descendant:</strong> te 🇦🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tela.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tela"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tēla" -- "web",
                      "loom", via the Old Spanish "tela" -- "cloth", "fabric".
                      <div></div>
                      <strong>Related to:</strong> <u>tela</u>raña
                      <div></div>
                      <strong>Cognates:</strong> toile 🇫🇷, tela 🇵🇹, teia 🇵🇹,
                      tela 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/terre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/M2lknMW7HiI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tierra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ters-" -- "dry", via the Proto-Italic "*terzā" --
                      "earth" and the Latin "terra" -- "dry land".
                      <div></div>
                      <strong>Cognates:</strong> terre 🇫🇷, terra 🇵🇹, terra 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/towel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;toalla"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic verb
                      "*þwahaną" -- "to wash" via the Frankish verb "*þwahilu"
                      -- "cloth".
                      <div></div>
                      <strong>Cognates:</strong> towel 🇬🇧, toalha 🇵🇹, tuwalya
                      🇵🇭, tuala 🇲🇾, tuáille 🇮🇪, タオル 🇯🇵, taulo 🇹🇿, taul 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tomate.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/5XbF_f45DRM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tomate"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Nahuatl (Aztec) "tomatl"
                      -- "tomatillo", "tomato". The word was brought to Spain
                      from the New World and from there spread all over Europe
                      and the rest of the world.
                      <div></div>
                      <strong>Descendants:</strong> tomate 🇫🇷, Tomate 🇩🇪, tomate
                      🇵🇹, дома́т 🇧🇬, домат 🇲🇰, tomāts 🇱🇻, ντομάτα 🇬🇷, トマト 🇯🇵,
                      토마토 🇰🇷, ቲማቲም 🇪🇹, टमाटर 🇮🇳, tómatur 🇮🇸, tomat 🇮🇩, tomat
                      🇲🇾, tomat 🇸🇪, domates 🇹🇷, tomato 🏴󠁧󠁢󠁷󠁬󠁳󠁿, tomato 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/toque.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/suyCgi6wEos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;toque de queda"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first word is from the Vulgar
                      Latin "*tuccāre" -- "to touch", "to strike" (which is
                      itself likely of onomatopeic origin). The preposition "de"
                      is from the Latin preposition "de" -- "of", "concerning",
                      "about". The third word is from the Latin verb "quiētāre"
                      -- "to quiet", "to calm".
                      <div></div>
                      <strong>Partial cognates:</strong> <u>toque</u> de
                      recolher 🇵🇹
                      <div></div>
                      <strong>Semantic equivalents:</strong> avondklok 🇳🇱,
                      couvre-feu 🇫🇷, coprifuoco 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vacation.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jEPPz2zKL7M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;vacaciones (<i>pl.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*h₁weh₂-" -- "to leave", "to abandon", "to empty" via the
                      Latin verb "vacō" -- "to be free" and later "vacātiō" --
                      "freedom", "exemption". The original "vacación" centered
                      around the idea of being at leisure, idle, and unoccupied,
                      (<i>i.e.</i>, "empty").
                      <div></div>
                      <strong>Related to:</strong> vago, vacío (<i>adj</i>.),
                      vacante (adj.)
                      <div></div>
                      <strong>Cognates:</strong> vacances (<i>pl.</i>) 🇫🇷,
                      vacation 🇬🇧, vacanza 🇮🇹, vakantie 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/venom.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/gaCBLUPPoCM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;veneno"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*wenh₁-" -- "to strive", "to wish", "to love", via the
                      Latin "venēnum" -- "(love) potion", "poison", "charm”.
                      <div></div>
                      <strong>Related to:</strong> Venus
                      <div></div>
                      <strong>Cognates:</strong> venim 🇫🇷, venom 🇬🇧, veleno 🇵🇹,
                      veleno 🇮🇹, venin 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/venir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/t4CwXz_CSU8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;venir (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic verb
                      "*gʷənjō" -- "to come", via the Latin "venīo" -- "to
                      come", and the Old Spanish "venir" -- "to come".
                      <div></div>
                      <strong>Related to:</strong> a<u>ventura</u>
                      <div></div>
                      <strong>Cognates:</strong> venir 🇫🇷, venire 🇮🇹, vir 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/window.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ventana"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "ventus" -- "wind"
                      (so called because originally it was paneless and let in
                      the wind).
                      <div></div>
                      <strong>Related to:</strong> viento
                      <div></div>
                      <strong>Cognates:</strong> window 🇬🇧, vindue 🇩🇰, vindu 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/verbo.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;verbo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say", via the Proto-Italic
                      "*werβom" -- "word", and the the Latin "verbum" -- "spoken
                      word", "verb". The modern meaning was influenced by the
                      fact that the Romans considered the "verbum" to be the
                      most important word in a sentence from a grammatical
                      perspective.
                      <div></div>
                      <strong>Cognates:</strong> verb 🇬🇧, verbe 🇫🇷, verbo 🇵🇹,
                      Verb 🇩🇪
                      <div></div>
                      <strong>Semantic Equivalents:</strong> глагол 🇷🇸, глагол
                      🇧🇬, глагол 🇲🇰, глагол 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/verter.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZEpHDl447ms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;verter (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "vertō" -- "to
                      turn", via the Old Spanish "verter" -- "to spill", "to
                      unload".
                      <div></div>
                      <strong>Related to:</strong> verso
                      <div></div>
                      <strong>Cognates:</strong> verser 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/vino.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/u-W4k9uLUN4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;vino"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "vīnum" -- “wine”,
                      via the Old Spanish - "bino" -- "wine".
                      <div></div>
                      <strong>Related to:</strong> vinagre
                      <div></div>
                      <strong>Cognates:</strong> vin 🇫🇷, wine 🇬🇧, viini 🇫🇮,
                      vinho 🇵🇹, vino 🇮🇹, vin 🇷🇴, wino 🇵🇱, вино́ 🇷🇺, wijn 🇳🇱,
                      vynas 🇱🇹, wain 🇲🇾, víno 🇨🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/visita.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-5drh9EjhZM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;visita"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "videō" --
                      "to see", via the verb "vīsō" -- "to behold", "to survey”,
                      and its frequentative derived form "vīsitō" -- "to go to
                      see", "to visit".
                      <div></div>
                      <strong>Related to:</strong> evi<u>dente</u>, pru
                      <u>dente</u> (<i>adj</i>.), visa, visión, en<u>vidia</u>,
                      video, aviso
                      <div></div>
                      <strong>Cognates:</strong> visit 🇬🇧, visita 🇮🇹, visita 🇵🇹,
                      vizită 🇷🇴, wizyta 🇵🇱, visite 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇹🇿 SWAHILI 🇹🇿
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/basi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;basi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>,
                      巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇲🇼,
                      bhazi 🇿🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chai2.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;chai"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, شَاي 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gesi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gaz 🇫🇷, gas 🇬🇧, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷,
                      ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kahawa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kahawa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then eventually spread to East
                      Africa as well.
                      <div></div>
                      <strong>Ancestors:</strong> قَهْوَة 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> café 🇫🇷, café 🇪🇸, Kaffee 🇩🇪,
                      ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰,
                      kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦,
                      ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴, کافی 🇵🇰, кофе 🇰🇿,
                      kafe 🇲🇬, 咖啡 🇹🇼, қаҳва 🇹🇯, قهوه 🇮🇷, コーヒー 🇯🇵, 咖啡 🇨🇳,
                      커피 🇰🇷, ກາເຟ 🇱🇦, កាហ្វេ 🇰🇭, кофе 🇲🇳, cà phê 🇻🇳, ကော်ဖီ
                      🇲🇲, ყავა 🇬🇪, กาแฟ 🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, কফি 🇧🇩, ކޮފީ 🇲🇻,
                      kahve 🇹🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kalamu.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kalamu"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, possibly
                      via the Ge'ez "ቀለም" /ḳäläm/ -- "reed".
                      <div></div>
                      <strong>Ancestor:</strong> قلم 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> калем 🇰🇬, kalem 🇹🇷, क़लम 🇮🇳,
                      कलम 🇳🇵, kalamu 🇹🇿, қалам 🇹🇯, қалам 🇰🇿, ގަލަން 🇲🇻, কলম 🇧🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muziki"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)", via the Latin "mūsica" --
                      "music".
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, música 🇪🇸,
                      مُوسِيقَى 🇸🇦, му́зыка 🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik
                      🇮🇩, musiikki 🇫🇮, musik 🇸🇪, музыка 🇰🇬, му́зика 🇺🇦, მუსიკა
                      🇬🇪, ሙዚቃ 🇪🇹, މިއުޒިކް 🇲🇻, muzik 🇲🇾, musiikki 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jamal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_NKrT6Niapo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ngamia"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Semitic "*gamal-"
                      -- "camel".
                      <div></div>
                      <strong>Ancestor:</strong> جمل 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> גמל 🇮🇱, camello 🇪🇸, camel 🇬🇧,
                      cammello 🇮🇹, camelo 🇵🇹, chameau 🇫🇷, kamel 🇩🇰, ޖަމަލު 🇲🇻,
                      ግመል 🇪🇹, Kamel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradiso.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paradiso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible. From Greek
                      the word evolved into the Latin "paradīsus" -- "park",
                      "orchard", "yard", and eventually (likely via Italian) the
                      modern Swahili word.
                      <div></div>
                      <strong>Cognates:</strong> paradis 🇫🇷, paraíso 🇵🇹, paraiso
                      🇵🇭, Paradies 🇩🇪, paradise 🇬🇧, paradís 🇮🇸, paraíso 🇪🇸,
                      paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇸🇪 SWEDISH 🇸🇪
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/apelsin2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;apelsin"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the French "pomme de Sine"
                      🇫🇷 – “apple from China”. The word was calqued into the
                      Dutch "appelsien" -- "orange", and, from there, the Low
                      German "appelsina" -- "orange". The name reflects the fact
                      that the fruit originated from a region that encompasses
                      Southern China.
                      <div></div>
                      <strong>Cognates:</strong> sinaasappel 🇳🇱, Apfelsine 🇩🇪,
                      appelsin 🇳🇴, апельсин 🇰🇿, апельсин 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/distance.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sJgO6bNR7x4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avstånd"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Borrowed as a word-for-word
                      translation (<i>i.e.</i>a "calque"), of the German
                      "Abstand" -- "distance", "interval". The German "Abstand"
                      was calqued from the Latin "distantia", derived from the
                      present participle of the Latin verb "distō" -- "to stand
                      apart", "to be distant" (itself a combination of the
                      prefix "dis-" -- "apart" "in two" and the verb "stō" --
                      "to stand"), via the Old French "destance" -- "debate",
                      "distinctio. The concept comes from the idea that when
                      people argue, they’re not on the same page (or really, in
                      the same place). Therefore, they stand apart, and there is
                      "avstånd" between them.
                      <div></div>
                      <strong>Ancestor:</strong> Abstand 🇩🇪
                      <div></div>
                      <strong>Cognates:</strong> afstand 🇩🇰, afstand 🇳🇱
                      <div></div>
                      <strong>Semantic equivalents:</strong> distancia 🇪🇸,
                      distância 🇵🇹, distance 🇫🇷, distanță 🇷🇴, distanza 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/back1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PtZcAf8r9Ws"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bäck"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "bʰeg-" -- "flowing water", via the Old Norse "bekkr" --
                      "brook", "creek", and the Old Swedish "bækker" -- "brook",
                      "stream".
                      <div></div>
                      <strong>Cognates:</strong> Bach 🇩🇪, bekk 🇳🇴, beek 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;banan"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳
                      <div></div>
                      <strong>Cognates:</strong> banane 🇫🇷, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana
                      🇪🇸, banana 🇵🇹, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪,
                      banaan 🇳🇱, μπανάνα 🇬🇷, banana 🇬🇧
                      <div></div>
                      <strong>Descendants:</strong> banaani 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/blomma.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b8XQw2AbIQU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;blomma"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰleh₃-" –- "flower", "bloom" via the Proto-Germanic
                      "*blōmô" -- “flower”, and the Old Norse "blóm" --
                      "flower".
                      <div></div>
                      <strong>Cognates:</strong> bloem 🇳🇱, fleur 🇫🇷, flor 🇵🇹,
                      flor 🇪🇸, fiore 🇮🇹, flower 🇬🇧, blomst 🇳🇴, blomst 🇩🇰, Blume
                      🇸🇪, floare 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/budget.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bdywn-WNYnw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;budget"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*bʰelǵʰ-" -- "to swell", via the Latin "bulga" --
                      "knapsack", "wallet" and the Old French "bougette" --
                      "small leather pouch", "wallet". In the 17th and 18th
                      centuries, politicians often used "budgets" for their
                      everyday affairs, including government officials, who used
                      them to carry important paperwork, including ones related
                      to finance (such as Prime Minister Robert Walpole, whose
                      tax policies were criticized in an 1833 pamphlet called
                      “the budget opened”).
                      <div></div>
                      <strong>Ancestor:</strong> budget 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> budget 🇫🇷, budget 🇩🇰, buiséad
                      🇮🇪, budget 🇸🇪, буџет 🇲🇰, bütçe 🇹🇷, bajeti 🇹🇿, բյուջե 🇦🇲
                      <div></div>
                      <strong>Descendant:</strong> budjetti 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/buss.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;buss"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/choklad.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;choklad"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolat 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾, شکلات 🇮🇷,
                      チョコレート 🇯🇵, chocolate 🇬🇧, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬
                      <div></div>
                      <strong>Descendant:</strong> suklaa 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fenetre.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/zZUIMWi2H9Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fönster"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "fenestra" --
                      "(glass) window", via the Old Swedish "fynster" --
                      "window".
                      <div></div>
                      <strong>Cognates:</strong> finestra 🇮🇹, Fenster 🇩🇪,
                      fenêtre 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/foot.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ocN6ivjqaZE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;fot"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*ped-" -- "foot", "to walk" via the Proto-Germanic
                      "*fōts" -- "foot", the Old Norse "fótr" -- "foot", and the
                      Old Swedish "fōt" -- "foot".
                      <div></div>
                      <strong>Related to:</strong> pedal, pilot, <u>fot</u>
                      gängare
                      <div></div>
                      <strong>Cognates:</strong> Fuß 🇩🇪, voet 🇳🇱, pie 🇪🇸, pied
                      🇫🇷, πόδι 🇬🇷, fot 🇸🇪, پا 🇮🇷, پَاؤُں 🇵🇰, पैर 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gravity.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Tq5F8KypH5U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;gravid (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin adjective "gravis"
                      -- "heavy", via the noun "gravidus" -- "pregnant".
                      <div></div>
                      <strong>Related to:</strong> grav
                      <div></div>
                      <strong>Cognates:</strong> gravid 🇩🇰, gravid 🇳🇴, grávida
                      🇵🇹, gravidă 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/god.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WGpozOAIp8w"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gud"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the via the Proto-Germanic
                      "gudą" - "god", "deity" via the Old Swedish "guþ" --
                      "god", "deity".
                      <div></div>
                      <strong>Cognates:</strong> god 🇳🇱, gud 🇩🇰, gud 🇳🇴, Gott
                      🇩🇪, god 🇬🇧, god 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobbi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hobby"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Ancestor:</strong> hobby 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> hobi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, xоби 🇲🇰, hobi 🇹🇷,
                      hobbi 🇭🇺, хо́бби 🇷🇺, Hobby 🇩🇪, hobis 🇱🇹, hobbi 🇦🇿, hobijs
                      🇱🇻, хоби 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hundra.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hundra"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*hundaradą" -- "a large number (usually equal to either
                      100 or 120)", via the Old Norse "hundrað" -- "120".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundert 🇩🇪, hundred 🇬🇧, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, cent 🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/jamn.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;jämn (<i>adj.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*ebnaz"
                      -- "even", "level", via the Old Norse "jafn" -- "even",
                      "equal".
                      <div></div>
                      <strong>Cognates:</strong> even 🇬🇧, even 🇳🇱, eben 🇩🇪, jafn
                      🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dinde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kalkon"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Dutch "kalkoen" --
                      "turkey" (which is short for "kalkûnsche höner" -- "hen
                      from Calicut", in India, where turkeys were traditionally
                      believed to come from.)
                      <div></div>
                      <strong>Ancestor:</strong> kalkoen 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> kalkoen 🇿🇦, kalkun 🇩🇰, kalkun
                      🇪🇪, kalakutas 🇱🇹
                      <div></div>
                      <strong>Descendant:</strong> kalkkuna 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/krasa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/p_sq77aw_Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;krasa (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old Norse verb "*krasa"
                      –- "to shatter" (which itself is likely of onomatopoeic
                      origin).
                      <div></div>
                      <strong>Possibly related to:</strong> krasch
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/krig.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/R69LQtIcbM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;krig"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-West Germanic
                      "*krīg" –- "strife", "endeavor", "struggle" via the Middle
                      Low German "krîch" -– "battle", "fight", "dispute".
                      <div></div>
                      <strong>Cognates:</strong> Krieg 🇩🇪, krig 🇳🇴, krig 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇳🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/leiche.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/-GzSRtGKQkI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "cyan" }}
                  ></i>
                </a>
                <Popover
                  text={<>&nbsp;lig</>}
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*līką"
                      -- "body", via the Old Danish "līk" -- "corpse".
                      <div></div>
                      <strong>Cognates</strong>: Leiche 🇩🇪, lijk 🇳🇱, lik 🇸🇪, lík
                      🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/museum.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;musik"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)", via the Latin "mūsica" --
                      "music".
                      <div></div>
                      <strong>Related to:</strong> museum, musa
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, música 🇪🇸,
                      مُوسِيقَى 🇸🇦, му́зыка 🇷🇺, muzyka 🇵🇱, مُوسِیقِی 🇮🇷, musik
                      🇮🇩, musiikki 🇫🇮, musik 🇸🇪, музыка 🇰🇬, му́зика 🇺🇦, მუსიკა
                      🇬🇪, ሙዚቃ 🇪🇹, މިއުޒިކް 🇲🇻, muzik 🇲🇾, muziki 🇹🇿
                      <div></div>
                      <strong>Descendants:</strong> musiikki 🇫🇮
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/muscle.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muskel"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Indo-European "*múHs"
                      -- "mouse" via the Latin "mūsculus" -- "little mouse", so
                      called because flexed arm muscles look like little mice.
                      <div></div>
                      <strong>Related to:</strong> mus, mussla
                      <div></div>
                      <strong>Cognates:</strong> muscle 🇫🇷, muscolo 🇮🇹, mușchi
                      🇷🇴, músculo 🇪🇸, músculo 🇵🇹, muscle 🇬🇧, muskel 🇩🇰, muskel
                      🇳🇴, muskel 🇸🇪, мышца 🇷🇺, mišića 🇭🇷, Muskel 🇩🇪
                      <div></div>
                      <strong>Semantic equivalents:</strong> ጭዋዳ 🇪🇷, عَضَلَة 🇸🇦,
                      մկան 🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/natt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/b0_Fn124bAc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;natt"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*nókʷts" -- "night", via the Old Norse "nátt" -- "night".
                      <div></div>
                      <strong>Cognates:</strong> Nuecht 🇱🇺, night 🇬🇧, Nacht 🇩🇪,
                      natt 🇳🇴, nuit 🇫🇷, noche 🇪🇸, noite 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ord.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/_6TT3ZsVKg0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ord"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European root
                      "*werh₁-" -- "to speak", "to say" via the Proto-Germanic
                      "*wurdą" -- "word", "saying", and the Old Norse "orð" --
                      "word", "saying".
                      <div></div>
                      <strong>Cognates:</strong> ord 🇳🇴, woord 🇳🇱, Wuert 🇱🇺,
                      vārds 🇱🇻, word 🇬🇧, woord 🇳🇦, Wort 🇩🇪, word 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sark.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;särk"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic "*sorka" --
                      "shirt", via the Proto-Germanic "*sarkiz" -- "(armored)
                      shirt", "hauberk", the Old Norse "serkr" -- "shirt", and
                      the Old Swedish "særker" -- "shirt".
                      <div></div>
                      <strong>Cognates:</strong> særk 🇩🇰, särk 🇪🇪, cорочка 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/socker.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;socker"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel".
                      <div></div>
                      <strong>Ancestor:</strong> شکر 🇮🇷, سُكَّر 🇸🇦, zucchero 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> ζάχαρη 🇬🇷, са́хар 🇷🇺, sucre 🇫🇷,
                      azúcar 🇪🇸, sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪, suiker 🇳🇱,
                      cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲, suhkur 🇪🇪, ስኳር
                      🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, sport 🇫🇷, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇳🇴, sport 🇭🇺,
                      ስፖርት 🇪🇹, šport 🇸🇰, spor 🇹🇷, sport 🇷🇴, Sport 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/fungus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sLoO1viJMeQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;svamp"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Germanic "*swambaz" --
                      "tree fungus", "mushroom", "sponge", via the Old East
                      Norse "svampr" -- "sponge", "fungus", and the Old Danish
                      "swamp" -- "sponge", "fungus".
                      <div></div>
                      <strong>Likely related to:</strong> sump
                      <div></div>
                      <strong>Cognates:</strong> svamp 🇩🇰, svamp 🇸🇪, zwam 🇳🇱,
                      fungus 🇬🇧, hongo 🇪🇸, fungo 🇵🇹, sponge 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/svar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/VvZv83SW8Bg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;svar"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic "*swarō"
                      -- "solemn statement or affirmation", "oath", "vow", via
                      the Old Norse "svar" -- "answer", "reply".
                      <div></div>
                      <strong>Related to:</strong> svära (<i>v.</i>)<div></div>
                      <strong>Cognates:</strong> svar 🇳🇴, svar 🇩🇰, svar 🇮🇸, an
                      <u>swer</u>
                      🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tes.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;te"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, Tee 🇩🇪, tee 🇫🇮
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇫🇮, te 🇳🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/toalett.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;toalett"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "tēla" -- "web",
                      "loom", via the Old French "toile" -- "cloth", "net", and
                      the Middle French "toilette" -- "small cloth". Originally,
                      people wrapped the "toilette" around their shoulders to
                      protect their clothes while doing their grooming. Over
                      time the cloth went from being on shoulders to being
                      spread out on a dressing table on which people would put
                      toiletry items. Eventually, the word came to refer to the
                      whole area where the dressing table was located (which was
                      often close to where people did their modern-day "toilet"
                      business).
                      <div></div>
                      <strong>Ancestor:</strong> toilettes 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> Toilette 🇩🇪, toilet 🇳🇱, туале́т
                      🇷🇺, toaleta 🇵🇱, toilet 🇬🇧, tualete 🇱🇻, tuvalet 🇹🇷, トイレ
                      🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/varld.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/w5RmgA6S31Y"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;värld"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic
                      "*weraldiz" -- "lifetime", "worldly existence", "mankind",
                      which was a combination of "*weraz" -- "man", "husband"
                      and "*alþi" -- "age", "generation, "lifetime". The "värld"
                      therefore denotes the entire period of history during
                      which humans have inhabited the domain of mankind.
                      <div></div>
                      <strong>Related to:</strong> <u>var</u>ulv
                      <div></div>
                      <strong>Cognates:</strong> Welt 🇩🇪, wereld 🇳🇱, verden 🇳🇴,
                      verden 🇩🇰, world 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇵🇭 TAGALOG 🇵🇭
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sugar.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/fPn5SEoSTBE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;asukal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit "शर्करा"
                      /śárkarā/ -- "pebbles", "gravel", via the Middle Persian
                      "𐭱𐭪𐭥" /šakar/ -- "sugar", and the Arabic "السُّكَّر"
                      /as-sukkar/ -- "sugar".
                      <div></div>
                      <strong>Ancestor:</strong> شکر 🇮🇷, سُكَّر 🇸🇦, azúcar 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> zucchero 🇮🇹, ζάχαρη 🇬🇷, са́хар
                      🇷🇺, sucre 🇫🇷, sugar 🇬🇧, sukker 🇳🇴, cukier 🇵🇱, siúcra 🇮🇪,
                      suiker 🇳🇱, cukrus 🇱🇹, Zucker 🇩🇪, за́хар 🇧🇬, շաքար 🇦🇲,
                      suhkur 🇪🇪, ስኳር 🇪🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/basura1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;basura"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "verrō" --
                      "to sweep (away)", "to carry off", via the Vulgar Latin
                      "*versūra" –- “sweepings”, "rubbish", and the Old Spanish
                      "vassura" -- "trash".
                      <div></div>
                      <strong>Ancestor:</strong> basura 🇪🇸
                      <div></div>
                      <strong>Semantic equivalents:</strong> śmieci (<i>pl</i>.)
                      🇵🇱, cме́цце 🇧🇾, смѐће 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus_ta.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦,
                      বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cheese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6t3E7ArIx_g"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;keso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin noun "caseus" (
                      <i>acc</i>. "caseum"), <i>i.e.</i>, "fermented dairy
                      product", via the Proto-West-Germanic "*kāsī" -- "cheese".
                      <div></div>
                      <strong>Ancestor:</strong> queso 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> cheese 🇬🇧, queijo 🇵🇹, Käse 🇩🇪,
                      kaas 🇳🇱
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/family.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L3OvlLFZ7q4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;pamilya"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Italic "*famelos"
                      -- "slave" via the Latin "familia" -- "a household", "the
                      slaves of a household". Through the concept of a "pater
                      familias" -- "ruler of the household", the "familia"
                      gradually went from denoting "the slaves of the
                      household", to denoting "anyone in the household", to
                      denoting only "family members".
                      <div></div>
                      <strong>Ancestor:</strong> familia 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> family 🇬🇧, familja 🇲🇹, famille
                      🇫🇷, familie 🇩🇰, familie 🇳🇴, Familie 🇩🇪, famiglia 🇮🇹,
                      família 🇵🇹, familie 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/paradise.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;paraiso"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Iranian "*paridayjah"
                      -- "walled garden". Via Greek the word became associated
                      with the Garden of Eden in the Christian Bible.
                      <div></div>
                      <strong>Ancestor:</strong> paraíso 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> paradis 🇫🇷, paraíso 🇵🇹,
                      paradise 🇬🇧, Paradies 🇩🇪, paradiso 🇹🇿, paradís 🇮🇸,
                      paradijs 🇳🇱, پردیس 🇮🇷, παράδεισος 🇬🇷, فِرْدَوْس 🇸🇦
                      <div></div>
                      <strong>Semantic equivalents:</strong> جَنَّة 🇸🇦, cennet
                      🇹🇷, jennet 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/potato.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;patatas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Taíno "b
                      <u>atata</u>" -- "sweet potato". The word's spelling may
                      also have been influenced by the Quechua "<u>p</u>
                      apa" -- "white potato". Both varieties of potato were
                      brought back to Europe from the Americas.
                      <div></div>
                      <strong>Ancestor:</strong> patata 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> بَطَاطَا 🇸🇦, potato 🇬🇧, batata
                      🇵🇹, potet 🇳🇴, patata 🇪🇸, potatis 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇫🇷
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/presa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/f20q4tgnzAQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "blue" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;presa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "frāgum" --
                      "strawberry" (and specifically its nominative plural form
                      "frāga") via the Old French "freise" -- "strawberry".
                      <div></div>
                      <strong>Not related to:</strong> prambuwesas
                      <div></div>
                      <strong>Cognates:</strong> fragola 🇮🇹, فراولة 🇸🇦
                      <div></div>
                      <strong>Ancestors:</strong> fraise 🇫🇷, fresa 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cementerio.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ZYq6_CttRm4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sementeryo"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "κοιμητήριον"
                      /koimētḗrĭon/ -- "place to sleep", "dormitory".
                      <div></div>
                      <strong>Descendants:</strong> cementerio 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> κοιμητήριο 🇬🇷, cimitero 🇮🇹,
                      cimitir 🇷🇴, cemitério 🇵🇹, cmentarz 🇵🇱, cimetière 🇫🇷,
                      cemetery 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tsa.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tsa"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea".
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲, شَاي 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tsokolate.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tsokolate"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, seacláid 🇮🇪, coklat
                      🇲🇾, 巧克力 🇨🇳, ချောကလက် 🇲🇲, چاکْلیٹ 🇵🇰, សូកូឡា 🇰🇭, ໂຊໂກລາ
                      🇱🇦, chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat
                      🇫🇷, xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹, coklat 🇲🇾, شکلات 🇮🇷,
                      チョコレート 🇯🇵, chocolate 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/towel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/swKB6hWmXmE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;tuwalya"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Germanic verb
                      "*þwahaną" -- "to wash" via the Frankish verb "*þwahilu"
                      -- "cloth".
                      <div></div>
                      <strong>Ancestor:</strong> toalla 🇪🇸
                      <div></div>
                      <strong>Cognates:</strong> towel 🇬🇧, toalha 🇵🇹, tuala 🇲🇾,
                      tuáille 🇮🇪, タオル 🇯🇵, taulo 🇹🇿, taul 🇵🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇹🇯 TAJIK 🇹🇯
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avtobus_mg.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;автобус"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷, авто́бус 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, awtobus 🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿,
                      buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese
                      🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷,
                      バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;газ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, gaz 🇫🇷, газ 🇷🇺, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kzalam.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;қалам"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, possibly
                      via the Ge'ez "ቀለም" /ḳäläm/ -- "reed".
                      <div></div>
                      <strong>Ancestor:</strong> قلم 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> калем 🇰🇬, kalem 🇹🇷, क़लम 🇮🇳,
                      कलम 🇳🇵, kalamu 🇹🇿, қалам 🇰🇿, ގަލަން 🇲🇻, কলম 🇧🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sad.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cад"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" - "100", via the Classical Persian "صَد" /sad/ --
                      "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, εκατό
                      🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto 🇵🇱, сто 🇧🇬,
                      сто 🇷🇺, cent 🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tshoi.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;чой"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many Central and West
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, çay 🇹🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, 茶 🇯🇵, 차
                      🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸,
                      thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý 🇹🇲, tea 🇬🇧, attaya
                      🇸🇳, اتاي 🇲🇷, شَاي 🇸🇦, چای 🇮🇷, шай 🇰🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shokolad2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;шакалод"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, cioccolato 🇮🇹,
                      шоколад 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, seacláid 🇮🇪, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      Schokolade 🇩🇪, czekolada 🇵🇱, chocolate 🇵🇹, chocolate 🇬🇧,
                      siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿, shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇹🇭 THAI 🇹🇭
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chat.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ชา"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲, شَاي 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;แก๊ส"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱, gas 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> गैस 🇮🇳, گاز 🇮🇷, গ্যাস 🇧🇩, gaz
                      🇫🇷, gas 🇬🇧, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ 🇧🇾, газ
                      🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז 🇮🇱, gass
                      🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷,
                      ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saramontir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ดนตรี"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Sanskrit "तन्त्री" /tantrī/
                      — "loom-like musical instrument", "lute"
                      <div></div>
                      <strong>Cognates:</strong> តន្ត្រី 🇰🇭, ດົນຕີ 🇱🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/midhla.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S9ctbChJZYg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ร่ม"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Proto-Tai "*rɤmᴮ" --
                      "shade", which itself is from the Old Chinese "陰" /*qrɯm/
                      -- "overcast", "shade".
                      <div></div>
                      <strong>Semantic equivalents:</strong> مِظَلَّة 🇸🇦,
                      ombrello 🇮🇹, umbrella 🇬🇧, ombrello 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/rotbat.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;รถบัส"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The second element, "บัส" /bát/,
                      is from "omnibus", the dative plural form of the Latin
                      adjective "omnes" -- "for all". The first "omnibus" was
                      developed in Nantes, France, in the 1820s by businessman
                      Stanislas Baudry, who wanted to find a means of
                      transportation to bring groups of customers from the
                      center of town to the business district. He named his new
                      vehicle "omnibus" because it was meant to be a means of
                      transportation "for all people". Eventually, "omnibus" was
                      shortened to "bus". The first element "รถ" /rót/ is from
                      the Sanskrit "รถ" /ratha/ -- "chariot" via the Pali
                      /ratha/ -- "chariot".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇪🇷 TIGRINYA 🇪🇷
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autóbusz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ኣውቶቡስ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus 🇹🇲,
                      אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪,
                      buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴,
                      bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi
                      🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/myshtsa.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/IMmiW70rNxU"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ጭዋዳ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "ኣንጭዋ" /ʾanč̣əwa/ -- "mouse",
                      so called because flexed arm muscles look like little
                      mice.
                      <div></div>
                      <strong>Related to:</strong> ኣንጭዋ
                      <div></div>
                      <strong>Semantic equivalents:</strong> عَضَلَة 🇸🇦, մկան
                      🇦🇲, ماهیچِه 🇮🇷, ကြွက်သား 🇲🇲, muscle 🇬🇧, mišića 🇭🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sahi.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ሻሂ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷, شَاي 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, tè 🇮🇹, tee 🇫🇮,
                      te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻይ 🇪🇹, shaah 🇸🇴,
                      ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, 茶 🇯🇵, 차 🇰🇷,
                      තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸,
                      thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, çay 🇹🇷, شَاي 🇸🇦, çaý 🇹🇲, čaj 🇨🇿,
                      çaj 🇦🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇵🇬 TOK PISIN 🇵🇬
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/titp.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ti"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Hokkien Chinese "茶" /tê/ --
                      "tea". The drink and its corresponding word was discovered
                      by Dutch traders in the early 17th century. The word made
                      its way by sea to Europe and the East Indies via Dutch.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, tea 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, чай
                      🇷🇺, choy 🇺🇿, шай 🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻,
                      תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, tee 🇪🇪
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇧🇼 TSWANA 🇧🇼
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bese.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bese"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, auto
                      <u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u> 🇪🇸,
                      auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u> 🇵🇱,
                      auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u> 🇦🇱,
                      auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u> 🇺🇦,
                      авто́
                      <u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>, 巴士 🇨🇳,
                      बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇲🇼, bhazi 🇿🇼
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇹🇷 TURKISH 🇹🇷
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ananas.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ananas"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Tupi-Guarani
                      "*nanã" -- "pineapple", via the Old Tupi "naná" --
                      "pineapple".
                      <div></div>
                      <strong>Ancestors:</strong> ananas 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> Ananas 🇩🇪, анана́с 🇷🇺, آناناس
                      🇮🇷, أَنَانَاس 🇸🇦, nanasi 🇹🇿, ананас 🇰🇿, ananāss 🇱🇻, ananas
                      🇫🇮, ananas 🇹🇷, နာနတ် 🇲🇲, ananas 🇩🇰, ananas 🇮🇸
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cennet.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cennet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Classical Syriac "ܓܰܢܬܳܐ"
                      /gannəṯā/ -- "garden", "park".
                      <div></div>
                      <strong>Ancestor:</strong> جَنَّة 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> jennet 🇹🇲, <u>גן</u> עדן 🇮🇱,
                      cənnət 🇦🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/çay.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;çay"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai
                      🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy
                      🇺🇿, шай 🇰🇿, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦,
                      tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cikolata.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;çikolata"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, cioccolato 🇮🇹
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, seacláid 🇮🇪, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, шокола́д 🇷🇺, shokolad 🇺🇿,
                      שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪, czekolada 🇵🇱,
                      chocolate 🇵🇹, chocolate 🇬🇧, xocolata 🇦🇩, чоколада 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dolmetscher.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/j2E_-Jyl6AM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;dilmaç"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*tilmač"
                      -- "an intermediary in communication between two parties
                      using different languages".
                      <div></div>
                      <strong>Cognates:</strong> тілмаш 🇰🇿
                      <div></div>
                      <strong>Descendants:</strong> tolmács 🇭🇺, tłumacz 🇵🇱,
                      tolmač 🇸🇮, tlmočník 🇸🇰, Dolmetscher 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/economy.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/WwM5Xa7Ql04"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ekonomi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Ancient Greek "οἰκονομία"
                      /oikonomía/ -- "management of a household (a combination
                      of "οἶκος" /oîkos/ -- "house", "dwelling place" and the
                      verb "νέμω" /némō/ -- "to distribute", "to allocate”).
                      Originally, the word denoted the concept of properly
                      allocating and distributing the resources within one's
                      house.
                      <div></div>
                      <strong>Ancestor:</strong> économie 🇫🇷
                      <div></div>
                      <strong>Related to:</strong> <u>eko</u>loji
                      <div></div>
                      <strong>Cognates:</strong> economía 🇪🇸, economia 🇵🇹,
                      economie 🇷🇴, economia 🇮🇹, økonomi 🇳🇴, økonomi 🇩🇰,
                      οικονομία 🇬🇷, ეკონომია 🇬🇪, эконо́мия 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gaz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to :</strong> kaos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gaz 🇫🇷, gas 🇬🇧, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/dinde.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hindi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "هِنْدِيّ"
                      /hindi/ -- "from or relating to India". The name derives
                      from the mistaken idea in many cultures that turkeys come
                      from the Indian Subcontinent.
                      <div></div>
                      <strong>Related to:</strong> Hindistan
                      <div></div>
                      <strong>Cognates:</strong> indyk 🇵🇱, индю́к 🇷🇺, d
                      <u>inde</u> 🇫🇷
                      <div></div>
                      <strong>Partial semantic equivalents:</strong> kalkoen 🇳🇱,
                      kalakùtas 🇱🇹, kalkon 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hobi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Ancestor:</strong> hobby 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> hobi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, xоби 🇲🇰, hobi 🇹🇷,
                      hobby 🇸🇪, хо́бби 🇷🇺, Hobby 🇩🇪, hobbi 🇭🇺, hobis 🇱🇹, hobbi
                      🇦🇿, hobijs 🇱🇻, хоби 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/iklim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;iklim"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west. From Greek, the word developed into the Arabic
                      "إِقْلِيم" /ʔiqlīm/ -- "territory", and then, from there,
                      Malay.
                      <div></div>
                      <strong>Ancestor:</strong> iklim 🇲🇾
                      <div></div>
                      <strong>Cognates:</strong> climate 🇺🇸, climat 🇫🇷, klimaat
                      🇳🇱, кли́мат 🇷🇺, κλίμα 🇬🇷, iklim 🇹🇷, iqlim 🇺🇿, ַַאַקְלִים
                      🇮🇱, اِقْلِیم 🇮🇷, clima 🇵🇹, اقليم 🇦🇫, klimat 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hipoteca.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/38-XMigB0vA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ipotek"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Greek "ῠ̔ποθήκη"
                      /hŭpothḗkē/ -- "pledge", "deposit", "mortgage", via the
                      Latin "hypothēca" -- "a pledge given as security for a
                      loan".
                      <div></div>
                      <strong>Ancestor:</strong> hypothèque 🇫🇷
                      <div></div>
                      <strong>Related to:</strong> tez
                      <div></div>
                      <strong>Cognates:</strong> hüpoteek 🇪🇪, hipoteca 🇵🇹,
                      hipoteca 🇸🇮, hipoteka 🇵🇱, hipoteka 🇸🇮, ипотека 🇰🇿,
                      Hypothek 🇩🇪, ипотека 🇰🇬
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇸🇦
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kahve.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/PEZq07E-f6M"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "orange" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kahve"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Aramaic verb "ܩܵܗܹܐ"
                      /qāhē/ -- "to become blunt", "to become dull", In the
                      Umayyad period, people considered coffee to be an
                      intoxicating drink that dulled the mind and deprived one
                      of appetite. Eventually the word developed into Arabic as
                      "قَهْوَة" -- "coffee" and then eventually spread to the
                      Anatolian Peninsula via the Ottoman Turkish "قهوه" /kahve/
                      -- "coffee".
                      <div></div>
                      <strong>Ancestors:</strong> قَهْوَة 🇸🇦
                      <div></div>
                      <strong>Related to:</strong> kafe
                      <div></div>
                      <strong>Cognates:</strong> café 🇫🇷, café 🇪🇸, Kaffee 🇩🇪,
                      ка̀фа 🇷🇸, café 🇵🇹, cafea 🇷🇴, kava 🇱🇹, кафе́ 🇧🇬, кафе 🇲🇰,
                      kafija 🇱🇻, kafe 🇦🇱, cafè, 🇦🇩 kohv 🇪🇪, kávé 🇭🇺, ка́ва 🇺🇦,
                      ко́фе 🇷🇺, coffi 🏴󠁧󠁢󠁷󠁬󠁳󠁿, καφές 🇬🇷, kaffe 🇳🇴, کافی 🇵🇰, кофе 🇰🇿,
                      kafe 🇲🇬, 咖啡 🇹🇼, қаҳва 🇹🇯, قهوه 🇮🇷, コーヒー 🇯🇵, 咖啡 🇨🇳,
                      커피 🇰🇷, ກາເຟ 🇱🇦, កាហ្វេ 🇰🇭, кофе 🇲🇳, cà phê 🇻🇳, ကော်ဖီ
                      🇲🇲, ყავა 🇬🇪, กาแฟ 🇹🇭, ཀཱ་ཕི། 🇧🇹, කෝපි 🇱🇰, kahawa 🇹🇿, কফি
                      🇧🇩, ކޮފީ 🇲🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kalem.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/UFdzCYpzE3E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kalem"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κᾰ́λᾰμος"
                      /kắlămos/ -- “reed (ink) pen used for writing”, possibly
                      via the Ge'ez "ቀለም" /ḳäläm/ -- "reed".
                      <div></div>
                      <strong>Ancestor:</strong> قلم 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> калем 🇰🇬, क़लम 🇮🇳, कलम 🇳🇵,
                      kalamu 🇹🇿, қалам 🇹🇯, қалам 🇰🇿, ގަލަން 🇲🇻, কলম 🇧🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kirk.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kırk"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*kïrk" --
                      "40", via the Ottoman Turksih "قرق" /kırk/ -- "40".
                      <div></div>
                      <strong>Possible cognates:</strong> cорaк 🇧🇾, cо́рок 🇺🇦,
                      cорок 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> кырк 🇰🇬, kyрк 🇹🇲, қырық 🇰🇿,
                      qirq 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/crimson.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/ebkAtW2Z8DI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kırmızı"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-Iranian noun
                      "*kŕ̥miš" -- "worm", via the Persian "کِرمِست" /kêrmêst/ --
                      "worm". The word comes from the crimson dye produced by a
                      worm-like insect called "kermes".
                      <div></div>
                      <strong>Ancestors:</strong> قِرْمِزِيّ 🇸🇦 (adj.)
                      <div></div>
                      <strong>Cognates:</strong> cramoisi 🇫🇷, cremisi 🇮🇹,
                      carmesim 🇵🇹, क़िरमिज़ी 🇮🇳, karmosin 🇸🇪, kırmızı 🇹🇷,
                      червоний 🇺🇦, czerwony 🇵🇱, червен 🇧🇬, црвен 🇲🇰, červený 🇸🇰,
                      чырво́ны 🇧🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/koepek.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;köpek"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*köpek" --
                      "dog", via the Ottoman Turkish "كوپك" /köpek/ -- "dog".
                      <div></div>
                      <strong>Cognate:</strong> köpek 🇹🇲
                      <div></div>
                      <strong>Possible Cognates:</strong> сабака 🇧🇾, собака 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mathematiques.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/AYqZfW6gXk4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;matematik"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μάθημα"
                      /máthēma/ -- "something that is learned", "lesson",
                      "knowledge", whence the phrase "μαθηματικὴ τέχνη"
                      /mathēmatikḗ tékhnē/ -- "mathematical sciences”, "sciences
                      of matters that have been learned" was derived.
                      Originally, “mathematics” referred to the science of
                      learning in general. Only after the term was used by the
                      "mathematikoi" (<i>i.e.,</i> "those who love to learn"), a
                      group of scholars in Ancient Greece who studied the ideas
                      of Pythagoras, especially those pertaining to arithmetic
                      and geometry, did the term "mathematics" become closely
                      associated with its modern meaning.
                      <div></div>
                      <strong>Ancestor:</strong> mathématiques 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> математика 🇰🇿, Mathematik 🇩🇪,
                      matematica 🇮🇹, matematika 🇸🇰, mathematics 🇬🇧, математика
                      🇰🇬, matematyka 🇵🇱, matematik 🇸🇪, matemáticas 🇪🇸, matematik
                      🇹🇷, математик 🇲🇳, матема́тика 🇷🇺, matematika 🇵🇭, matamaitic
                      🇮🇪, mathemateg 🏴󠁧󠁢󠁷󠁬󠁳󠁿, matematik 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;müze"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)", via the French "musée" -- "museum".
                      <div></div>
                      <strong>Related to:</strong> müzik
                      <div></div>
                      <strong>Ancestor:</strong> musée 🇫🇷
                      <div></div>
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      Museum 🇩🇪, музе́й 🇧🇾, muzeum 🇦🇱, موزه 🇮🇷, muzej 🇸🇮, muzejs
                      🇱🇻, muzeum 🇨🇿, muuseum 🇪🇪, múzeum 🇭🇺, מוּזֵיאוֹן 🇮🇱, muzeý
                      🇹🇲, музе́й 🇷🇺, muzium 🇲🇾
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/otobus_tr.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;otobüs"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, автобус 🇲🇳, awtobus 🇹🇲, אוֹטוֹבּוּס 🇮🇱, авто́бус 🇷🇺,
                      ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦,
                      বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/potato.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JaTqmfajWag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;patates"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Combination of Taíno "b
                      <u>atata</u>", and Quechua "<u>p</u>
                      apa", which denoted the sweet potato and white potato,
                      respectively. Both varieties of potato were brought back
                      to Europe from the Americas. For generations the two were
                      thought to come from the same plant and often mistaken for
                      one another, hence why the names were gradually merged.
                      From the Western Hemisphere, the word eventually evolved
                      into the Greek "πατάτες" /patátes/ -- "potato" and then
                      the Ottoman Turkish "پاتاتس" /patates/ -- "potato".
                      <div></div>
                      <strong>Cognates:</strong> بَطَاطَا 🇸🇦, potato 🇬🇧, batata
                      🇵🇹, potet 🇳🇴, patatas 🇵🇭, patata 🇪🇸, potatis 🇸🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/portakal.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;portakal"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Italian "portogallo" –
                      “orange (from Portugal)” via the Ottoman Turkish "پورتقال"
                      /portakal/ -- "orange". Portuguese traders brought the
                      fruit from East Asia to Europe, whence the name.
                      <div></div>
                      <strong>Cognates:</strong> ُرْتُقَال 🇸🇦, portokall 🇦🇱,
                      portocală 🇷🇴, πορτοκάλι 🇬🇷, portağal 🇦🇿, портокал 🇲🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/psychiatry.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6zy44o86UWI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;psikiyatr"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Ancient
                      Greek "ψυχή" /psukhḗ/ -- "soul" and "ἰατρός" /iatrós/ --
                      “doctor”.
                      <div></div>
                      <strong>Ancestor:</strong> psychiatre 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> Psychiater 🇩🇪, psychiatrist 🇬🇧,
                      psiquiatra 🇵🇹, ფსიქიატრი 🇬🇪, psiquiatra 🇪🇸, pszichiáter
                      🇭🇺, ψυχίατρος 🇬🇷, psühhiaater 🇪🇪, פסיכיאטר 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/renk.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/S0XaJZ4YJL4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;renk"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*reng-" – "to dye", via the Proto-Iranian "*rang-" – “to
                      colour", “to dye”, the Classical Persian "رنگ" /rang/ –-
                      “color”, and the Ottoman Turkish "رنك" /renk/ – “color".
                      <div></div>
                      <strong>Cognates:</strong> رنگ 🇮🇷, rəng 🇦🇿, رنګ 🇦🇫, रंग 🇮🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇹
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sevda.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "pink" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sevda"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Arabic "سوداء" /sawdāʔ/
                      -– "melancholy", "black bile", which itself is the
                      feminine form of the noun "أَسْوَد" /ʔaswad/ -- "black",
                      via the Ottoman Turkish "سودا" /sevda/ -- "black bile",
                      "melancholy", "passion".
                      <div></div>
                      <strong>Ancestor:</strong> سوداء 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong> sevdah 🇧🇦, sevda 🇦🇱, სევდა 🇬🇪,
                      sevda 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;spor"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧, sport 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺, ስፖርት 🇪🇹,
                      šport 🇸🇰, sport 🇷🇴
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hippopotamus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/k7tGCw0J5pY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;su aygırı"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The first word derives from the
                      Proto-Turkic "*sub" -- "water", via the Ottoman Turkish
                      "صو" /su/ -- "water". The second word derives from the
                      Proto-Turkic "*adgïr" -- "stallion" via the Ottoman
                      Turkish "آیغر" /ayğır/ -- "stallion".
                      <div></div>
                      <strong>Semantic equivalents:</strong> 河馬 🇯🇵, 河马 🇨🇳,
                      Nilpferd 🇩🇪, nijlpaard 🇳🇱, فَرَس نَهْر 🇸🇦, दरियाई घोड़ा
                      🇮🇳, dobhareach 🇮🇪, нилски коњ 🇲🇰, اسب آبی 🇮🇷, hippopotamus
                      🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇹🇲 TURKMEN 🇹🇲
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/awtobus.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;awtobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷, авто́бус 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, ավտոբուս 🇦🇲,
                      buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese
                      🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷,
                      バス 🇯🇵, ኣውቶቡስ 🇪🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cay.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;çaý"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many West and Central
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, شَاي
                      🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tshemedan.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/FndjOKzQbKE"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;çemedan"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Persian "جامه‌دان"
                      /jâme-dân/ -- "suitcase", which is itself a combination of
                      "جامه" /jâme/, -- “cloth” and "دان" /dân/ -- "container".
                      Literally, a "çemedan" is a container for storing cloth or
                      clothing, especially one used while travelling.
                      <div></div>
                      <strong>Related to:</strong> pi<u>jama</u>
                      <div></div>
                      <strong>Ancestor:</strong> جامه‌دان 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> čemodāns 🇱🇻, چمدان 🇮🇷, ჩემოდანი
                      🇬🇪, чемодан 🇲🇳, чамадон 🇹🇯, чемодан 🇰🇬, шабадан 🇰🇿,
                      čemodāns 🇱🇻
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gaz"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to:</strong> chaos
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇫🇷, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cennet.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/J1NadeO1_g4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;jennet"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Classical Syriac "ܓܰܢܬܳܐ"
                      /gannəṯā/ -- "garden", "park", via the Arabic "جَنَّة"
                      /janna/ -- "garden", "paradise", and the Persian "جنت"
                      /jannat/ -- "paradise", "heaven".
                      <div></div>
                      <strong>Ancestors:</strong> جَنَّة 🇸🇦, جَنَّت 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> cennet 🇹🇷, <u>גן</u> עדן 🇮🇱,
                      cənnət 🇦🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/koepek.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;köpek"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*köpek" --
                      "dog".
                      <div></div>
                      <strong>Cognate:</strong> köpek 🇹🇷
                      <div></div>
                      <strong>Possible Cognates:</strong> сабака 🇧🇾, собака 🇺🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/kyrk.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;kyrk"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*kïrk" --
                      "40", via the Ottoman Turksih "قرق" /kırk/ -- "40".
                      <div></div>
                      <strong>Possible cognates:</strong> cорaк 🇧🇾, cо́рок 🇺🇦,
                      cорок 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> кырк 🇰🇬, kırk 🇹🇷, қырық 🇰🇿,
                      qirq 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/moneta.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/yr0UobSKwLw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;manat"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin "monēta" -- "place
                      for coining money".
                      <div></div>
                      <strong>Ancestors:</strong> моне́та 🇷🇺, moneta 🇵🇱
                      <div></div>
                      <strong>Cognates:</strong> manat 🇦🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/musee.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;muzeý"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "Μουσεῖον"
                      /Mouseîon/ -- "shrine of the muses (goddesses of the
                      arts)", via the Latin "mūsēum" -- "library", "study".
                      <div></div>
                      <strong>Cognates:</strong> museo 🇮🇹, museo 🇪🇸, museu 🇵🇹,
                      Museum 🇩🇪, музе́й 🇧🇾, muzeum 🇦🇱, موزه 🇮🇷, müze 🇹🇷, muzejs
                      🇱🇻, muzeum 🇨🇿, muzeum 🇨🇿, múzeum 🇭🇺, מוּזֵיאוֹן 🇮🇱, muzeý,
                      музе́й 🇷🇺, muzium 🇲🇾, muzȇj 🇸🇮, muuseum 🇪🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;sport"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      <div></div>
                      <strong>Ancestor:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, Sport 🇩🇪, სპორტი 🇬🇪, spor 🇹🇷, ספּוֹרט 🇮🇱, sport 🇸🇪,
                      sport 🇭🇺, ስፖርት 🇪🇹, šport 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇺🇦 UKRAINIAN 🇺🇦
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/abrikos_ru.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/jFfgi1_HwZY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;абрикос"
                  hoverText={
                    <span>
                      <strong>Likely origin:</strong> From the latter word in
                      the Latin phrase "persica praecocia" -- "peach that ripens
                      early". "Praecocia" evolved from Latin into the Ancient
                      Greek "πραικόκῐον" /praikókĭon/ -- "apricot", the
                      Byzantine Greek "βερικοκκία" /berikokkía/ -- "apricot
                      tree", the Arabic "الْبَرْقُوق" /al-barqūq/ – “the
                      plum(s)”, and, eventually, the modern Ukrainian word.
                      <div></div>
                      <strong>Ancestors:</strong> albercoc 🇦🇩, abrikoos 🇳🇱,
                      абрико́с 🇺🇦
                      <div></div>
                      <strong>Descendant:</strong> абрикос 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> βερίκοκο 🇬🇷, albicocca 🇮🇹,
                      apricot 🇬🇧, berquq 🇲🇹, Aprikose 🇩🇪, aibreog 🇮🇪, aprikoti
                      🇹🇿, aprikot 🇮🇩, abricot 🇫🇷, albaricoque 🇪🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/autobus_ru.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;автобус"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, autóbusz 🇭🇺, ôni<u>bus</u> 🇵🇹, autobusas
                      🇱🇹, ავტობუსი 🇬🇪, اتوبوس 🇮🇷, otobüs 🇹🇷, автобус 🇲🇳, awtobus
                      🇹🇲, אוֹטוֹבּוּס 🇮🇱, ավտոբուս 🇦🇲, avtobus 🇺🇿, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;банан"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳, бана́н 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> banane 🇫🇷, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana
                      🇪🇸, banana 🇵🇹, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪,
                      banaan 🇳🇱, μπανάνα 🇬🇷, banan 🇸🇪, バナナ 🇯🇵, 바나나 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;газ"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Related to:</strong> хаос
                      <div></div>
                      <strong>Not related to:</strong> газета
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, gaz 🇫🇷, газ 🇷🇺, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, gaas 🇪🇪, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹,
                      qaz 🇦🇿, gáz 🇭🇺, gás 🇮🇪, gás 🇵🇹, گَیس 🇵🇰, غَاز 🇸🇦, ጋዝ 🇪🇹,
                      가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪, գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/zavtrak.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/6ZwH421T-lw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;завтра"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of "за" and "утро".
                      "завтра" was originally meant to signify a period that
                      would start as soon as we wake up from our night’s sleep
                      (i.e., in the next morning). Over time "завтра" also came
                      to mean not just "the morning", but also "the entire day
                      after today."
                      <div></div>
                      <strong>Cognates:</strong> за́ўтра 🇧🇾, у́тре 🇧🇬, у́тре 🇲🇰,
                      zítra 🇨🇿, jutro 🇵🇱,
                      <div></div>
                      <strong>Semantic Equivalents:</strong> mañana 🇪🇸, morgen
                      🇩🇪, 明日 🇯🇵
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇪🇸
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/mesti2.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/56LTN9s2yK4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "black" }}
                  ></i>
                </a>
                <Popover
                  text={
                    <>
                      &nbsp;мести (<i>v.</i>)
                    </>
                  }
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Slavic verb
                      "*mestì" -- "to throw", "to sweep".
                      <div></div>
                      <strong>Related to:</strong> підміта́ти (<i>v</i>.)
                      <div></div>
                      <strong>Cognates:</strong> (под)мести́ 🇷🇺, zamiatać 🇵🇱,
                      mesti 🇸🇮, помести 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/museum.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;музика"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "μουσικὴ
                      (τέχνη)" /mousikḕ (tékhnē)/ -- "(art) of the muses
                      (goddesses of the arts)".
                      <div></div>
                      <strong>Related to:</strong> музей, муза
                      <div></div>
                      <strong>Ancestor:</strong> muzyka 🇵🇱
                      <div></div>
                      <strong>Cognates:</strong> musique 🇫🇷, música 🇪🇸,
                      مُوسِيقَى 🇸🇦, му́зыка 🇷🇺, مُوسِیقِی 🇮🇷, musik 🇮🇩, musiikki
                      🇫🇮, musik 🇸🇪, музыка 🇰🇬, მუსიკა 🇬🇪, ሙዚቃ 🇪🇹, މިއުޒިކް 🇲🇻,
                      muzik 🇲🇾, muziki 🇹🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/probleme.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Tib6XaYX4c"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;проблема"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek verb
                      "προβάλλω" /probállō/ -- “to throw something in front of
                      someone", "to put forward”, which itself is a compound of
                      "προ-" /pro-/ -- “in front of” + "βάλλω" /bállō/, -- “to
                      throw", "to cast", "to hurl”. In this sense, a "проблема"
                      is an obstacle in one's path that must be overcome.
                      <div></div>
                      <strong>Related to:</strong> балістика
                      <div></div>
                      <strong>Ancestor</strong> пробле́ма 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> Problem 🇩🇪, probleem 🇳🇱,
                      прабле́ма 🇧🇾 problema 🇵🇹, problème 🇫🇷, problema 🇲🇹, problem
                      🇵🇱, problema 🇱🇹, пробле́м 🇧🇬, про́блем 🇲🇰, problema 🇪🇸,
                      problem 🇬🇧, problēma 🇱🇻, probleemi 🇪🇪, probléma 🇭🇺,
                      про̀бле̄м 🇷🇸, πρόβλημα 🇬🇷, problem 🇳🇴, problema 🇵🇭,
                      <div></div>
                      <strong>Descendants:</strong> პრობლემა 🇬🇪, проблема 🇰🇿,
                      проблема 🇰🇬, problema 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sobaka.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;собака"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Iranian
                      "*cwā" -- "dog", via the Proto-Medo-Parthian "*spā́kəh" --
                      "dog", the Proto-Slavic "*sobàka" -- "dog", and the Old
                      East Slavic "собака" -- "dog".
                      <div></div>
                      <strong>Cognates:</strong> сабака 🇧🇾, собака 🇺🇦
                      <div></div>
                      <strong>Probable cognates:</strong> سپی 🇦🇫, سگ 🇮🇷
                      <div></div>
                      <strong>Possible cognates:</strong> köpek 🇹🇷, köpek 🇹🇲
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sorok.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cорок"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Old East Slavic verb
                      "cорокъ" -- "bunch (40) of sable pelts".
                      <div></div>
                      <strong>Likely related to:</strong> сорока
                      <div></div>
                      <strong>Cognates:</strong> cорaк 🇧🇾, cо́рок 🇷🇺
                      <div></div>
                      <strong>Possible cognates:</strong> kırk 🇹🇷, кырк 🇰🇬, kyрк
                      🇹🇲, қырық 🇰🇿, qirq 🇺🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/sport1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/vgqAoQunN6U"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;спорт"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Latin verb "dēportō" --
                      "to bring", "to convey", "to take home", "to carry along"
                      via the Old French reflexive verb "deporter" -- "to
                      amuse", "to entertain oneself", and the English "disport"
                      -- "activity that offers amusement", "pleasure".
                      <div></div>
                      <strong>Ancestors:</strong> sport 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> deporte 🇪🇸, esporte 🇵🇹, спорт
                      🇷🇺, სპორტი 🇬🇪, ספּוֹרט 🇮🇱, sport 🇸🇪, sport 🇭🇺, ስፖርት 🇪🇹,
                      šport 🇸🇰, sport 🇷🇴, sport 🇫🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/chay.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;чай"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea" and the Ottoman Turkish "چای" /çay/ -- "tea". The
                      drink and its corresponding word made its way into many
                      West and Central Asian languages via land-based trading
                      routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷,
                      ሻይ 🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай
                      🇰🇿, çay 🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦,
                      tsa 🇵🇭, teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇵🇰 URDU 🇵🇰
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bus3.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;بس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, 버스 🇰🇷, basi 🇹🇿,
                      basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, 巴士 🇨🇳
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/pshay.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;چائے"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea" and the Ottoman Turkish "چای" /çay/ -- "tea". The
                      drink and its corresponding word made its way into many
                      West and Central Asian languages via land-based trading
                      routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, شَاي 🇸🇦, chá
                      🇵🇹, tè 🇮🇹, tee 🇫🇮, te 🇸🇪, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ 🇪🇹,
                      shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿, çay
                      🇹🇷, 茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭,
                      teh 🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, чай 🇷🇺
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/Dschungel.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/L06q6nSa4Zc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;جَنْگَل"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Sanskrit adjective
                      "जङ्गल" /jaṅgala/ -- "arid", "sterile", "desert".
                      <div></div>
                      <strong>Cognates:</strong> जंगल 🇮🇳, জঙ্গল 🇧🇩, जङ्गल 🇳🇵,
                      ځنګل 🇦🇫, جَن٘گَل 🇮🇷
                      <div></div>
                      <strong>Descendants:</strong> cəngəllik 🇦🇿, ҷангал 🇹🇯,
                      джу́нгли 🇷🇺, jungle 🇫🇷, jungle 🇩🇰, jungle 🇳🇴, djungel 🇸🇪,
                      dżungla 🇵🇱, ջունգլի 🇦🇲, ჯუნგლი 🇬🇪, ジャングル 🇯🇵, džungla
                      🇸🇮, džùngla 🇭🇷, jyngl 🏴󠁧󠁢󠁷󠁬󠁳󠁿, jungle 🇬🇧, Dschungel 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/gaz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/RqP5fec0SUg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;گَیس"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Coined in 1648 by the Flemish
                      physician Jan Baptist van Helmont, who derived the name
                      from the Ancient Greek "χάος" /kháos/ -- “chasm", "void",
                      "empty space”, and likely also from the fact that it
                      sounded like the Dutch "geest" -- "spirit", "ghost" (as
                      in, the "geest" that inhabits the air).
                      <div></div>
                      <strong>Ancestor:</strong> gas 🇳🇱
                      <div></div>
                      <strong>Cognates:</strong> แก๊ส 🇹🇭, गैस 🇮🇳, گاز 🇮🇷, গ্যাস
                      🇧🇩, gas 🇬🇧, gaz 🇹🇷, gaz 🇦🇱, gaz 🇵🇱, gaz 🇷🇴, gaz 🇹🇲, газ
                      🇧🇾, газ 🇹🇯, газ 🇷🇺, газ 🇺🇦, газ 🇰🇬, газ 🇰🇿, газ 🇧🇬, גַּז
                      🇮🇱, gass 🇳🇴, kaasu 🇫🇮, gāze 🇱🇻, gesi 🇹🇿, gass 🇲🇹, qaz 🇦🇿,
                      gás 🇮🇪, gás 🇵🇹, غَاز 🇸🇦, ጋዝ 🇪🇹, 가스 🇰🇷, ガス 🇯🇵, გაზი 🇬🇪,
                      գազ 🇦🇲, গ্যাস 🇧🇩, ගෑස් 🇱🇰, Gas 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇺🇿 UZBEK 🇺🇿
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/avtobus_uz.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;avtobus"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually, the
                      original French term was shortened to "bus", and the
                      prefix "auto-", short for "automobile", was added, to form
                      "autobus".
                      <div></div>
                      <strong>Ancestor:</strong> autobus 🇫🇷
                      <div></div>
                      <strong>Cognates:</strong> autobús 🇪🇸, autobus 🇨🇿, autobus
                      🇮🇹, авто́бус 🇺🇦, ôni<u>bus</u> 🇵🇹, autobusas 🇱🇹, ავტობუსი
                      🇬🇪, awtobus 🇹🇲, ավտոբուս 🇦🇲, ավտոբուս 🇦🇲, buss 🇪🇪, buss
                      🇸🇪, buss 🇳🇴, Bus 🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas
                      🇸🇴, bísi 🇨🇩, bus 🇳🇦, 巴士 🇨🇳, बस 🇮🇳, basi 🇹🇿, basi 🇲🇼,
                      bhazi 🇿🇼, bus 🇳🇦, বাস 🇧🇩, بس 🇦🇫, 버스 🇰🇷, バス 🇯🇵, ኣውቶቡስ
                      🇪🇷, авто́бус 🇷🇺, אוֹטוֹבּוּס 🇮🇱
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/choy.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;choy"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many Central and West
                      Asian languages via land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, چای 🇮🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, шай 🇰🇿, tea 🇬🇧, 茶
                      🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩,
                      té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý 🇹🇲,
                      tea 🇬🇧, attaya 🇸🇳, اتاي 🇲🇷, شَاي 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/iklim.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/sSsqWzZHxP4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;iqlim"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Ancient Greek "κλίμα"
                      /klíma/ -- "latitude", via the Latin "clima" -- "region",
                      "slope of the earth". As described by Aristotle (among
                      others), in Ancient Greece "κλῐ́μᾰτᾰ" /klĭ́mătă/ (the plural
                      of "κλῐ́μᾰ") denoted regions of the earth with a specific
                      temperature (<i>i.e.</i>, frigid, temperate, or torrid)
                      that were separated by a parallel travelling from east to
                      west.
                      <div></div>
                      <strong>Ancestor</strong> إِقْلِيم 🇸🇦
                      <div></div>
                      <strong>Cognates:</strong>
                      اقليم 🇵🇰, اِقْلِیم 🇮🇷, iqlim 🇦🇿, iklim 🇮🇩, iqlim 🇺🇿
                      ַַאַקְלִים 🇮🇱, climate 🇺🇸, climat 🇫🇷, klimaat 🇳🇱, кли́мат
                      🇷🇺, κλίμα 🇬🇷, clima 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇷🇺
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/qirq.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/mwZPgZpAkQI"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "gray" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;qirq"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Turkic "*kïrk" --
                      "40", via the Ottoman Turksih "قرق" /kırk/ -- "40".
                      <div></div>
                      <strong>Possible cognates:</strong> cорaк 🇧🇾, cо́рок 🇺🇦,
                      cорок 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> kyrk 🇹🇲, kırk 🇹🇷, кырк 🇰🇬,
                      қырық 🇰🇿
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/shokolad1.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;shokolad"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, cioccolato 🇮🇹,
                      шоколад 🇷🇺
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, seacláid 🇮🇪, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪, czekolada 🇵🇱,
                      chocolate 🇵🇹, chocolate 🇬🇧, siocled 🏴󠁧󠁢󠁷󠁬󠁳󠁿
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇻🇳 VIETNAMESE 🇻🇳
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/saramontir.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/W-31tZ5VDGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;âm nhạc"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From Middle Chinese "音樂" /'im
                      ngaewk/ -- "music".
                      <div></div>
                      <strong>Ancestor:</strong> 音乐 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> 음악 🇰🇷, 음악 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/ga tay.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Vjr5a0s_QMc"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;gà tây"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "gà" -- "chicken" + "tây" --
                      "Western". Literally, a "gà tây" is a "chicken from the
                      West", which is where turkeys were traditionally thought
                      to be from.
                      <div></div>
                      <strong>Partial semantic equivalents:</strong> دِيك
                      رُومِيّ 🇸🇦, មាន់បារាំង 🇰🇭
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/giac.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/abvF2Ec_BU0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;giác"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*krəw" -- "horn", "angle", "corner", via the Middle
                      Chinese "角" /kaewk/ -- "horn", "angle", "corner".
                      <div></div>
                      <strong>Cognates:</strong> 角 🇯🇵, 角 🇨🇳, 각 🇰🇷
                      <div></div>
                      <strong>Semantic equivalents:</strong> horn 🇬🇧, cuerno 🇪🇸,
                      corne 🇫🇷, hoorn 🇳🇱, horn 🇳🇴, horn 🇩🇰
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/tra.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;trà"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the
                      Proto-Sino-Tibetan "*s-la" -- "leaf".
                      <div></div>
                      <strong>Ancestor: </strong> 茶 🇨🇳
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh 🇮🇩, té
                      🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çaý 🇹🇲, តែ 🇰🇭, شَاي
                      🇸🇦, çay 🇹🇷, ჩაი 🇬🇪, 차 🇰🇷, চা 🇧🇩
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/xebuyt.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;xe buýt"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> The second element, "buýt", is
                      from "omnibus", the dative plural form of the Latin
                      adjective "omnes" -- "for all". The first "omnibus" was
                      developed in Nantes, France, in the 1820s by businessman
                      Stanislas Baudry, who wanted to find a means of
                      transportation to bring groups of customers from the
                      center of town to the business district. He named his new
                      vehicle "omnibus" because it was meant to be a means of
                      transportation "for all people". Eventually, "omnibus" was
                      shortened to "bus". The first element, "xe", comes from
                      the Chinese '車' /chē/ -- "vehicle".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bws 🏴󠁧󠁢󠁷󠁬󠁳󠁿, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus
                      🇳🇦, auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u>{" "}
                      🇪🇸, auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u>{" "}
                      🇵🇱, auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u>{" "}
                      🇦🇱, auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u>{" "}
                      🇺🇦, авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u>{" "}
                      🇵🇹, 巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi
                      🇹🇿, basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🏴󠁧󠁢󠁷󠁬󠁳󠁿 WELSH 🏴󠁧󠁢󠁷󠁬󠁳󠁿
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bear.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/1Y5iVsql7b0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;arth"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*h₂ŕ̥tḱos" -- "bear", via the Proto-Celtic "*artos" --
                      "bear", and the Proto-Brythonic "*arθ" -- "bear".
                      <div></div>
                      <strong>Cognates:</strong> ours 🇫🇷, urso 🇵🇹, oso 🇪🇸, arth
                      🏴󠁧󠁢󠁷󠁬󠁳󠁿, արջ 🇦🇲, ariu 🇦🇱, αρκούδα 🇬🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;banana"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Ancestor:</strong> banaana 🇸🇳, banana 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> banane 🇫🇷, banana 🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana
                      🇪🇸, banana 🇵🇹, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦, Banane 🇩🇪,
                      banaan 🇳🇱, μπανάνα 🇬🇷, banan 🇸🇪, バナナ 🇯🇵, 바나나 🇰🇷
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇵🇱
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/bws.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/JwTG5PPWfeM"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "purple" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;bws"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From "omnibus", the dative plural
                      form of the Latin adjective "omnes" -- "for all". The
                      first "omnibus" was developed in Nantes, France, in the
                      1820s by businessman Stanislas Baudry, who wanted to find
                      a means of transportation to bring groups of customers
                      from the center of town to the business district. He named
                      his new vehicle "omnibus" because it was meant to be a
                      means of transportation "for all people". Eventually,
                      "omnibus" was shortened to "bus".
                      <div></div>
                      <strong>Ancestor:</strong> bus 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> buss 🇪🇪, buss 🇸🇪, buss 🇳🇴, Bus
                      🇩🇪, bese 🇧🇼, bese 🇱🇸, bas 🇳🇬, bas 🇸🇴, bísi 🇨🇩, bus 🇳🇦,
                      auto<u>busas</u> 🇱🇹, auto<u>bús</u> 🇦🇩, auto<u>bús</u> 🇪🇸,
                      auto<u>buz</u> 🇷🇴, avto<u>bus</u> 🇸🇮, auto<u>bus</u> 🇵🇱,
                      auto<u>bus</u> 🇨🇿, auto<u>bus</u> 🇸🇰, auto<u>bus</u> 🇦🇱,
                      auto<u>bus</u> 🇮🇹, auto<u>bus</u> 🇭🇷 авто́<u>бус</u> 🇺🇦,
                      авто́<u>бус</u> 🇷🇺, autó<u>busz</u> 🇭🇺, ôni<u>bus</u> 🇵🇹,
                      巴士 🇨🇳, बस 🇮🇳, バス 🇯🇵, bas 🇲🇾, بَس 🇵🇰, 버스 🇰🇷, basi 🇹🇿,
                      basi 🇲🇼, bhazi 🇿🇼, bus 🇳🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/cant.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/Y3XbvCszBiw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cant"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Indo-European
                      "*ḱm̥tóm" - "100", via the Proto-Celtic "*kantom" - "100".
                      <div></div>
                      <strong>Cognates:</strong> hundrede 🇩🇰, hundrað 🇮🇸, hundre
                      🇳🇴, hundra 🇸🇪, hundert 🇩🇪, honderd 🇳🇱, صد 🇮🇷, सौ 🇮🇳, cад
                      🇹🇯, εκατό 🇬🇷, cant 🏴󠁧󠁢󠁷󠁬󠁳󠁿, šimtas 🇱🇻, simts 🇱🇹, stó 🇸🇮, sto
                      🇵🇱, сто 🇧🇬, сто 🇷🇺, cent 🇫🇷, cien 🇪🇸, cem 🇵🇹, cento 🇮🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/clock.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/QXB-65eOT40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;cloch"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Proto-Celtic
                      "*klokkos" -- "bell" via the Medieval Latin "clocca" --
                      "bell". The word emerged in the Middle Ages with the
                      emergence of mechanical clocks, which first emerged in the
                      late 13th century and had a small bell that would ring at
                      intervals, for example, to remind monks in a monastery
                      when it was time for prayer.
                      <div></div>
                      <strong>Not related to:</strong> clog
                      <div></div>
                      <strong>Cognates:</strong> clock 🇬🇧, klok 🇳🇱, klukka 🇮🇸,
                      clog 🇮🇪, Glocke 🇩🇪
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/hobi.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/bxn7KPzO2Us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;hobi"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Middle-English "hoby" --
                      "small horse", "pony", which is possibly derived from the
                      name "Robyn". The phrase "hobby-horse", which was derived
                      from "hoby", denoted a toy horse that children played on
                      and ran around on (often in circles and without really
                      having any destination to get to). Eventually, any
                      activity that was just for fun and didn’t have any real
                      purpose became known as a “hobby-horse”, and, later,
                      simply, a “hobby”.
                      <div></div>
                      <strong>Ancestor:</strong> hobby 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> xоби 🇲🇰, hobi 🇹🇷, hobby 🇸🇪,
                      хо́бби 🇷🇺, Hobby 🇩🇪, hobbi 🇭🇺, hobis 🇱🇹, hobbi 🇦🇿, hobijs
                      🇱🇻, хоби 🇷🇸
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/siocled.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/dPR4yZQpHY0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;siocled"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Likely from the Classical Nahuatl
                      (Aztec) "chocolātl" -- "chocolate", whose origin is
                      uncertain but likely either a combination of the Classical
                      Nahuatl "xocoatl" –- "bitter water" or the Yucatec Mayan
                      "chokolātl" -– "hot water". In both variants the latter
                      element descends from the Proto-Uto-Aztecan "*pa" --
                      "water", via the Proto-Nahuan "*aa-tl" –- "water".
                      <div></div>
                      <strong>Ancestors:</strong> chocolate 🇪🇸, chocolate 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> شکلات 🇮🇷, seacláid 🇮🇪, coklat
                      🇲🇾, ချောကလက် 🇲🇲, චොකලට් 🇱🇰, 巧克力 🇨🇳, チョコレート 🇯🇵,
                      초콜릿 🇰🇷, چاکْلیٹ 🇵🇰, tsokolate 🇵🇭, សូកូឡា 🇰🇭, ໂຊໂກລາ 🇱🇦,
                      chokola 🇭🇹, sokola 🇲🇬, suklaa 🇫🇮, choklad 🇸🇪, chocolat 🇫🇷,
                      xocolata 🇦🇩, чокола́да 🇷🇸, cioccolato 🇮🇹, шокола́д 🇷🇺,
                      shokolad 🇺🇿, שׁוֹקוֹלָד 🇮🇱, шакалод 🇹🇯, Schokolade 🇩🇪,
                      czekolada 🇵🇱, chocolate 🇵🇹
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/insect.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/v4_W35BFIoQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;trychfil"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> A combination of the Proto-Celtic
                      verb "*twerḱ-" -- "to cut off" and the noun "*mīlom" --
                      "animal".
                      <div></div>
                      <strong>Related to:</strong> mil (animal), trwch
                      <div></div>
                      <strong>Semantic equivalents:</strong> έντομο 🇬🇷, rovar
                      🇭🇺, insect 🇬🇧, насеко́мое 🇷🇺, Insekt 🇩🇪, insect 🇳🇱, insekt
                      🇳🇴,
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇸🇳 WOLOF 🇸🇳
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/attaya.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;attaya"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many Central and West
                      Asian languages (and, later, African languages) via
                      land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, شَاي 🇸🇦, اتاي 🇲🇷
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲, tea 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇬🇧
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/banana.png"
                      alt="average"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/XKJyaWr4KYY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "red" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;banaana"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> Possibly from the Arabic "بنان"
                      /banān/ -- "fingertips".
                      <div></div>
                      <strong>Probable Descendants:</strong> banane 🇫🇷, banana
                      🏴󠁧󠁢󠁷󠁬󠁳󠁿, banana 🇪🇸, banana 🇵🇹, banāns 🇱🇻, бана́н 🇷🇺, бана́н 🇺🇦,
                      Banane 🇩🇪, banaan 🇳🇱, μπανάνα 🇬🇷, banan 🇸🇪, バナナ 🇯🇵,
                      바나나 🇰🇷, banana 🇬🇧
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                --------------------------------{" "}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "100%", textAlign: "left" }}>
              <Typography variant="h5" color="black">
                🇿🇦 XHOSA 🇿🇦
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                width: "100%",
                maxWidth: "400px",
                mx: "auto",
                textAlign: "left",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Popover
                  text={
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 6px",
                        fontSize: "16px",
                        lineHeight: "1",
                        cursor: "pointer",
                      }}
                    >
                      🇩🇪
                    </span>
                  }
                  hoverText={
                    <img
                      src="/images/iti.png"
                      alt="tailor"
                      style={{
                        width: "100%",
                        maxWidth: getImageSize(),
                        borderRadius: "4px",
                      }}
                    />
                  }
                />
                <a
                  href="https://youtu.be/KRbWjeHCjM0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{ color: "green" }}
                  ></i>
                </a>
                <Popover
                  text="&nbsp;ítí"
                  hoverText={
                    <span>
                      <strong>Origin:</strong> From the Proto-Sino-Tibetan
                      "*s-la" -- "leaf", via the Cantonese Chinese "茶" /chá/ --
                      "tea", the Persian "چای" /čây/ -- "tea" and the Ottoman
                      Turkish "چای" /çay/ -- "tea". The drink and its
                      corresponding word made its way into many Central and West
                      Asian languages (and, later, African languages) via
                      land-based trading routes.
                      <div></div>
                      <strong>Ancestor:</strong> 茶 🇨🇳, thee 🇳🇱, tea 🇬🇧
                      <div></div>
                      <strong>Cognates:</strong> thé 🇫🇷, τσάι 🇬🇷, chá 🇵🇹, tè 🇮🇹,
                      tee 🇫🇮, te 🇸🇪, чай 🇺🇦, чай 🇷🇺, dite 🇲🇬, chai 🇹🇿, ሻሂ 🇪🇷, ሻይ
                      🇪🇹, shaah 🇸🇴, ⴰⵜⴰⵢ 🇩🇿, tēja 🇱🇻, tae 🇮🇪, choy 🇺🇿, шай 🇰🇿,
                      茶 🇯🇵, 차 🇰🇷, තේ 🇱🇰, ސައި 🇲🇻, תֵּה 🇮🇱, ຊາ 🇱🇦, tsa 🇵🇭, teh
                      🇮🇩, té 🇪🇸, thee 🇳🇱, tee 🇪🇪, ceai 🇷🇴, čaj 🇸🇰, çay 🇹🇷, çaý
                      🇹🇲, اتاي 🇲🇷, شَاي 🇸🇦
                      <div></div>
                    </span>
                  }
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Popover />
      <Footer />
    </div>
  );
};
export default History;
